var p1 = (e) => {
  throw TypeError(e);
};
var so = (e, t, r) => t.has(e) || p1("Cannot " + r);
var L = (e, t, r) => (so(e, t, "read from private field"), r ? r.call(e) : t.get(e)), fe = (e, t, r) => t.has(e) ? p1("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Q = (e, t, r, n) => (so(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Ce = (e, t, r) => (so(e, t, "access private method"), r);
import * as De from "react";
import ye, { createContext as Ut, forwardRef as Ii, useCallback as Fe, createElement as na, useContext as mt, useMemo as yt, useEffect as Be, useState as be, useRef as Le, useLayoutEffect as dc, isValidElement as oa, cloneElement as pc, Fragment as hc, useId as Qr, useImperativeHandle as yc } from "react";
import { jsx as c, Fragment as Jr, jsxs as D } from "react/jsx-runtime";
import { flushSync as mc, createPortal as gc } from "react-dom";
var Hn = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Cc = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: (e) => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: (e) => clearInterval(e)
}, ht, er, Ys, vc = (Ys = class {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    fe(this, ht, Cc);
    fe(this, er, !1);
  }
  setTimeoutProvider(e) {
    process.env.NODE_ENV !== "production" && L(this, er) && e !== L(this, ht) && console.error(
      "[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.",
      { previous: L(this, ht), provider: e }
    ), Q(this, ht, e), process.env.NODE_ENV !== "production" && Q(this, er, !1);
  }
  setTimeout(e, t) {
    return process.env.NODE_ENV !== "production" && Q(this, er, !0), L(this, ht).setTimeout(e, t);
  }
  clearTimeout(e) {
    L(this, ht).clearTimeout(e);
  }
  setInterval(e, t) {
    return process.env.NODE_ENV !== "production" && Q(this, er, !0), L(this, ht).setInterval(e, t);
  }
  clearInterval(e) {
    L(this, ht).clearInterval(e);
  }
}, ht = new WeakMap(), er = new WeakMap(), Ys), Sn = new vc();
function bc(e) {
  setTimeout(e, 0);
}
var zr = typeof window > "u" || "Deno" in globalThis;
function Fn() {
}
function h1(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function wc(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Vr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function st(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function y1(e) {
  return JSON.stringify(
    e,
    (t, r) => ui(r) ? Object.keys(r).sort().reduce((n, o) => (n[o] = r[o], n), {}) : r
  );
}
var Sc = Object.prototype.hasOwnProperty;
function li(e, t) {
  if (e === t)
    return e;
  const r = m1(e) && m1(t);
  if (!r && !(ui(e) && ui(t))) return t;
  const o = (r ? e : Object.keys(e)).length, i = r ? t : Object.keys(t), s = i.length, a = r ? new Array(s) : {};
  let u = 0;
  for (let d = 0; d < s; d++) {
    const h = r ? d : i[d], f = e[h], b = t[h];
    if (f === b) {
      a[h] = f, (r ? d < o : Sc.call(e, h)) && u++;
      continue;
    }
    if (f === null || b === null || typeof f != "object" || typeof b != "object") {
      a[h] = b;
      continue;
    }
    const C = li(f, b);
    a[h] = C, C === f && u++;
  }
  return o === s && u === o ? e : a;
}
function $n(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function m1(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function ui(e) {
  if (!g1(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(!g1(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function g1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function C1(e, t, r) {
  if (typeof r.structuralSharing == "function")
    return r.structuralSharing(e, t);
  if (r.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return li(e, t);
      } catch (n) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${r.queryHash}]: ${n}`
        ), n;
      }
    return li(e, t);
  }
  return t;
}
function Yr(e) {
  return e;
}
function ia(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var tr, qt, yr, Xs, Ec = (Xs = class extends Hn {
  constructor() {
    super();
    fe(this, tr);
    fe(this, qt);
    fe(this, yr);
    Q(this, yr, (t) => {
      if (!zr && window.addEventListener) {
        const r = () => t();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    L(this, qt) || this.setEventListener(L(this, yr));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = L(this, qt)) == null || t.call(this), Q(this, qt, void 0));
  }
  setEventListener(t) {
    var r;
    Q(this, yr, t), (r = L(this, qt)) == null || r.call(this), Q(this, qt, t((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    }));
  }
  setFocused(t) {
    L(this, tr) !== t && (Q(this, tr, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((r) => {
      r(t);
    });
  }
  isFocused() {
    var t;
    return typeof L(this, tr) == "boolean" ? L(this, tr) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, tr = new WeakMap(), qt = new WeakMap(), yr = new WeakMap(), Xs), xc = new Ec();
function v1() {
  let e, t;
  const r = new Promise((o, i) => {
    e = o, t = i;
  });
  r.status = "pending", r.catch(() => {
  });
  function n(o) {
    Object.assign(r, o), delete r.resolve, delete r.reject;
  }
  return r.resolve = (o) => {
    n({
      status: "fulfilled",
      value: o
    }), e(o);
  }, r.reject = (o) => {
    n({
      status: "rejected",
      reason: o
    }), t(o);
  }, r;
}
var Rc = bc;
function Oc() {
  let e = [], t = 0, r = (a) => {
    a();
  }, n = (a) => {
    a();
  }, o = Rc;
  const i = (a) => {
    t ? e.push(a) : o(() => {
      r(a);
    });
  }, s = () => {
    const a = e;
    e = [], a.length && o(() => {
      n(() => {
        a.forEach((u) => {
          r(u);
        });
      });
    });
  };
  return {
    batch: (a) => {
      let u;
      t++;
      try {
        u = a();
      } finally {
        t--, t || s();
      }
      return u;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (a) => (...u) => {
      i(() => {
        a(...u);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (a) => {
      r = a;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (a) => {
      n = a;
    },
    setScheduler: (a) => {
      o = a;
    }
  };
}
var Bn = Oc(), mr, kt, gr, ea, Pc = (ea = class extends Hn {
  constructor() {
    super();
    fe(this, mr, !0);
    fe(this, kt);
    fe(this, gr);
    Q(this, gr, (t) => {
      if (!zr && window.addEventListener) {
        const r = () => t(!0), n = () => t(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", n);
        };
      }
    });
  }
  onSubscribe() {
    L(this, kt) || this.setEventListener(L(this, gr));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = L(this, kt)) == null || t.call(this), Q(this, kt, void 0));
  }
  setEventListener(t) {
    var r;
    Q(this, gr, t), (r = L(this, kt)) == null || r.call(this), Q(this, kt, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    L(this, mr) !== t && (Q(this, mr, t), this.listeners.forEach((n) => {
      n(t);
    }));
  }
  isOnline() {
    return L(this, mr);
  }
}, mr = new WeakMap(), kt = new WeakMap(), gr = new WeakMap(), ea), Ac = new Pc();
function Lc(e) {
  return (e ?? "online") === "online" ? Ac.isOnline() : !0;
}
function Tc(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Lc(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
var ze, ie, Zr, Ue, rr, Cr, wt, Dt, Wr, vr, br, nr, or, Ht, wr, de, Br, fi, di, pi, hi, yi, mi, gi, sa, ta, Mc = (ta = class extends Hn {
  constructor(t, r) {
    super();
    fe(this, de);
    fe(this, ze);
    fe(this, ie);
    fe(this, Zr);
    fe(this, Ue);
    fe(this, rr);
    fe(this, Cr);
    fe(this, wt);
    fe(this, Dt);
    fe(this, Wr);
    fe(this, vr);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    fe(this, br);
    fe(this, nr);
    fe(this, or);
    fe(this, Ht);
    fe(this, wr, /* @__PURE__ */ new Set());
    this.options = r, Q(this, ze, t), Q(this, Dt, null), Q(this, wt, v1()), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (L(this, ie).addObserver(this), b1(L(this, ie), this.options) ? Ce(this, de, Br).call(this) : this.updateResult(), Ce(this, de, hi).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Ci(
      L(this, ie),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Ci(
      L(this, ie),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Ce(this, de, yi).call(this), Ce(this, de, mi).call(this), L(this, ie).removeObserver(this);
  }
  setOptions(t) {
    const r = this.options, n = L(this, ie);
    if (this.options = L(this, ze).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof st(this.options.enabled, L(this, ie)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    Ce(this, de, gi).call(this), L(this, ie).setOptions(this.options), r._defaulted && !$n(this.options, r) && L(this, ze).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: L(this, ie),
      observer: this
    });
    const o = this.hasListeners();
    o && w1(
      L(this, ie),
      n,
      this.options,
      r
    ) && Ce(this, de, Br).call(this), this.updateResult(), o && (L(this, ie) !== n || st(this.options.enabled, L(this, ie)) !== st(r.enabled, L(this, ie)) || Vr(this.options.staleTime, L(this, ie)) !== Vr(r.staleTime, L(this, ie))) && Ce(this, de, fi).call(this);
    const i = Ce(this, de, di).call(this);
    o && (L(this, ie) !== n || st(this.options.enabled, L(this, ie)) !== st(r.enabled, L(this, ie)) || i !== L(this, Ht)) && Ce(this, de, pi).call(this, i);
  }
  getOptimisticResult(t) {
    const r = L(this, ze).getQueryCache().build(L(this, ze), t), n = this.createResult(r, t);
    return Nc(this, n) && (Q(this, Ue, n), Q(this, Cr, this.options), Q(this, rr, L(this, ie).state)), n;
  }
  getCurrentResult() {
    return L(this, Ue);
  }
  trackResult(t, r) {
    return new Proxy(t, {
      get: (n, o) => (this.trackProp(o), r == null || r(o), o === "promise" && !this.options.experimental_prefetchInRender && L(this, wt).status === "pending" && L(this, wt).reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      ), Reflect.get(n, o))
    });
  }
  trackProp(t) {
    L(this, wr).add(t);
  }
  getCurrentQuery() {
    return L(this, ie);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const r = L(this, ze).defaultQueryOptions(t), n = L(this, ze).getQueryCache().build(L(this, ze), r);
    return n.fetch().then(() => this.createResult(n, r));
  }
  fetch(t) {
    return Ce(this, de, Br).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), L(this, Ue)));
  }
  createResult(t, r) {
    var I;
    const n = L(this, ie), o = this.options, i = L(this, Ue), s = L(this, rr), a = L(this, Cr), d = t !== n ? t.state : L(this, Zr), { state: h } = t;
    let f = { ...h }, b = !1, C;
    if (r._optimisticResults) {
      const F = this.hasListeners(), V = !F && b1(t, r), k = F && w1(t, n, r, o);
      (V || k) && (f = {
        ...f,
        ...Tc(h.data, t.options)
      }), r._optimisticResults === "isRestoring" && (f.fetchStatus = "idle");
    }
    let { error: l, errorUpdatedAt: g, status: p } = f;
    C = f.data;
    let m = !1;
    if (r.placeholderData !== void 0 && C === void 0 && p === "pending") {
      let F;
      i != null && i.isPlaceholderData && r.placeholderData === (a == null ? void 0 : a.placeholderData) ? (F = i.data, m = !0) : F = typeof r.placeholderData == "function" ? r.placeholderData(
        (I = L(this, br)) == null ? void 0 : I.state.data,
        L(this, br)
      ) : r.placeholderData, F !== void 0 && (p = "success", C = C1(
        i == null ? void 0 : i.data,
        F,
        r
      ), b = !0);
    }
    if (r.select && C !== void 0 && !m)
      if (i && C === (s == null ? void 0 : s.data) && r.select === L(this, Wr))
        C = L(this, vr);
      else
        try {
          Q(this, Wr, r.select), C = r.select(C), C = C1(i == null ? void 0 : i.data, C, r), Q(this, vr, C), Q(this, Dt, null);
        } catch (F) {
          Q(this, Dt, F);
        }
    L(this, Dt) && (l = L(this, Dt), C = L(this, vr), g = Date.now(), p = "error");
    const v = f.fetchStatus === "fetching", S = p === "pending", x = p === "error", A = S && v, N = C !== void 0, q = {
      status: p,
      fetchStatus: f.fetchStatus,
      isPending: S,
      isSuccess: p === "success",
      isError: x,
      isInitialLoading: A,
      isLoading: A,
      data: C,
      dataUpdatedAt: f.dataUpdatedAt,
      error: l,
      errorUpdatedAt: g,
      failureCount: f.fetchFailureCount,
      failureReason: f.fetchFailureReason,
      errorUpdateCount: f.errorUpdateCount,
      isFetched: f.dataUpdateCount > 0 || f.errorUpdateCount > 0,
      isFetchedAfterMount: f.dataUpdateCount > d.dataUpdateCount || f.errorUpdateCount > d.errorUpdateCount,
      isFetching: v,
      isRefetching: v && !S,
      isLoadingError: x && !N,
      isPaused: f.fetchStatus === "paused",
      isPlaceholderData: b,
      isRefetchError: x && N,
      isStale: qi(t, r),
      refetch: this.refetch,
      promise: L(this, wt),
      isEnabled: st(r.enabled, t) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const F = (Y) => {
        q.status === "error" ? Y.reject(q.error) : q.data !== void 0 && Y.resolve(q.data);
      }, V = () => {
        const Y = Q(this, wt, q.promise = v1());
        F(Y);
      }, k = L(this, wt);
      switch (k.status) {
        case "pending":
          t.queryHash === n.queryHash && F(k);
          break;
        case "fulfilled":
          (q.status === "error" || q.data !== k.value) && V();
          break;
        case "rejected":
          (q.status !== "error" || q.error !== k.reason) && V();
          break;
      }
    }
    return q;
  }
  updateResult() {
    const t = L(this, Ue), r = this.createResult(L(this, ie), this.options);
    if (Q(this, rr, L(this, ie).state), Q(this, Cr, this.options), L(this, rr).data !== void 0 && Q(this, br, L(this, ie)), $n(r, t))
      return;
    Q(this, Ue, r);
    const n = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: o } = this.options, i = typeof o == "function" ? o() : o;
      if (i === "all" || !i && !L(this, wr).size)
        return !0;
      const s = new Set(
        i ?? L(this, wr)
      );
      return this.options.throwOnError && s.add("error"), Object.keys(L(this, Ue)).some((a) => {
        const u = a;
        return L(this, Ue)[u] !== t[u] && s.has(u);
      });
    };
    Ce(this, de, sa).call(this, { listeners: n() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Ce(this, de, hi).call(this);
  }
}, ze = new WeakMap(), ie = new WeakMap(), Zr = new WeakMap(), Ue = new WeakMap(), rr = new WeakMap(), Cr = new WeakMap(), wt = new WeakMap(), Dt = new WeakMap(), Wr = new WeakMap(), vr = new WeakMap(), br = new WeakMap(), nr = new WeakMap(), or = new WeakMap(), Ht = new WeakMap(), wr = new WeakMap(), de = new WeakSet(), Br = function(t) {
  Ce(this, de, gi).call(this);
  let r = L(this, ie).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (r = r.catch(Fn)), r;
}, fi = function() {
  Ce(this, de, yi).call(this);
  const t = Vr(
    this.options.staleTime,
    L(this, ie)
  );
  if (zr || L(this, Ue).isStale || !h1(t))
    return;
  const n = wc(L(this, Ue).dataUpdatedAt, t) + 1;
  Q(this, nr, Sn.setTimeout(() => {
    L(this, Ue).isStale || this.updateResult();
  }, n));
}, di = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(L(this, ie)) : this.options.refetchInterval) ?? !1;
}, pi = function(t) {
  Ce(this, de, mi).call(this), Q(this, Ht, t), !(zr || st(this.options.enabled, L(this, ie)) === !1 || !h1(L(this, Ht)) || L(this, Ht) === 0) && Q(this, or, Sn.setInterval(() => {
    (this.options.refetchIntervalInBackground || xc.isFocused()) && Ce(this, de, Br).call(this);
  }, L(this, Ht)));
}, hi = function() {
  Ce(this, de, fi).call(this), Ce(this, de, pi).call(this, Ce(this, de, di).call(this));
}, yi = function() {
  L(this, nr) && (Sn.clearTimeout(L(this, nr)), Q(this, nr, void 0));
}, mi = function() {
  L(this, or) && (Sn.clearInterval(L(this, or)), Q(this, or, void 0));
}, gi = function() {
  const t = L(this, ze).getQueryCache().build(L(this, ze), this.options);
  if (t === L(this, ie))
    return;
  const r = L(this, ie);
  Q(this, ie, t), Q(this, Zr, t.state), this.hasListeners() && (r == null || r.removeObserver(this), t.addObserver(this));
}, sa = function(t) {
  Bn.batch(() => {
    t.listeners && this.listeners.forEach((r) => {
      r(L(this, Ue));
    }), L(this, ze).getQueryCache().notify({
      query: L(this, ie),
      type: "observerResultsUpdated"
    });
  });
}, ta);
function _c(e, t) {
  return st(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function b1(e, t) {
  return _c(e, t) || e.state.data !== void 0 && Ci(e, t, t.refetchOnMount);
}
function Ci(e, t, r) {
  if (st(t.enabled, e) !== !1 && Vr(t.staleTime, e) !== "static") {
    const n = typeof r == "function" ? r(e) : r;
    return n === "always" || n !== !1 && qi(e, t);
  }
  return !1;
}
function w1(e, t, r, n) {
  return (e !== t || st(n.enabled, e) === !1) && (!r.suspense || e.state.status !== "error") && qi(e, r);
}
function qi(e, t) {
  return st(t.enabled, e) !== !1 && e.isStaleByTime(Vr(t.staleTime, e));
}
function Nc(e, t) {
  return !$n(e.getCurrentResult(), t);
}
function Fc() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var St, Bt, Ge, Et, xt, On, vi, ra, $c = (ra = class extends Hn {
  constructor(r, n) {
    super();
    fe(this, xt);
    fe(this, St);
    fe(this, Bt);
    fe(this, Ge);
    fe(this, Et);
    Q(this, St, r), this.setOptions(n), this.bindMethods(), Ce(this, xt, On).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(r) {
    var o;
    const n = this.options;
    this.options = L(this, St).defaultMutationOptions(r), $n(this.options, n) || L(this, St).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: L(this, Ge),
      observer: this
    }), n != null && n.mutationKey && this.options.mutationKey && y1(n.mutationKey) !== y1(this.options.mutationKey) ? this.reset() : ((o = L(this, Ge)) == null ? void 0 : o.state.status) === "pending" && L(this, Ge).setOptions(this.options);
  }
  onUnsubscribe() {
    var r;
    this.hasListeners() || (r = L(this, Ge)) == null || r.removeObserver(this);
  }
  onMutationUpdate(r) {
    Ce(this, xt, On).call(this), Ce(this, xt, vi).call(this, r);
  }
  getCurrentResult() {
    return L(this, Bt);
  }
  reset() {
    var r;
    (r = L(this, Ge)) == null || r.removeObserver(this), Q(this, Ge, void 0), Ce(this, xt, On).call(this), Ce(this, xt, vi).call(this);
  }
  mutate(r, n) {
    var o;
    return Q(this, Et, n), (o = L(this, Ge)) == null || o.removeObserver(this), Q(this, Ge, L(this, St).getMutationCache().build(L(this, St), this.options)), L(this, Ge).addObserver(this), L(this, Ge).execute(r);
  }
}, St = new WeakMap(), Bt = new WeakMap(), Ge = new WeakMap(), Et = new WeakMap(), xt = new WeakSet(), On = function() {
  var n;
  const r = ((n = L(this, Ge)) == null ? void 0 : n.state) ?? Fc();
  Q(this, Bt, {
    ...r,
    isPending: r.status === "pending",
    isSuccess: r.status === "success",
    isError: r.status === "error",
    isIdle: r.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, vi = function(r) {
  Bn.batch(() => {
    var n, o, i, s, a, u, d, h;
    if (L(this, Et) && this.hasListeners()) {
      const f = L(this, Bt).variables, b = L(this, Bt).context, C = {
        client: L(this, St),
        meta: this.options.meta,
        mutationKey: this.options.mutationKey
      };
      (r == null ? void 0 : r.type) === "success" ? ((o = (n = L(this, Et)).onSuccess) == null || o.call(
        n,
        r.data,
        f,
        b,
        C
      ), (s = (i = L(this, Et)).onSettled) == null || s.call(
        i,
        r.data,
        null,
        f,
        b,
        C
      )) : (r == null ? void 0 : r.type) === "error" && ((u = (a = L(this, Et)).onError) == null || u.call(
        a,
        r.error,
        f,
        b,
        C
      ), (h = (d = L(this, Et)).onSettled) == null || h.call(
        d,
        void 0,
        r.error,
        f,
        b,
        C
      ));
    }
    this.listeners.forEach((f) => {
      f(L(this, Bt));
    });
  });
}, ra), Ic = De.createContext(
  void 0
), ki = (e) => {
  const t = De.useContext(Ic);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, aa = De.createContext(!1), qc = () => De.useContext(aa);
aa.Provider;
function kc() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var Dc = De.createContext(kc()), Hc = () => De.useContext(Dc), Bc = (e, t) => {
  (e.suspense || e.throwOnError || e.experimental_prefetchInRender) && (t.isReset() || (e.retryOnMount = !1));
}, Uc = (e) => {
  De.useEffect(() => {
    e.clearReset();
  }, [e]);
}, Vc = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: r,
  query: n,
  suspense: o
}) => e.isError && !t.isReset() && !e.isFetching && n && (o && e.data === void 0 || ia(r, [e.error, n])), jc = (e) => {
  if (e.suspense) {
    const r = (o) => o === "static" ? o : Math.max(o ?? 1e3, 1e3), n = e.staleTime;
    e.staleTime = typeof n == "function" ? (...o) => r(n(...o)) : r(n), typeof e.gcTime == "number" && (e.gcTime = Math.max(
      e.gcTime,
      1e3
    ));
  }
}, Kc = (e, t) => e.isLoading && e.isFetching && !t, zc = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, S1 = (e, t, r) => t.fetchOptimistic(e).catch(() => {
  r.clearReset();
});
function Gc(e, t, r) {
  var f, b, C, l, g;
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const n = qc(), o = Hc(), i = ki(), s = i.defaultQueryOptions(e);
  (b = (f = i.getDefaultOptions().queries) == null ? void 0 : f._experimental_beforeQuery) == null || b.call(
    f,
    s
  ), process.env.NODE_ENV !== "production" && (s.queryFn || console.error(
    `[${s.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
  )), s._optimisticResults = n ? "isRestoring" : "optimistic", jc(s), Bc(s, o), Uc(o);
  const a = !i.getQueryCache().get(s.queryHash), [u] = De.useState(
    () => new t(
      i,
      s
    )
  ), d = u.getOptimisticResult(s), h = !n && e.subscribed !== !1;
  if (De.useSyncExternalStore(
    De.useCallback(
      (p) => {
        const m = h ? u.subscribe(Bn.batchCalls(p)) : Fn;
        return u.updateResult(), m;
      },
      [u, h]
    ),
    () => u.getCurrentResult(),
    () => u.getCurrentResult()
  ), De.useEffect(() => {
    u.setOptions(s);
  }, [s, u]), zc(s, d))
    throw S1(s, u, o);
  if (Vc({
    result: d,
    errorResetBoundary: o,
    throwOnError: s.throwOnError,
    query: i.getQueryCache().get(s.queryHash),
    suspense: s.suspense
  }))
    throw d.error;
  if ((l = (C = i.getDefaultOptions().queries) == null ? void 0 : C._experimental_afterQuery) == null || l.call(
    C,
    s,
    d
  ), s.experimental_prefetchInRender && !zr && Kc(d, n)) {
    const p = a ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      S1(s, u, o)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (g = i.getQueryCache().get(s.queryHash)) == null ? void 0 : g.promise
    );
    p == null || p.catch(Fn).finally(() => {
      u.updateResult();
    });
  }
  return s.notifyOnChangeProps ? d : u.trackResult(d);
}
function Zc(e, t) {
  return Gc(e, Mc);
}
function E1(e, t) {
  const r = ki(), [n] = De.useState(
    () => new $c(
      r,
      e
    )
  );
  De.useEffect(() => {
    n.setOptions(e);
  }, [n, e]);
  const o = De.useSyncExternalStore(
    De.useCallback(
      (s) => n.subscribe(Bn.batchCalls(s)),
      [n]
    ),
    () => n.getCurrentResult(),
    () => n.getCurrentResult()
  ), i = De.useCallback(
    (s, a) => {
      n.mutate(s, a).catch(Fn);
    },
    [n]
  );
  if (o.error && ia(n.options.throwOnError, [o.error]))
    throw o.error;
  return { ...o, mutate: i, mutateAsync: o.mutate };
}
function ca(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Wc } = Object.prototype, { getPrototypeOf: Di } = Object, { iterator: Un, toStringTag: la } = Symbol, Vn = /* @__PURE__ */ ((e) => (t) => {
  const r = Wc.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ct = (e) => (e = e.toLowerCase(), (t) => Vn(t) === e), jn = (e) => (t) => typeof t === e, { isArray: Er } = Array, Sr = jn("undefined");
function Xr(e) {
  return e !== null && !Sr(e) && e.constructor !== null && !Sr(e.constructor) && Ze(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ua = ct("ArrayBuffer");
function Qc(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && ua(e.buffer), t;
}
const Jc = jn("string"), Ze = jn("function"), fa = jn("number"), en = (e) => e !== null && typeof e == "object", Yc = (e) => e === !0 || e === !1, Pn = (e) => {
  if (Vn(e) !== "object")
    return !1;
  const t = Di(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(la in e) && !(Un in e);
}, Xc = (e) => {
  if (!en(e) || Xr(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, el = ct("Date"), tl = ct("File"), rl = ct("Blob"), nl = ct("FileList"), ol = (e) => en(e) && Ze(e.pipe), il = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ze(e.append) && ((t = Vn(e)) === "formdata" || // detect form-data instance
  t === "object" && Ze(e.toString) && e.toString() === "[object FormData]"));
}, sl = ct("URLSearchParams"), [al, cl, ll, ul] = ["ReadableStream", "Request", "Response", "Headers"].map(ct), fl = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function tn(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), Er(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    if (Xr(e))
      return;
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let a;
    for (n = 0; n < s; n++)
      a = i[n], t.call(null, e[a], a, e);
  }
}
function da(e, t) {
  if (Xr(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const Yt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, pa = (e) => !Sr(e) && e !== Yt;
function bi() {
  const { caseless: e, skipUndefined: t } = pa(this) && this || {}, r = {}, n = (o, i) => {
    const s = e && da(r, i) || i;
    Pn(r[s]) && Pn(o) ? r[s] = bi(r[s], o) : Pn(o) ? r[s] = bi({}, o) : Er(o) ? r[s] = o.slice() : (!t || !Sr(o)) && (r[s] = o);
  };
  for (let o = 0, i = arguments.length; o < i; o++)
    arguments[o] && tn(arguments[o], n);
  return r;
}
const dl = (e, t, r, { allOwnKeys: n } = {}) => (tn(t, (o, i) => {
  r && Ze(o) ? e[i] = ca(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), pl = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), hl = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, yl = (e, t, r, n) => {
  let o, i, s;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!n || n(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = r !== !1 && Di(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, ml = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, gl = (e) => {
  if (!e) return null;
  if (Er(e)) return e;
  let t = e.length;
  if (!fa(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Cl = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Di(Uint8Array)), vl = (e, t) => {
  const n = (e && e[Un]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, bl = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, wl = ct("HTMLFormElement"), Sl = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), x1 = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), El = ct("RegExp"), ha = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  tn(r, (o, i) => {
    let s;
    (s = t(o, i, e)) !== !1 && (n[i] = s || o);
  }), Object.defineProperties(e, n);
}, xl = (e) => {
  ha(e, (t, r) => {
    if (Ze(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (Ze(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Rl = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return Er(e) ? n(e) : n(String(e).split(t)), r;
}, Ol = () => {
}, Pl = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Al(e) {
  return !!(e && Ze(e.append) && e[la] === "FormData" && e[Un]);
}
const Ll = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (en(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (Xr(n))
        return n;
      if (!("toJSON" in n)) {
        t[o] = n;
        const i = Er(n) ? [] : {};
        return tn(n, (s, a) => {
          const u = r(s, o + 1);
          !Sr(u) && (i[a] = u);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, Tl = ct("AsyncFunction"), Ml = (e) => e && (en(e) || Ze(e)) && Ze(e.then) && Ze(e.catch), ya = ((e, t) => e ? setImmediate : t ? ((r, n) => (Yt.addEventListener("message", ({ source: o, data: i }) => {
  o === Yt && i === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), Yt.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Ze(Yt.postMessage)
), _l = typeof queueMicrotask < "u" ? queueMicrotask.bind(Yt) : typeof process < "u" && process.nextTick || ya, Nl = (e) => e != null && Ze(e[Un]), O = {
  isArray: Er,
  isArrayBuffer: ua,
  isBuffer: Xr,
  isFormData: il,
  isArrayBufferView: Qc,
  isString: Jc,
  isNumber: fa,
  isBoolean: Yc,
  isObject: en,
  isPlainObject: Pn,
  isEmptyObject: Xc,
  isReadableStream: al,
  isRequest: cl,
  isResponse: ll,
  isHeaders: ul,
  isUndefined: Sr,
  isDate: el,
  isFile: tl,
  isBlob: rl,
  isRegExp: El,
  isFunction: Ze,
  isStream: ol,
  isURLSearchParams: sl,
  isTypedArray: Cl,
  isFileList: nl,
  forEach: tn,
  merge: bi,
  extend: dl,
  trim: fl,
  stripBOM: pl,
  inherits: hl,
  toFlatObject: yl,
  kindOf: Vn,
  kindOfTest: ct,
  endsWith: ml,
  toArray: gl,
  forEachEntry: vl,
  matchAll: bl,
  isHTMLForm: wl,
  hasOwnProperty: x1,
  hasOwnProp: x1,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ha,
  freezeMethods: xl,
  toObjectSet: Rl,
  toCamelCase: Sl,
  noop: Ol,
  toFiniteNumber: Pl,
  findKey: da,
  global: Yt,
  isContextDefined: pa,
  isSpecCompliantForm: Al,
  toJSONObject: Ll,
  isAsyncFn: Tl,
  isThenable: Ml,
  setImmediate: ya,
  asap: _l,
  isIterable: Nl
};
function J(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
O.inherits(J, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: O.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const ma = J.prototype, ga = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ga[e] = { value: e };
});
Object.defineProperties(J, ga);
Object.defineProperty(ma, "isAxiosError", { value: !0 });
J.from = (e, t, r, n, o, i) => {
  const s = Object.create(ma);
  O.toFlatObject(e, s, function(h) {
    return h !== Error.prototype;
  }, (d) => d !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", u = t == null && e ? e.code : t;
  return J.call(s, a, u, r, n, o), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", i && Object.assign(s, i), s;
};
const Fl = null;
function wi(e) {
  return O.isPlainObject(e) || O.isArray(e);
}
function Ca(e) {
  return O.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function R1(e, t, r) {
  return e ? e.concat(t).map(function(o, i) {
    return o = Ca(o), !r && i ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function $l(e) {
  return O.isArray(e) && !e.some(wi);
}
const Il = O.toFlatObject(O, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Kn(e, t, r) {
  if (!O.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = O.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, p) {
    return !O.isUndefined(p[g]);
  });
  const n = r.metaTokens, o = r.visitor || h, i = r.dots, s = r.indexes, u = (r.Blob || typeof Blob < "u" && Blob) && O.isSpecCompliantForm(t);
  if (!O.isFunction(o))
    throw new TypeError("visitor must be a function");
  function d(l) {
    if (l === null) return "";
    if (O.isDate(l))
      return l.toISOString();
    if (O.isBoolean(l))
      return l.toString();
    if (!u && O.isBlob(l))
      throw new J("Blob is not supported. Use a Buffer instead.");
    return O.isArrayBuffer(l) || O.isTypedArray(l) ? u && typeof Blob == "function" ? new Blob([l]) : Buffer.from(l) : l;
  }
  function h(l, g, p) {
    let m = l;
    if (l && !p && typeof l == "object") {
      if (O.endsWith(g, "{}"))
        g = n ? g : g.slice(0, -2), l = JSON.stringify(l);
      else if (O.isArray(l) && $l(l) || (O.isFileList(l) || O.endsWith(g, "[]")) && (m = O.toArray(l)))
        return g = Ca(g), m.forEach(function(S, x) {
          !(O.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? R1([g], x, i) : s === null ? g : g + "[]",
            d(S)
          );
        }), !1;
    }
    return wi(l) ? !0 : (t.append(R1(p, g, i), d(l)), !1);
  }
  const f = [], b = Object.assign(Il, {
    defaultVisitor: h,
    convertValue: d,
    isVisitable: wi
  });
  function C(l, g) {
    if (!O.isUndefined(l)) {
      if (f.indexOf(l) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      f.push(l), O.forEach(l, function(m, v) {
        (!(O.isUndefined(m) || m === null) && o.call(
          t,
          m,
          O.isString(v) ? v.trim() : v,
          g,
          b
        )) === !0 && C(m, g ? g.concat(v) : [v]);
      }), f.pop();
    }
  }
  if (!O.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), t;
}
function O1(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Hi(e, t) {
  this._pairs = [], e && Kn(e, this, t);
}
const va = Hi.prototype;
va.append = function(t, r) {
  this._pairs.push([t, r]);
};
va.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, O1);
  } : O1;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function ql(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function ba(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || ql;
  O.isFunction(r) && (r = {
    serialize: r
  });
  const o = r && r.serialize;
  let i;
  if (o ? i = o(t, r) : i = O.isURLSearchParams(t) ? t.toString() : new Hi(t, r).toString(n), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class P1 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    O.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const wa = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, kl = typeof URLSearchParams < "u" ? URLSearchParams : Hi, Dl = typeof FormData < "u" ? FormData : null, Hl = typeof Blob < "u" ? Blob : null, Bl = {
  isBrowser: !0,
  classes: {
    URLSearchParams: kl,
    FormData: Dl,
    Blob: Hl
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Bi = typeof window < "u" && typeof document < "u", Si = typeof navigator == "object" && navigator || void 0, Ul = Bi && (!Si || ["ReactNative", "NativeScript", "NS"].indexOf(Si.product) < 0), Vl = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", jl = Bi && window.location.href || "http://localhost", Kl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Bi,
  hasStandardBrowserEnv: Ul,
  hasStandardBrowserWebWorkerEnv: Vl,
  navigator: Si,
  origin: jl
}, Symbol.toStringTag, { value: "Module" })), He = {
  ...Kl,
  ...Bl
};
function zl(e, t) {
  return Kn(e, new He.classes.URLSearchParams(), {
    visitor: function(r, n, o, i) {
      return He.isNode && O.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function Gl(e) {
  return O.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Zl(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function Sa(e) {
  function t(r, n, o, i) {
    let s = r[i++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), u = i >= r.length;
    return s = !s && O.isArray(o) ? o.length : s, u ? (O.hasOwnProp(o, s) ? o[s] = [o[s], n] : o[s] = n, !a) : ((!o[s] || !O.isObject(o[s])) && (o[s] = []), t(r, n, o[s], i) && O.isArray(o[s]) && (o[s] = Zl(o[s])), !a);
  }
  if (O.isFormData(e) && O.isFunction(e.entries)) {
    const r = {};
    return O.forEachEntry(e, (n, o) => {
      t(Gl(n), o, r, 0);
    }), r;
  }
  return null;
}
function Wl(e, t, r) {
  if (O.isString(e))
    try {
      return (t || JSON.parse)(e), O.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const rn = {
  transitional: wa,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, i = O.isObject(t);
    if (i && O.isHTMLForm(t) && (t = new FormData(t)), O.isFormData(t))
      return o ? JSON.stringify(Sa(t)) : t;
    if (O.isArrayBuffer(t) || O.isBuffer(t) || O.isStream(t) || O.isFile(t) || O.isBlob(t) || O.isReadableStream(t))
      return t;
    if (O.isArrayBufferView(t))
      return t.buffer;
    if (O.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return zl(t, this.formSerializer).toString();
      if ((a = O.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return Kn(
          a ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return i || o ? (r.setContentType("application/json", !1), Wl(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || rn.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (O.isResponse(t) || O.isReadableStream(t))
      return t;
    if (t && O.isString(t) && (n && !this.responseType || o)) {
      const s = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? J.from(a, J.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: He.classes.FormData,
    Blob: He.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
O.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  rn.headers[e] = {};
});
const Ql = O.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Jl = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), r = s.substring(0, o).trim().toLowerCase(), n = s.substring(o + 1).trim(), !(!r || t[r] && Ql[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, A1 = Symbol("internals");
function qr(e) {
  return e && String(e).trim().toLowerCase();
}
function An(e) {
  return e === !1 || e == null ? e : O.isArray(e) ? e.map(An) : String(e);
}
function Yl(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Xl = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ao(e, t, r, n, o) {
  if (O.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!O.isString(t)) {
    if (O.isString(n))
      return t.indexOf(n) !== -1;
    if (O.isRegExp(n))
      return n.test(t);
  }
}
function eu(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function tu(e, t) {
  const r = O.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, i, s) {
        return this[n].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
let We = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function i(a, u, d) {
      const h = qr(u);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const f = O.findKey(o, h);
      (!f || o[f] === void 0 || d === !0 || d === void 0 && o[f] !== !1) && (o[f || u] = An(a));
    }
    const s = (a, u) => O.forEach(a, (d, h) => i(d, h, u));
    if (O.isPlainObject(t) || t instanceof this.constructor)
      s(t, r);
    else if (O.isString(t) && (t = t.trim()) && !Xl(t))
      s(Jl(t), r);
    else if (O.isObject(t) && O.isIterable(t)) {
      let a = {}, u, d;
      for (const h of t) {
        if (!O.isArray(h))
          throw TypeError("Object iterator must return a key-value pair");
        a[d = h[0]] = (u = a[d]) ? O.isArray(u) ? [...u, h[1]] : [u, h[1]] : h[1];
      }
      s(a, r);
    } else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = qr(t), t) {
      const n = O.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return Yl(o);
        if (O.isFunction(r))
          return r.call(this, o, n);
        if (O.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = qr(t), t) {
      const n = O.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || ao(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function i(s) {
      if (s = qr(s), s) {
        const a = O.findKey(n, s);
        a && (!r || ao(n, n[a], a, r)) && (delete n[a], o = !0);
      }
    }
    return O.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || ao(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return O.forEach(this, (o, i) => {
      const s = O.findKey(n, i);
      if (s) {
        r[s] = An(o), delete r[i];
        return;
      }
      const a = t ? eu(i) : String(i).trim();
      a !== i && delete r[i], r[a] = An(o), n[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return O.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && O.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[A1] = this[A1] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(s) {
      const a = qr(s);
      n[a] || (tu(o, s), n[a] = !0);
    }
    return O.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
We.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
O.reduceDescriptors(We.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
O.freezeMethods(We);
function co(e, t) {
  const r = this || rn, n = t || r, o = We.from(n.headers);
  let i = n.data;
  return O.forEach(e, function(a) {
    i = a.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Ea(e) {
  return !!(e && e.__CANCEL__);
}
function xr(e, t, r) {
  J.call(this, e ?? "canceled", J.ERR_CANCELED, t, r), this.name = "CanceledError";
}
O.inherits(xr, J, {
  __CANCEL__: !0
});
function xa(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new J(
    "Request failed with status code " + r.status,
    [J.ERR_BAD_REQUEST, J.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function ru(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function nu(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const d = Date.now(), h = n[i];
    s || (s = d), r[o] = u, n[o] = d;
    let f = i, b = 0;
    for (; f !== o; )
      b += r[f++], f = f % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), d - s < t)
      return;
    const C = h && d - h;
    return C ? Math.round(b * 1e3 / C) : void 0;
  };
}
function ou(e, t) {
  let r = 0, n = 1e3 / t, o, i;
  const s = (d, h = Date.now()) => {
    r = h, o = null, i && (clearTimeout(i), i = null), e(...d);
  };
  return [(...d) => {
    const h = Date.now(), f = h - r;
    f >= n ? s(d, h) : (o = d, i || (i = setTimeout(() => {
      i = null, s(o);
    }, n - f)));
  }, () => o && s(o)];
}
const In = (e, t, r = 3) => {
  let n = 0;
  const o = nu(50, 250);
  return ou((i) => {
    const s = i.loaded, a = i.lengthComputable ? i.total : void 0, u = s - n, d = o(u), h = s <= a;
    n = s;
    const f = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: u,
      rate: d || void 0,
      estimated: d && a && h ? (a - s) / d : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, L1 = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, T1 = (e) => (...t) => O.asap(() => e(...t)), iu = He.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, He.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(He.origin),
  He.navigator && /(msie|trident)/i.test(He.navigator.userAgent)
) : () => !0, su = He.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      O.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), O.isString(n) && s.push("path=" + n), O.isString(o) && s.push("domain=" + o), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function au(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cu(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ra(e, t, r) {
  let n = !au(t);
  return e && (n || r == !1) ? cu(e, t) : t;
}
const M1 = (e) => e instanceof We ? { ...e } : e;
function sr(e, t) {
  t = t || {};
  const r = {};
  function n(d, h, f, b) {
    return O.isPlainObject(d) && O.isPlainObject(h) ? O.merge.call({ caseless: b }, d, h) : O.isPlainObject(h) ? O.merge({}, h) : O.isArray(h) ? h.slice() : h;
  }
  function o(d, h, f, b) {
    if (O.isUndefined(h)) {
      if (!O.isUndefined(d))
        return n(void 0, d, f, b);
    } else return n(d, h, f, b);
  }
  function i(d, h) {
    if (!O.isUndefined(h))
      return n(void 0, h);
  }
  function s(d, h) {
    if (O.isUndefined(h)) {
      if (!O.isUndefined(d))
        return n(void 0, d);
    } else return n(void 0, h);
  }
  function a(d, h, f) {
    if (f in t)
      return n(d, h);
    if (f in e)
      return n(void 0, d);
  }
  const u = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (d, h, f) => o(M1(d), M1(h), f, !0)
  };
  return O.forEach(Object.keys({ ...e, ...t }), function(h) {
    const f = u[h] || o, b = f(e[h], t[h], h);
    O.isUndefined(b) && f !== a || (r[h] = b);
  }), r;
}
const Oa = (e) => {
  const t = sr({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: s, auth: a } = t;
  if (t.headers = s = We.from(s), t.url = ba(Ra(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  ), O.isFormData(r)) {
    if (He.hasStandardBrowserEnv || He.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (O.isFunction(r.getHeaders)) {
      const u = r.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(u).forEach(([h, f]) => {
        d.includes(h.toLowerCase()) && s.set(h, f);
      });
    }
  }
  if (He.hasStandardBrowserEnv && (n && O.isFunction(n) && (n = n(t)), n || n !== !1 && iu(t.url))) {
    const u = o && i && su.read(i);
    u && s.set(o, u);
  }
  return t;
}, lu = typeof XMLHttpRequest < "u", uu = lu && function(e) {
  return new Promise(function(r, n) {
    const o = Oa(e);
    let i = o.data;
    const s = We.from(o.headers).normalize();
    let { responseType: a, onUploadProgress: u, onDownloadProgress: d } = o, h, f, b, C, l;
    function g() {
      C && C(), l && l(), o.cancelToken && o.cancelToken.unsubscribe(h), o.signal && o.signal.removeEventListener("abort", h);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function m() {
      if (!p)
        return;
      const S = We.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), A = {
        data: !a || a === "text" || a === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: S,
        config: e,
        request: p
      };
      xa(function($) {
        r($), g();
      }, function($) {
        n($), g();
      }, A), p = null;
    }
    "onloadend" in p ? p.onloadend = m : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(m);
    }, p.onabort = function() {
      p && (n(new J("Request aborted", J.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function(x) {
      const A = x && x.message ? x.message : "Network Error", N = new J(A, J.ERR_NETWORK, e, p);
      N.event = x || null, n(N), p = null;
    }, p.ontimeout = function() {
      let x = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const A = o.transitional || wa;
      o.timeoutErrorMessage && (x = o.timeoutErrorMessage), n(new J(
        x,
        A.clarifyTimeoutError ? J.ETIMEDOUT : J.ECONNABORTED,
        e,
        p
      )), p = null;
    }, i === void 0 && s.setContentType(null), "setRequestHeader" in p && O.forEach(s.toJSON(), function(x, A) {
      p.setRequestHeader(A, x);
    }), O.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), a && a !== "json" && (p.responseType = o.responseType), d && ([b, l] = In(d, !0), p.addEventListener("progress", b)), u && p.upload && ([f, C] = In(u), p.upload.addEventListener("progress", f), p.upload.addEventListener("loadend", C)), (o.cancelToken || o.signal) && (h = (S) => {
      p && (n(!S || S.type ? new xr(null, e, p) : S), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(h), o.signal && (o.signal.aborted ? h() : o.signal.addEventListener("abort", h)));
    const v = ru(o.url);
    if (v && He.protocols.indexOf(v) === -1) {
      n(new J("Unsupported protocol " + v + ":", J.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(i || null);
  });
}, fu = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const i = function(d) {
      if (!o) {
        o = !0, a();
        const h = d instanceof Error ? d : this.reason;
        n.abort(h instanceof J ? h : new xr(h instanceof Error ? h.message : h));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new J(`timeout ${t} of ms exceeded`, J.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(i) : d.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", i));
    const { signal: u } = n;
    return u.unsubscribe = () => O.asap(a), u;
  }
}, du = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, pu = async function* (e, t) {
  for await (const r of hu(e))
    yield* du(r, t);
}, hu = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, _1 = (e, t, r, n) => {
  const o = pu(e, t);
  let i = 0, s, a = (u) => {
    s || (s = !0, n && n(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: d, value: h } = await o.next();
        if (d) {
          a(), u.close();
          return;
        }
        let f = h.byteLength;
        if (r) {
          let b = i += f;
          r(b);
        }
        u.enqueue(new Uint8Array(h));
      } catch (d) {
        throw a(d), d;
      }
    },
    cancel(u) {
      return a(u), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, N1 = 64 * 1024, { isFunction: En } = O, yu = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(O.global), {
  ReadableStream: F1,
  TextEncoder: $1
} = O.global, I1 = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, mu = (e) => {
  e = O.merge.call({
    skipUndefined: !0
  }, yu, e);
  const { fetch: t, Request: r, Response: n } = e, o = t ? En(t) : typeof fetch == "function", i = En(r), s = En(n);
  if (!o)
    return !1;
  const a = o && En(F1), u = o && (typeof $1 == "function" ? /* @__PURE__ */ ((l) => (g) => l.encode(g))(new $1()) : async (l) => new Uint8Array(await new r(l).arrayBuffer())), d = i && a && I1(() => {
    let l = !1;
    const g = new r(He.origin, {
      body: new F1(),
      method: "POST",
      get duplex() {
        return l = !0, "half";
      }
    }).headers.has("Content-Type");
    return l && !g;
  }), h = s && a && I1(() => O.isReadableStream(new n("").body)), f = {
    stream: h && ((l) => l.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((l) => {
    !f[l] && (f[l] = (g, p) => {
      let m = g && g[l];
      if (m)
        return m.call(g);
      throw new J(`Response type '${l}' is not supported`, J.ERR_NOT_SUPPORT, p);
    });
  });
  const b = async (l) => {
    if (l == null)
      return 0;
    if (O.isBlob(l))
      return l.size;
    if (O.isSpecCompliantForm(l))
      return (await new r(He.origin, {
        method: "POST",
        body: l
      }).arrayBuffer()).byteLength;
    if (O.isArrayBufferView(l) || O.isArrayBuffer(l))
      return l.byteLength;
    if (O.isURLSearchParams(l) && (l = l + ""), O.isString(l))
      return (await u(l)).byteLength;
  }, C = async (l, g) => {
    const p = O.toFiniteNumber(l.getContentLength());
    return p ?? b(g);
  };
  return async (l) => {
    let {
      url: g,
      method: p,
      data: m,
      signal: v,
      cancelToken: S,
      timeout: x,
      onDownloadProgress: A,
      onUploadProgress: N,
      responseType: $,
      headers: q,
      withCredentials: I = "same-origin",
      fetchOptions: F
    } = Oa(l), V = t || fetch;
    $ = $ ? ($ + "").toLowerCase() : "text";
    let k = fu([v, S && S.toAbortSignal()], x), Y = null;
    const ne = k && k.unsubscribe && (() => {
      k.unsubscribe();
    });
    let ae;
    try {
      if (N && d && p !== "get" && p !== "head" && (ae = await C(q, m)) !== 0) {
        let z = new r(g, {
          method: "POST",
          body: m,
          duplex: "half"
        }), te;
        if (O.isFormData(m) && (te = z.headers.get("content-type")) && q.setContentType(te), z.body) {
          const [re, pe] = L1(
            ae,
            In(T1(N))
          );
          m = _1(z.body, N1, re, pe);
        }
      }
      O.isString(I) || (I = I ? "include" : "omit");
      const T = i && "credentials" in r.prototype, M = {
        ...F,
        signal: k,
        method: p.toUpperCase(),
        headers: q.normalize().toJSON(),
        body: m,
        duplex: "half",
        credentials: T ? I : void 0
      };
      Y = i && new r(g, M);
      let P = await (i ? V(Y, F) : V(g, M));
      const U = h && ($ === "stream" || $ === "response");
      if (h && (A || U && ne)) {
        const z = {};
        ["status", "statusText", "headers"].forEach((W) => {
          z[W] = P[W];
        });
        const te = O.toFiniteNumber(P.headers.get("content-length")), [re, pe] = A && L1(
          te,
          In(T1(A), !0)
        ) || [];
        P = new n(
          _1(P.body, N1, re, () => {
            pe && pe(), ne && ne();
          }),
          z
        );
      }
      $ = $ || "text";
      let H = await f[O.findKey(f, $) || "text"](P, l);
      return !U && ne && ne(), await new Promise((z, te) => {
        xa(z, te, {
          data: H,
          headers: We.from(P.headers),
          status: P.status,
          statusText: P.statusText,
          config: l,
          request: Y
        });
      });
    } catch (T) {
      throw ne && ne(), T && T.name === "TypeError" && /Load failed|fetch/i.test(T.message) ? Object.assign(
        new J("Network Error", J.ERR_NETWORK, l, Y),
        {
          cause: T.cause || T
        }
      ) : J.from(T, T && T.code, l, Y);
    }
  };
}, gu = /* @__PURE__ */ new Map(), Pa = (e) => {
  let t = e ? e.env : {};
  const { fetch: r, Request: n, Response: o } = t, i = [
    n,
    o,
    r
  ];
  let s = i.length, a = s, u, d, h = gu;
  for (; a--; )
    u = i[a], d = h.get(u), d === void 0 && h.set(u, d = a ? /* @__PURE__ */ new Map() : mu(t)), h = d;
  return d;
};
Pa();
const Ei = {
  http: Fl,
  xhr: uu,
  fetch: {
    get: Pa
  }
};
O.forEach(Ei, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const q1 = (e) => `- ${e}`, Cu = (e) => O.isFunction(e) || e === null || e === !1, Aa = {
  getAdapter: (e, t) => {
    e = O.isArray(e) ? e : [e];
    const { length: r } = e;
    let n, o;
    const i = {};
    for (let s = 0; s < r; s++) {
      n = e[s];
      let a;
      if (o = n, !Cu(n) && (o = Ei[(a = String(n)).toLowerCase()], o === void 0))
        throw new J(`Unknown adapter '${a}'`);
      if (o && (O.isFunction(o) || (o = o.get(t))))
        break;
      i[a || "#" + s] = o;
    }
    if (!o) {
      const s = Object.entries(i).map(
        ([u, d]) => `adapter ${u} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = r ? s.length > 1 ? `since :
` + s.map(q1).join(`
`) : " " + q1(s[0]) : "as no adapter specified";
      throw new J(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Ei
};
function lo(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new xr(null, e);
}
function k1(e) {
  return lo(e), e.headers = We.from(e.headers), e.data = co.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Aa.getAdapter(e.adapter || rn.adapter, e)(e).then(function(n) {
    return lo(e), n.data = co.call(
      e,
      e.transformResponse,
      n
    ), n.headers = We.from(n.headers), n;
  }, function(n) {
    return Ea(n) || (lo(e), n && n.response && (n.response.data = co.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = We.from(n.response.headers))), Promise.reject(n);
  });
}
const La = "1.12.2", zn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  zn[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const D1 = {};
zn.transitional = function(t, r, n) {
  function o(i, s) {
    return "[Axios v" + La + "] Transitional option '" + i + "'" + s + (n ? ". " + n : "");
  }
  return (i, s, a) => {
    if (t === !1)
      throw new J(
        o(s, " has been removed" + (r ? " in " + r : "")),
        J.ERR_DEPRECATED
      );
    return r && !D1[s] && (D1[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, s, a) : !0;
  };
};
zn.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function vu(e, t, r) {
  if (typeof e != "object")
    throw new J("options must be an object", J.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const i = n[o], s = t[i];
    if (s) {
      const a = e[i], u = a === void 0 || s(a, i, e);
      if (u !== !0)
        throw new J("option " + i + " must be " + u, J.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new J("Unknown option " + i, J.ERR_BAD_OPTION);
  }
}
const Ln = {
  assertOptions: vu,
  validators: zn
}, pt = Ln.validators;
let ir = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new P1(),
      response: new P1()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = sr(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: i } = r;
    n !== void 0 && Ln.assertOptions(n, {
      silentJSONParsing: pt.transitional(pt.boolean),
      forcedJSONParsing: pt.transitional(pt.boolean),
      clarifyTimeoutError: pt.transitional(pt.boolean)
    }, !1), o != null && (O.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : Ln.assertOptions(o, {
      encode: pt.function,
      serialize: pt.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ln.assertOptions(r, {
      baseUrl: pt.spelling("baseURL"),
      withXsrfToken: pt.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = i && O.merge(
      i.common,
      i[r.method]
    );
    i && O.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (l) => {
        delete i[l];
      }
    ), r.headers = We.concat(s, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(r) === !1 || (u = u && g.synchronous, a.unshift(g.fulfilled, g.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(g) {
      d.push(g.fulfilled, g.rejected);
    });
    let h, f = 0, b;
    if (!u) {
      const l = [k1.bind(this), void 0];
      for (l.unshift(...a), l.push(...d), b = l.length, h = Promise.resolve(r); f < b; )
        h = h.then(l[f++], l[f++]);
      return h;
    }
    b = a.length;
    let C = r;
    for (; f < b; ) {
      const l = a[f++], g = a[f++];
      try {
        C = l(C);
      } catch (p) {
        g.call(this, p);
        break;
      }
    }
    try {
      h = k1.call(this, C);
    } catch (l) {
      return Promise.reject(l);
    }
    for (f = 0, b = d.length; f < b; )
      h = h.then(d[f++], d[f++]);
    return h;
  }
  getUri(t) {
    t = sr(this.defaults, t);
    const r = Ra(t.baseURL, t.url, t.allowAbsoluteUrls);
    return ba(r, t.params, t.paramsSerializer);
  }
};
O.forEach(["delete", "get", "head", "options"], function(t) {
  ir.prototype[t] = function(r, n) {
    return this.request(sr(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
O.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, s, a) {
      return this.request(sr(a || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  ir.prototype[t] = r(), ir.prototype[t + "Form"] = r(!0);
});
let bu = class Ta {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((a) => {
        n.subscribe(a), i = a;
      }).then(o);
      return s.cancel = function() {
        n.unsubscribe(i);
      }, s;
    }, t(function(i, s, a) {
      n.reason || (n.reason = new xr(i, s, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ta(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
};
function wu(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Su(e) {
  return O.isObject(e) && e.isAxiosError === !0;
}
const xi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(xi).forEach(([e, t]) => {
  xi[t] = e;
});
function Ma(e) {
  const t = new ir(e), r = ca(ir.prototype.request, t);
  return O.extend(r, ir.prototype, t, { allOwnKeys: !0 }), O.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return Ma(sr(e, o));
  }, r;
}
const me = Ma(rn);
me.Axios = ir;
me.CanceledError = xr;
me.CancelToken = bu;
me.isCancel = Ea;
me.VERSION = La;
me.toFormData = Kn;
me.AxiosError = J;
me.Cancel = me.CanceledError;
me.all = function(t) {
  return Promise.all(t);
};
me.spread = wu;
me.isAxiosError = Su;
me.mergeConfig = sr;
me.AxiosHeaders = We;
me.formToJSON = (e) => Sa(O.isHTMLForm(e) ? new FormData(e) : e);
me.getAdapter = Aa.getAdapter;
me.HttpStatusCode = xi;
me.default = me;
const {
  Axios: m6,
  AxiosError: g6,
  CanceledError: C6,
  isCancel: v6,
  CancelToken: b6,
  VERSION: w6,
  all: S6,
  Cancel: E6,
  isAxiosError: x6,
  spread: R6,
  toFormData: O6,
  AxiosHeaders: P6,
  HttpStatusCode: A6,
  formToJSON: L6,
  getAdapter: T6,
  mergeConfig: M6
} = me, fr = () => {
  const e = /* @__PURE__ */ new Date();
  return `${`${e.getHours()}`.padStart(2, "0")}:${`${e.getMinutes()}`.padStart(2, "0")}:${`${e.getSeconds()}`.padStart(2, "0")}.${`${e.getMilliseconds()}`.padStart(3, "0")}`;
}, Eu = (e, t) => ({
  log: (u, d) => {
    console.log(
      `%c${fr()}${e ? ` - ${e}` : null}`,
      "color:#208050;font-weight:400;",
      u
    ), t && d && typeof u == "string" && t(u);
  },
  verbose: (u, d) => {
    console.log(
      `%c${fr()}${e ? ` - ${e}` : null}`,
      "color:#606060;font-weight:400;",
      u
    ), t && d && typeof u == "string" && t(u);
  },
  warn: (u, d) => {
    console.warn(
      `%c${fr()}${e ? ` - ${e}` : null}`,
      "color:#ff8050;font-weight:700;",
      u
    ), console.trace(), t && d && typeof u == "string" && t(u);
  },
  error: (u, d) => {
    console.error(
      `%c${fr()}${e ? ` - ${e}` : null}`,
      "color:#ff0000;font-weight:800;",
      u
    ), console.trace(), t && d && typeof u == "string" && t(u);
  },
  socketSend: (u, d) => {
    console.debug(
      `  %c${fr()} - Websocket %cSEND >> %c${u}`,
      "color:#606060;font-weight:400;",
      "color:#208050;font-weight:700;",
      "color:#606060;font-weight:500;",
      d
    );
  },
  socketReceive: (u, d) => {
    console.debug(
      `  %c${fr()} - Websocket %cRECEIVE << %c${u}`,
      "color:#606060;font-weight:400;",
      "color:#ff0000;font-weight:700;",
      "color:#606060;font-weight:500;",
      d
    );
  }
}), nn = (e, t, r) => {
  const { error: n } = Eu(r ?? "Axios");
  return n(`Error on route: ${e}`), t.response ? (n({ message: "Response error", response: t.response }), `Error: ${t.response.data.message}`) : t.request ? (n(`Request error: ${t.request}`), "The request timed out, if the issue persists please restart Bonza.") : (n(`Client error: ${t.message}`), "There was an problem sending your request.");
}, G = (e, t) => me.get(e).then((n) => n.data).catch((n) => {
  throw Error(nn(e, n, t));
}), le = (e, t, r) => me.post(e, t).then((o) => o.data).catch((o) => {
  throw Error(nn(e, o, r));
}), gt = (e, t, r) => me.put(e, t).then((o) => o.data).catch((o) => {
  throw Error(nn(e, o, r));
}), xu = (e, t, r) => me.patch(e, t).then((o) => o.data).catch((o) => {
  throw Error(nn(e, o, r));
}), Rt = (e, t) => me.delete(e).then((n) => n.data).catch((n) => {
  throw Error(nn(e, n, t));
}), Ru = () => G(route("api.account.index"), "Account"), Ou = () => G(route("api.account.own"), "Account"), Pu = () => G(route("api.account.usage"), "Account"), Au = (e) => G(
  route("api.account.get", { account: e }),
  "Account"
), Lu = (e) => G(
  route("api.account.getWithUsers", { account: e }),
  "Account"
), Tu = (e) => G(route("api.account.plan", { account: e }), "Account"), Mu = (e) => G(
  route("api.account.subscriptions", { account: e }),
  "Account"
).then((t) => t.data), _u = (e) => G(
  route("api.account.activePlans", { account: e }),
  "Account"
).then((t) => t.data), Nu = (e) => G(
  route("api.account.transactions", { account: e }),
  "Account"
), _6 = (e) => G(
  route("api.account.transactions.getInvoiceUrl", { transaction: e }),
  "Account"
), Fu = (e, t) => gt(
  route("api.account.update", { account: e }),
  t,
  "Account"
), $u = ({
  account: e,
  user: t,
  role: r
}) => gt(
  route("api.account.setRole", { account: e, user: t, role: r }),
  void 0,
  "Account"
), Iu = ({ account: e, user: t }) => le(
  route("api.account.kick", { account: e, user: t }),
  void 0,
  "Account"
), N6 = (e, t = !1) => Rt(
  route(
    t ? "api.account.subscription.cancelNow" : "api.account.subscription.cancel",
    { account: e }
  ),
  "Account"
), F6 = (e, t = !1) => Rt(
  route(
    t ? "api.account.subscription.pauseNow" : "api.account.subscription.pause",
    { account: e }
  ),
  "Account"
), $6 = (e) => gt(
  route("api.account.subscription.resume", { account: e }),
  "Account"
), I6 = (e) => gt(
  route("api.account.subscription.uncancel", { account: e }),
  "Account"
), q6 = (e, t) => gt(
  route("api.account.subscription.swap", { account: e }),
  t,
  "Account"
), k6 = (e) => G(
  route("api.account.subscription.getUpdatePaymentUrl", {
    account: e
  }),
  "Account"
), qu = () => G(
  route("api.account.getPlans"),
  "Plans"
).then((e) => e.data), ku = (e, t) => le(
  route("api.account.trial.start", { account: e }),
  { plan_id: t },
  "Account"
), Du = (e) => Rt(
  route("api.account.trial.cancel", { account: e }),
  "Account"
), Hu = (e) => gt(
  route("api.account.trial.confirmCardTrial", { account: e }),
  void 0,
  "Account"
), Bu = (e, t) => le(
  route("api.account.checkout.transaction", { account: e }),
  { price_id: t },
  "Account"
), Z = {
  base: ["account"],
  all: () => [...Z.base, "all"],
  own: () => [...Z.base, "own"],
  usage: () => [...Z.base, "usage"],
  sessionAccess: () => [...Z.base, "session_access"],
  id: (e) => [...Z.base, e],
  withUsers: (e) => [...Z.base, "users", e],
  plan: (e) => [...Z.base, "plan", e],
  kick: (e, t) => [...Z.base, "kick", e, t],
  subscriptions: (e) => [...Z.id(e), "subscriptions"],
  activePlans: (e) => [...Z.id(e), "subscriptions"],
  transactions: (e) => [...Z.id(e), "transactions"],
  availablePlans: () => [...Z.base, "available_plans"]
}, D6 = (e) => ({
  queryKey: Z.all(),
  queryFn: Ru,
  ...e
}), H6 = (e) => ({
  queryKey: Z.own(),
  queryFn: Ou,
  ...e
}), B6 = (e, t) => ({
  queryKey: Z.id(e),
  queryFn: () => Au(e),
  ...t
}), U6 = (e, t) => ({
  queryKey: Z.plan(e),
  queryFn: () => Tu(e),
  ...t
}), V6 = (e, t) => ({
  queryKey: Z.subscriptions(e),
  queryFn: () => Mu(e),
  ...t
}), Uu = (e, t) => ({
  queryKey: Z.activePlans(e),
  queryFn: () => _u(e),
  ...t
}), j6 = (e, t) => ({
  queryKey: Z.withUsers(e),
  queryFn: () => Lu(e),
  ...t
}), K6 = (e, t) => ({
  queryKey: Z.transactions(e),
  queryFn: () => Nu(e),
  ...t
}), z6 = (e) => ({
  queryKey: Z.usage(),
  queryFn: () => Pu(),
  ...e
}), G6 = (e, t) => ({
  mutationFn: (r) => Fu(e, r),
  ...t,
  onSuccess: async (r, n, o, i) => {
    await Promise.all([
      i.client.invalidateQueries({
        queryKey: Z.all()
      }),
      i.client.invalidateQueries({
        queryKey: Z.activePlans(e)
      }),
      i.client.invalidateQueries({
        queryKey: Z.own()
      })
    ]), i.client.setQueryData(
      Z.id(`${r.id}`),
      r
    ), t != null && t.onSuccess && await t.onSuccess(r, n, o, i);
  }
}), Z6 = (e) => ({
  queryKey: Z.availablePlans(),
  queryFn: () => qu(),
  ...e
}), W6 = (e, t) => ({
  mutationFn: (r) => ku(e, r.plan_id),
  ...t,
  onSuccess: async (r, n, o, i) => {
    await Promise.all([
      i.client.invalidateQueries({
        queryKey: Z.all()
      }),
      i.client.invalidateQueries({
        queryKey: Z.own()
      }),
      i.client.invalidateQueries({
        queryKey: Z.activePlans(e)
      })
    ]), i.client.setQueryData(
      Z.id(`${r.id}`),
      r
    ), t != null && t.onSuccess && await t.onSuccess(r, n, o, i);
  }
}), Q6 = (e, t) => ({
  mutationFn: () => Du(e),
  ...t,
  onSuccess: async (r, n, o, i) => {
    await Promise.all([
      i.client.invalidateQueries({
        queryKey: Z.all()
      }),
      i.client.invalidateQueries({
        queryKey: Z.own()
      }),
      i.client.invalidateQueries({
        queryKey: Z.activePlans(e)
      })
    ]), i.client.setQueryData(
      Z.id(`${r.id}`),
      r
    ), t != null && t.onSuccess && await t.onSuccess(r, n, o, i);
  }
}), Vu = (e, t) => ({
  mutationFn: () => Hu(e),
  ...t,
  onSuccess: async (r, n, o, i) => {
    await Promise.all([
      i.client.invalidateQueries({
        queryKey: Z.all()
      }),
      i.client.invalidateQueries({
        queryKey: Z.own()
      }),
      i.client.invalidateQueries({
        queryKey: Z.activePlans(e)
      })
    ]), i.client.setQueryData(
      Z.id(`${r.id}`),
      r
    ), t != null && t.onSuccess && await t.onSuccess(r, n, o, i);
  }
}), ju = (e, t) => ({
  mutationFn: (r) => Bu(e, r.price_id),
  ...t
}), J6 = (e, t) => ({
  mutationFn: () => $u(e),
  ...t,
  onSuccess: async (r, n, o, i) => {
    await Promise.all([
      i.client.invalidateQueries({
        queryKey: Z.all()
      }),
      i.client.invalidateQueries({
        queryKey: [Z.id(`${r.id}`)]
      }),
      i.client.invalidateQueries({
        queryKey: [Z.withUsers(`${r.id}`)]
      })
    ]), t != null && t.onSuccess && await t.onSuccess(r, n, o, i);
  }
}), Y6 = (e) => ({
  mutationFn: Iu,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: Z.all()
      }),
      o.client.invalidateQueries({
        queryKey: [Z.id(`${t.id}`)]
      }),
      o.client.invalidateQueries({
        queryKey: [Z.withUsers(`${t.id}`)]
      })
    ]), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), Ku = () => G(
  route("api.admin.dashboard.index"),
  "Dashboard"
), _a = {
  base: ["dashboard"],
  index: () => [..._a.base, "index"]
}, X6 = (e) => ({
  queryKey: _a.index(),
  queryFn: Ku,
  placeholderData: Yr,
  ...e
}), zu = () => {
  const t = route("api.session.index");
  return G(t, "Sessions");
}, Gu = (e, t) => G(
  route("api.session.connections", { session: e, includeInactive: t }),
  "Session"
), Na = (e) => {
  const r = route("api.session.get", { session: e });
  return G(r, "Sessions");
}, Zu = (e) => {
  const r = route("api.session.create", { addCreator: !0 });
  return le(
    r,
    e,
    "Sessions"
  );
}, Wu = ({
  id: e,
  data: t
}) => {
  const n = route("api.session.update", { session: e });
  return gt(
    n,
    t,
    "Sessions"
  );
}, Qu = (e) => {
  const r = route("api.session.delete", { session: e });
  return Rt(r);
}, Fa = (e) => {
  const r = route("api.session.members", { session: e });
  return G(r);
}, Ju = (e) => {
  const r = route("api.session.invitationsCombined", { session: e });
  return G(r);
}, Yu = ({
  sessionId: e,
  userId: t,
  data: r
}) => {
  const o = route("api.session.invite", { session: e, user: t });
  return le(
    o,
    r,
    "Sessions"
  );
}, Xu = ({
  id: e,
  data: t
}) => {
  const n = route("api.session.inviteMultiple", { session: e });
  return le(n, t, "Sessions");
}, e0 = (e) => {
  const r = route("api.session.accept", { invitation: e });
  return le(
    r,
    void 0,
    "Sessions"
  );
}, t0 = (e) => {
  const r = route("api.session.revoke", { invitation: e });
  return le(
    r,
    void 0,
    "Sessions"
  );
}, r0 = ({
  sessionId: e,
  userId: t
}) => {
  const r = "api.session.leave", n = t ? { user: t } : void 0, o = route(r, { session: e, ...n });
  return le(o, void 0, "Sessions");
}, $a = (e) => {
  const r = route("api.session.query", e);
  return G(
    r,
    "Sessions"
  );
}, Ia = (e) => {
  const r = route("api.admin.session.index", e);
  return G(
    r,
    "Sessions"
  );
}, n0 = () => {
  const t = route("api.group.index");
  return G(t, "Groups");
}, o0 = (e) => {
  const r = route("api.group.get", { group: e });
  return G(r, "Groups");
}, i0 = () => {
  const t = route("api.group.types");
  return G(t, "Groups");
}, s0 = (e) => {
  const r = route("api.group.create", { addCreator: !0 });
  return le(
    r,
    e,
    "Groups"
  );
}, e7 = (e, t) => {
  const n = route("api.group.uploadAvatar", { group: e });
  return gt(
    n,
    t,
    "Groups"
  );
}, a0 = ({ id: e, data: t }) => {
  const n = route("api.group.update", { group: e });
  return gt(
    n,
    t,
    "Groups"
  );
}, c0 = (e) => {
  const r = route("api.group.delete", { group: e });
  return Rt(r);
}, t7 = (e, t) => {
  const r = new FormData();
  r.append("avatar", t);
  const o = route("api.group.uploadAvatar", { group: e });
  return le(
    o,
    r,
    "Groups"
  );
}, r7 = (e) => {
  const r = route("api.group.deleteAvatar", { group: e });
  return Rt(r);
}, l0 = (e) => {
  const r = route("api.group.members", { group: e });
  return console.log("refetching: ", e), G(r, "Groups");
}, u0 = (e) => {
  const r = route("api.group.invitationsCombined", { group: e });
  return G(r, "Groups");
}, f0 = (e) => {
  const r = route("api.group.sessions", { group: e });
  return G(r, "Groups");
}, d0 = ({
  groupId: e,
  userId: t,
  data: r
}) => {
  const o = route("api.group.invite", { group: e, user: t });
  return le(
    o,
    r,
    "Groups"
  );
}, p0 = ({
  id: e,
  data: t
}) => {
  const n = route("api.group.inviteMultiple", { group: e });
  return le(
    n,
    t,
    "Sessions"
  );
}, h0 = (e) => {
  const r = route("api.group.accept", { invitation: e });
  return le(r, void 0, "Groups");
}, y0 = (e) => {
  const r = route("api.group.revoke", { invitation: e });
  return le(
    r,
    void 0,
    "Groups"
  );
}, m0 = ({
  groupId: e,
  userId: t
}) => {
  const r = "api.group.leave", n = t ? { user: t } : void 0, o = route(r, { group: e, ...n });
  return le(o, void 0, "Sessions");
}, g0 = (e) => {
  const r = route("api.group.query", e);
  return G(
    r,
    "Groups"
  );
}, qa = (e) => {
  const r = route("api.admin.group.index", e);
  return G(
    r,
    "Groups"
  );
}, C0 = (e) => {
  const r = route("app.profile.update");
  return xu(
    r,
    e
  );
}, v0 = (e) => {
  const r = route("api.user.search", { search: e });
  return G(r, "User");
}, b0 = () => {
  const t = route("api.user.invitations");
  return G(t, "User");
}, w0 = () => {
  const t = route("api.user.bonza_sessions");
  return G(t, "User");
}, S0 = () => {
  const t = route("api.user.list");
  return G(t, "User");
}, E0 = ({ id: e, data: t }) => {
  const r = new FormData();
  r.append("avatar", t);
  const o = route("api.user.uploadAvatar", { user: e });
  return le(
    o,
    r,
    "User"
  );
}, x0 = (e) => {
  const r = route("api.user.deleteAvatar", { user: e });
  return Rt(r);
}, n7 = (e) => {
  const r = route("api.user.groups", e);
  return G(
    r,
    "Groups"
  );
}, o7 = () => le(
  route("api.user.resendVerificationEmail")
), R0 = (e) => G(route("api.stats.user", { user: e }), "User"), O0 = (e) => {
  const t = route("api.user.calendarToken", e ? { user: e } : void 0);
  return G(t, "User");
}, P0 = () => G(route("api.user.two-factor.status"), "TwoFactor"), A0 = () => le(route("api.user.two-factor.totp.generate"), void 0, "TwoFactor"), L0 = (e) => le(route("api.user.two-factor.totp.enable"), { code: e }, "TwoFactor"), T0 = () => le(route("api.user.two-factor.email.enable"), void 0, "TwoFactor"), M0 = (e) => le(route("api.user.two-factor.disable"), e, "TwoFactor"), _0 = () => G(route("api.user.two-factor.recovery-codes"), "TwoFactor"), N0 = () => le(route("api.user.two-factor.recovery-codes.regenerate"), void 0, "TwoFactor");
var pr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function F0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $0(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var uo, H1;
function I0() {
  if (H1) return uo;
  H1 = 1;
  var e = function(v) {
    return t(v) && !r(v);
  };
  function t(m) {
    return !!m && typeof m == "object";
  }
  function r(m) {
    var v = Object.prototype.toString.call(m);
    return v === "[object RegExp]" || v === "[object Date]" || i(m);
  }
  var n = typeof Symbol == "function" && Symbol.for, o = n ? Symbol.for("react.element") : 60103;
  function i(m) {
    return m.$$typeof === o;
  }
  function s(m) {
    return Array.isArray(m) ? [] : {};
  }
  function a(m, v) {
    return v.clone !== !1 && v.isMergeableObject(m) ? g(s(m), m, v) : m;
  }
  function u(m, v, S) {
    return m.concat(v).map(function(x) {
      return a(x, S);
    });
  }
  function d(m, v) {
    if (!v.customMerge)
      return g;
    var S = v.customMerge(m);
    return typeof S == "function" ? S : g;
  }
  function h(m) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(m).filter(function(v) {
      return Object.propertyIsEnumerable.call(m, v);
    }) : [];
  }
  function f(m) {
    return Object.keys(m).concat(h(m));
  }
  function b(m, v) {
    try {
      return v in m;
    } catch {
      return !1;
    }
  }
  function C(m, v) {
    return b(m, v) && !(Object.hasOwnProperty.call(m, v) && Object.propertyIsEnumerable.call(m, v));
  }
  function l(m, v, S) {
    var x = {};
    return S.isMergeableObject(m) && f(m).forEach(function(A) {
      x[A] = a(m[A], S);
    }), f(v).forEach(function(A) {
      C(m, A) || (b(m, A) && S.isMergeableObject(v[A]) ? x[A] = d(A, S)(m[A], v[A], S) : x[A] = a(v[A], S));
    }), x;
  }
  function g(m, v, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || e, S.cloneUnlessOtherwiseSpecified = a;
    var x = Array.isArray(v), A = Array.isArray(m), N = x === A;
    return N ? x ? S.arrayMerge(m, v, S) : l(m, v, S) : a(v, S);
  }
  g.all = function(v, S) {
    if (!Array.isArray(v))
      throw new Error("first argument should be an array");
    return v.reduce(function(x, A) {
      return g(x, A, S);
    }, {});
  };
  var p = g;
  return uo = p, uo;
}
var q0 = I0();
const k0 = /* @__PURE__ */ F0(q0);
var fo, B1;
function Rr() {
  return B1 || (B1 = 1, fo = TypeError), fo;
}
const D0 = {}, H0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D0
}, Symbol.toStringTag, { value: "Module" })), B0 = /* @__PURE__ */ $0(H0);
var po, U1;
function Gn() {
  if (U1) return po;
  U1 = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, i = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = o && i && typeof i.get == "function" ? i.get : null, a = o && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype, d = u ? WeakMap.prototype.has : null, h = typeof WeakSet == "function" && WeakSet.prototype, f = h ? WeakSet.prototype.has : null, b = typeof WeakRef == "function" && WeakRef.prototype, C = b ? WeakRef.prototype.deref : null, l = Boolean.prototype.valueOf, g = Object.prototype.toString, p = Function.prototype.toString, m = String.prototype.match, v = String.prototype.slice, S = String.prototype.replace, x = String.prototype.toUpperCase, A = String.prototype.toLowerCase, N = RegExp.prototype.test, $ = Array.prototype.concat, q = Array.prototype.join, I = Array.prototype.slice, F = Math.floor, V = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, k = Object.getOwnPropertySymbols, Y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ne = typeof Symbol == "function" && typeof Symbol.iterator == "object", ae = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ne || !0) ? Symbol.toStringTag : null, T = Object.prototype.propertyIsEnumerable, M = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(E) {
    return E.__proto__;
  } : null);
  function P(E, R) {
    if (E === 1 / 0 || E === -1 / 0 || E !== E || E && E > -1e3 && E < 1e3 || N.call(/e/, R))
      return R;
    var ce = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof E == "number") {
      var se = E < 0 ? -F(-E) : F(E);
      if (se !== E) {
        var he = String(se), X = v.call(R, he.length + 1);
        return S.call(he, ce, "$&_") + "." + S.call(S.call(X, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return S.call(R, ce, "$&_");
  }
  var U = B0, H = U.custom, z = Pe(H) ? H : null, te = {
    __proto__: null,
    double: '"',
    single: "'"
  }, re = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  po = function E(R, ce, se, he) {
    var X = ce || {};
    if (qe(X, "quoteStyle") && !qe(te, X.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (qe(X, "maxStringLength") && (typeof X.maxStringLength == "number" ? X.maxStringLength < 0 && X.maxStringLength !== 1 / 0 : X.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var ut = qe(X, "customInspect") ? X.customInspect : !0;
    if (typeof ut != "boolean" && ut !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (qe(X, "indent") && X.indent !== null && X.indent !== "	" && !(parseInt(X.indent, 10) === X.indent && X.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (qe(X, "numericSeparator") && typeof X.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var nt = X.numericSeparator;
    if (typeof R > "u")
      return "undefined";
    if (R === null)
      return "null";
    if (typeof R == "boolean")
      return R ? "true" : "false";
    if (typeof R == "string")
      return jt(R, X);
    if (typeof R == "number") {
      if (R === 0)
        return 1 / 0 / R > 0 ? "0" : "-0";
      var Ae = String(R);
      return nt ? P(R, Ae) : Ae;
    }
    if (typeof R == "bigint") {
      var Ye = String(R) + "n";
      return nt ? P(R, Ye) : Ye;
    }
    var Kt = typeof X.depth > "u" ? 5 : X.depth;
    if (typeof se > "u" && (se = 0), se >= Kt && Kt > 0 && typeof R == "object")
      return Te(R) ? "[Array]" : "[Object]";
    var ft = ro(X, se);
    if (typeof he > "u")
      he = [];
    else if (lt(he, R) >= 0)
      return "[Circular]";
    function $e(Nt, lr, oo) {
      if (lr && (he = I.call(he), he.push(lr)), oo) {
        var dt = {
          depth: X.depth
        };
        return qe(X, "quoteStyle") && (dt.quoteStyle = X.quoteStyle), E(Nt, dt, se + 1, he);
      }
      return E(Nt, X, se + 1, he);
    }
    if (typeof R == "function" && !Oe(R)) {
      var un = At(R), fn = Ct(R, $e);
      return "[Function" + (un ? ": " + un : " (anonymous)") + "]" + (fn.length > 0 ? " { " + q.call(fn, ", ") + " }" : "");
    }
    if (Pe(R)) {
      var dn = ne ? S.call(String(R), /^(Symbol\(.*\))_[^)]*$/, "$1") : Y.call(R);
      return typeof R == "object" && !ne ? _t(dn) : dn;
    }
    if (to(R)) {
      for (var zt = "<" + A.call(String(R.nodeName)), Mr = R.attributes || [], Gt = 0; Gt < Mr.length; Gt++)
        zt += " " + Mr[Gt].name + "=" + pe(W(Mr[Gt].value), "double", X);
      return zt += ">", R.childNodes && R.childNodes.length && (zt += "..."), zt += "</" + A.call(String(R.nodeName)) + ">", zt;
    }
    if (Te(R)) {
      if (R.length === 0)
        return "[]";
      var Zt = Ct(R, $e);
      return ft && !ln(Zt) ? "[" + cr(Zt, ft) + "]" : "[ " + q.call(Zt, ", ") + " ]";
    }
    if (oe(R)) {
      var ot = Ct(R, $e);
      return !("cause" in Error.prototype) && "cause" in R && !T.call(R, "cause") ? "{ [" + String(R) + "] " + q.call($.call("[cause]: " + $e(R.cause), ot), ", ") + " }" : ot.length === 0 ? "[" + String(R) + "]" : "{ [" + String(R) + "] " + q.call(ot, ", ") + " }";
    }
    if (typeof R == "object" && ut) {
      if (z && typeof R[z] == "function" && U)
        return U(R, { depth: Kt - se });
      if (ut !== "symbol" && typeof R.inspect == "function")
        return R.inspect();
    }
    if (Qe(R)) {
      var pn = [];
      return n && n.call(R, function(Nt, lr) {
        pn.push($e(lr, R, !0) + " => " + $e(Nt, R));
      }), Tr("Map", r.call(R), pn, ft);
    }
    if (Mt(R)) {
      var hn = [];
      return a && a.call(R, function(Nt) {
        hn.push($e(Nt, R));
      }), Tr("Set", s.call(R), hn, ft);
    }
    if (Lt(R))
      return Ke("WeakMap");
    if (eo(R))
      return Ke("WeakSet");
    if (Tt(R))
      return Ke("WeakRef");
    if (ue(R))
      return _t($e(Number(R)));
    if (Ve(R))
      return _t($e(V.call(R)));
    if (Se(R))
      return _t(l.call(R));
    if (ve(R))
      return _t($e(String(R)));
    if (typeof window < "u" && R === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && R === globalThis || typeof pr < "u" && R === pr)
      return "{ [object globalThis] }";
    if (!Me(R) && !Oe(R)) {
      var _r = Ct(R, $e), yn = M ? M(R) === Object.prototype : R instanceof Object || R.constructor === Object, Nr = R instanceof Object ? "" : "null prototype", Xe = !yn && ae && Object(R) === R && ae in R ? v.call(je(R), 8, -1) : Nr ? "Object" : "", no = yn || typeof R.constructor != "function" ? "" : R.constructor.name ? R.constructor.name + " " : "", Fr = no + (Xe || Nr ? "[" + q.call($.call([], Xe || [], Nr || []), ": ") + "] " : "");
      return _r.length === 0 ? Fr + "{}" : ft ? Fr + "{" + cr(_r, ft) + "}" : Fr + "{ " + q.call(_r, ", ") + " }";
    }
    return String(R);
  };
  function pe(E, R, ce) {
    var se = ce.quoteStyle || R, he = te[se];
    return he + E + he;
  }
  function W(E) {
    return S.call(String(E), /"/g, "&quot;");
  }
  function xe(E) {
    return !ae || !(typeof E == "object" && (ae in E || typeof E[ae] < "u"));
  }
  function Te(E) {
    return je(E) === "[object Array]" && xe(E);
  }
  function Me(E) {
    return je(E) === "[object Date]" && xe(E);
  }
  function Oe(E) {
    return je(E) === "[object RegExp]" && xe(E);
  }
  function oe(E) {
    return je(E) === "[object Error]" && xe(E);
  }
  function ve(E) {
    return je(E) === "[object String]" && xe(E);
  }
  function ue(E) {
    return je(E) === "[object Number]" && xe(E);
  }
  function Se(E) {
    return je(E) === "[object Boolean]" && xe(E);
  }
  function Pe(E) {
    if (ne)
      return E && typeof E == "object" && E instanceof Symbol;
    if (typeof E == "symbol")
      return !0;
    if (!E || typeof E != "object" || !Y)
      return !1;
    try {
      return Y.call(E), !0;
    } catch {
    }
    return !1;
  }
  function Ve(E) {
    if (!E || typeof E != "object" || !V)
      return !1;
    try {
      return V.call(E), !0;
    } catch {
    }
    return !1;
  }
  var _e = Object.prototype.hasOwnProperty || function(E) {
    return E in this;
  };
  function qe(E, R) {
    return _e.call(E, R);
  }
  function je(E) {
    return g.call(E);
  }
  function At(E) {
    if (E.name)
      return E.name;
    var R = m.call(p.call(E), /^function\s*([\w$]+)/);
    return R ? R[1] : null;
  }
  function lt(E, R) {
    if (E.indexOf)
      return E.indexOf(R);
    for (var ce = 0, se = E.length; ce < se; ce++)
      if (E[ce] === R)
        return ce;
    return -1;
  }
  function Qe(E) {
    if (!r || !E || typeof E != "object")
      return !1;
    try {
      r.call(E);
      try {
        s.call(E);
      } catch {
        return !0;
      }
      return E instanceof Map;
    } catch {
    }
    return !1;
  }
  function Lt(E) {
    if (!d || !E || typeof E != "object")
      return !1;
    try {
      d.call(E, d);
      try {
        f.call(E, f);
      } catch {
        return !0;
      }
      return E instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Tt(E) {
    if (!C || !E || typeof E != "object")
      return !1;
    try {
      return C.call(E), !0;
    } catch {
    }
    return !1;
  }
  function Mt(E) {
    if (!s || !E || typeof E != "object")
      return !1;
    try {
      s.call(E);
      try {
        r.call(E);
      } catch {
        return !0;
      }
      return E instanceof Set;
    } catch {
    }
    return !1;
  }
  function eo(E) {
    if (!f || !E || typeof E != "object")
      return !1;
    try {
      f.call(E, f);
      try {
        d.call(E, d);
      } catch {
        return !0;
      }
      return E instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function to(E) {
    return !E || typeof E != "object" ? !1 : typeof HTMLElement < "u" && E instanceof HTMLElement ? !0 : typeof E.nodeName == "string" && typeof E.getAttribute == "function";
  }
  function jt(E, R) {
    if (E.length > R.maxStringLength) {
      var ce = E.length - R.maxStringLength, se = "... " + ce + " more character" + (ce > 1 ? "s" : "");
      return jt(v.call(E, 0, R.maxStringLength), R) + se;
    }
    var he = re[R.quoteStyle || "single"];
    he.lastIndex = 0;
    var X = S.call(S.call(E, he, "\\$1"), /[\x00-\x1f]/g, Lr);
    return pe(X, "single", R);
  }
  function Lr(E) {
    var R = E.charCodeAt(0), ce = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[R];
    return ce ? "\\" + ce : "\\x" + (R < 16 ? "0" : "") + x.call(R.toString(16));
  }
  function _t(E) {
    return "Object(" + E + ")";
  }
  function Ke(E) {
    return E + " { ? }";
  }
  function Tr(E, R, ce, se) {
    var he = se ? cr(ce, se) : q.call(ce, ", ");
    return E + " (" + R + ") {" + he + "}";
  }
  function ln(E) {
    for (var R = 0; R < E.length; R++)
      if (lt(E[R], `
`) >= 0)
        return !1;
    return !0;
  }
  function ro(E, R) {
    var ce;
    if (E.indent === "	")
      ce = "	";
    else if (typeof E.indent == "number" && E.indent > 0)
      ce = q.call(Array(E.indent + 1), " ");
    else
      return null;
    return {
      base: ce,
      prev: q.call(Array(R + 1), ce)
    };
  }
  function cr(E, R) {
    if (E.length === 0)
      return "";
    var ce = `
` + R.prev + R.base;
    return ce + q.call(E, "," + ce) + `
` + R.prev;
  }
  function Ct(E, R) {
    var ce = Te(E), se = [];
    if (ce) {
      se.length = E.length;
      for (var he = 0; he < E.length; he++)
        se[he] = qe(E, he) ? R(E[he], E) : "";
    }
    var X = typeof k == "function" ? k(E) : [], ut;
    if (ne) {
      ut = {};
      for (var nt = 0; nt < X.length; nt++)
        ut["$" + X[nt]] = X[nt];
    }
    for (var Ae in E)
      qe(E, Ae) && (ce && String(Number(Ae)) === Ae && Ae < E.length || ne && ut["$" + Ae] instanceof Symbol || (N.call(/[^\w$]/, Ae) ? se.push(R(Ae, E) + ": " + R(E[Ae], E)) : se.push(Ae + ": " + R(E[Ae], E))));
    if (typeof k == "function")
      for (var Ye = 0; Ye < X.length; Ye++)
        T.call(E, X[Ye]) && se.push("[" + R(X[Ye]) + "]: " + R(E[X[Ye]], E));
    return se;
  }
  return po;
}
var ho, V1;
function U0() {
  if (V1) return ho;
  V1 = 1;
  var e = /* @__PURE__ */ Gn(), t = /* @__PURE__ */ Rr(), r = function(a, u, d) {
    for (var h = a, f; (f = h.next) != null; h = f)
      if (f.key === u)
        return h.next = f.next, d || (f.next = /** @type {NonNullable<typeof list.next>} */
        a.next, a.next = f), f;
  }, n = function(a, u) {
    if (a) {
      var d = r(a, u);
      return d && d.value;
    }
  }, o = function(a, u, d) {
    var h = r(a, u);
    h ? h.value = d : a.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: u,
      next: a.next,
      value: d
    };
  }, i = function(a, u) {
    return a ? !!r(a, u) : !1;
  }, s = function(a, u) {
    if (a)
      return r(a, u, !0);
  };
  return ho = function() {
    var u, d = {
      assert: function(h) {
        if (!d.has(h))
          throw new t("Side channel does not contain " + e(h));
      },
      delete: function(h) {
        var f = u && u.next, b = s(u, h);
        return b && f && f === b && (u = void 0), !!b;
      },
      get: function(h) {
        return n(u, h);
      },
      has: function(h) {
        return i(u, h);
      },
      set: function(h, f) {
        u || (u = {
          next: void 0
        }), o(
          /** @type {NonNullable<typeof $o>} */
          u,
          h,
          f
        );
      }
    };
    return d;
  }, ho;
}
var yo, j1;
function ka() {
  return j1 || (j1 = 1, yo = Object), yo;
}
var mo, K1;
function V0() {
  return K1 || (K1 = 1, mo = Error), mo;
}
var go, z1;
function j0() {
  return z1 || (z1 = 1, go = EvalError), go;
}
var Co, G1;
function K0() {
  return G1 || (G1 = 1, Co = RangeError), Co;
}
var vo, Z1;
function z0() {
  return Z1 || (Z1 = 1, vo = ReferenceError), vo;
}
var bo, W1;
function G0() {
  return W1 || (W1 = 1, bo = SyntaxError), bo;
}
var wo, Q1;
function Z0() {
  return Q1 || (Q1 = 1, wo = URIError), wo;
}
var So, J1;
function W0() {
  return J1 || (J1 = 1, So = Math.abs), So;
}
var Eo, Y1;
function Q0() {
  return Y1 || (Y1 = 1, Eo = Math.floor), Eo;
}
var xo, X1;
function J0() {
  return X1 || (X1 = 1, xo = Math.max), xo;
}
var Ro, es;
function Y0() {
  return es || (es = 1, Ro = Math.min), Ro;
}
var Oo, ts;
function X0() {
  return ts || (ts = 1, Oo = Math.pow), Oo;
}
var Po, rs;
function e3() {
  return rs || (rs = 1, Po = Math.round), Po;
}
var Ao, ns;
function t3() {
  return ns || (ns = 1, Ao = Number.isNaN || function(t) {
    return t !== t;
  }), Ao;
}
var Lo, os;
function r3() {
  if (os) return Lo;
  os = 1;
  var e = /* @__PURE__ */ t3();
  return Lo = function(r) {
    return e(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, Lo;
}
var To, is;
function n3() {
  return is || (is = 1, To = Object.getOwnPropertyDescriptor), To;
}
var Mo, ss;
function Da() {
  if (ss) return Mo;
  ss = 1;
  var e = /* @__PURE__ */ n3();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Mo = e, Mo;
}
var _o, as;
function o3() {
  if (as) return _o;
  as = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return _o = e, _o;
}
var No, cs;
function i3() {
  return cs || (cs = 1, No = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var o = 42;
    t[r] = o;
    for (var i in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(t);
    if (s.length !== 1 || s[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var a = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, r)
      );
      if (a.value !== o || a.enumerable !== !0)
        return !1;
    }
    return !0;
  }), No;
}
var Fo, ls;
function s3() {
  if (ls) return Fo;
  ls = 1;
  var e = typeof Symbol < "u" && Symbol, t = i3();
  return Fo = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Fo;
}
var $o, us;
function Ha() {
  return us || (us = 1, $o = typeof Reflect < "u" && Reflect.getPrototypeOf || null), $o;
}
var Io, fs;
function Ba() {
  if (fs) return Io;
  fs = 1;
  var e = /* @__PURE__ */ ka();
  return Io = e.getPrototypeOf || null, Io;
}
var qo, ds;
function a3() {
  if (ds) return qo;
  ds = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", o = function(u, d) {
    for (var h = [], f = 0; f < u.length; f += 1)
      h[f] = u[f];
    for (var b = 0; b < d.length; b += 1)
      h[b + u.length] = d[b];
    return h;
  }, i = function(u, d) {
    for (var h = [], f = d, b = 0; f < u.length; f += 1, b += 1)
      h[b] = u[f];
    return h;
  }, s = function(a, u) {
    for (var d = "", h = 0; h < a.length; h += 1)
      d += a[h], h + 1 < a.length && (d += u);
    return d;
  };
  return qo = function(u) {
    var d = this;
    if (typeof d != "function" || t.apply(d) !== n)
      throw new TypeError(e + d);
    for (var h = i(arguments, 1), f, b = function() {
      if (this instanceof f) {
        var m = d.apply(
          this,
          o(h, arguments)
        );
        return Object(m) === m ? m : this;
      }
      return d.apply(
        u,
        o(h, arguments)
      );
    }, C = r(0, d.length - h.length), l = [], g = 0; g < C; g++)
      l[g] = "$" + g;
    if (f = Function("binder", "return function (" + s(l, ",") + "){ return binder.apply(this,arguments); }")(b), d.prototype) {
      var p = function() {
      };
      p.prototype = d.prototype, f.prototype = new p(), p.prototype = null;
    }
    return f;
  }, qo;
}
var ko, ps;
function Zn() {
  if (ps) return ko;
  ps = 1;
  var e = a3();
  return ko = Function.prototype.bind || e, ko;
}
var Do, hs;
function Ui() {
  return hs || (hs = 1, Do = Function.prototype.call), Do;
}
var Ho, ys;
function Ua() {
  return ys || (ys = 1, Ho = Function.prototype.apply), Ho;
}
var Bo, ms;
function c3() {
  return ms || (ms = 1, Bo = typeof Reflect < "u" && Reflect && Reflect.apply), Bo;
}
var Uo, gs;
function l3() {
  if (gs) return Uo;
  gs = 1;
  var e = Zn(), t = Ua(), r = Ui(), n = c3();
  return Uo = n || e.call(r, t), Uo;
}
var Vo, Cs;
function Va() {
  if (Cs) return Vo;
  Cs = 1;
  var e = Zn(), t = /* @__PURE__ */ Rr(), r = Ui(), n = l3();
  return Vo = function(i) {
    if (i.length < 1 || typeof i[0] != "function")
      throw new t("a function is required");
    return n(e, r, i);
  }, Vo;
}
var jo, vs;
function u3() {
  if (vs) return jo;
  vs = 1;
  var e = Va(), t = /* @__PURE__ */ Da(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), o = Object, i = o.getPrototypeOf;
  return jo = n && typeof n.get == "function" ? e([n.get]) : typeof i == "function" ? (
    /** @type {import('./get')} */
    function(a) {
      return i(a == null ? a : o(a));
    }
  ) : !1, jo;
}
var Ko, bs;
function f3() {
  if (bs) return Ko;
  bs = 1;
  var e = Ha(), t = Ba(), r = /* @__PURE__ */ u3();
  return Ko = e ? function(o) {
    return e(o);
  } : t ? function(o) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new TypeError("getProto: not an object");
    return t(o);
  } : r ? function(o) {
    return r(o);
  } : null, Ko;
}
var zo, ws;
function d3() {
  if (ws) return zo;
  ws = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Zn();
  return zo = r.call(e, t), zo;
}
var Go, Ss;
function Vi() {
  if (Ss) return Go;
  Ss = 1;
  var e, t = /* @__PURE__ */ ka(), r = /* @__PURE__ */ V0(), n = /* @__PURE__ */ j0(), o = /* @__PURE__ */ K0(), i = /* @__PURE__ */ z0(), s = /* @__PURE__ */ G0(), a = /* @__PURE__ */ Rr(), u = /* @__PURE__ */ Z0(), d = /* @__PURE__ */ W0(), h = /* @__PURE__ */ Q0(), f = /* @__PURE__ */ J0(), b = /* @__PURE__ */ Y0(), C = /* @__PURE__ */ X0(), l = /* @__PURE__ */ e3(), g = /* @__PURE__ */ r3(), p = Function, m = function(Oe) {
    try {
      return p('"use strict"; return (' + Oe + ").constructor;")();
    } catch {
    }
  }, v = /* @__PURE__ */ Da(), S = /* @__PURE__ */ o3(), x = function() {
    throw new a();
  }, A = v ? (function() {
    try {
      return arguments.callee, x;
    } catch {
      try {
        return v(arguments, "callee").get;
      } catch {
        return x;
      }
    }
  })() : x, N = s3()(), $ = f3(), q = Ba(), I = Ha(), F = Ua(), V = Ui(), k = {}, Y = typeof Uint8Array > "u" || !$ ? e : $(Uint8Array), ne = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": N && $ ? $([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": k,
    "%AsyncGenerator%": k,
    "%AsyncGeneratorFunction%": k,
    "%AsyncIteratorPrototype%": k,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": p,
    "%GeneratorFunction%": k,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": N && $ ? $($([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !N || !$ ? e : $((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": v,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": o,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !N || !$ ? e : $((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": N && $ ? $(""[Symbol.iterator]()) : e,
    "%Symbol%": N ? Symbol : e,
    "%SyntaxError%": s,
    "%ThrowTypeError%": A,
    "%TypedArray%": Y,
    "%TypeError%": a,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": u,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": V,
    "%Function.prototype.apply%": F,
    "%Object.defineProperty%": S,
    "%Object.getPrototypeOf%": q,
    "%Math.abs%": d,
    "%Math.floor%": h,
    "%Math.max%": f,
    "%Math.min%": b,
    "%Math.pow%": C,
    "%Math.round%": l,
    "%Math.sign%": g,
    "%Reflect.getPrototypeOf%": I
  };
  if ($)
    try {
      null.error;
    } catch (Oe) {
      var ae = $($(Oe));
      ne["%Error.prototype%"] = ae;
    }
  var T = function Oe(oe) {
    var ve;
    if (oe === "%AsyncFunction%")
      ve = m("async function () {}");
    else if (oe === "%GeneratorFunction%")
      ve = m("function* () {}");
    else if (oe === "%AsyncGeneratorFunction%")
      ve = m("async function* () {}");
    else if (oe === "%AsyncGenerator%") {
      var ue = Oe("%AsyncGeneratorFunction%");
      ue && (ve = ue.prototype);
    } else if (oe === "%AsyncIteratorPrototype%") {
      var Se = Oe("%AsyncGenerator%");
      Se && $ && (ve = $(Se.prototype));
    }
    return ne[oe] = ve, ve;
  }, M = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, P = Zn(), U = /* @__PURE__ */ d3(), H = P.call(V, Array.prototype.concat), z = P.call(F, Array.prototype.splice), te = P.call(V, String.prototype.replace), re = P.call(V, String.prototype.slice), pe = P.call(V, RegExp.prototype.exec), W = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, xe = /\\(\\)?/g, Te = function(oe) {
    var ve = re(oe, 0, 1), ue = re(oe, -1);
    if (ve === "%" && ue !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (ue === "%" && ve !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var Se = [];
    return te(oe, W, function(Pe, Ve, _e, qe) {
      Se[Se.length] = _e ? te(qe, xe, "$1") : Ve || Pe;
    }), Se;
  }, Me = function(oe, ve) {
    var ue = oe, Se;
    if (U(M, ue) && (Se = M[ue], ue = "%" + Se[0] + "%"), U(ne, ue)) {
      var Pe = ne[ue];
      if (Pe === k && (Pe = T(ue)), typeof Pe > "u" && !ve)
        throw new a("intrinsic " + oe + " exists, but is not available. Please file an issue!");
      return {
        alias: Se,
        name: ue,
        value: Pe
      };
    }
    throw new s("intrinsic " + oe + " does not exist!");
  };
  return Go = function(oe, ve) {
    if (typeof oe != "string" || oe.length === 0)
      throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof ve != "boolean")
      throw new a('"allowMissing" argument must be a boolean');
    if (pe(/^%?[^%]*%?$/, oe) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var ue = Te(oe), Se = ue.length > 0 ? ue[0] : "", Pe = Me("%" + Se + "%", ve), Ve = Pe.name, _e = Pe.value, qe = !1, je = Pe.alias;
    je && (Se = je[0], z(ue, H([0, 1], je)));
    for (var At = 1, lt = !0; At < ue.length; At += 1) {
      var Qe = ue[At], Lt = re(Qe, 0, 1), Tt = re(Qe, -1);
      if ((Lt === '"' || Lt === "'" || Lt === "`" || Tt === '"' || Tt === "'" || Tt === "`") && Lt !== Tt)
        throw new s("property names with quotes must have matching quotes");
      if ((Qe === "constructor" || !lt) && (qe = !0), Se += "." + Qe, Ve = "%" + Se + "%", U(ne, Ve))
        _e = ne[Ve];
      else if (_e != null) {
        if (!(Qe in _e)) {
          if (!ve)
            throw new a("base intrinsic for " + oe + " exists, but the property is not available.");
          return;
        }
        if (v && At + 1 >= ue.length) {
          var Mt = v(_e, Qe);
          lt = !!Mt, lt && "get" in Mt && !("originalValue" in Mt.get) ? _e = Mt.get : _e = _e[Qe];
        } else
          lt = U(_e, Qe), _e = _e[Qe];
        lt && !qe && (ne[Ve] = _e);
      }
    }
    return _e;
  }, Go;
}
var Zo, Es;
function ja() {
  if (Es) return Zo;
  Es = 1;
  var e = /* @__PURE__ */ Vi(), t = Va(), r = t([e("%String.prototype.indexOf%")]);
  return Zo = function(o, i) {
    var s = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(o, !!i)
    );
    return typeof s == "function" && r(o, ".prototype.") > -1 ? t(
      /** @type {const} */
      [s]
    ) : s;
  }, Zo;
}
var Wo, xs;
function Ka() {
  if (xs) return Wo;
  xs = 1;
  var e = /* @__PURE__ */ Vi(), t = /* @__PURE__ */ ja(), r = /* @__PURE__ */ Gn(), n = /* @__PURE__ */ Rr(), o = e("%Map%", !0), i = t("Map.prototype.get", !0), s = t("Map.prototype.set", !0), a = t("Map.prototype.has", !0), u = t("Map.prototype.delete", !0), d = t("Map.prototype.size", !0);
  return Wo = !!o && /** @type {Exclude<import('.'), false>} */
  function() {
    var f, b = {
      assert: function(C) {
        if (!b.has(C))
          throw new n("Side channel does not contain " + r(C));
      },
      delete: function(C) {
        if (f) {
          var l = u(f, C);
          return d(f) === 0 && (f = void 0), l;
        }
        return !1;
      },
      get: function(C) {
        if (f)
          return i(f, C);
      },
      has: function(C) {
        return f ? a(f, C) : !1;
      },
      set: function(C, l) {
        f || (f = new o()), s(f, C, l);
      }
    };
    return b;
  }, Wo;
}
var Qo, Rs;
function p3() {
  if (Rs) return Qo;
  Rs = 1;
  var e = /* @__PURE__ */ Vi(), t = /* @__PURE__ */ ja(), r = /* @__PURE__ */ Gn(), n = Ka(), o = /* @__PURE__ */ Rr(), i = e("%WeakMap%", !0), s = t("WeakMap.prototype.get", !0), a = t("WeakMap.prototype.set", !0), u = t("WeakMap.prototype.has", !0), d = t("WeakMap.prototype.delete", !0);
  return Qo = i ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var f, b, C = {
        assert: function(l) {
          if (!C.has(l))
            throw new o("Side channel does not contain " + r(l));
        },
        delete: function(l) {
          if (i && l && (typeof l == "object" || typeof l == "function")) {
            if (f)
              return d(f, l);
          } else if (n && b)
            return b.delete(l);
          return !1;
        },
        get: function(l) {
          return i && l && (typeof l == "object" || typeof l == "function") && f ? s(f, l) : b && b.get(l);
        },
        has: function(l) {
          return i && l && (typeof l == "object" || typeof l == "function") && f ? u(f, l) : !!b && b.has(l);
        },
        set: function(l, g) {
          i && l && (typeof l == "object" || typeof l == "function") ? (f || (f = new i()), a(f, l, g)) : n && (b || (b = n()), b.set(l, g));
        }
      };
      return C;
    }
  ) : n, Qo;
}
var Jo, Os;
function h3() {
  if (Os) return Jo;
  Os = 1;
  var e = /* @__PURE__ */ Rr(), t = /* @__PURE__ */ Gn(), r = U0(), n = Ka(), o = p3(), i = o || n || r;
  return Jo = function() {
    var a, u = {
      assert: function(d) {
        if (!u.has(d))
          throw new e("Side channel does not contain " + t(d));
      },
      delete: function(d) {
        return !!a && a.delete(d);
      },
      get: function(d) {
        return a && a.get(d);
      },
      has: function(d) {
        return !!a && a.has(d);
      },
      set: function(d, h) {
        a || (a = i()), a.set(d, h);
      }
    };
    return u;
  }, Jo;
}
var Yo, Ps;
function ji() {
  if (Ps) return Yo;
  Ps = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Yo = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Yo;
}
var Xo, As;
function za() {
  if (As) return Xo;
  As = 1;
  var e = /* @__PURE__ */ ji(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = (function() {
    for (var p = [], m = 0; m < 256; ++m)
      p.push("%" + ((m < 16 ? "0" : "") + m.toString(16)).toUpperCase());
    return p;
  })(), o = function(m) {
    for (; m.length > 1; ) {
      var v = m.pop(), S = v.obj[v.prop];
      if (r(S)) {
        for (var x = [], A = 0; A < S.length; ++A)
          typeof S[A] < "u" && x.push(S[A]);
        v.obj[v.prop] = x;
      }
    }
  }, i = function(m, v) {
    for (var S = v && v.plainObjects ? { __proto__: null } : {}, x = 0; x < m.length; ++x)
      typeof m[x] < "u" && (S[x] = m[x]);
    return S;
  }, s = function p(m, v, S) {
    if (!v)
      return m;
    if (typeof v != "object" && typeof v != "function") {
      if (r(m))
        m.push(v);
      else if (m && typeof m == "object")
        (S && (S.plainObjects || S.allowPrototypes) || !t.call(Object.prototype, v)) && (m[v] = !0);
      else
        return [m, v];
      return m;
    }
    if (!m || typeof m != "object")
      return [m].concat(v);
    var x = m;
    return r(m) && !r(v) && (x = i(m, S)), r(m) && r(v) ? (v.forEach(function(A, N) {
      if (t.call(m, N)) {
        var $ = m[N];
        $ && typeof $ == "object" && A && typeof A == "object" ? m[N] = p($, A, S) : m.push(A);
      } else
        m[N] = A;
    }), m) : Object.keys(v).reduce(function(A, N) {
      var $ = v[N];
      return t.call(A, N) ? A[N] = p(A[N], $, S) : A[N] = $, A;
    }, x);
  }, a = function(m, v) {
    return Object.keys(v).reduce(function(S, x) {
      return S[x] = v[x], S;
    }, m);
  }, u = function(p, m, v) {
    var S = p.replace(/\+/g, " ");
    if (v === "iso-8859-1")
      return S.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(S);
    } catch {
      return S;
    }
  }, d = 1024, h = function(m, v, S, x, A) {
    if (m.length === 0)
      return m;
    var N = m;
    if (typeof m == "symbol" ? N = Symbol.prototype.toString.call(m) : typeof m != "string" && (N = String(m)), S === "iso-8859-1")
      return escape(N).replace(/%u[0-9a-f]{4}/gi, function(Y) {
        return "%26%23" + parseInt(Y.slice(2), 16) + "%3B";
      });
    for (var $ = "", q = 0; q < N.length; q += d) {
      for (var I = N.length >= d ? N.slice(q, q + d) : N, F = [], V = 0; V < I.length; ++V) {
        var k = I.charCodeAt(V);
        if (k === 45 || k === 46 || k === 95 || k === 126 || k >= 48 && k <= 57 || k >= 65 && k <= 90 || k >= 97 && k <= 122 || A === e.RFC1738 && (k === 40 || k === 41)) {
          F[F.length] = I.charAt(V);
          continue;
        }
        if (k < 128) {
          F[F.length] = n[k];
          continue;
        }
        if (k < 2048) {
          F[F.length] = n[192 | k >> 6] + n[128 | k & 63];
          continue;
        }
        if (k < 55296 || k >= 57344) {
          F[F.length] = n[224 | k >> 12] + n[128 | k >> 6 & 63] + n[128 | k & 63];
          continue;
        }
        V += 1, k = 65536 + ((k & 1023) << 10 | I.charCodeAt(V) & 1023), F[F.length] = n[240 | k >> 18] + n[128 | k >> 12 & 63] + n[128 | k >> 6 & 63] + n[128 | k & 63];
      }
      $ += F.join("");
    }
    return $;
  }, f = function(m) {
    for (var v = [{ obj: { o: m }, prop: "o" }], S = [], x = 0; x < v.length; ++x)
      for (var A = v[x], N = A.obj[A.prop], $ = Object.keys(N), q = 0; q < $.length; ++q) {
        var I = $[q], F = N[I];
        typeof F == "object" && F !== null && S.indexOf(F) === -1 && (v.push({ obj: N, prop: I }), S.push(F));
      }
    return o(v), m;
  }, b = function(m) {
    return Object.prototype.toString.call(m) === "[object RegExp]";
  }, C = function(m) {
    return !m || typeof m != "object" ? !1 : !!(m.constructor && m.constructor.isBuffer && m.constructor.isBuffer(m));
  }, l = function(m, v) {
    return [].concat(m, v);
  }, g = function(m, v) {
    if (r(m)) {
      for (var S = [], x = 0; x < m.length; x += 1)
        S.push(v(m[x]));
      return S;
    }
    return v(m);
  };
  return Xo = {
    arrayToObject: i,
    assign: a,
    combine: l,
    compact: f,
    decode: u,
    encode: h,
    isBuffer: C,
    isRegExp: b,
    maybeMap: g,
    merge: s
  }, Xo;
}
var ei, Ls;
function y3() {
  if (Ls) return ei;
  Ls = 1;
  var e = h3(), t = /* @__PURE__ */ za(), r = /* @__PURE__ */ ji(), n = Object.prototype.hasOwnProperty, o = {
    brackets: function(p) {
      return p + "[]";
    },
    comma: "comma",
    indices: function(p, m) {
      return p + "[" + m + "]";
    },
    repeat: function(p) {
      return p;
    }
  }, i = Array.isArray, s = Array.prototype.push, a = function(g, p) {
    s.apply(g, i(p) ? p : [p]);
  }, u = Date.prototype.toISOString, d = r.default, h = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: d,
    formatter: r.formatters[d],
    // deprecated
    indices: !1,
    serializeDate: function(p) {
      return u.call(p);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, f = function(p) {
    return typeof p == "string" || typeof p == "number" || typeof p == "boolean" || typeof p == "symbol" || typeof p == "bigint";
  }, b = {}, C = function g(p, m, v, S, x, A, N, $, q, I, F, V, k, Y, ne, ae, T, M) {
    for (var P = p, U = M, H = 0, z = !1; (U = U.get(b)) !== void 0 && !z; ) {
      var te = U.get(p);
      if (H += 1, typeof te < "u") {
        if (te === H)
          throw new RangeError("Cyclic object value");
        z = !0;
      }
      typeof U.get(b) > "u" && (H = 0);
    }
    if (typeof I == "function" ? P = I(m, P) : P instanceof Date ? P = k(P) : v === "comma" && i(P) && (P = t.maybeMap(P, function(Ve) {
      return Ve instanceof Date ? k(Ve) : Ve;
    })), P === null) {
      if (A)
        return q && !ae ? q(m, h.encoder, T, "key", Y) : m;
      P = "";
    }
    if (f(P) || t.isBuffer(P)) {
      if (q) {
        var re = ae ? m : q(m, h.encoder, T, "key", Y);
        return [ne(re) + "=" + ne(q(P, h.encoder, T, "value", Y))];
      }
      return [ne(m) + "=" + ne(String(P))];
    }
    var pe = [];
    if (typeof P > "u")
      return pe;
    var W;
    if (v === "comma" && i(P))
      ae && q && (P = t.maybeMap(P, q)), W = [{ value: P.length > 0 ? P.join(",") || null : void 0 }];
    else if (i(I))
      W = I;
    else {
      var xe = Object.keys(P);
      W = F ? xe.sort(F) : xe;
    }
    var Te = $ ? String(m).replace(/\./g, "%2E") : String(m), Me = S && i(P) && P.length === 1 ? Te + "[]" : Te;
    if (x && i(P) && P.length === 0)
      return Me + "[]";
    for (var Oe = 0; Oe < W.length; ++Oe) {
      var oe = W[Oe], ve = typeof oe == "object" && oe && typeof oe.value < "u" ? oe.value : P[oe];
      if (!(N && ve === null)) {
        var ue = V && $ ? String(oe).replace(/\./g, "%2E") : String(oe), Se = i(P) ? typeof v == "function" ? v(Me, ue) : Me : Me + (V ? "." + ue : "[" + ue + "]");
        M.set(p, H);
        var Pe = e();
        Pe.set(b, M), a(pe, g(
          ve,
          Se,
          v,
          S,
          x,
          A,
          N,
          $,
          v === "comma" && ae && i(P) ? null : q,
          I,
          F,
          V,
          k,
          Y,
          ne,
          ae,
          T,
          Pe
        ));
      }
    }
    return pe;
  }, l = function(p) {
    if (!p)
      return h;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.encodeDotInKeys < "u" && typeof p.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.encoder !== null && typeof p.encoder < "u" && typeof p.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var m = p.charset || h.charset;
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var v = r.default;
    if (typeof p.format < "u") {
      if (!n.call(r.formatters, p.format))
        throw new TypeError("Unknown format option provided.");
      v = p.format;
    }
    var S = r.formatters[v], x = h.filter;
    (typeof p.filter == "function" || i(p.filter)) && (x = p.filter);
    var A;
    if (p.arrayFormat in o ? A = p.arrayFormat : "indices" in p ? A = p.indices ? "indices" : "repeat" : A = h.arrayFormat, "commaRoundTrip" in p && typeof p.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var N = typeof p.allowDots > "u" ? p.encodeDotInKeys === !0 ? !0 : h.allowDots : !!p.allowDots;
    return {
      addQueryPrefix: typeof p.addQueryPrefix == "boolean" ? p.addQueryPrefix : h.addQueryPrefix,
      allowDots: N,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : h.allowEmptyArrays,
      arrayFormat: A,
      charset: m,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : h.charsetSentinel,
      commaRoundTrip: !!p.commaRoundTrip,
      delimiter: typeof p.delimiter > "u" ? h.delimiter : p.delimiter,
      encode: typeof p.encode == "boolean" ? p.encode : h.encode,
      encodeDotInKeys: typeof p.encodeDotInKeys == "boolean" ? p.encodeDotInKeys : h.encodeDotInKeys,
      encoder: typeof p.encoder == "function" ? p.encoder : h.encoder,
      encodeValuesOnly: typeof p.encodeValuesOnly == "boolean" ? p.encodeValuesOnly : h.encodeValuesOnly,
      filter: x,
      format: v,
      formatter: S,
      serializeDate: typeof p.serializeDate == "function" ? p.serializeDate : h.serializeDate,
      skipNulls: typeof p.skipNulls == "boolean" ? p.skipNulls : h.skipNulls,
      sort: typeof p.sort == "function" ? p.sort : null,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : h.strictNullHandling
    };
  };
  return ei = function(g, p) {
    var m = g, v = l(p), S, x;
    typeof v.filter == "function" ? (x = v.filter, m = x("", m)) : i(v.filter) && (x = v.filter, S = x);
    var A = [];
    if (typeof m != "object" || m === null)
      return "";
    var N = o[v.arrayFormat], $ = N === "comma" && v.commaRoundTrip;
    S || (S = Object.keys(m)), v.sort && S.sort(v.sort);
    for (var q = e(), I = 0; I < S.length; ++I) {
      var F = S[I], V = m[F];
      v.skipNulls && V === null || a(A, C(
        V,
        F,
        N,
        $,
        v.allowEmptyArrays,
        v.strictNullHandling,
        v.skipNulls,
        v.encodeDotInKeys,
        v.encode ? v.encoder : null,
        v.filter,
        v.sort,
        v.allowDots,
        v.serializeDate,
        v.format,
        v.formatter,
        v.encodeValuesOnly,
        v.charset,
        q
      ));
    }
    var k = A.join(v.delimiter), Y = v.addQueryPrefix === !0 ? "?" : "";
    return v.charsetSentinel && (v.charset === "iso-8859-1" ? Y += "utf8=%26%2310003%3B&" : Y += "utf8=%E2%9C%93&"), k.length > 0 ? Y + k : "";
  }, ei;
}
var ti, Ts;
function m3() {
  if (Ts) return ti;
  Ts = 1;
  var e = /* @__PURE__ */ za(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, o = function(b) {
    return b.replace(/&#(\d+);/g, function(C, l) {
      return String.fromCharCode(parseInt(l, 10));
    });
  }, i = function(b, C, l) {
    if (b && typeof b == "string" && C.comma && b.indexOf(",") > -1)
      return b.split(",");
    if (C.throwOnLimitExceeded && l >= C.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + C.arrayLimit + " element" + (C.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return b;
  }, s = "utf8=%26%2310003%3B", a = "utf8=%E2%9C%93", u = function(C, l) {
    var g = { __proto__: null }, p = l.ignoreQueryPrefix ? C.replace(/^\?/, "") : C;
    p = p.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var m = l.parameterLimit === 1 / 0 ? void 0 : l.parameterLimit, v = p.split(
      l.delimiter,
      l.throwOnLimitExceeded ? m + 1 : m
    );
    if (l.throwOnLimitExceeded && v.length > m)
      throw new RangeError("Parameter limit exceeded. Only " + m + " parameter" + (m === 1 ? "" : "s") + " allowed.");
    var S = -1, x, A = l.charset;
    if (l.charsetSentinel)
      for (x = 0; x < v.length; ++x)
        v[x].indexOf("utf8=") === 0 && (v[x] === a ? A = "utf-8" : v[x] === s && (A = "iso-8859-1"), S = x, x = v.length);
    for (x = 0; x < v.length; ++x)
      if (x !== S) {
        var N = v[x], $ = N.indexOf("]="), q = $ === -1 ? N.indexOf("=") : $ + 1, I, F;
        q === -1 ? (I = l.decoder(N, n.decoder, A, "key"), F = l.strictNullHandling ? null : "") : (I = l.decoder(N.slice(0, q), n.decoder, A, "key"), F = e.maybeMap(
          i(
            N.slice(q + 1),
            l,
            r(g[I]) ? g[I].length : 0
          ),
          function(k) {
            return l.decoder(k, n.decoder, A, "value");
          }
        )), F && l.interpretNumericEntities && A === "iso-8859-1" && (F = o(String(F))), N.indexOf("[]=") > -1 && (F = r(F) ? [F] : F);
        var V = t.call(g, I);
        V && l.duplicates === "combine" ? g[I] = e.combine(g[I], F) : (!V || l.duplicates === "last") && (g[I] = F);
      }
    return g;
  }, d = function(b, C, l, g) {
    var p = 0;
    if (b.length > 0 && b[b.length - 1] === "[]") {
      var m = b.slice(0, -1).join("");
      p = Array.isArray(C) && C[m] ? C[m].length : 0;
    }
    for (var v = g ? C : i(C, l, p), S = b.length - 1; S >= 0; --S) {
      var x, A = b[S];
      if (A === "[]" && l.parseArrays)
        x = l.allowEmptyArrays && (v === "" || l.strictNullHandling && v === null) ? [] : e.combine([], v);
      else {
        x = l.plainObjects ? { __proto__: null } : {};
        var N = A.charAt(0) === "[" && A.charAt(A.length - 1) === "]" ? A.slice(1, -1) : A, $ = l.decodeDotInKeys ? N.replace(/%2E/g, ".") : N, q = parseInt($, 10);
        !l.parseArrays && $ === "" ? x = { 0: v } : !isNaN(q) && A !== $ && String(q) === $ && q >= 0 && l.parseArrays && q <= l.arrayLimit ? (x = [], x[q] = v) : $ !== "__proto__" && (x[$] = v);
      }
      v = x;
    }
    return v;
  }, h = function(C, l, g, p) {
    if (C) {
      var m = g.allowDots ? C.replace(/\.([^.[]+)/g, "[$1]") : C, v = /(\[[^[\]]*])/, S = /(\[[^[\]]*])/g, x = g.depth > 0 && v.exec(m), A = x ? m.slice(0, x.index) : m, N = [];
      if (A) {
        if (!g.plainObjects && t.call(Object.prototype, A) && !g.allowPrototypes)
          return;
        N.push(A);
      }
      for (var $ = 0; g.depth > 0 && (x = S.exec(m)) !== null && $ < g.depth; ) {
        if ($ += 1, !g.plainObjects && t.call(Object.prototype, x[1].slice(1, -1)) && !g.allowPrototypes)
          return;
        N.push(x[1]);
      }
      if (x) {
        if (g.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + g.depth + " and strictDepth is true");
        N.push("[" + m.slice(x.index) + "]");
      }
      return d(N, l, g, p);
    }
  }, f = function(C) {
    if (!C)
      return n;
    if (typeof C.allowEmptyArrays < "u" && typeof C.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof C.decodeDotInKeys < "u" && typeof C.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (C.decoder !== null && typeof C.decoder < "u" && typeof C.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof C.charset < "u" && C.charset !== "utf-8" && C.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof C.throwOnLimitExceeded < "u" && typeof C.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var l = typeof C.charset > "u" ? n.charset : C.charset, g = typeof C.duplicates > "u" ? n.duplicates : C.duplicates;
    if (g !== "combine" && g !== "first" && g !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var p = typeof C.allowDots > "u" ? C.decodeDotInKeys === !0 ? !0 : n.allowDots : !!C.allowDots;
    return {
      allowDots: p,
      allowEmptyArrays: typeof C.allowEmptyArrays == "boolean" ? !!C.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof C.allowPrototypes == "boolean" ? C.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof C.allowSparse == "boolean" ? C.allowSparse : n.allowSparse,
      arrayLimit: typeof C.arrayLimit == "number" ? C.arrayLimit : n.arrayLimit,
      charset: l,
      charsetSentinel: typeof C.charsetSentinel == "boolean" ? C.charsetSentinel : n.charsetSentinel,
      comma: typeof C.comma == "boolean" ? C.comma : n.comma,
      decodeDotInKeys: typeof C.decodeDotInKeys == "boolean" ? C.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof C.decoder == "function" ? C.decoder : n.decoder,
      delimiter: typeof C.delimiter == "string" || e.isRegExp(C.delimiter) ? C.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof C.depth == "number" || C.depth === !1 ? +C.depth : n.depth,
      duplicates: g,
      ignoreQueryPrefix: C.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof C.interpretNumericEntities == "boolean" ? C.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof C.parameterLimit == "number" ? C.parameterLimit : n.parameterLimit,
      parseArrays: C.parseArrays !== !1,
      plainObjects: typeof C.plainObjects == "boolean" ? C.plainObjects : n.plainObjects,
      strictDepth: typeof C.strictDepth == "boolean" ? !!C.strictDepth : n.strictDepth,
      strictNullHandling: typeof C.strictNullHandling == "boolean" ? C.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof C.throwOnLimitExceeded == "boolean" ? C.throwOnLimitExceeded : !1
    };
  };
  return ti = function(b, C) {
    var l = f(C);
    if (b === "" || b === null || typeof b > "u")
      return l.plainObjects ? { __proto__: null } : {};
    for (var g = typeof b == "string" ? u(b, l) : b, p = l.plainObjects ? { __proto__: null } : {}, m = Object.keys(g), v = 0; v < m.length; ++v) {
      var S = m[v], x = h(S, g[S], l, typeof b == "string");
      p = e.merge(p, x, l);
    }
    return l.allowSparse === !0 ? p : e.compact(p);
  }, ti;
}
var ri, Ms;
function g3() {
  if (Ms) return ri;
  Ms = 1;
  var e = /* @__PURE__ */ y3(), t = /* @__PURE__ */ m3(), r = /* @__PURE__ */ ji();
  return ri = {
    formats: r,
    parse: t,
    stringify: e
  }, ri;
}
var _s = /* @__PURE__ */ g3(), Tn = { exports: {} };
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */
var C3 = Tn.exports, Ns;
function v3() {
  return Ns || (Ns = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(C3, function() {
      var r = {};
      r.version = "0.2.0";
      var n = r.settings = {
        minimum: 0.08,
        easing: "ease",
        positionUsing: "",
        speed: 200,
        trickle: !0,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: !0,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
      };
      r.configure = function(l) {
        var g, p;
        for (g in l)
          p = l[g], p !== void 0 && l.hasOwnProperty(g) && (n[g] = p);
        return this;
      }, r.status = null, r.set = function(l) {
        var g = r.isStarted();
        l = o(l, n.minimum, 1), r.status = l === 1 ? null : l;
        var p = r.render(!g), m = p.querySelector(n.barSelector), v = n.speed, S = n.easing;
        return p.offsetWidth, a(function(x) {
          n.positionUsing === "" && (n.positionUsing = r.getPositioningCSS()), u(m, s(l, v, S)), l === 1 ? (u(p, {
            transition: "none",
            opacity: 1
          }), p.offsetWidth, setTimeout(function() {
            u(p, {
              transition: "all " + v + "ms linear",
              opacity: 0
            }), setTimeout(function() {
              r.remove(), x();
            }, v);
          }, v)) : setTimeout(x, v);
        }), this;
      }, r.isStarted = function() {
        return typeof r.status == "number";
      }, r.start = function() {
        r.status || r.set(0);
        var l = function() {
          setTimeout(function() {
            r.status && (r.trickle(), l());
          }, n.trickleSpeed);
        };
        return n.trickle && l(), this;
      }, r.done = function(l) {
        return !l && !r.status ? this : r.inc(0.3 + 0.5 * Math.random()).set(1);
      }, r.inc = function(l) {
        var g = r.status;
        return g ? (typeof l != "number" && (l = (1 - g) * o(Math.random() * g, 0.1, 0.95)), g = o(g + l, 0, 0.994), r.set(g)) : r.start();
      }, r.trickle = function() {
        return r.inc(Math.random() * n.trickleRate);
      }, (function() {
        var l = 0, g = 0;
        r.promise = function(p) {
          return !p || p.state() === "resolved" ? this : (g === 0 && r.start(), l++, g++, p.always(function() {
            g--, g === 0 ? (l = 0, r.done()) : r.set((l - g) / l);
          }), this);
        };
      })(), r.render = function(l) {
        if (r.isRendered()) return document.getElementById("nprogress");
        h(document.documentElement, "nprogress-busy");
        var g = document.createElement("div");
        g.id = "nprogress", g.innerHTML = n.template;
        var p = g.querySelector(n.barSelector), m = l ? "-100" : i(r.status || 0), v = document.querySelector(n.parent), S;
        return u(p, {
          transition: "all 0 linear",
          transform: "translate3d(" + m + "%,0,0)"
        }), n.showSpinner || (S = g.querySelector(n.spinnerSelector), S && C(S)), v != document.body && h(v, "nprogress-custom-parent"), v.appendChild(g), g;
      }, r.remove = function() {
        f(document.documentElement, "nprogress-busy"), f(document.querySelector(n.parent), "nprogress-custom-parent");
        var l = document.getElementById("nprogress");
        l && C(l);
      }, r.isRendered = function() {
        return !!document.getElementById("nprogress");
      }, r.getPositioningCSS = function() {
        var l = document.body.style, g = "WebkitTransform" in l ? "Webkit" : "MozTransform" in l ? "Moz" : "msTransform" in l ? "ms" : "OTransform" in l ? "O" : "";
        return g + "Perspective" in l ? "translate3d" : g + "Transform" in l ? "translate" : "margin";
      };
      function o(l, g, p) {
        return l < g ? g : l > p ? p : l;
      }
      function i(l) {
        return (-1 + l) * 100;
      }
      function s(l, g, p) {
        var m;
        return n.positionUsing === "translate3d" ? m = { transform: "translate3d(" + i(l) + "%,0,0)" } : n.positionUsing === "translate" ? m = { transform: "translate(" + i(l) + "%,0)" } : m = { "margin-left": i(l) + "%" }, m.transition = "all " + g + "ms " + p, m;
      }
      var a = /* @__PURE__ */ (function() {
        var l = [];
        function g() {
          var p = l.shift();
          p && p(g);
        }
        return function(p) {
          l.push(p), l.length == 1 && g();
        };
      })(), u = /* @__PURE__ */ (function() {
        var l = ["Webkit", "O", "Moz", "ms"], g = {};
        function p(x) {
          return x.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(A, N) {
            return N.toUpperCase();
          });
        }
        function m(x) {
          var A = document.body.style;
          if (x in A) return x;
          for (var N = l.length, $ = x.charAt(0).toUpperCase() + x.slice(1), q; N--; )
            if (q = l[N] + $, q in A) return q;
          return x;
        }
        function v(x) {
          return x = p(x), g[x] || (g[x] = m(x));
        }
        function S(x, A, N) {
          A = v(A), x.style[A] = N;
        }
        return function(x, A) {
          var N = arguments, $, q;
          if (N.length == 2)
            for ($ in A)
              q = A[$], q !== void 0 && A.hasOwnProperty($) && S(x, $, q);
          else
            S(x, N[1], N[2]);
        };
      })();
      function d(l, g) {
        var p = typeof l == "string" ? l : b(l);
        return p.indexOf(" " + g + " ") >= 0;
      }
      function h(l, g) {
        var p = b(l), m = p + g;
        d(p, g) || (l.className = m.substring(1));
      }
      function f(l, g) {
        var p = b(l), m;
        d(l, g) && (m = p.replace(" " + g + " ", " "), l.className = m.substring(1, m.length - 1));
      }
      function b(l) {
        return (" " + (l.className || "") + " ").replace(/\s+/gi, " ");
      }
      function C(l) {
        l && l.parentNode && l.parentNode.removeChild(l);
      }
      return r;
    });
  })(Tn)), Tn.exports;
}
v3();
function b3(e, t) {
  let r;
  return function(...n) {
    clearTimeout(r), r = setTimeout(() => e.apply(this, n), t);
  };
}
function Ot(e, t) {
  return document.dispatchEvent(new CustomEvent(`inertia:${e}`, t));
}
var w3 = (e) => Ot("before", { cancelable: !0, detail: { visit: e } }), S3 = (e) => Ot("error", { detail: { errors: e } }), E3 = (e) => Ot("exception", { cancelable: !0, detail: { exception: e } }), Fs = (e) => Ot("finish", { detail: { visit: e } }), x3 = (e) => Ot("invalid", { cancelable: !0, detail: { response: e } }), kr = (e) => Ot("navigate", { detail: { page: e } }), R3 = (e) => Ot("progress", { detail: { progress: e } }), O3 = (e) => Ot("start", { detail: { visit: e } }), P3 = (e) => Ot("success", { detail: { page: e } });
function Ri(e) {
  return e instanceof File || e instanceof Blob || e instanceof FileList && e.length > 0 || e instanceof FormData && Array.from(e.values()).some((t) => Ri(t)) || typeof e == "object" && e !== null && Object.values(e).some((t) => Ri(t));
}
function Ga(e, t = new FormData(), r = null) {
  e = e || {};
  for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && Wa(t, Za(r, n), e[n]);
  return t;
}
function Za(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Wa(e, t, r) {
  if (Array.isArray(r)) return Array.from(r.keys()).forEach((n) => Wa(e, Za(t, n.toString()), r[n]));
  if (r instanceof Date) return e.append(t, r.toISOString());
  if (r instanceof File) return e.append(t, r, r.name);
  if (r instanceof Blob) return e.append(t, r);
  if (typeof r == "boolean") return e.append(t, r ? "1" : "0");
  if (typeof r == "string") return e.append(t, r);
  if (typeof r == "number") return e.append(t, `${r}`);
  if (r == null) return e.append(t, "");
  Ga(r, e, t);
}
var A3 = { modal: null, listener: null, show(e) {
  typeof e == "object" && (e = `All Inertia requests must receive a valid Inertia response, however a plain JSON response was received.<hr>${JSON.stringify(e)}`);
  let t = document.createElement("html");
  t.innerHTML = e, t.querySelectorAll("a").forEach((n) => n.setAttribute("target", "_top")), this.modal = document.createElement("div"), this.modal.style.position = "fixed", this.modal.style.width = "100vw", this.modal.style.height = "100vh", this.modal.style.padding = "50px", this.modal.style.boxSizing = "border-box", this.modal.style.backgroundColor = "rgba(0, 0, 0, .6)", this.modal.style.zIndex = 2e5, this.modal.addEventListener("click", () => this.hide());
  let r = document.createElement("iframe");
  if (r.style.backgroundColor = "white", r.style.borderRadius = "5px", r.style.width = "100%", r.style.height = "100%", this.modal.appendChild(r), document.body.prepend(this.modal), document.body.style.overflow = "hidden", !r.contentWindow) throw new Error("iframe not yet ready.");
  r.contentWindow.document.open(), r.contentWindow.document.write(t.outerHTML), r.contentWindow.document.close(), this.listener = this.hideOnEscape.bind(this), document.addEventListener("keydown", this.listener);
}, hide() {
  this.modal.outerHTML = "", this.modal = null, document.body.style.overflow = "visible", document.removeEventListener("keydown", this.listener);
}, hideOnEscape(e) {
  e.keyCode === 27 && this.hide();
} };
function dr(e) {
  return new URL(e.toString(), window.location.toString());
}
function Qa(e, t, r, n = "brackets") {
  let o = /^https?:\/\//.test(t.toString()), i = o || t.toString().startsWith("/"), s = !i && !t.toString().startsWith("#") && !t.toString().startsWith("?"), a = t.toString().includes("?") || e === "get" && Object.keys(r).length, u = t.toString().includes("#"), d = new URL(t.toString(), "http://localhost");
  return e === "get" && Object.keys(r).length && (d.search = _s.stringify(k0(_s.parse(d.search, { ignoreQueryPrefix: !0 }), r), { encodeValuesOnly: !0, arrayFormat: n }), r = {}), [[o ? `${d.protocol}//${d.host}` : "", i ? d.pathname : "", s ? d.pathname.substring(1) : "", a ? d.search : "", u ? d.hash : ""].join(""), r];
}
function Dr(e) {
  return e = new URL(e.href), e.hash = "", e;
}
var Mn = typeof window > "u", $s = !Mn && /CriOS/.test(window.navigator.userAgent), Is = (e) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}, L3 = class {
  constructor() {
    this.visitId = null;
  }
  init({ initialPage: t, resolveComponent: r, swapComponent: n }) {
    this.page = t, this.resolveComponent = r, this.swapComponent = n, this.setNavigationType(), this.clearRememberedStateOnReload(), this.isBackForwardVisit() ? this.handleBackForwardVisit(this.page) : this.isLocationVisit() ? this.handleLocationVisit(this.page) : this.handleInitialPageVisit(this.page), this.setupEventListeners();
  }
  setNavigationType() {
    this.navigationType = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType("navigation").length > 0 ? window.performance.getEntriesByType("navigation")[0].type : "navigate";
  }
  clearRememberedStateOnReload() {
    var t;
    this.navigationType === "reload" && ((t = window.history.state) != null && t.rememberedState) && delete window.history.state.rememberedState;
  }
  handleInitialPageVisit(t) {
    let r = window.location.hash;
    this.page.url.includes(r) || (this.page.url += r), this.setPage(t, { preserveScroll: !0, preserveState: !0 }).then(() => kr(t));
  }
  setupEventListeners() {
    window.addEventListener("popstate", this.handlePopstateEvent.bind(this)), document.addEventListener("scroll", b3(this.handleScrollEvent.bind(this), 100), !0);
  }
  scrollRegions() {
    return document.querySelectorAll("[scroll-region]");
  }
  handleScrollEvent(t) {
    typeof t.target.hasAttribute == "function" && t.target.hasAttribute("scroll-region") && this.saveScrollPositions();
  }
  saveScrollPositions() {
    this.replaceState({ ...this.page, scrollRegions: Array.from(this.scrollRegions()).map((t) => ({ top: t.scrollTop, left: t.scrollLeft })) });
  }
  resetScrollPositions() {
    Is(() => {
      var t;
      window.scrollTo(0, 0), this.scrollRegions().forEach((r) => {
        typeof r.scrollTo == "function" ? r.scrollTo(0, 0) : (r.scrollTop = 0, r.scrollLeft = 0);
      }), this.saveScrollPositions(), window.location.hash && ((t = document.getElementById(window.location.hash.slice(1))) == null || t.scrollIntoView());
    });
  }
  restoreScrollPositions() {
    Is(() => {
      this.page.scrollRegions && this.scrollRegions().forEach((t, r) => {
        let n = this.page.scrollRegions[r];
        if (n) typeof t.scrollTo == "function" ? t.scrollTo(n.left, n.top) : (t.scrollTop = n.top, t.scrollLeft = n.left);
        else return;
      });
    });
  }
  isBackForwardVisit() {
    return window.history.state && this.navigationType === "back_forward";
  }
  handleBackForwardVisit(t) {
    window.history.state.version = t.version, this.setPage(window.history.state, { preserveScroll: !0, preserveState: !0 }).then(() => {
      this.restoreScrollPositions(), kr(t);
    });
  }
  locationVisit(t, r) {
    try {
      let n = { preserveScroll: r };
      window.sessionStorage.setItem("inertiaLocationVisit", JSON.stringify(n)), window.location.href = t.href, Dr(window.location).href === Dr(t).href && window.location.reload();
    } catch {
      return !1;
    }
  }
  isLocationVisit() {
    try {
      return window.sessionStorage.getItem("inertiaLocationVisit") !== null;
    } catch {
      return !1;
    }
  }
  handleLocationVisit(t) {
    var n, o;
    let r = JSON.parse(window.sessionStorage.getItem("inertiaLocationVisit") || "");
    window.sessionStorage.removeItem("inertiaLocationVisit"), t.url += window.location.hash, t.rememberedState = ((n = window.history.state) == null ? void 0 : n.rememberedState) ?? {}, t.scrollRegions = ((o = window.history.state) == null ? void 0 : o.scrollRegions) ?? [], this.setPage(t, { preserveScroll: r.preserveScroll, preserveState: !0 }).then(() => {
      r.preserveScroll && this.restoreScrollPositions(), kr(t);
    });
  }
  isLocationVisitResponse(t) {
    return !!(t && t.status === 409 && t.headers["x-inertia-location"]);
  }
  isInertiaResponse(t) {
    return !!(t != null && t.headers["x-inertia"]);
  }
  createVisitId() {
    return this.visitId = {}, this.visitId;
  }
  cancelVisit(t, { cancelled: r = !1, interrupted: n = !1 }) {
    t && !t.completed && !t.cancelled && !t.interrupted && (t.cancelToken.abort(), t.onCancel(), t.completed = !1, t.cancelled = r, t.interrupted = n, Fs(t), t.onFinish(t));
  }
  finishVisit(t) {
    !t.cancelled && !t.interrupted && (t.completed = !0, t.cancelled = !1, t.interrupted = !1, Fs(t), t.onFinish(t));
  }
  resolvePreserveOption(t, r) {
    return typeof t == "function" ? t(r) : t === "errors" ? Object.keys(r.props.errors || {}).length > 0 : t;
  }
  cancel() {
    this.activeVisit && this.cancelVisit(this.activeVisit, { cancelled: !0 });
  }
  visit(t, { method: r = "get", data: n = {}, replace: o = !1, preserveScroll: i = !1, preserveState: s = !1, only: a = [], except: u = [], headers: d = {}, errorBag: h = "", forceFormData: f = !1, onCancelToken: b = () => {
  }, onBefore: C = () => {
  }, onStart: l = () => {
  }, onProgress: g = () => {
  }, onFinish: p = () => {
  }, onCancel: m = () => {
  }, onSuccess: v = () => {
  }, onError: S = () => {
  }, queryStringArrayFormat: x = "brackets" } = {}) {
    let A = typeof t == "string" ? dr(t) : t;
    if ((Ri(n) || f) && !(n instanceof FormData) && (n = Ga(n)), !(n instanceof FormData)) {
      let [I, F] = Qa(r, A, n, x);
      A = dr(I), n = F;
    }
    let N = { url: A, method: r, data: n, replace: o, preserveScroll: i, preserveState: s, only: a, except: u, headers: d, errorBag: h, forceFormData: f, queryStringArrayFormat: x, cancelled: !1, completed: !1, interrupted: !1 };
    if (C(N) === !1 || !w3(N)) return;
    this.activeVisit && this.cancelVisit(this.activeVisit, { interrupted: !0 }), this.saveScrollPositions();
    let $ = this.createVisitId();
    this.activeVisit = { ...N, onCancelToken: b, onBefore: C, onStart: l, onProgress: g, onFinish: p, onCancel: m, onSuccess: v, onError: S, queryStringArrayFormat: x, cancelToken: new AbortController() }, b({ cancel: () => {
      this.activeVisit && this.cancelVisit(this.activeVisit, { cancelled: !0 });
    } }), O3(N), l(N);
    let q = !!(a.length || u.length);
    me({ method: r, url: Dr(A).href, data: r === "get" ? {} : n, params: r === "get" ? n : {}, signal: this.activeVisit.cancelToken.signal, headers: { ...d, Accept: "text/html, application/xhtml+xml", "X-Requested-With": "XMLHttpRequest", "X-Inertia": !0, ...q ? { "X-Inertia-Partial-Component": this.page.component } : {}, ...a.length ? { "X-Inertia-Partial-Data": a.join(",") } : {}, ...u.length ? { "X-Inertia-Partial-Except": u.join(",") } : {}, ...h && h.length ? { "X-Inertia-Error-Bag": h } : {}, ...this.page.version ? { "X-Inertia-Version": this.page.version } : {} }, onUploadProgress: (I) => {
      n instanceof FormData && (I.percentage = I.progress ? Math.round(I.progress * 100) : 0, R3(I), g(I));
    } }).then((I) => {
      var Y;
      if (!this.isInertiaResponse(I)) return Promise.reject({ response: I });
      let F = I.data;
      q && F.component === this.page.component && (F.props = { ...this.page.props, ...F.props }), i = this.resolvePreserveOption(i, F), s = this.resolvePreserveOption(s, F), s && ((Y = window.history.state) != null && Y.rememberedState) && F.component === this.page.component && (F.rememberedState = window.history.state.rememberedState);
      let V = A, k = dr(F.url);
      return V.hash && !k.hash && Dr(V).href === k.href && (k.hash = V.hash, F.url = k.href), this.setPage(F, { visitId: $, replace: o, preserveScroll: i, preserveState: s });
    }).then(() => {
      let I = this.page.props.errors || {};
      if (Object.keys(I).length > 0) {
        let F = h ? I[h] ? I[h] : {} : I;
        return S3(F), S(F);
      }
      return P3(this.page), v(this.page);
    }).catch((I) => {
      if (this.isInertiaResponse(I.response)) return this.setPage(I.response.data, { visitId: $ });
      if (this.isLocationVisitResponse(I.response)) {
        let F = dr(I.response.headers["x-inertia-location"]), V = A;
        V.hash && !F.hash && Dr(V).href === F.href && (F.hash = V.hash), this.locationVisit(F, i === !0);
      } else if (I.response) x3(I.response) && A3.show(I.response.data);
      else return Promise.reject(I);
    }).then(() => {
      this.activeVisit && this.finishVisit(this.activeVisit);
    }).catch((I) => {
      if (!me.isCancel(I)) {
        let F = E3(I);
        if (this.activeVisit && this.finishVisit(this.activeVisit), F) return Promise.reject(I);
      }
    });
  }
  setPage(t, { visitId: r = this.createVisitId(), replace: n = !1, preserveScroll: o = !1, preserveState: i = !1 } = {}) {
    return Promise.resolve(this.resolveComponent(t.component)).then((s) => {
      r === this.visitId && (t.scrollRegions = this.page.scrollRegions || [], t.rememberedState = t.rememberedState || {}, n = n || dr(t.url).href === window.location.href, n ? this.replaceState(t) : this.pushState(t), this.swapComponent({ component: s, page: t, preserveState: i }).then(() => {
        o ? this.restoreScrollPositions() : this.resetScrollPositions(), n || kr(t);
      }));
    });
  }
  pushState(t) {
    this.page = t, $s ? setTimeout(() => window.history.pushState(t, "", t.url)) : window.history.pushState(t, "", t.url);
  }
  replaceState(t) {
    this.page = t, $s ? setTimeout(() => window.history.replaceState(t, "", t.url)) : window.history.replaceState(t, "", t.url);
  }
  handlePopstateEvent(t) {
    if (t.state !== null) {
      let r = t.state, n = this.createVisitId();
      Promise.resolve(this.resolveComponent(r.component)).then((o) => {
        n === this.visitId && (this.page = r, this.swapComponent({ component: o, page: r, preserveState: !1 }).then(() => {
          this.restoreScrollPositions(), kr(r);
        }));
      });
    } else {
      let r = dr(this.page.url);
      r.hash = window.location.hash, this.replaceState({ ...this.page, url: r.href }), this.resetScrollPositions();
    }
  }
  get(t, r = {}, n = {}) {
    return this.visit(t, { ...n, method: "get", data: r });
  }
  reload(t = {}) {
    return this.visit(window.location.href, { ...t, preserveScroll: !0, preserveState: !0 });
  }
  replace(t, r = {}) {
    return console.warn(`Inertia.replace() has been deprecated and will be removed in a future release. Please use Inertia.${r.method ?? "get"}() instead.`), this.visit(t, { preserveState: !0, ...r, replace: !0 });
  }
  post(t, r = {}, n = {}) {
    return this.visit(t, { preserveState: !0, ...n, method: "post", data: r });
  }
  put(t, r = {}, n = {}) {
    return this.visit(t, { preserveState: !0, ...n, method: "put", data: r });
  }
  patch(t, r = {}, n = {}) {
    return this.visit(t, { preserveState: !0, ...n, method: "patch", data: r });
  }
  delete(t, r = {}) {
    return this.visit(t, { preserveState: !0, ...r, method: "delete" });
  }
  remember(t, r = "default") {
    var n;
    Mn || this.replaceState({ ...this.page, rememberedState: { ...(n = this.page) == null ? void 0 : n.rememberedState, [r]: t } });
  }
  restore(t = "default") {
    var r, n;
    if (!Mn) return (n = (r = window.history.state) == null ? void 0 : r.rememberedState) == null ? void 0 : n[t];
  }
  on(t, r) {
    if (Mn) return () => {
    };
    let n = (o) => {
      let i = r(o);
      o.cancelable && !o.defaultPrevented && i === !1 && o.preventDefault();
    };
    return document.addEventListener(`inertia:${t}`, n), () => document.removeEventListener(`inertia:${t}`, n);
  }
};
function T3(e) {
  let t = e.currentTarget.tagName.toLowerCase() === "a";
  return !(e.target && (e == null ? void 0 : e.target).isContentEditable || e.defaultPrevented || t && e.altKey || t && e.ctrlKey || t && e.metaKey || t && e.shiftKey || t && "button" in e && e.button !== 0);
}
var Ja = new L3(), Ur = { exports: {} };
Ur.exports;
var qs;
function M3() {
  return qs || (qs = 1, (function(e, t) {
    var r = 200, n = "__lodash_hash_undefined__", o = 1, i = 2, s = 9007199254740991, a = "[object Arguments]", u = "[object Array]", d = "[object AsyncFunction]", h = "[object Boolean]", f = "[object Date]", b = "[object Error]", C = "[object Function]", l = "[object GeneratorFunction]", g = "[object Map]", p = "[object Number]", m = "[object Null]", v = "[object Object]", S = "[object Promise]", x = "[object Proxy]", A = "[object RegExp]", N = "[object Set]", $ = "[object String]", q = "[object Symbol]", I = "[object Undefined]", F = "[object WeakMap]", V = "[object ArrayBuffer]", k = "[object DataView]", Y = "[object Float32Array]", ne = "[object Float64Array]", ae = "[object Int8Array]", T = "[object Int16Array]", M = "[object Int32Array]", P = "[object Uint8Array]", U = "[object Uint8ClampedArray]", H = "[object Uint16Array]", z = "[object Uint32Array]", te = /[\\^$.*+?()[\]{}|]/g, re = /^\[object .+?Constructor\]$/, pe = /^(?:0|[1-9]\d*)$/, W = {};
    W[Y] = W[ne] = W[ae] = W[T] = W[M] = W[P] = W[U] = W[H] = W[z] = !0, W[a] = W[u] = W[V] = W[h] = W[k] = W[f] = W[b] = W[C] = W[g] = W[p] = W[v] = W[A] = W[N] = W[$] = W[F] = !1;
    var xe = typeof pr == "object" && pr && pr.Object === Object && pr, Te = typeof self == "object" && self && self.Object === Object && self, Me = xe || Te || Function("return this")(), Oe = t && !t.nodeType && t, oe = Oe && !0 && e && !e.nodeType && e, ve = oe && oe.exports === Oe, ue = ve && xe.process, Se = (function() {
      try {
        return ue && ue.binding && ue.binding("util");
      } catch {
      }
    })(), Pe = Se && Se.isTypedArray;
    function Ve(y, w) {
      for (var _ = -1, B = y == null ? 0 : y.length, ge = 0, ee = []; ++_ < B; ) {
        var Ee = y[_];
        w(Ee, _, y) && (ee[ge++] = Ee);
      }
      return ee;
    }
    function _e(y, w) {
      for (var _ = -1, B = w.length, ge = y.length; ++_ < B; )
        y[ge + _] = w[_];
      return y;
    }
    function qe(y, w) {
      for (var _ = -1, B = y == null ? 0 : y.length; ++_ < B; )
        if (w(y[_], _, y))
          return !0;
      return !1;
    }
    function je(y, w) {
      for (var _ = -1, B = Array(y); ++_ < y; )
        B[_] = w(_);
      return B;
    }
    function At(y) {
      return function(w) {
        return y(w);
      };
    }
    function lt(y, w) {
      return y.has(w);
    }
    function Qe(y, w) {
      return y == null ? void 0 : y[w];
    }
    function Lt(y) {
      var w = -1, _ = Array(y.size);
      return y.forEach(function(B, ge) {
        _[++w] = [ge, B];
      }), _;
    }
    function Tt(y, w) {
      return function(_) {
        return y(w(_));
      };
    }
    function Mt(y) {
      var w = -1, _ = Array(y.size);
      return y.forEach(function(B) {
        _[++w] = B;
      }), _;
    }
    var eo = Array.prototype, to = Function.prototype, jt = Object.prototype, Lr = Me["__core-js_shared__"], _t = to.toString, Ke = jt.hasOwnProperty, Tr = (function() {
      var y = /[^.]+$/.exec(Lr && Lr.keys && Lr.keys.IE_PROTO || "");
      return y ? "Symbol(src)_1." + y : "";
    })(), ln = jt.toString, ro = RegExp(
      "^" + _t.call(Ke).replace(te, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), cr = ve ? Me.Buffer : void 0, Ct = Me.Symbol, E = Me.Uint8Array, R = jt.propertyIsEnumerable, ce = eo.splice, se = Ct ? Ct.toStringTag : void 0, he = Object.getOwnPropertySymbols, X = cr ? cr.isBuffer : void 0, ut = Tt(Object.keys, Object), nt = ur(Me, "DataView"), Ae = ur(Me, "Map"), Ye = ur(Me, "Promise"), Kt = ur(Me, "Set"), ft = ur(Me, "WeakMap"), $e = ur(Object, "create"), un = Wt(nt), fn = Wt(Ae), dn = Wt(Ye), zt = Wt(Kt), Mr = Wt(ft), Gt = Ct ? Ct.prototype : void 0, Zt = Gt ? Gt.valueOf : void 0;
    function ot(y) {
      var w = -1, _ = y == null ? 0 : y.length;
      for (this.clear(); ++w < _; ) {
        var B = y[w];
        this.set(B[0], B[1]);
      }
    }
    function pn() {
      this.__data__ = $e ? $e(null) : {}, this.size = 0;
    }
    function hn(y) {
      var w = this.has(y) && delete this.__data__[y];
      return this.size -= w ? 1 : 0, w;
    }
    function _r(y) {
      var w = this.__data__;
      if ($e) {
        var _ = w[y];
        return _ === n ? void 0 : _;
      }
      return Ke.call(w, y) ? w[y] : void 0;
    }
    function yn(y) {
      var w = this.__data__;
      return $e ? w[y] !== void 0 : Ke.call(w, y);
    }
    function Nr(y, w) {
      var _ = this.__data__;
      return this.size += this.has(y) ? 0 : 1, _[y] = $e && w === void 0 ? n : w, this;
    }
    ot.prototype.clear = pn, ot.prototype.delete = hn, ot.prototype.get = _r, ot.prototype.has = yn, ot.prototype.set = Nr;
    function Xe(y) {
      var w = -1, _ = y == null ? 0 : y.length;
      for (this.clear(); ++w < _; ) {
        var B = y[w];
        this.set(B[0], B[1]);
      }
    }
    function no() {
      this.__data__ = [], this.size = 0;
    }
    function Fr(y) {
      var w = this.__data__, _ = gn(w, y);
      if (_ < 0)
        return !1;
      var B = w.length - 1;
      return _ == B ? w.pop() : ce.call(w, _, 1), --this.size, !0;
    }
    function Nt(y) {
      var w = this.__data__, _ = gn(w, y);
      return _ < 0 ? void 0 : w[_][1];
    }
    function lr(y) {
      return gn(this.__data__, y) > -1;
    }
    function oo(y, w) {
      var _ = this.__data__, B = gn(_, y);
      return B < 0 ? (++this.size, _.push([y, w])) : _[B][1] = w, this;
    }
    Xe.prototype.clear = no, Xe.prototype.delete = Fr, Xe.prototype.get = Nt, Xe.prototype.has = lr, Xe.prototype.set = oo;
    function dt(y) {
      var w = -1, _ = y == null ? 0 : y.length;
      for (this.clear(); ++w < _; ) {
        var B = y[w];
        this.set(B[0], B[1]);
      }
    }
    function N2() {
      this.size = 0, this.__data__ = {
        hash: new ot(),
        map: new (Ae || Xe)(),
        string: new ot()
      };
    }
    function F2(y) {
      var w = Cn(this, y).delete(y);
      return this.size -= w ? 1 : 0, w;
    }
    function $2(y) {
      return Cn(this, y).get(y);
    }
    function I2(y) {
      return Cn(this, y).has(y);
    }
    function q2(y, w) {
      var _ = Cn(this, y), B = _.size;
      return _.set(y, w), this.size += _.size == B ? 0 : 1, this;
    }
    dt.prototype.clear = N2, dt.prototype.delete = F2, dt.prototype.get = $2, dt.prototype.has = I2, dt.prototype.set = q2;
    function mn(y) {
      var w = -1, _ = y == null ? 0 : y.length;
      for (this.__data__ = new dt(); ++w < _; )
        this.add(y[w]);
    }
    function k2(y) {
      return this.__data__.set(y, n), this;
    }
    function D2(y) {
      return this.__data__.has(y);
    }
    mn.prototype.add = mn.prototype.push = k2, mn.prototype.has = D2;
    function Ft(y) {
      var w = this.__data__ = new Xe(y);
      this.size = w.size;
    }
    function H2() {
      this.__data__ = new Xe(), this.size = 0;
    }
    function B2(y) {
      var w = this.__data__, _ = w.delete(y);
      return this.size = w.size, _;
    }
    function U2(y) {
      return this.__data__.get(y);
    }
    function V2(y) {
      return this.__data__.has(y);
    }
    function j2(y, w) {
      var _ = this.__data__;
      if (_ instanceof Xe) {
        var B = _.__data__;
        if (!Ae || B.length < r - 1)
          return B.push([y, w]), this.size = ++_.size, this;
        _ = this.__data__ = new dt(B);
      }
      return _.set(y, w), this.size = _.size, this;
    }
    Ft.prototype.clear = H2, Ft.prototype.delete = B2, Ft.prototype.get = U2, Ft.prototype.has = V2, Ft.prototype.set = j2;
    function K2(y, w) {
      var _ = vn(y), B = !_ && sc(y), ge = !_ && !B && io(y), ee = !_ && !B && !ge && f1(y), Ee = _ || B || ge || ee, Ne = Ee ? je(y.length, String) : [], Ie = Ne.length;
      for (var we in y)
        Ke.call(y, we) && !(Ee && // Safari 9 has enumerable `arguments.length` in strict mode.
        (we == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        ge && (we == "offset" || we == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        ee && (we == "buffer" || we == "byteLength" || we == "byteOffset") || // Skip index properties.
        tc(we, Ie))) && Ne.push(we);
      return Ne;
    }
    function gn(y, w) {
      for (var _ = y.length; _--; )
        if (a1(y[_][0], w))
          return _;
      return -1;
    }
    function z2(y, w, _) {
      var B = w(y);
      return vn(y) ? B : _e(B, _(y));
    }
    function $r(y) {
      return y == null ? y === void 0 ? I : m : se && se in Object(y) ? X2(y) : ic(y);
    }
    function n1(y) {
      return Ir(y) && $r(y) == a;
    }
    function o1(y, w, _, B, ge) {
      return y === w ? !0 : y == null || w == null || !Ir(y) && !Ir(w) ? y !== y && w !== w : G2(y, w, _, B, o1, ge);
    }
    function G2(y, w, _, B, ge, ee) {
      var Ee = vn(y), Ne = vn(w), Ie = Ee ? u : $t(y), we = Ne ? u : $t(w);
      Ie = Ie == a ? v : Ie, we = we == a ? v : we;
      var Je = Ie == v, it = we == v, ke = Ie == we;
      if (ke && io(y)) {
        if (!io(w))
          return !1;
        Ee = !0, Je = !1;
      }
      if (ke && !Je)
        return ee || (ee = new Ft()), Ee || f1(y) ? i1(y, w, _, B, ge, ee) : J2(y, w, Ie, _, B, ge, ee);
      if (!(_ & o)) {
        var et = Je && Ke.call(y, "__wrapped__"), tt = it && Ke.call(w, "__wrapped__");
        if (et || tt) {
          var It = et ? y.value() : y, vt = tt ? w.value() : w;
          return ee || (ee = new Ft()), ge(It, vt, _, B, ee);
        }
      }
      return ke ? (ee || (ee = new Ft()), Y2(y, w, _, B, ge, ee)) : !1;
    }
    function Z2(y) {
      if (!u1(y) || nc(y))
        return !1;
      var w = c1(y) ? ro : re;
      return w.test(Wt(y));
    }
    function W2(y) {
      return Ir(y) && l1(y.length) && !!W[$r(y)];
    }
    function Q2(y) {
      if (!oc(y))
        return ut(y);
      var w = [];
      for (var _ in Object(y))
        Ke.call(y, _) && _ != "constructor" && w.push(_);
      return w;
    }
    function i1(y, w, _, B, ge, ee) {
      var Ee = _ & o, Ne = y.length, Ie = w.length;
      if (Ne != Ie && !(Ee && Ie > Ne))
        return !1;
      var we = ee.get(y);
      if (we && ee.get(w))
        return we == w;
      var Je = -1, it = !0, ke = _ & i ? new mn() : void 0;
      for (ee.set(y, w), ee.set(w, y); ++Je < Ne; ) {
        var et = y[Je], tt = w[Je];
        if (B)
          var It = Ee ? B(tt, et, Je, w, y, ee) : B(et, tt, Je, y, w, ee);
        if (It !== void 0) {
          if (It)
            continue;
          it = !1;
          break;
        }
        if (ke) {
          if (!qe(w, function(vt, Qt) {
            if (!lt(ke, Qt) && (et === vt || ge(et, vt, _, B, ee)))
              return ke.push(Qt);
          })) {
            it = !1;
            break;
          }
        } else if (!(et === tt || ge(et, tt, _, B, ee))) {
          it = !1;
          break;
        }
      }
      return ee.delete(y), ee.delete(w), it;
    }
    function J2(y, w, _, B, ge, ee, Ee) {
      switch (_) {
        case k:
          if (y.byteLength != w.byteLength || y.byteOffset != w.byteOffset)
            return !1;
          y = y.buffer, w = w.buffer;
        case V:
          return !(y.byteLength != w.byteLength || !ee(new E(y), new E(w)));
        case h:
        case f:
        case p:
          return a1(+y, +w);
        case b:
          return y.name == w.name && y.message == w.message;
        case A:
        case $:
          return y == w + "";
        case g:
          var Ne = Lt;
        case N:
          var Ie = B & o;
          if (Ne || (Ne = Mt), y.size != w.size && !Ie)
            return !1;
          var we = Ee.get(y);
          if (we)
            return we == w;
          B |= i, Ee.set(y, w);
          var Je = i1(Ne(y), Ne(w), B, ge, ee, Ee);
          return Ee.delete(y), Je;
        case q:
          if (Zt)
            return Zt.call(y) == Zt.call(w);
      }
      return !1;
    }
    function Y2(y, w, _, B, ge, ee) {
      var Ee = _ & o, Ne = s1(y), Ie = Ne.length, we = s1(w), Je = we.length;
      if (Ie != Je && !Ee)
        return !1;
      for (var it = Ie; it--; ) {
        var ke = Ne[it];
        if (!(Ee ? ke in w : Ke.call(w, ke)))
          return !1;
      }
      var et = ee.get(y);
      if (et && ee.get(w))
        return et == w;
      var tt = !0;
      ee.set(y, w), ee.set(w, y);
      for (var It = Ee; ++it < Ie; ) {
        ke = Ne[it];
        var vt = y[ke], Qt = w[ke];
        if (B)
          var d1 = Ee ? B(Qt, vt, ke, w, y, ee) : B(vt, Qt, ke, y, w, ee);
        if (!(d1 === void 0 ? vt === Qt || ge(vt, Qt, _, B, ee) : d1)) {
          tt = !1;
          break;
        }
        It || (It = ke == "constructor");
      }
      if (tt && !It) {
        var bn = y.constructor, wn = w.constructor;
        bn != wn && "constructor" in y && "constructor" in w && !(typeof bn == "function" && bn instanceof bn && typeof wn == "function" && wn instanceof wn) && (tt = !1);
      }
      return ee.delete(y), ee.delete(w), tt;
    }
    function s1(y) {
      return z2(y, lc, ec);
    }
    function Cn(y, w) {
      var _ = y.__data__;
      return rc(w) ? _[typeof w == "string" ? "string" : "hash"] : _.map;
    }
    function ur(y, w) {
      var _ = Qe(y, w);
      return Z2(_) ? _ : void 0;
    }
    function X2(y) {
      var w = Ke.call(y, se), _ = y[se];
      try {
        y[se] = void 0;
        var B = !0;
      } catch {
      }
      var ge = ln.call(y);
      return B && (w ? y[se] = _ : delete y[se]), ge;
    }
    var ec = he ? function(y) {
      return y == null ? [] : (y = Object(y), Ve(he(y), function(w) {
        return R.call(y, w);
      }));
    } : uc, $t = $r;
    (nt && $t(new nt(new ArrayBuffer(1))) != k || Ae && $t(new Ae()) != g || Ye && $t(Ye.resolve()) != S || Kt && $t(new Kt()) != N || ft && $t(new ft()) != F) && ($t = function(y) {
      var w = $r(y), _ = w == v ? y.constructor : void 0, B = _ ? Wt(_) : "";
      if (B)
        switch (B) {
          case un:
            return k;
          case fn:
            return g;
          case dn:
            return S;
          case zt:
            return N;
          case Mr:
            return F;
        }
      return w;
    });
    function tc(y, w) {
      return w = w ?? s, !!w && (typeof y == "number" || pe.test(y)) && y > -1 && y % 1 == 0 && y < w;
    }
    function rc(y) {
      var w = typeof y;
      return w == "string" || w == "number" || w == "symbol" || w == "boolean" ? y !== "__proto__" : y === null;
    }
    function nc(y) {
      return !!Tr && Tr in y;
    }
    function oc(y) {
      var w = y && y.constructor, _ = typeof w == "function" && w.prototype || jt;
      return y === _;
    }
    function ic(y) {
      return ln.call(y);
    }
    function Wt(y) {
      if (y != null) {
        try {
          return _t.call(y);
        } catch {
        }
        try {
          return y + "";
        } catch {
        }
      }
      return "";
    }
    function a1(y, w) {
      return y === w || y !== y && w !== w;
    }
    var sc = n1(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? n1 : function(y) {
      return Ir(y) && Ke.call(y, "callee") && !R.call(y, "callee");
    }, vn = Array.isArray;
    function ac(y) {
      return y != null && l1(y.length) && !c1(y);
    }
    var io = X || fc;
    function cc(y, w) {
      return o1(y, w);
    }
    function c1(y) {
      if (!u1(y))
        return !1;
      var w = $r(y);
      return w == C || w == l || w == d || w == x;
    }
    function l1(y) {
      return typeof y == "number" && y > -1 && y % 1 == 0 && y <= s;
    }
    function u1(y) {
      var w = typeof y;
      return y != null && (w == "object" || w == "function");
    }
    function Ir(y) {
      return y != null && typeof y == "object";
    }
    var f1 = Pe ? At(Pe) : W2;
    function lc(y) {
      return ac(y) ? K2(y) : Q2(y);
    }
    function uc() {
      return [];
    }
    function fc() {
      return !1;
    }
    e.exports = cc;
  })(Ur, Ur.exports)), Ur.exports;
}
M3();
var Ya = Ut(void 0);
Ya.displayName = "InertiaHeadContext";
var _3 = Ya, N3 = Ut(void 0);
N3.displayName = "InertiaPageContext";
var F3 = function({ children: e, title: t }) {
  let r = mt(_3), n = yt(() => r.createProvider(), [r]);
  Be(() => () => {
    n.disconnect();
  }, [n]);
  function o(f) {
    return ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"].indexOf(f.type) > -1;
  }
  function i(f) {
    let b = Object.keys(f.props).reduce((C, l) => {
      if (["head-key", "children", "dangerouslySetInnerHTML"].includes(l)) return C;
      let g = f.props[l];
      return g === "" ? C + ` ${l}` : C + ` ${l}="${g}"`;
    }, "");
    return `<${f.type}${b}>`;
  }
  function s(f) {
    return typeof f.props.children == "string" ? f.props.children : f.props.children.reduce((b, C) => b + a(C), "");
  }
  function a(f) {
    let b = i(f);
    return f.props.children && (b += s(f)), f.props.dangerouslySetInnerHTML && (b += f.props.dangerouslySetInnerHTML.__html), o(f) || (b += `</${f.type}>`), b;
  }
  function u(f) {
    return ye.cloneElement(f, { inertia: f.props["head-key"] !== void 0 ? f.props["head-key"] : "" });
  }
  function d(f) {
    return a(u(f));
  }
  function h(f) {
    let b = ye.Children.toArray(f).filter((C) => C).map((C) => d(C));
    return t && !b.find((C) => C.startsWith("<title")) && b.push(`<title inertia>${t}</title>`), b;
  }
  return n.update(h(e)), null;
}, $3 = F3, bt = () => {
}, I3 = Ii(({ children: e, as: t = "a", data: r = {}, href: n, method: o = "get", preserveScroll: i = !1, preserveState: s = null, replace: a = !1, only: u = [], except: d = [], headers: h = {}, queryStringArrayFormat: f = "brackets", onClick: b = bt, onCancelToken: C = bt, onBefore: l = bt, onStart: g = bt, onProgress: p = bt, onFinish: m = bt, onCancel: v = bt, onSuccess: S = bt, onError: x = bt, ...A }, N) => {
  let $ = Fe((F) => {
    b(F), T3(F) && (F.preventDefault(), Ja.visit(n, { data: r, method: o, preserveScroll: i, preserveState: s ?? o !== "get", replace: a, only: u, except: d, headers: h, onCancelToken: C, onBefore: l, onStart: g, onProgress: p, onFinish: m, onCancel: v, onSuccess: S, onError: x }));
  }, [r, n, o, i, s, a, u, d, h, b, C, l, g, p, m, v, S, x]);
  t = t.toLowerCase(), o = o.toLowerCase();
  let [q, I] = Qa(o, n || "", r, f);
  return n = q, r = I, t === "a" && o !== "get" && console.warn(`Creating POST/PUT/PATCH/DELETE <a> links is discouraged as it causes "Open Link in New Tab/Window" accessibility issues.

Please specify a more appropriate element using the "as" attribute. For example:

<Link href="${n}" method="${o}" as="button">...</Link>`), na(t, { ...A, ...t === "a" ? { href: n } : {}, ref: N, onClick: $ }, e);
});
I3.displayName = "InertiaLink";
var Or = Ja;
const Ki = {
  status: ["user", "twoFactor", "status"],
  recoveryCodes: ["user", "twoFactor", "recoveryCodes"],
  totpSetup: ["user", "twoFactor", "totpSetup"]
}, Re = {
  base: ["user"],
  sessions: () => [...Re.base, "sessions"],
  invites: () => [...Re.base, "invites"],
  users: () => [...Re.base, "list"],
  usersSearch: (e) => [...Re.users(), { search: e }],
  calendarToken: (e) => [...Re.base, "calendarToken", e],
  stats: (e) => [...Re.base, "stats", e]
}, s7 = (e) => ({
  queryKey: Re.sessions(),
  queryFn: w0,
  ...e
}), a7 = (e) => ({
  queryKey: Re.invites(),
  queryFn: b0,
  ...e
}), c7 = (e) => ({
  queryKey: Re.users(),
  queryFn: S0,
  ...e
}), l7 = (e, t) => ({
  queryKey: Re.usersSearch(e),
  queryFn: () => v0(e),
  enabled: !!e,
  initialData: [],
  ...t
}), u7 = (e) => ({
  mutationFn: C0,
  onSuccess: async (...t) => {
    Or.reload({ only: ["mustVerifyEmail", "status", "auth"] }), e != null && e.onSuccess && await e.onSuccess(...t);
  },
  ...e
}), f7 = (e) => ({
  mutationFn: E0,
  onSuccess: async (...t) => {
    Or.reload({ only: ["auth"] }), e != null && e.onSuccess && await e.onSuccess(...t);
  },
  ...e
}), d7 = (e) => ({
  mutationFn: x0,
  onSuccess: async (...t) => {
    Or.reload({ only: ["auth"] }), e != null && e.onSuccess && await e.onSuccess(...t);
  },
  ...e
}), p7 = (e, t) => ({
  queryKey: Re.stats(e),
  queryFn: () => R0(e),
  ...t
}), h7 = (e, t) => ({
  queryKey: Re.calendarToken(e),
  queryFn: () => O0(e),
  ...t
}), y7 = (e) => ({
  queryKey: Ki.status,
  queryFn: P0,
  ...e
}), m7 = (e) => ({
  queryKey: Ki.totpSetup,
  queryFn: A0,
  ...e
}), g7 = (e) => ({
  queryKey: Ki.recoveryCodes,
  queryFn: _0,
  ...e
}), C7 = (e) => ({
  mutationFn: L0,
  ...e
}), v7 = (e) => ({
  mutationFn: T0,
  ...e
}), b7 = (e) => ({
  mutationFn: M0,
  ...e
}), w7 = (e) => ({
  mutationFn: N0,
  ...e
}), j = {
  base: ["groups"],
  types: () => [...j.base, "types"],
  all: () => [...j.base, "all"],
  id: (e) => [...j.base, e],
  infinite: () => [...j.base, "paginated"],
  infiniteFilters: (e) => [...j.paginated(), e],
  members: () => [...j.base, "members"],
  membersId: (e) => [...j.members(), e],
  pending: () => [...j.base, "pending"],
  pendingId: (e) => [...j.pending(), e],
  sessions: () => [...j.base, "sessions"],
  sessionsId: (e) => [...j.sessions(), e],
  admin: ["groups", "admin"],
  paginated: () => [...j.admin, "paginated"],
  paginatedFilters: (e) => [...j.paginated(), e]
}, S7 = (e) => ({
  queryKey: j.all(),
  queryFn: n0,
  ...e
}), E7 = (e, t) => ({
  queryKey: j.infiniteFilters(e),
  queryFn: ({ pageParam: r = 1 }) => g0({
    ...e,
    page: r
  }),
  initialPageParam: 1,
  getNextPageParam: (r) => r.hasMore ? r.page + 1 : void 0,
  gcTime: e.search ? 0 : 300 * 1e3,
  ...t
}), x7 = (e, t) => ({
  queryKey: j.id(e),
  queryFn: () => o0(e),
  ...t
}), R7 = (e) => ({
  queryKey: j.types(),
  queryFn: () => i0().then(
    (t) => t.filter((r) => r.allow[0] === "create_group")
  ),
  ...e
}), O7 = (e) => ({
  mutationFn: s0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.all()
      }),
      o.client.invalidateQueries({
        queryKey: j.paginated()
      })
    ]), o.client.setQueryData(
      j.id(`${t.id}`),
      t
    ), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), P7 = (e, t) => ({
  mutationFn: (r) => a0({ id: e, data: r }),
  ...t,
  onSuccess: async (r, n, o, i) => {
    await Promise.all([
      i.client.invalidateQueries({
        queryKey: j.all()
      }),
      i.client.invalidateQueries({
        queryKey: j.paginated()
      })
    ]), i.client.setQueryData(
      j.id(`${r.id}`),
      r
    ), t != null && t.onSuccess && await t.onSuccess(r, n, o, i);
  }
}), A7 = (e, t) => ({
  queryKey: j.membersId(e),
  queryFn: () => l0(e),
  ...t
}), L7 = (e, t) => ({
  queryKey: j.pendingId(e),
  queryFn: () => u0(e),
  ...t
}), T7 = (e) => ({
  mutationFn: d0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.pendingId(r.groupId)
      })
    ]), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), M7 = (e) => ({
  mutationFn: (t) => p0(t),
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.pendingId(r.id)
      })
    ]), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), _7 = (e) => ({
  mutationFn: h0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.all()
      }),
      o.client.invalidateQueries({
        queryKey: Re.invites()
      }),
      o.client.invalidateQueries({
        queryKey: j.paginated()
      }),
      o.client.invalidateQueries({
        queryKey: j.membersId(`${t.id}`)
      }),
      o.client.invalidateQueries({
        queryKey: j.pendingId(`${t.id}`)
      })
    ]), o.client.setQueryData(
      j.id(`${t.id}`),
      t
    ), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), N7 = (e) => ({
  mutationFn: y0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.pendingId(`${t.id}`)
      }),
      o.client.invalidateQueries({
        queryKey: Re.invites()
      })
    ]), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), F7 = (e, t) => ({
  queryKey: j.sessionsId(e),
  queryFn: () => f0(e),
  ...t
}), $7 = (e) => ({
  mutationFn: m0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    if (r.userId ? await o.client.invalidateQueries({
      queryKey: j.membersId(r.userId)
    }) : (await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.all()
      }),
      o.client.invalidateQueries({
        queryKey: j.paginated()
      })
    ]), o.client.removeQueries({
      queryKey: j.id(r.groupId)
    }), o.client.removeQueries({
      queryKey: j.membersId(r.groupId)
    }), o.client.removeQueries({
      queryKey: j.pendingId(r.groupId)
    })), e != null && e.onSuccess)
      return e.onSuccess(t, r, n, o);
  }
}), I7 = (e) => ({
  mutationFn: c0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: j.all()
      }),
      o.client.invalidateQueries({
        queryKey: j.paginated()
      })
    ]), o.client.removeQueries({
      queryKey: j.id(r)
    }), o.client.removeQueries({
      queryKey: j.membersId(r)
    }), o.client.removeQueries({
      queryKey: j.pendingId(r)
    }), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), q7 = (e, t) => ({
  queryKey: j.paginatedFilters(e),
  queryFn: () => qa(e),
  placeholderData: Yr,
  ...t
}), k7 = (e) => ({
  queryKey: j.paginatedFilters(e),
  queryFn: () => qa(e)
}), K = {
  base: ["sessions"],
  all: () => [...K.base, "all"],
  id: (e) => [...K.base, e],
  next: () => [...K.base, "next"],
  current: () => [...K.base, "current"],
  infinite: () => [...K.base, "infinite"],
  infiniteFilters: (e) => [...K.paginated(), e],
  members: () => [...K.base, "members"],
  membersId: (e) => [...K.members(), e],
  pending: () => [...K.base, "pending"],
  pendingId: (e) => [...K.pending(), e],
  connections: (e) => [...K.id(e), "connections"],
  admin: ["sessions", "admin"],
  paginated: () => [...K.admin, "paginated"],
  paginatedFilters: (e) => [...K.paginated(), e]
}, D7 = (e) => ({
  queryKey: K.all(),
  queryFn: zu,
  ...e
}), H7 = (e, t) => ({
  queryKey: K.infiniteFilters(e),
  queryFn: ({ pageParam: r = 1 }) => $a({
    ...e,
    page: r
  }),
  initialPageParam: 1,
  getNextPageParam: (r) => r.hasMore ? r.page + 1 : void 0,
  gcTime: e.search ? 0 : 300 * 1e3,
  ...t
}), B7 = () => ({
  queryKey: K.next(),
  queryFn: () => $a({
    page: 1,
    sort_by: "ends_at",
    order: "asc",
    is_past: !1,
    members_only: !0,
    limit: 1
  })
}), U7 = (e, t) => ({
  queryKey: K.id(e),
  queryFn: () => Na(e),
  ...t
}), V7 = (e, t) => ({
  queryKey: K.current(),
  queryFn: () => Na(e ?? ""),
  ...t
}), j7 = (e) => ({
  mutationFn: Zu,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.all()
      }),
      o.client.invalidateQueries({
        queryKey: Re.sessions()
      }),
      o.client.invalidateQueries({
        queryKey: K.paginated()
      }),
      o.client.invalidateQueries({
        queryKey: K.next()
      }),
      o.client.invalidateQueries({
        queryKey: j.sessions()
      })
    ]), o.client.setQueryData(
      K.id(`${t.id}`),
      t
    ), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), K7 = (e) => ({
  mutationFn: Wu,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.all()
      }),
      o.client.invalidateQueries({
        queryKey: Re.sessions()
      }),
      o.client.invalidateQueries({
        queryKey: K.paginated()
      }),
      o.client.invalidateQueries({
        queryKey: K.next()
      }),
      o.client.invalidateQueries({
        queryKey: j.sessions()
      })
    ]), o.client.setQueryData(
      K.id(`${t.id}`),
      t
    ), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), z7 = (e, t) => ({
  queryKey: K.membersId(e),
  queryFn: (r) => (r.client.refetchQueries({
    queryKey: K.connections(e)
  }), Fa(e)),
  ...t
}), G7 = (e, t) => ({
  queryKey: K.pendingId(e),
  queryFn: () => Ju(e),
  ...t
}), Z7 = (e) => ({
  mutationFn: Yu,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.pendingId(r.sessionId)
      })
    ]), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), W7 = (e) => ({
  mutationFn: (t) => Xu(t),
  ...e,
  onSuccess: async (t, r, n, o) => {
    if (await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.pendingId(r.id)
      })
    ]), e != null && e.onSuccess)
      return e.onSuccess(t, r, n, o);
  }
}), Q7 = (e) => ({
  mutationFn: e0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    if (await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.all()
      }),
      o.client.invalidateQueries({
        queryKey: Re.sessions()
      }),
      o.client.invalidateQueries({
        queryKey: Re.invites()
      }),
      o.client.invalidateQueries({
        queryKey: K.paginated()
      }),
      o.client.invalidateQueries({
        queryKey: K.next()
      }),
      o.client.invalidateQueries({
        queryKey: j.sessions()
      })
    ]), o.client.setQueryData(
      K.id(`${t.id}`),
      t
    ), e != null && e.onSuccess)
      return e.onSuccess(t, r, n, o);
  }
}), J7 = (e) => ({
  mutationFn: t0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    if (await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.pendingId(`${t.id}`)
      }),
      o.client.invalidateQueries({
        queryKey: Re.invites()
      })
    ]), e != null && e.onSuccess)
      return e.onSuccess(t, r, n, o);
  }
}), Y7 = (e) => ({
  mutationFn: r0,
  ...e,
  onSuccess: async (t, r, n, o) => {
    if (r.userId ? await o.client.invalidateQueries({
      queryKey: K.membersId(r.userId)
    }) : (await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.all()
      }),
      o.client.invalidateQueries({
        queryKey: Re.sessions()
      }),
      o.client.invalidateQueries({
        queryKey: K.paginated()
      }),
      o.client.invalidateQueries({
        queryKey: K.next()
      }),
      o.client.invalidateQueries({
        queryKey: j.sessions()
      })
    ]), o.client.removeQueries({
      queryKey: K.id(r.sessionId)
    }), o.client.removeQueries({
      queryKey: K.membersId(r.sessionId)
    }), o.client.removeQueries({
      queryKey: K.pendingId(r.sessionId)
    })), e != null && e.onSuccess)
      return e.onSuccess(t, r, n, o);
  }
}), X7 = (e) => ({
  mutationFn: Qu,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await Promise.all([
      o.client.invalidateQueries({
        queryKey: K.all()
      }),
      o.client.invalidateQueries({
        queryKey: Re.sessions()
      }),
      o.client.invalidateQueries({
        queryKey: K.paginated()
      }),
      o.client.invalidateQueries({
        queryKey: K.next()
      }),
      o.client.invalidateQueries({
        queryKey: j.sessions()
      })
    ]), o.client.removeQueries({
      queryKey: K.id(r)
    }), o.client.removeQueries({
      queryKey: K.membersId(r)
    }), o.client.removeQueries({
      queryKey: K.pendingId(r)
    }), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), e8 = (e, t) => ({
  queryKey: K.paginatedFilters(e),
  queryFn: () => Ia(e),
  placeholderData: Yr,
  ...t
}), t8 = (e) => ({
  queryKey: K.paginatedFilters(e),
  queryFn: () => Ia(e)
}), r8 = (e, t, r) => ({
  queryKey: K.connections(e),
  queryFn: async () => {
    const n = await Fa(e);
    return n ? await Gu(`${e}`, !1).then((o) => {
      const i = o.map((s) => s.user.id);
      return n.map((s) => ({
        ...s,
        connections_count: i.filter(
          (a) => a === s.id
        ).length
      }));
    }) : [];
  },
  initialData: t,
  refetchOnMount: !1,
  refetchOnWindowFocus: !1,
  ...r
}), q3 = () => G(
  route("api.connection.index.all"),
  "Connection"
), k3 = (e) => le(
  route("api.connection.connect"),
  e,
  "Connection"
), D3 = (e) => gt(
  route("api.connection.update"),
  e,
  "Connection"
), H3 = (e) => Rt(
  route("api.connection.disconnect", { identifier: e })
), B3 = (e) => {
  const r = route("api.connection.join", e);
  return le(
    r,
    void 0,
    "Connection"
  );
}, U3 = (e) => {
  const r = route("api.connection.leave", { connection: e });
  return le(
    r,
    void 0,
    "Connection"
  );
}, V3 = (e) => {
  const t = route("api.connection.peers", { connection: e });
  return G(t, "Connection");
}, j3 = ({
  session: e,
  data: { message: t }
}) => le(
  route("api.connection.whisper", { session: e }),
  {
    message: t
  }
), on = {
  base: ["connection"],
  peers: () => [...on.base, "peers"]
}, n8 = (e) => ({
  queryKey: on.peers(),
  queryFn: q3,
  ...e
}), o8 = (e) => ({
  mutationFn: k3,
  ...e,
  onSuccess: async (...t) => {
    Or.reload({ only: ["connection"] }), e != null && e.onSuccess && await e.onSuccess(...t);
  }
}), i8 = (e) => ({
  mutationFn: D3,
  ...e,
  onSuccess: async (...t) => {
    Or.reload({ only: ["connection"] }), e != null && e.onSuccess && await e.onSuccess(...t);
  }
}), s8 = (e) => ({
  mutationFn: H3,
  ...e,
  onSuccess: async (...t) => {
    Or.reload({ only: ["connection"] }), e != null && e.onSuccess && await e.onSuccess(...t);
  }
}), a8 = (e) => ({
  mutationFn: B3,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await o.client.invalidateQueries({
      queryKey: on.peers()
    }), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), c8 = (e) => ({
  mutationFn: U3,
  ...e,
  onSuccess: async (t, r, n, o) => {
    await o.client.invalidateQueries({
      queryKey: on.peers()
    }), e != null && e.onSuccess && await e.onSuccess(t, r, n, o);
  }
}), l8 = (e, t) => ({
  queryKey: on.peers(),
  queryFn: () => V3(e),
  enabled: !!e,
  ...t
}), u8 = (e) => ({
  mutationFn: j3,
  ...e
}), K3 = () => G(route("api.mirror.index"), "Mirror"), f8 = (e) => le(
  route("api.mirror.connect", { mirror: e }),
  void 0,
  "Mirror"
), z3 = ({
  mirror: e,
  session: t,
  persistent: r
}) => le(
  route("api.mirror.connect_and_join", {
    mirror: e,
    session: t,
    persistent: r ?? !1
  }),
  void 0,
  "Mirror"
), d8 = (e) => Rt(
  route("api.mirror.disconnect", { mirror: e }),
  "Mirror"
), p8 = (e, t) => G(
  route("api.mirror.join", { connection: e, session: t }),
  "Mirror"
), G3 = (e) => G(
  route("api.mirror.leave", { connection: e }),
  "Mirror"
), Xa = {
  base: ["mirror"],
  all: () => [...Xa.base, "all"]
}, h8 = (e) => ({
  queryFn: K3,
  queryKey: Xa.all(),
  ...e
}), y8 = (e) => ({
  mutationFn: z3,
  ...e
}), m8 = (e) => ({
  mutationFn: G3,
  ...e
}), Z3 = () => G(
  route("api.admin.plan.products"),
  "Paddle"
), W3 = () => G(route("api.admin.plan.prices"), "Paddle"), qn = {
  base: ["paddle"],
  products: () => [...qn.base, "products"],
  prices: () => [...qn.base, "prices"]
}, g8 = (e) => ({
  queryKey: qn.products(),
  queryFn: Z3,
  placeholderData: Yr,
  ...e
}), C8 = (e) => ({
  queryKey: qn.prices(),
  queryFn: W3,
  placeholderData: Yr,
  ...e
}), Q3 = (e) => {
  const r = route("api.blog.query", e);
  return G(r, "Blog");
}, J3 = (e) => {
  const r = route("api.blog.get", e);
  return G(r, "Blog");
}, Y3 = (e) => {
  const r = route("api.tag.query", e);
  return G(r, "Tag");
}, X3 = (e) => {
  const r = route("api.tag.get", e);
  return G(r, "Tag");
}, hr = {
  base: ["blog"],
  all: () => [...hr.base, "all"],
  infinite: () => [...hr.base, "infinite"],
  infiniteFilters: (e) => [...hr.infinite(), e],
  id: (e) => [...hr.base, e]
}, jr = {
  base: ["tag"],
  all: () => [...jr.base, "all"],
  filters: (e) => [...jr.all(), e],
  id: (e) => [...jr.base, e]
}, v8 = (e, t) => ({
  queryKey: hr.infiniteFilters(e),
  queryFn: ({ pageParam: r = 1 }) => Q3({
    ...e,
    page: r
  }),
  initialPageParam: 1,
  getNextPageParam: (r) => r.hasMore ? r.page + 1 : void 0,
  gcTime: e.search ? 0 : 300 * 1e3,
  ...t
}), b8 = (e, t) => ({
  queryKey: hr.id(e),
  queryFn: () => J3(e),
  ...t
}), w8 = (e = {}, t) => ({
  queryKey: jr.filters(e),
  queryFn: () => Y3(e),
  gcTime: e.search ? 0 : 300 * 1e3,
  ...t
}), S8 = (e, t) => ({
  queryKey: jr.id(e),
  queryFn: () => X3(e),
  ...t
}), E8 = (e) => {
  const r = route("register.store");
  return le(r, e, "login");
}, x8 = async (e) => {
  const r = route("api.crm.sync");
  return le(r, e);
}, R8 = (e) => {
  const r = route("api.crm.marketing-signup");
  return le(
    r,
    e
  );
}, O8 = ({
  formKey: e,
  data: t
}) => {
  const r = route("api.crm.form", { formKey: e });
  return le(r, t);
}, e5 = /^.+@.+\..+$/, P8 = /^[\w\-\s]+$/, A8 = (e) => e5.test(e), L8 = (e, t) => {
  const [r, n] = be(e);
  return Be(
    () => {
      const o = setTimeout(() => {
        n(e);
      }, t);
      return () => {
        clearTimeout(o);
      };
    },
    [e, t]
    // Only re-call effect if value or delay changes
  ), r;
}, T8 = (e) => {
  const [t, r] = be({}), n = (o, i) => {
    r({ ...t, [o]: i });
  };
  return Be(() => {
    const o = setTimeout(() => {
      Object.values(t).forEach((i) => i()), r({});
    }, e);
    return () => {
      clearTimeout(o);
    };
  }, [t, e]), n;
}, M8 = (e, t) => {
  if (t === void 0)
    return {
      dayMonth: "--",
      weekday: "-----",
      monthLong: "-----",
      monthShort: "---",
      time: "--:--"
    };
  typeof t == "string" && (t = new Date(t));
  const n = ((o) => {
    if (!o) return "default";
    const i = o.replace(/_/g, "-");
    try {
      return new Intl.Locale(i), i;
    } catch {
      return "default";
    }
  })(e.locale ?? void 0);
  return {
    dayMonth: t.toLocaleString(n, {
      day: "2-digit",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    }),
    weekday: t.toLocaleString(n, {
      weekday: "long",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    }),
    monthLong: t.toLocaleString(n, {
      month: "long",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    }),
    monthShort: t.toLocaleString(n, {
      month: "short",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    }),
    yearShort: t.toLocaleString(n, {
      year: "2-digit",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    }),
    yearLong: t.toLocaleString(n, {
      year: "numeric",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    }),
    time: t.toLocaleString(n, {
      hour12: !1,
      timeStyle: "short",
      timeZone: (e == null ? void 0 : e.timezone) ?? void 0
    })
  };
};
function _8(e) {
  if (!e) return;
  const t = new Date(e), r = t.getDate(), n = r % 10 === 1 && r !== 11 ? "st" : r % 10 === 2 && r !== 12 ? "nd" : r % 10 === 3 && r !== 13 ? "rd" : "th";
  return `${r}${n} ${t.toLocaleString("en-GB", { month: "long" })} ${t.getFullYear()}`;
}
function N8(e) {
  if (!e) return null;
  const t = Math.floor((Date.now() - e.getTime()) / 1e3), r = [
    { label: "year", seconds: 31536e3 },
    { label: "month", seconds: 2592e3 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 }
  ];
  for (const n of r) {
    const o = Math.floor(t / n.seconds);
    if (o >= 1)
      return `${o} ${n.label}${o !== 1 ? "s" : ""} ago`;
  }
  return "just now";
}
const F8 = (e, t) => e === void 0 || t === void 0 ? "" : (typeof e == "string" && (e = new Date(e)), typeof t == "string" && (t = new Date(t)), `${e.toLocaleString("default", { day: "2-digit" })} ${e.toLocaleString("default", { month: "short" })} ${e.toLocaleTimeString(
  "default",
  {
    hour12: !0,
    timeStyle: "short"
  }
)} - ${t.toLocaleTimeString("default", {
  hour12: !0,
  timeStyle: "short"
})}`), $8 = () => {
  const [e, t] = be({
    width: window.innerWidth,
    height: window.innerHeight
  });
  return Be(() => {
    const r = () => t({ width: window.innerWidth, height: window.innerHeight });
    return window.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r);
    };
  }), e;
}, ks = (e) => {
  switch (e) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    default:
      return;
  }
}, I8 = (e) => {
  var r;
  if (!e) return null;
  const t = e ? Number(e.unit_price.amount) / 100 : null;
  return ((r = e.billing_cycle) == null ? void 0 : r.interval) === "year" ? `${ks(e.unit_price.currency_code)}${(Math.round(Number(t) / 12 * 2) / 2 - 0.01).toFixed(2)}` : `${ks(e.unit_price.currency_code)}${t}`;
};
function Ds(e, t, r, n, o, i, s) {
  try {
    var a = e[i](s), u = a.value;
  } catch (d) {
    return void r(d);
  }
  a.done ? t(u) : Promise.resolve(u).then(n, o);
}
function t5(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, o) {
      var i = e.apply(t, r);
      function s(u) {
        Ds(i, n, o, s, a, "next", u);
      }
      function a(u) {
        Ds(i, n, o, s, a, "throw", u);
      }
      s(void 0);
    });
  };
}
function r5(e, t, r) {
  return (t = i5(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Hs(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Oi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hs(Object(r), !0).forEach(function(n) {
      r5(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hs(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function e2(e, t) {
  if (e == null) return {};
  var r, n, o = n5(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function n5(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.includes(n)) continue;
    r[n] = e[n];
  }
  return r;
}
function Pi() {
  Pi = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(T, M, P) {
    T[M] = P.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, s = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function d(T, M, P) {
    return Object.defineProperty(T, M, {
      value: P,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), T[M];
  }
  try {
    d({}, "");
  } catch {
    d = function(M, P, U) {
      return M[P] = U;
    };
  }
  function h(T, M, P, U) {
    var H = M && M.prototype instanceof m ? M : m, z = Object.create(H.prototype), te = new ne(U || []);
    return o(z, "_invoke", {
      value: F(T, P, te)
    }), z;
  }
  function f(T, M, P) {
    try {
      return {
        type: "normal",
        arg: T.call(M, P)
      };
    } catch (U) {
      return {
        type: "throw",
        arg: U
      };
    }
  }
  t.wrap = h;
  var b = "suspendedStart", C = "suspendedYield", l = "executing", g = "completed", p = {};
  function m() {
  }
  function v() {
  }
  function S() {
  }
  var x = {};
  d(x, s, function() {
    return this;
  });
  var A = Object.getPrototypeOf, N = A && A(A(ae([])));
  N && N !== r && n.call(N, s) && (x = N);
  var $ = S.prototype = m.prototype = Object.create(x);
  function q(T) {
    ["next", "throw", "return"].forEach(function(M) {
      d(T, M, function(P) {
        return this._invoke(M, P);
      });
    });
  }
  function I(T, M) {
    function P(H, z, te, re) {
      var pe = f(T[H], T, z);
      if (pe.type !== "throw") {
        var W = pe.arg, xe = W.value;
        return xe && typeof xe == "object" && n.call(xe, "__await") ? M.resolve(xe.__await).then(function(Te) {
          P("next", Te, te, re);
        }, function(Te) {
          P("throw", Te, te, re);
        }) : M.resolve(xe).then(function(Te) {
          W.value = Te, te(W);
        }, function(Te) {
          return P("throw", Te, te, re);
        });
      }
      re(pe.arg);
    }
    var U;
    o(this, "_invoke", {
      value: function(H, z) {
        function te() {
          return new M(function(re, pe) {
            P(H, z, re, pe);
          });
        }
        return U = U ? U.then(te, te) : te();
      }
    });
  }
  function F(T, M, P) {
    var U = b;
    return function(H, z) {
      if (U === l) throw Error("Generator is already running");
      if (U === g) {
        if (H === "throw") throw z;
        return {
          value: e,
          done: !0
        };
      }
      for (P.method = H, P.arg = z; ; ) {
        var te = P.delegate;
        if (te) {
          var re = V(te, P);
          if (re) {
            if (re === p) continue;
            return re;
          }
        }
        if (P.method === "next") P.sent = P._sent = P.arg;
        else if (P.method === "throw") {
          if (U === b) throw U = g, P.arg;
          P.dispatchException(P.arg);
        } else P.method === "return" && P.abrupt("return", P.arg);
        U = l;
        var pe = f(T, M, P);
        if (pe.type === "normal") {
          if (U = P.done ? g : C, pe.arg === p) continue;
          return {
            value: pe.arg,
            done: P.done
          };
        }
        pe.type === "throw" && (U = g, P.method = "throw", P.arg = pe.arg);
      }
    };
  }
  function V(T, M) {
    var P = M.method, U = T.iterator[P];
    if (U === e) return M.delegate = null, P === "throw" && T.iterator.return && (M.method = "return", M.arg = e, V(T, M), M.method === "throw") || P !== "return" && (M.method = "throw", M.arg = new TypeError("The iterator does not provide a '" + P + "' method")), p;
    var H = f(U, T.iterator, M.arg);
    if (H.type === "throw") return M.method = "throw", M.arg = H.arg, M.delegate = null, p;
    var z = H.arg;
    return z ? z.done ? (M[T.resultName] = z.value, M.next = T.nextLoc, M.method !== "return" && (M.method = "next", M.arg = e), M.delegate = null, p) : z : (M.method = "throw", M.arg = new TypeError("iterator result is not an object"), M.delegate = null, p);
  }
  function k(T) {
    var M = {
      tryLoc: T[0]
    };
    1 in T && (M.catchLoc = T[1]), 2 in T && (M.finallyLoc = T[2], M.afterLoc = T[3]), this.tryEntries.push(M);
  }
  function Y(T) {
    var M = T.completion || {};
    M.type = "normal", delete M.arg, T.completion = M;
  }
  function ne(T) {
    this.tryEntries = [{
      tryLoc: "root"
    }], T.forEach(k, this), this.reset(!0);
  }
  function ae(T) {
    if (T || T === "") {
      var M = T[s];
      if (M) return M.call(T);
      if (typeof T.next == "function") return T;
      if (!isNaN(T.length)) {
        var P = -1, U = function H() {
          for (; ++P < T.length; ) if (n.call(T, P)) return H.value = T[P], H.done = !1, H;
          return H.value = e, H.done = !0, H;
        };
        return U.next = U;
      }
    }
    throw new TypeError(typeof T + " is not iterable");
  }
  return v.prototype = S, o($, "constructor", {
    value: S,
    configurable: !0
  }), o(S, "constructor", {
    value: v,
    configurable: !0
  }), v.displayName = d(S, u, "GeneratorFunction"), t.isGeneratorFunction = function(T) {
    var M = typeof T == "function" && T.constructor;
    return !!M && (M === v || (M.displayName || M.name) === "GeneratorFunction");
  }, t.mark = function(T) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : (T.__proto__ = S, d(T, u, "GeneratorFunction")), T.prototype = Object.create($), T;
  }, t.awrap = function(T) {
    return {
      __await: T
    };
  }, q(I.prototype), d(I.prototype, a, function() {
    return this;
  }), t.AsyncIterator = I, t.async = function(T, M, P, U, H) {
    H === void 0 && (H = Promise);
    var z = new I(h(T, M, P, U), H);
    return t.isGeneratorFunction(M) ? z : z.next().then(function(te) {
      return te.done ? te.value : z.next();
    });
  }, q($), d($, u, "Generator"), d($, s, function() {
    return this;
  }), d($, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(T) {
    var M = Object(T), P = [];
    for (var U in M) P.push(U);
    return P.reverse(), function H() {
      for (; P.length; ) {
        var z = P.pop();
        if (z in M) return H.value = z, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, t.values = ae, ne.prototype = {
    constructor: ne,
    reset: function(T) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(Y), !T) for (var M in this) M.charAt(0) === "t" && n.call(this, M) && !isNaN(+M.slice(1)) && (this[M] = e);
    },
    stop: function() {
      this.done = !0;
      var T = this.tryEntries[0].completion;
      if (T.type === "throw") throw T.arg;
      return this.rval;
    },
    dispatchException: function(T) {
      if (this.done) throw T;
      var M = this;
      function P(pe, W) {
        return z.type = "throw", z.arg = T, M.next = pe, W && (M.method = "next", M.arg = e), !!W;
      }
      for (var U = this.tryEntries.length - 1; U >= 0; --U) {
        var H = this.tryEntries[U], z = H.completion;
        if (H.tryLoc === "root") return P("end");
        if (H.tryLoc <= this.prev) {
          var te = n.call(H, "catchLoc"), re = n.call(H, "finallyLoc");
          if (te && re) {
            if (this.prev < H.catchLoc) return P(H.catchLoc, !0);
            if (this.prev < H.finallyLoc) return P(H.finallyLoc);
          } else if (te) {
            if (this.prev < H.catchLoc) return P(H.catchLoc, !0);
          } else {
            if (!re) throw Error("try statement without catch or finally");
            if (this.prev < H.finallyLoc) return P(H.finallyLoc);
          }
        }
      }
    },
    abrupt: function(T, M) {
      for (var P = this.tryEntries.length - 1; P >= 0; --P) {
        var U = this.tryEntries[P];
        if (U.tryLoc <= this.prev && n.call(U, "finallyLoc") && this.prev < U.finallyLoc) {
          var H = U;
          break;
        }
      }
      H && (T === "break" || T === "continue") && H.tryLoc <= M && M <= H.finallyLoc && (H = null);
      var z = H ? H.completion : {};
      return z.type = T, z.arg = M, H ? (this.method = "next", this.next = H.finallyLoc, p) : this.complete(z);
    },
    complete: function(T, M) {
      if (T.type === "throw") throw T.arg;
      return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && M && (this.next = M), p;
    },
    finish: function(T) {
      for (var M = this.tryEntries.length - 1; M >= 0; --M) {
        var P = this.tryEntries[M];
        if (P.finallyLoc === T) return this.complete(P.completion, P.afterLoc), Y(P), p;
      }
    },
    catch: function(T) {
      for (var M = this.tryEntries.length - 1; M >= 0; --M) {
        var P = this.tryEntries[M];
        if (P.tryLoc === T) {
          var U = P.completion;
          if (U.type === "throw") {
            var H = U.arg;
            Y(P);
          }
          return H;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(T, M, P) {
      return this.delegate = {
        iterator: ae(T),
        resultName: M,
        nextLoc: P
      }, this.method === "next" && (this.arg = e), p;
    }
  }, t;
}
function o5(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function i5(e) {
  var t = o5(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
var Gr = {
  CLASSIC: "classic",
  V1: "v1"
}, s5 = Gr.V1, a5 = "https://cdn.paddle.com/paddle/paddle.js", c5 = "https://cdn.paddle.com/paddle/v2/paddle.js", l5 = {
  url: a5
}, u5 = {
  url: c5
};
function f5(e) {
  return document.querySelector('script[src="'.concat(e, '"]')) || void 0;
}
function d5(e) {
  var t = document.createElement("script");
  t.src = e;
  var r = document.head || document.body;
  if (!r)
    throw new Error("Cannot inject Paddle.js. It needs a <head> or <body> element.");
  return r.appendChild(t), t;
}
var ni = {
  classic: void 0,
  v1: void 0
}, p5 = {
  classic: "PaddleClassic",
  v1: "PaddleBillingV1"
};
function h5(e) {
  var t, r = (t = y5(e)) === null || t === void 0 ? void 0 : t.url;
  if (r) {
    var n = ni[e], o = p5[e];
    return n !== void 0 ? n : (ni[e] = new Promise(function(i, s) {
      if (typeof window > "u") {
        i(void 0);
        return;
      }
      if (window[o]) {
        i(window[o]);
        return;
      }
      try {
        var a = f5(r);
        a || (a = d5(r)), a.addEventListener("load", function() {
          window[o] ? i(window[o]) : s(new Error("Paddle.js not available"));
        }), a.addEventListener("error", function() {
          s(new Error("Failed to load Paddle.js - ".concat(e)));
        });
      } catch (u) {
        s(u);
        return;
      }
    }), ni[e]);
  }
}
function y5(e) {
  if (e === Gr.CLASSIC)
    return l5;
  if (e === Gr.V1)
    return u5;
  console.error("[Paddle] Unknown Paddle Version");
}
var m5 = ["environment", "version"], g5 = ["environment", "version"];
function C5(e, t) {
  var r = e.environment;
  e.version;
  var n = e2(e, m5);
  try {
    r && t.Environment.set(r), t.Initialized ? t.Update(Oi({}, n)) : t.Initialize(Oi({}, n));
  } catch (o) {
    console.warn("[Paddle] Paddle Initialization failed. Please check the inputs", o);
  }
}
function v5(e, t) {
  var r = e.environment;
  e.version;
  var n = e2(e, g5);
  try {
    r && t.Environment.set(r), t.Setup(Oi({}, n));
  } catch (o) {
    console.warn("[Paddle] Paddle Initialization failed. Please check the inputs", o);
  }
}
var Bs;
(function(e) {
  e.CHECKOUT_LOADED = "checkout.loaded", e.CHECKOUT_CLOSED = "checkout.closed", e.CHECKOUT_UPDATED = "checkout.updated", e.CHECKOUT_COMPLETED = "checkout.completed", e.CHECKOUT_ERROR = "checkout.error", e.CHECKOUT_FAILED = "checkout.failed", e.CHECKOUT_ITEMS_UPDATED = "checkout.items.updated", e.CHECKOUT_ITEMS_REMOVED = "checkout.items.removed", e.CHECKOUT_CUSTOMER_CREATED = "checkout.customer.created", e.CHECKOUT_CUSTOMER_UPDATED = "checkout.customer.updated", e.CHECKOUT_CUSTOMER_REMOVED = "checkout.customer.removed", e.CHECKOUT_PAYMENT_SELECTED = "checkout.payment.selected", e.CHECKOUT_PAYMENT_INITIATED = "checkout.payment.initiated", e.CHECKOUT_PAYMENT_FAILED = "checkout.payment.failed", e.CHECKOUT_PAYMENT_ERROR = "checkout.payment.error", e.CHECKOUT_DISCOUNT_APPLIED = "checkout.discount.applied", e.CHECKOUT_DISCOUNT_REMOVED = "checkout.discount.removed", e.CHECKOUT_UPSELL_CANCELED = "checkout.upsell.canceled";
})(Bs || (Bs = {}));
var Us;
(function(e) {
  e.DAY = "day", e.WEEK = "week", e.MONTH = "month", e.YEAR = "year";
})(Us || (Us = {}));
var Vs;
(function(e) {
  e.ALIPAY = "alipay", e.APPLE_PAY = "apple-pay", e.CARD = "card", e.GOOGLE_PAY = "google-pay", e.IDEAL = "ideal", e.PAYPAL = "paypal", e.WECHAT_PAY = "wechat-pay", e.WIRE_TRANSFER = "wire-transfer", e.NONE = "none";
})(Vs || (Vs = {}));
var js;
(function(e) {
  e.AMERICAN_EXPRESS = "american_express", e.DINERS_CLUB = "diners_club", e.DISCOVER = "discover", e.JCB = "jcb", e.MADA = "mada", e.MAESTRO = "maestro", e.MASTER_CARD = "mastercard", e.UNION_PAY = "union_pay", e.VISA = "visa", e.UNKNOWN = "unknown";
})(js || (js = {}));
var Ks;
(function(e) {
  e.DRAFT = "draft", e.READY = "ready", e.COMPLETED = "completed", e.BILLED = "billed", e.canceled = "canceled", e.PAST_DUE = "past_due";
})(Ks || (Ks = {}));
function b5(e) {
  return Ai.apply(this, arguments);
}
function Ai() {
  return Ai = t5(/* @__PURE__ */ Pi().mark(function e(t) {
    var r, n;
    return Pi().wrap(function(i) {
      for (; ; ) switch (i.prev = i.next) {
        case 0:
          return r = (t == null ? void 0 : t.version) || s5, i.next = 3, h5(r);
        case 3:
          if (n = i.sent, !n) {
            i.next = 9;
            break;
          }
          return t && (r === Gr.V1 ? C5(t, n) : r === Gr.CLASSIC && v5(t, n)), i.abrupt("return", n);
        case 9:
          return console.error("[Paddle] Error Loading Paddle"), i.abrupt("return");
        case 11:
        case "end":
          return i.stop();
      }
    }, e);
  })), Ai.apply(this, arguments);
}
const Li = Ut(void 0);
function q8({ children: e }) {
  const t = mt(Li), [r, n] = be(), o = Le(null), i = Le(null), s = Le();
  Be(() => {
    if (t) return;
    const h = "live_54a5ebe2c7bc8c996bcb21e941e", f = "production";
    s.current = b5({
      environment: f,
      token: h,
      checkout: {
        settings: {
          theme: "dark",
          variant: "one-page"
        }
      },
      eventCallback: (b) => {
        var C, l, g;
        b.name === "checkout.completed" && ((C = o.current) == null || C.call(o, b), o.current = null, i.current = null), b.name === "checkout.closed" && ((l = o.current) == null || l.call(o, b), o.current = null, i.current = null), b.name === "checkout.error" && ((g = i.current) == null || g.call(i, b.detail), o.current = null, i.current = null);
      }
    }).then((b) => (b && n(b), b));
  }, []);
  const a = Fe(
    (h, f) => {
      if (f) return Promise.reject(f);
      if (o.current)
        return Promise.reject("Checkout already in progress");
      const b = (C) => new Promise(
        (l, g) => {
          if (!C) {
            g("Paddle not initialized");
            return;
          }
          o.current = l, i.current = g, h(C);
        }
      );
      return r ? b(r) : (s.current ?? Promise.resolve(void 0)).then(b);
    },
    [r]
  ), u = Fe(
    (h, f, b) => a(
      (C) => C.Checkout.open({
        items: [
          {
            priceId: h,
            quantity: 1
          }
        ],
        customer: f,
        customData: b
      }),
      h ? void 0 : "Error opening checkout: Invalid price id"
    ),
    [a]
  ), d = Fe(
    (h, f, b) => a(
      (C) => C.Checkout.open({
        transactionId: h,
        customer: f,
        customData: b
      }),
      h ? void 0 : "Error opening checkout: Invalid transaction id"
    ),
    [a]
  );
  return t ? /* @__PURE__ */ c(Jr, { children: e }) : /* @__PURE__ */ c(
    Li.Provider,
    {
      value: { checkout: u, checkoutWithTransaction: d },
      children: e
    }
  );
}
function w5() {
  const e = mt(Li);
  if (e === void 0) throw Error("Paddle checkout context is undefined");
  return e;
}
function k8(e) {
  var t;
  return ((e == null ? void 0 : e.kind) === "subscription" || (e == null ? void 0 : e.kind) === "trial") && ((t = e.plan) != null && t.handle) ? { handle: e.plan.handle, kind: e.kind } : null;
}
const S5 = ["paygo", "founder"];
function _n(e) {
  return !!e && !S5.includes(e);
}
const E5 = ["paygo", "founder"];
function D8(e) {
  return !!e && E5.includes(e);
}
function H8(e, t, r) {
  return r && _n(e) ? "Start trial" : t ? "Continue" : "Sign up";
}
function B8(e, t) {
  var r;
  return (e == null ? void 0 : e.handle) ?? ((r = t == null ? void 0 : t.plan) == null ? void 0 : r.handle);
}
function U8(e) {
  return (e ?? []).filter((t) => !t.activated_at).reduce(
    (t, r) => (t[r.plan_id] = (t[r.plan_id] ?? 0) + 1, t),
    {}
  );
}
function V8({
  accountId: e,
  user: t,
  plans: r,
  trialEndsAt: n,
  trialDays: o,
  trialEligible: i
}) {
  var $, q, I;
  const { checkout: s, checkoutWithTransaction: a } = w5(), u = ki(), d = `${e}`, [h, f] = be(null), [b, C] = be(void 0), [l, g] = be(!1), [p, m] = be(!1), { data: v } = Zc({
    ...Uu(d),
    enabled: !!h && !!e
  }), S = (I = (q = ($ = v == null ? void 0 : v.find(
    (F) => {
      var V;
      return F.kind === "subscription" && ((V = F.plan) == null ? void 0 : V.handle) === (h == null ? void 0 : h.handle);
    }
  )) == null ? void 0 : $.subscription) == null ? void 0 : q.next_payment) == null ? void 0 : I.date, { mutate: x } = E1(
    Vu(d)
  ), { mutateAsync: A } = E1(
    ju(d)
  );
  return {
    purchaseConfirmation: h,
    purchasedPrice: b,
    renewsAt: S,
    purchaseIncludesTrial: l,
    showCheckoutError: p,
    setShowCheckoutError: m,
    openCheckoutCallback: (F) => {
      if (!F || !t) {
        console.log("Error opening checkout: Invalid price id");
        return;
      }
      m(!1);
      const V = !!n && new Date(n) > /* @__PURE__ */ new Date(), k = r.find(
        (ae) => ae.prices.some((T) => T.paddle_price_id === F)
      ), Y = !V && i && k && _n(k.handle) ? new Date(
        Date.now() + o * 24 * 60 * 60 * 1e3
      ).toISOString() : null;
      (k && _n(k.handle) ? A({ price_id: F }).then(
        ({ transactionId: ae }) => a(ae, {
          email: t.email
        })
      ) : s(F, { email: t.email })).then((ae) => {
        var T, M;
        ae.name === "checkout.completed" && ((M = (T = ae.data) == null ? void 0 : T.items[0]) != null && M.price_id) ? (Y && x(), k && (f(k), C(
          k.prices.find(
            (P) => P.paddle_price_id === F
          )
        ), g(
          _n(k.handle) && (V || !!Y)
        ), u.invalidateQueries({
          queryKey: Z.activePlans(d)
        }), u.invalidateQueries({
          queryKey: Z.transactions(d)
        }))) : m(!0);
      }).catch((ae) => {
        console.log("Error in checkout: ", ae), m(!0);
      });
    }
  };
}
const j8 = ["18-24", "25-34", "35-44", "45-54", "55+"], K8 = [
  "Artist",
  "Performer",
  "Music Teacher",
  "Educator",
  "Student",
  "Learner",
  "Producer",
  "Hobbyist",
  "Other"
], z8 = [
  "Daily",
  "Weekly",
  "Occasionally",
  "Rarely"
], G8 = [
  "Band",
  "Students",
  "Friends",
  "Mostly Solo"
], Z8 = [
  "Friend",
  "Social Media",
  "Music School",
  "Press",
  "Other"
], W8 = [
  "Real-time connectivity",
  "Teaching",
  "Rehearsals",
  "Collaboration",
  "Spatial sound experience"
], Q8 = [
  "Sound quality",
  "Ease of use",
  "Low latency",
  "Collaboration",
  "Cost",
  "Accessibility",
  "Other"
], J8 = ["Yes", "Maybe", "No"], Y8 = {
  elevation: 0
}, X8 = {
  mode: "public",
  username: "placeholder"
}, e9 = {
  serverPort: "50000"
}, t9 = [1, 1, 2, 4], r9 = [64, 128, 256, 512], n9 = [48e3, 96e3, 192e3], o9 = ["48KHz", "96KHz", "192KHz"], i9 = ["Max", "Med", "Small", "VSmall"], s9 = [
  "OPUS 24kbps",
  "OPUS 48kbps",
  "OPUS 96kbps",
  "OPUS 192kbps",
  "Linear 768kbps"
], x5 = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19"
], a9 = ["auto", ...x5], c9 = {
  currentGroupPosition: "0"
}, l9 = [
  "#FFF075",
  "#EC682A",
  "#5EC76A",
  "#F0B3F8",
  "#F4B390"
], u9 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
function zi({
  type: e = "button",
  className: t = "",
  disabled: r,
  children: n,
  forwardRef: o,
  ...i
}) {
  return /* @__PURE__ */ c(
    "button",
    {
      ...i,
      ref: o,
      type: e,
      className: `
                text-md inline-flex content-center items-center justify-center
                rounded-3xl border border-transparent bg-bonza-primary px-4 py-2
                text-center text-bonza-pale transition duration-150 ease-in-out

                active:bg-bonza-pale active:text-bonza-dark

                disabled:bg-bonza-dark-semi

                focus:outline-none focus:ring-2 focus:ring-bonza-primary
                focus:ring-offset-2

                hover:bg-bonza-pale hover:text-bonza-dark

                ${r && "opacity-25"}
                ${t}
            `,
      disabled: r,
      children: n
    }
  );
}
function Gi({
  type: e = "button",
  className: t = "",
  disabled: r,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ c(
    "button",
    {
      ...o,
      type: e,
      className: `
                text-md inline-flex content-center items-center justify-center
                rounded-full bg-bonza-pale-t-7 px-4 py-2 text-center
                font-semibold text-bonza-pale transition duration-150
                ease-in-out

                active:bg-bonza-pale active:text-bonza-dark

                disabled:opacity-25

                focus:outline-none focus:ring-2 focus:ring-offset-2
                focus:ring-bonza-primary

                hover:bg-bonza-pale hover:text-bonza-dark

                ${r && "opacity-25"}
                ${t}
            `,
      disabled: r,
      children: n
    }
  );
}
function f9({
  className: e = "",
  disabled: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ c(
    "button",
    {
      ...n,
      className: `
                text-md inline-flex content-center items-center justify-center
                rounded-full bg-red-500 px-4 py-2 text-center font-semibold
                text-bonza-pale transition duration-150 ease-in-out

                active:bg-red-300 active:text-bonza-dark

                disabled:opacity-25

                focus:outline-none focus:ring-2 focus:ring-red-500
                focus:ring-offset-2

                hover:bg-red-300 hover:text-bonza-dark

                ${t && "opacity-25"}
                ${e}
            `,
      disabled: t,
      children: r
    }
  );
}
const t2 = typeof document < "u" ? ye.useLayoutEffect : () => {
};
var oi;
const R5 = (oi = ye.useInsertionEffect) !== null && oi !== void 0 ? oi : t2;
function O5(e) {
  const t = Le(null);
  return R5(() => {
    t.current = e;
  }, [
    e
  ]), Fe((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
const Vt = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Xt = (e) => e && "window" in e && e.window === e ? e : Vt(e).defaultView || window;
function P5(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function A5(e) {
  return P5(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let L5 = !1;
function Zi() {
  return L5;
}
function r2(e, t) {
  if (!Zi()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let r = t;
  for (; r !== null; ) {
    if (r === e) return !0;
    r.tagName === "SLOT" && r.assignedSlot ? r = r.assignedSlot.parentNode : A5(r) ? r = r.host : r = r.parentNode;
  }
  return !1;
}
const Ti = (e = document) => {
  var t;
  if (!Zi()) return e.activeElement;
  let r = e.activeElement;
  for (; r && "shadowRoot" in r && (!((t = r.shadowRoot) === null || t === void 0) && t.activeElement); ) r = r.shadowRoot.activeElement;
  return r;
};
function n2(e) {
  return Zi() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function o2(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = o2(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function T5() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = o2(e)) && (n && (n += " "), n += t);
  return n;
}
function Wn(e) {
  var t;
  if (typeof window > "u" || window.navigator == null) return !1;
  let r = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(r) && r.some((n) => e.test(n.brand)) || e.test(window.navigator.userAgent);
}
function Wi(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Pt(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Qi = Pt(function() {
  return Wi(/^Mac/i);
}), M5 = Pt(function() {
  return Wi(/^iPhone/i);
}), _5 = Pt(function() {
  return Wi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Qi() && navigator.maxTouchPoints > 1;
}), N5 = Pt(function() {
  return M5() || _5();
});
Pt(function() {
  return Qi() || N5();
});
Pt(function() {
  return Wn(/AppleWebKit/i) && !F5();
});
const F5 = Pt(function() {
  return Wn(/Chrome/i);
}), $5 = Pt(function() {
  return Wn(/Android/i);
});
Pt(function() {
  return Wn(/Firefox/i);
});
function i2() {
  let e = Le(/* @__PURE__ */ new Map()), t = Fe((o, i, s, a) => {
    let u = a != null && a.once ? (...d) => {
      e.current.delete(s), s(...d);
    } : s;
    e.current.set(s, {
      type: i,
      eventTarget: o,
      fn: u,
      options: a
    }), o.addEventListener(i, u, a);
  }, []), r = Fe((o, i, s, a) => {
    var u;
    let d = ((u = e.current.get(s)) === null || u === void 0 ? void 0 : u.fn) || s;
    o.removeEventListener(i, d, a), e.current.delete(s);
  }, []), n = Fe(() => {
    e.current.forEach((o, i) => {
      r(o.eventTarget, o.type, i, o.options);
    });
  }, [
    r
  ]);
  return Be(() => n, [
    n
  ]), {
    addGlobalListener: t,
    removeGlobalListener: r,
    removeAllGlobalListeners: n
  };
}
function I5(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : $5() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function s2(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function q5(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function a2(e) {
  let t = Le({
    isFocused: !1,
    observer: null
  });
  t2(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = O5((n) => {
    e == null || e(n);
  });
  return Fe((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = n.target, i = (s) => {
        if (t.current.isFocused = !1, o.disabled) {
          let a = s2(s);
          r(a);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var s;
          (s = t.current.observer) === null || s === void 0 || s.disconnect();
          let a = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
let k5 = !1, sn = null, Mi = /* @__PURE__ */ new Set(), Kr = /* @__PURE__ */ new Map(), ar = !1, _i = !1;
const D5 = {
  Tab: !0,
  Escape: !0
};
function Ji(e, t) {
  for (let r of Mi) r(e, t);
}
function H5(e) {
  return !(e.metaKey || !Qi() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function kn(e) {
  ar = !0, H5(e) && (sn = "keyboard", Ji("keyboard", e));
}
function rt(e) {
  sn = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (ar = !0, Ji("pointer", e));
}
function c2(e) {
  I5(e) && (ar = !0, sn = "virtual");
}
function l2(e) {
  e.target === window || e.target === document || k5 || !e.isTrusted || (!ar && !_i && (sn = "virtual", Ji("virtual", e)), ar = !1, _i = !1);
}
function u2() {
  ar = !1, _i = !0;
}
function Ni(e) {
  if (typeof window > "u" || typeof document > "u" || Kr.get(Xt(e))) return;
  const t = Xt(e), r = Vt(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    ar = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", kn, !0), r.addEventListener("keyup", kn, !0), r.addEventListener("click", c2, !0), t.addEventListener("focus", l2, !0), t.addEventListener("blur", u2, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", rt, !0), r.addEventListener("pointermove", rt, !0), r.addEventListener("pointerup", rt, !0)) : process.env.NODE_ENV === "test" && (r.addEventListener("mousedown", rt, !0), r.addEventListener("mousemove", rt, !0), r.addEventListener("mouseup", rt, !0)), t.addEventListener("beforeunload", () => {
    f2(e);
  }, {
    once: !0
  }), Kr.set(t, {
    focus: n
  });
}
const f2 = (e, t) => {
  const r = Xt(e), n = Vt(e);
  t && n.removeEventListener("DOMContentLoaded", t), Kr.has(r) && (r.HTMLElement.prototype.focus = Kr.get(r).focus, n.removeEventListener("keydown", kn, !0), n.removeEventListener("keyup", kn, !0), n.removeEventListener("click", c2, !0), r.removeEventListener("focus", l2, !0), r.removeEventListener("blur", u2, !1), typeof PointerEvent < "u" ? (n.removeEventListener("pointerdown", rt, !0), n.removeEventListener("pointermove", rt, !0), n.removeEventListener("pointerup", rt, !0)) : process.env.NODE_ENV === "test" && (n.removeEventListener("mousedown", rt, !0), n.removeEventListener("mousemove", rt, !0), n.removeEventListener("mouseup", rt, !0)), Kr.delete(r));
};
function B5(e) {
  const t = Vt(e);
  let r;
  return t.readyState !== "loading" ? Ni(e) : (r = () => {
    Ni(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => f2(e, r);
}
typeof document < "u" && B5();
function d2() {
  return sn !== "pointer";
}
const U5 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function V5(e, t, r) {
  let n = Vt(r == null ? void 0 : r.target);
  const o = typeof window < "u" ? Xt(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? Xt(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, s = typeof window < "u" ? Xt(r == null ? void 0 : r.target).HTMLElement : HTMLElement, a = typeof window < "u" ? Xt(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || n.activeElement instanceof o && !U5.has(n.activeElement.type) || n.activeElement instanceof i || n.activeElement instanceof s && n.activeElement.isContentEditable, !(e && t === "keyboard" && r instanceof a && !D5[r.key]);
}
function j5(e, t, r) {
  Ni(), Be(() => {
    let n = (o, i) => {
      V5(!!(r != null && r.isTextInput), o, i) && e(d2());
    };
    return Mi.add(n), () => {
      Mi.delete(n);
    };
  }, t);
}
function K5(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: o } = e;
  const i = Fe((u) => {
    if (u.target === u.currentTarget)
      return n && n(u), o && o(!1), !0;
  }, [
    n,
    o
  ]), s = a2(i), a = Fe((u) => {
    const d = Vt(u.target), h = d ? Ti(d) : Ti();
    u.target === u.currentTarget && h === n2(u.nativeEvent) && (r && r(u), o && o(!0), s(u));
  }, [
    o,
    r,
    s
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || o || n) ? a : void 0,
      onBlur: !t && (n || o) ? i : void 0
    }
  };
}
function z5(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: o } = e, i = Le({
    isFocusWithin: !1
  }), { addGlobalListener: s, removeAllGlobalListeners: a } = i2(), u = Fe((f) => {
    f.currentTarget.contains(f.target) && i.current.isFocusWithin && !f.currentTarget.contains(f.relatedTarget) && (i.current.isFocusWithin = !1, a(), r && r(f), o && o(!1));
  }, [
    r,
    o,
    i,
    a
  ]), d = a2(u), h = Fe((f) => {
    if (!f.currentTarget.contains(f.target)) return;
    const b = Vt(f.target), C = Ti(b);
    if (!i.current.isFocusWithin && C === n2(f.nativeEvent)) {
      n && n(f), o && o(!0), i.current.isFocusWithin = !0, d(f);
      let l = f.currentTarget;
      s(b, "focus", (g) => {
        if (i.current.isFocusWithin && !r2(l, g.target)) {
          let p = new b.defaultView.FocusEvent("blur", {
            relatedTarget: g.target
          });
          q5(p, l);
          let m = s2(p);
          u(m);
        }
      }, {
        capture: !0
      });
    }
  }, [
    n,
    o,
    d,
    s,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: h,
      onBlur: u
    }
  };
}
let Dn = !1, xn = 0;
function Fi() {
  Dn = !0, setTimeout(() => {
    Dn = !1;
  }, 50);
}
function zs(e) {
  e.pointerType === "touch" && Fi();
}
function G5() {
  if (!(typeof document > "u"))
    return xn === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", zs) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", Fi)), xn++, () => {
      xn--, !(xn > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", zs) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", Fi));
    };
}
function p2(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: o } = e, [i, s] = be(!1), a = Le({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Be(G5, []);
  let { addGlobalListener: u, removeAllGlobalListeners: d } = i2(), { hoverProps: h, triggerHoverEnd: f } = yt(() => {
    let b = (g, p) => {
      if (a.pointerType = p, o || p === "touch" || a.isHovered || !g.currentTarget.contains(g.target)) return;
      a.isHovered = !0;
      let m = g.currentTarget;
      a.target = m, u(Vt(g.target), "pointerover", (v) => {
        a.isHovered && a.target && !r2(a.target, v.target) && C(v, v.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: m,
        pointerType: p
      }), r && r(!0), s(!0);
    }, C = (g, p) => {
      let m = a.target;
      a.pointerType = "", a.target = null, !(p === "touch" || !a.isHovered || !m) && (a.isHovered = !1, d(), n && n({
        type: "hoverend",
        target: m,
        pointerType: p
      }), r && r(!1), s(!1));
    }, l = {};
    return typeof PointerEvent < "u" ? (l.onPointerEnter = (g) => {
      Dn && g.pointerType === "mouse" || b(g, g.pointerType);
    }, l.onPointerLeave = (g) => {
      !o && g.currentTarget.contains(g.target) && C(g, g.pointerType);
    }) : process.env.NODE_ENV === "test" && (l.onTouchStart = () => {
      a.ignoreEmulatedMouseEvents = !0;
    }, l.onMouseEnter = (g) => {
      !a.ignoreEmulatedMouseEvents && !Dn && b(g, "mouse"), a.ignoreEmulatedMouseEvents = !1;
    }, l.onMouseLeave = (g) => {
      !o && g.currentTarget.contains(g.target) && C(g, "mouse");
    }), {
      hoverProps: l,
      triggerHoverEnd: C
    };
  }, [
    t,
    r,
    n,
    o,
    a,
    u,
    d
  ]);
  return Be(() => {
    o && f({
      currentTarget: a.target
    }, a.pointerType);
  }, [
    o
  ]), {
    hoverProps: h,
    isHovered: i
  };
}
function h2(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, o = Le({
    isFocused: !1,
    isFocusVisible: t || d2()
  }), [i, s] = be(!1), [a, u] = be(() => o.current.isFocused && o.current.isFocusVisible), d = Fe(() => u(o.current.isFocused && o.current.isFocusVisible), []), h = Fe((C) => {
    o.current.isFocused = C, s(C), d();
  }, [
    d
  ]);
  j5((C) => {
    o.current.isFocusVisible = C, d();
  }, [], {
    isTextInput: r
  });
  let { focusProps: f } = K5({
    isDisabled: n,
    onFocusChange: h
  }), { focusWithinProps: b } = z5({
    isDisabled: !n,
    onFocusWithinChange: h
  });
  return {
    isFocused: i,
    isFocusVisible: a,
    focusProps: n ? b : f
  };
}
var Z5 = Object.defineProperty, W5 = (e, t, r) => t in e ? Z5(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ii = (e, t, r) => (W5(e, typeof t != "symbol" ? t + "" : t, r), r);
let Q5 = class {
  constructor() {
    ii(this, "current", this.detect()), ii(this, "handoffState", "pending"), ii(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, y2 = new Q5();
function J5(e) {
  var t;
  return y2.isServer ? null : e == null ? document : (t = e == null ? void 0 : e.ownerDocument) != null ? t : document;
}
function Y5(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function m2() {
  let e = [], t = { addEventListener(r, n, o, i) {
    return r.addEventListener(n, o, i), t.add(() => r.removeEventListener(n, o, i));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return Y5(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, o) {
    let i = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: o }), this.add(() => {
      Object.assign(r.style, { [n]: i });
    });
  }, group(r) {
    let n = m2();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.includes(r) || e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0) for (let o of e.splice(n, 1)) o();
    };
  }, dispose() {
    for (let r of e.splice(0)) r();
  } };
  return t;
}
function Yi() {
  let [e] = be(m2);
  return Be(() => () => e.dispose(), [e]), e;
}
let Xi = (e, t) => {
  y2.isServer ? Be(e, t) : dc(e, t);
};
function X5(e) {
  let t = Le(e);
  return Xi(() => {
    t.current = e;
  }, [e]), t;
}
let at = function(e) {
  let t = X5(e);
  return ye.useCallback((...r) => t.current(...r), [t]);
};
function e4(e) {
  let t = e.width / 2, r = e.height / 2;
  return { top: e.clientY - r, right: e.clientX + t, bottom: e.clientY + r, left: e.clientX - t };
}
function t4(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function g2({ disabled: e = !1 } = {}) {
  let t = Le(null), [r, n] = be(!1), o = Yi(), i = at(() => {
    t.current = null, n(!1), o.dispose();
  }), s = at((a) => {
    if (o.dispose(), t.current === null) {
      t.current = a.currentTarget, n(!0);
      {
        let u = J5(a.currentTarget);
        o.addEventListener(u, "pointerup", i, !1), o.addEventListener(u, "pointermove", (d) => {
          if (t.current) {
            let h = e4(d);
            n(t4(h, t.current.getBoundingClientRect()));
          }
        }, !1), o.addEventListener(u, "pointercancel", i, !1);
      }
    }
  });
  return { pressed: r, pressProps: e ? {} : { onPointerDown: s, onPointerUp: i, onClick: i } };
}
function an(e) {
  return yt(() => e, Object.values(e));
}
let C2 = Ut(void 0);
function cn() {
  return mt(C2);
}
function r4({ value: e, children: t }) {
  return ye.createElement(C2.Provider, { value: e }, t);
}
function Gs(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function v2(e, t, ...r) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...r) : o;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, v2), n;
}
var n4 = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(n4 || {}), o4 = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(o4 || {});
function Pr() {
  let e = s4();
  return Fe((t) => i4({ mergeRefs: e, ...t }), [e]);
}
function i4({ ourProps: e, theirProps: t, slot: r, defaultTag: n, features: o, visible: i = !0, name: s, mergeRefs: a }) {
  a = a ?? a4;
  let u = b2(t, e);
  if (i) return Rn(u, r, n, s, a);
  let d = o ?? 0;
  if (d & 2) {
    let { static: h = !1, ...f } = u;
    if (h) return Rn(f, r, n, s, a);
  }
  if (d & 1) {
    let { unmount: h = !0, ...f } = u;
    return v2(h ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Rn({ ...f, hidden: !0, style: { display: "none" } }, r, n, s, a);
    } });
  }
  return Rn(u, r, n, s, a);
}
function Rn(e, t = {}, r, n, o) {
  let { as: i = r, children: s, refName: a = "ref", ...u } = si(e, ["unmount", "static"]), d = e.ref !== void 0 ? { [a]: e.ref } : {}, h = typeof s == "function" ? s(t) : s;
  "className" in u && u.className && typeof u.className == "function" && (u.className = u.className(t)), u["aria-labelledby"] && u["aria-labelledby"] === u.id && (u["aria-labelledby"] = void 0);
  let f = {};
  if (t) {
    let b = !1, C = [];
    for (let [l, g] of Object.entries(t)) typeof g == "boolean" && (b = !0), g === !0 && C.push(l.replace(/([A-Z])/g, (p) => `-${p.toLowerCase()}`));
    if (b) {
      f["data-headlessui-state"] = C.join(" ");
      for (let l of C) f[`data-${l}`] = "";
    }
  }
  if (Nn(i) && (Object.keys(Jt(u)).length > 0 || Object.keys(Jt(f)).length > 0)) if (!oa(h) || Array.isArray(h) && h.length > 1 || l4(h)) {
    if (Object.keys(Jt(u)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(Jt(u)).concat(Object.keys(Jt(f))).map((b) => `  - ${b}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((b) => `  - ${b}`).join(`
`)].join(`
`));
  } else {
    let b = h.props, C = b == null ? void 0 : b.className, l = typeof C == "function" ? (...m) => Gs(C(...m), u.className) : Gs(C, u.className), g = l ? { className: l } : {}, p = b2(h.props, Jt(si(u, ["ref"])));
    for (let m in f) m in p && delete f[m];
    return pc(h, Object.assign({}, p, f, d, { ref: o(c4(h), d.ref) }, g));
  }
  return na(i, Object.assign({}, si(u, ["ref"]), !Nn(i) && d, !Nn(i) && f), h);
}
function s4() {
  let e = Le([]), t = Fe((r) => {
    for (let n of e.current) n != null && (typeof n == "function" ? n(r) : n.current = r);
  }, []);
  return (...r) => {
    if (!r.every((n) => n == null)) return e.current = r, t;
  };
}
function a4(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e) r != null && (typeof r == "function" ? r(t) : r.current = t);
  };
}
function b2(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let o in n) o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  if (t.disabled || t["aria-disabled"]) for (let n in r) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(n) && (r[n] = [(o) => {
    var i;
    return (i = o == null ? void 0 : o.preventDefault) == null ? void 0 : i.call(o);
  }]);
  for (let n in r) Object.assign(t, { [n](o, ...i) {
    let s = r[n];
    for (let a of s) {
      if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented) return;
      a(o, ...i);
    }
  } });
  return t;
}
function w2(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let o in n) o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  for (let n in r) Object.assign(t, { [n](...o) {
    let i = r[n];
    for (let s of i) s == null || s(...o);
  } });
  return t;
}
function Ar(e) {
  var t;
  return Object.assign(Ii(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function Jt(e) {
  let t = Object.assign({}, e);
  for (let r in t) t[r] === void 0 && delete t[r];
  return t;
}
function si(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t) n in r && delete r[n];
  return r;
}
function c4(e) {
  return ye.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
function Nn(e) {
  return e === hc || e === Symbol.for("react.fragment");
}
function l4(e) {
  return Nn(e.type);
}
function u4(e, t, r) {
  let [n, o] = be(r), i = e !== void 0, s = Le(i), a = Le(!1), u = Le(!1);
  return i && !s.current && !a.current ? (a.current = !0, s.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && s.current && !u.current && (u.current = !0, s.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : n, at((d) => (i || mc(() => o(d)), t == null ? void 0 : t(d)))];
}
function f4(e) {
  let [t] = be(e);
  return t;
}
function S2(e = {}, t = null, r = []) {
  for (let [n, o] of Object.entries(e)) x2(r, E2(t, n), o);
  return r;
}
function E2(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function x2(e, t, r) {
  if (Array.isArray(r)) for (let [n, o] of r.entries()) x2(e, E2(t, n.toString()), o);
  else r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : p4(r) && !oa(r) && S2(r, t, e);
}
function d4(e) {
  var t, r;
  let n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (n) {
    for (let o of n.elements) if (o !== e && (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image")) {
      o.click();
      return;
    }
    (r = n.requestSubmit) == null || r.call(n);
  }
}
function p4(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]") return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || Object.getPrototypeOf(t) === null;
}
let h4 = "span";
var Qn = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Qn || {});
function y4(e, t) {
  var r;
  let { features: n = 1, ...o } = e, i = { ref: t, "aria-hidden": (n & 2) === 2 ? !0 : (r = o["aria-hidden"]) != null ? r : void 0, hidden: (n & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return Pr()({ ourProps: i, theirProps: o, slot: {}, defaultTag: h4, name: "Hidden" });
}
let e1 = Ar(y4), R2 = Ut(null);
function m4(e) {
  let [t, r] = be(null);
  return ye.createElement(R2.Provider, { value: { target: t } }, e.children, ye.createElement(e1, { features: Qn.Hidden, ref: r }));
}
function g4({ children: e }) {
  let t = mt(R2);
  if (!t) return ye.createElement(ye.Fragment, null, e);
  let { target: r } = t;
  return r ? gc(ye.createElement(ye.Fragment, null, e), r) : null;
}
function C4({ data: e, form: t, disabled: r, onReset: n, overrides: o }) {
  let [i, s] = be(null), a = Yi();
  return Be(() => {
    if (n && i) return a.addEventListener(i, "reset", n);
  }, [i, t, n]), ye.createElement(g4, null, ye.createElement(v4, { setForm: s, formId: t }), S2(e).map(([u, d]) => ye.createElement(e1, { features: Qn.Hidden, ...Jt({ key: u, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: r, name: u, value: d, ...o }) })));
}
function v4({ setForm: e, formId: t }) {
  return Be(() => {
    if (t) {
      let r = document.getElementById(t);
      r && e(r);
    }
  }, [e, t]), t ? null : ye.createElement(e1, { features: Qn.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (r) => {
    if (!r) return;
    let n = r.closest("form");
    n && e(n);
  } });
}
let O2 = Ut(void 0);
function t1() {
  return mt(O2);
}
function b4({ id: e, children: t }) {
  return ye.createElement(O2.Provider, { value: e }, t);
}
function w4(e) {
  return typeof e != "object" || e === null ? !1 : "nodeType" in e;
}
function P2(e) {
  return w4(e) && "tagName" in e;
}
function Jn(e) {
  return P2(e) && "accessKey" in e;
}
function S4(e) {
  return Jn(e) && e.nodeName === "INPUT";
}
function Zs(e) {
  return Jn(e) && e.nodeName === "LABEL";
}
function E4(e) {
  return Jn(e) && e.nodeName === "FIELDSET";
}
function A2(e) {
  return Jn(e) && e.nodeName === "LEGEND";
}
function x4(e) {
  return P2(e) ? e.matches('a[href],audio[controls],button,details,embed,iframe,img[usemap],input:not([type="hidden"]),label,select,textarea,video[controls]') : !1;
}
function R4(e) {
  let t = e.parentElement, r = null;
  for (; t && !E4(t); ) A2(t) && (r = t), t = t.parentElement;
  let n = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return n && O4(r) ? !1 : n;
}
function O4(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (A2(t)) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let P4 = Symbol();
function L2(...e) {
  let t = Le(e);
  Be(() => {
    t.current = e;
  }, [e]);
  let r = at((n) => {
    for (let o of t.current) o != null && (typeof o == "function" ? o(n) : o.current = n);
  });
  return e.every((n) => n == null || (n == null ? void 0 : n[P4])) ? void 0 : r;
}
let Yn = Ut(null);
Yn.displayName = "DescriptionContext";
function T2() {
  let e = mt(Yn);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, T2), t;
  }
  return e;
}
function M2() {
  var e, t;
  return (t = (e = mt(Yn)) == null ? void 0 : e.value) != null ? t : void 0;
}
function A4() {
  let [e, t] = be([]);
  return [e.length > 0 ? e.join(" ") : void 0, yt(() => function(r) {
    let n = at((i) => (t((s) => [...s, i]), () => t((s) => {
      let a = s.slice(), u = a.indexOf(i);
      return u !== -1 && a.splice(u, 1), a;
    }))), o = yt(() => ({ register: n, slot: r.slot, name: r.name, props: r.props, value: r.value }), [n, r.slot, r.name, r.props, r.value]);
    return ye.createElement(Yn.Provider, { value: o }, r.children);
  }, [t])];
}
let L4 = "p";
function T4(e, t) {
  let r = Qr(), n = cn(), { id: o = `headlessui-description-${r}`, ...i } = e, s = T2(), a = L2(t);
  Xi(() => s.register(o), [o, s.register]);
  let u = an({ ...s.slot, disabled: n || !1 }), d = { ref: a, ...s.props, id: o };
  return Pr()({ ourProps: d, theirProps: i, slot: u, defaultTag: L4, name: s.name || "Description" });
}
let M4 = Ar(T4);
Object.assign(M4, {});
var $i = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))($i || {});
let Xn = Ut(null);
Xn.displayName = "LabelContext";
function _2() {
  let e = mt(Xn);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, _2), t;
  }
  return e;
}
function r1(e) {
  var t, r, n;
  let o = (r = (t = mt(Xn)) == null ? void 0 : t.value) != null ? r : void 0;
  return ((n = void 0) != null ? n : 0) > 0 ? [o, ...e].filter(Boolean).join(" ") : o;
}
function _4({ inherit: e = !1 } = {}) {
  let t = r1(), [r, n] = be([]), o = e ? [t, ...r].filter(Boolean) : r;
  return [o.length > 0 ? o.join(" ") : void 0, yt(() => function(i) {
    let s = at((u) => (n((d) => [...d, u]), () => n((d) => {
      let h = d.slice(), f = h.indexOf(u);
      return f !== -1 && h.splice(f, 1), h;
    }))), a = yt(() => ({ register: s, slot: i.slot, name: i.name, props: i.props, value: i.value }), [s, i.slot, i.name, i.props, i.value]);
    return ye.createElement(Xn.Provider, { value: a }, i.children);
  }, [n])];
}
let N4 = "label";
function F4(e, t) {
  var r;
  let n = Qr(), o = _2(), i = t1(), s = cn(), { id: a = `headlessui-label-${n}`, htmlFor: u = i ?? ((r = o.props) == null ? void 0 : r.htmlFor), passive: d = !1, ...h } = e, f = L2(t);
  Xi(() => o.register(a), [a, o.register]);
  let b = at((g) => {
    let p = g.currentTarget;
    if (!(g.target !== g.currentTarget && x4(g.target)) && (Zs(p) && g.preventDefault(), o.props && "onClick" in o.props && typeof o.props.onClick == "function" && o.props.onClick(g), Zs(p))) {
      let m = document.getElementById(p.htmlFor);
      if (m) {
        let v = m.getAttribute("disabled");
        if (v === "true" || v === "") return;
        let S = m.getAttribute("aria-disabled");
        if (S === "true" || S === "") return;
        (S4(m) && (m.type === "file" || m.type === "radio" || m.type === "checkbox") || m.role === "radio" || m.role === "checkbox" || m.role === "switch") && m.click(), m.focus({ preventScroll: !0 });
      }
    }
  }), C = an({ ...o.slot, disabled: s || !1 }), l = { ref: f, ...o.props, id: a, htmlFor: u, onClick: b };
  return d && ("onClick" in l && (delete l.htmlFor, delete l.onClick), "onClick" in h && delete h.onClick), Pr()({ ourProps: l, theirProps: h, slot: C, defaultTag: u ? N4 : "div", name: o.name || "Label" });
}
let $4 = Ar(F4), I4 = Object.assign($4, {}), q4 = "span";
function k4(e, t) {
  let r = Qr(), n = t1(), o = cn(), { id: i = n || `headlessui-checkbox-${r}`, disabled: s = o || !1, autoFocus: a = !1, checked: u, defaultChecked: d, onChange: h, name: f, value: b, form: C, indeterminate: l = !1, tabIndex: g = 0, ...p } = e, m = f4(d), [v, S] = u4(u, h, m ?? !1), x = r1(), A = M2(), N = Yi(), [$, q] = be(!1), I = at(() => {
    q(!0), S == null || S(!v), N.nextFrame(() => {
      q(!1);
    });
  }), F = at((re) => {
    if (R4(re.currentTarget)) return re.preventDefault();
    re.preventDefault(), I();
  }), V = at((re) => {
    re.key === $i.Space ? (re.preventDefault(), I()) : re.key === $i.Enter && d4(re.currentTarget);
  }), k = at((re) => re.preventDefault()), { isFocusVisible: Y, focusProps: ne } = h2({ autoFocus: a }), { isHovered: ae, hoverProps: T } = p2({ isDisabled: s }), { pressed: M, pressProps: P } = g2({ disabled: s }), U = w2({ ref: t, id: i, role: "checkbox", "aria-checked": l ? "mixed" : v ? "true" : "false", "aria-labelledby": x, "aria-describedby": A, "aria-disabled": s ? !0 : void 0, indeterminate: l ? "true" : void 0, tabIndex: s ? void 0 : g, onKeyUp: s ? void 0 : V, onKeyPress: s ? void 0 : k, onClick: s ? void 0 : F }, ne, T, P), H = an({ checked: v, disabled: s, hover: ae, focus: Y, active: M, indeterminate: l, changing: $, autofocus: a }), z = Fe(() => {
    if (m !== void 0) return S == null ? void 0 : S(m);
  }, [S, m]), te = Pr();
  return ye.createElement(ye.Fragment, null, f != null && ye.createElement(C4, { disabled: s, data: { [f]: b || "on" }, overrides: { type: "checkbox", checked: v }, form: C, onReset: z }), te({ ourProps: U, theirProps: p, slot: H, defaultTag: q4, name: "Checkbox" }));
}
let D4 = Ar(k4), H4 = "div";
function B4(e, t) {
  let r = `headlessui-control-${Qr()}`, [n, o] = _4(), [i, s] = A4(), a = cn(), { disabled: u = a || !1, ...d } = e, h = an({ disabled: u }), f = { ref: t, disabled: u || void 0, "aria-disabled": u || void 0 }, b = Pr();
  return ye.createElement(r4, { value: u }, ye.createElement(o, { value: n }, ye.createElement(s, { value: i }, ye.createElement(b4, { id: r }, b({ ourProps: f, theirProps: { ...d, children: ye.createElement(m4, null, typeof d.children == "function" ? d.children(h) : d.children) }, slot: h, defaultTag: H4, name: "Field" })))));
}
let U4 = Ar(B4), V4 = "select";
function j4(e, t) {
  let r = Qr(), n = t1(), o = cn(), { id: i = n || `headlessui-select-${r}`, disabled: s = o || !1, invalid: a = !1, autoFocus: u = !1, ...d } = e, h = r1(), f = M2(), { isFocusVisible: b, focusProps: C } = h2({ autoFocus: u }), { isHovered: l, hoverProps: g } = p2({ isDisabled: s }), { pressed: p, pressProps: m } = g2({ disabled: s }), v = w2({ ref: t, id: i, "aria-labelledby": h, "aria-describedby": f, "aria-invalid": a ? "true" : void 0, disabled: s || void 0, autoFocus: u }, C, g, m), S = an({ disabled: s, invalid: a, hover: l, focus: b, active: p, autofocus: u });
  return Pr()({ ourProps: v, theirProps: d, slot: S, defaultTag: V4, name: "Select" });
}
let K4 = Ar(j4);
function p9({ checked: e, onChange: t, label: r }) {
  return /* @__PURE__ */ D(U4, { className: "inline-flex items-center gap-3", children: [
    /* @__PURE__ */ c(
      D4,
      {
        className: `
                    group peer flex size-4 cursor-pointer rounded-full
                    bg-bonza-pale-t-7 p-1 shadow-sm

                    focus:ring-bonza-primary
                `,
        checked: e,
        onChange: t,
        children: /* @__PURE__ */ c(
          "span",
          {
            className: `
                        group size-full rounded-full bg-none

                        group-data-[checked]:bg-bonza-pale

                        peer-checked:bg-bonza-pale
                    `
          }
        )
      }
    ),
    r && /* @__PURE__ */ c(I4, { className: "cursor-pointer text-sm text-bonza-pale", children: r })
  ] });
}
function h9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      ...e,
      width: "1000",
      height: "224",
      viewBox: "0 0 1000 224",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            fill: e.fill ?? "#ffffff",
            opacity: "1.000000",
            stroke: "none",
            d: `
M76.000000,118.000000
	C75.999634,138.824783 75.565903,159.161133 76.108986,179.471390
	C76.782692,204.666077 51.802147,221.393173 29.202007,214.216980
	C13.824864,209.334305 4.011764,196.487625 4.006818,180.418518
	C3.992155,132.771896 4.387585,85.120522 3.799996,37.481155
	C3.583376,19.918411 21.309824,2.142396 38.524109,2.816890
	C58.109756,3.584299 71.589691,13.152913 75.460243,31.091585
	C75.945282,33.339577 75.973061,35.716267 75.976074,38.033634
	C76.010582,64.522392 75.999168,91.011200 76.000000,118.000000
z`
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: e.fill ?? "#ffffff",
            opacity: "1.000000",
            stroke: "none",
            d: `
M129.694183,215.403351
	C105.712349,212.590881 86.680733,192.718948 85.052979,169.103516
	C83.310997,143.830811 98.848915,121.081009 123.320297,115.274963
	C163.307877,105.787567 194.071915,140.593658 185.600174,176.675400
	C179.662720,201.963486 155.476715,218.932800 129.694183,215.403351
z`
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: e.fill ?? "#ffffff",
            opacity: "1.000000",
            stroke: "none",
            d: `
M97.242249,20.274292
	C111.705193,4.288445 129.563232,-0.519641 149.560501,4.554038
	C169.522659,9.618803 181.617279,23.345448 185.900513,43.418739
	C189.675339,61.109459 184.955872,77.050476 172.382202,89.721367
	C161.036469,101.154831 146.820450,105.979919 130.241425,104.422997
	C108.253532,102.358139 88.259026,83.559853 85.523506,60.948593
	C83.696541,45.847286 87.209755,32.310341 97.242249,20.274292
z`
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "transparent",
            opacity: "1.000000",
            stroke: "none",
            d: `
M353.713043,183.804886
	C326.366547,198.937439 293.412201,179.620895 292.916626,148.800964
	C292.724762,136.868530 294.017853,125.642761 301.485077,115.749008
	C307.508362,107.768410 315.512268,103.068031 325.077972,101.166428
	C337.801331,98.637085 349.330231,101.246765 359.531677,109.753250
	C367.524963,116.418419 371.766663,125.105957 373.305878,134.913284
	C375.834137,151.022644 373.465912,166.152481 361.173218,178.236313
	C359.067749,180.306046 356.409668,181.813629 353.713043,183.804886
z`
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "transparent",
            opacity: "1.000000",
            stroke: "none",
            d: `
M894.255066,177.737488
	C878.899658,161.180923 879.125000,133.469421 889.698303,117.515076
	C903.771301,96.279915 934.786377,94.890854 951.324951,111.104980
	C962.370667,121.933929 965.308289,136.151962 963.627197,151.187485
	C962.249023,163.514053 957.442871,174.384125 947.092224,181.871048
	C931.795044,192.935898 908.450684,191.066208 894.255066,177.737488
z`
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "transparent",
            opacity: "1.000000",
            stroke: "none",
            d: `
M529.664734,123.519394
	C535.076904,138.882065 535.736206,153.729004 528.330078,168.318527
	C520.778992,183.193588 502.924225,191.338287 486.432098,188.686035
	C463.996735,185.077988 452.437256,167.415024 451.976135,146.374268
	C451.688446,133.245224 454.653381,121.236473 463.997345,111.571609
	C477.257294,97.856369 502.860046,96.086021 517.454285,108.314178
	C522.253418,112.335312 525.539978,118.161812 529.664734,123.519394
z`
          }
        ),
        e.withoutText ? null : /* @__PURE__ */ D(Jr, { children: [
          /* @__PURE__ */ c(
            "path",
            {
              fill: e.fill ?? "#ffffff",
              opacity: "1.000000",
              stroke: "none",
              d: `
M280.981201,215.999130
	C275.320374,215.990265 270.153748,215.878860 264.993073,216.007248
	C261.332855,216.098312 259.784332,214.475403 260.012634,210.902954
	C260.086792,209.742157 260.002563,208.571686 260.002533,207.405640
	C260.001434,142.104294 259.999359,76.802948 260.004303,11.501600
	C260.004974,3.019538 260.021912,3.014050 268.578918,3.002492
	C274.742554,2.994168 280.906372,2.976883 287.069824,3.011092
	C293.788849,3.048384 293.981567,3.226123 293.987823,10.151873
	C294.009705,34.306686 293.998566,58.461533 293.999969,82.616364
	C294.000092,84.532906 294.000031,86.449448 294.000031,89.312897
	C295.789276,88.148308 296.711975,87.780624 297.315704,87.120964
	C316.405853,66.261246 354.813965,64.858139 378.005829,80.308983
	C394.616699,91.375458 403.444214,107.275734 406.662201,126.297386
	C409.485779,142.987732 409.208069,159.732422 402.920898,175.912827
	C394.105438,198.599884 377.921722,213.013306 354.119415,217.765366
	C335.581879,221.466339 317.632751,219.520660 302.142853,207.119446
	C299.615631,205.096146 297.331665,202.768936 293.989716,199.719391
	C293.989716,203.774170 293.799622,206.875351 294.034546,209.944000
	C294.382263,214.486008 292.541504,216.440994 287.971527,216.023331
	C285.824188,215.827072 283.643524,215.995804 280.981201,215.999130
M354.006897,183.580887
	C356.409668,181.813629 359.067749,180.306046 361.173218,178.236313
	C373.465912,166.152481 375.834137,151.022644 373.305878,134.913284
	C371.766663,125.105957 367.524963,116.418419 359.531677,109.753250
	C349.330231,101.246765 337.801331,98.637085 325.077972,101.166428
	C315.512268,103.068031 307.508362,107.768410 301.485077,115.749008
	C294.017853,125.642761 292.724762,136.868530 292.916626,148.800964
	C293.412201,179.620895 326.366547,198.937439 354.006897,183.580887
z`
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              fill: e.fill ?? "#ffffff",
              opacity: "1.000000",
              stroke: "none",
              d: `
M996.000000,156.000000
	C995.998047,174.152542 995.854858,191.806931 996.083679,209.456482
	C996.148682,214.468948 994.489502,216.310104 989.459656,216.074356
	C982.480408,215.747253 975.470825,215.844604 968.481750,216.034866
	C964.334534,216.147766 962.752258,214.416779 962.979370,210.391144
	C963.162476,207.145996 963.016418,203.882294 963.016418,199.026642
	C960.588684,201.176605 959.359070,202.150497 958.261414,203.255478
	C947.622131,213.966263 934.681580,218.773727 919.675476,219.078766
	C907.868469,219.318787 896.524780,218.033493 885.707764,212.911743
	C865.764709,203.468918 855.025024,186.914688 850.338684,166.226242
	C846.340454,148.575714 847.016357,130.862427 853.634094,113.755493
	C862.906006,89.787315 880.059265,75.215393 905.593933,70.968811
	C920.438721,68.500015 934.880127,69.574921 947.979370,77.643623
	C953.114136,80.806488 957.553894,85.097733 963.007202,89.428658
	C963.007202,85.845490 963.226196,82.740990 962.957153,79.679367
	C962.525879,74.770874 964.309570,72.692215 969.448242,72.950172
	C976.092773,73.283722 982.778015,73.267174 989.424500,72.953461
	C994.420227,72.717659 996.125183,74.529724 996.082092,79.561562
	C995.884094,102.708008 995.998108,125.857109 996.000000,149.005264
	C996.000183,151.170181 996.000000,153.335083 996.000000,156.000000
M894.504272,177.991531
	C908.450684,191.066208 931.795044,192.935898 947.092224,181.871048
	C957.442871,174.384125 962.249023,163.514053 963.627197,151.187485
	C965.308289,136.151962 962.370667,121.933929 951.324951,111.104980
	C934.786377,94.890854 903.771301,96.279915 889.698303,117.515076
	C879.125000,133.469421 878.899658,161.180923 894.504272,177.991531
z`
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              fill: e.fill ?? "#ffffff",
              opacity: "1.000000",
              stroke: "none",
              d: `
M436.231750,196.720825
	C426.556854,184.638275 420.521606,171.403931 418.585724,156.272934
	C413.295868,114.927551 435.646942,77.173988 478.833069,70.929535
	C493.859589,68.756790 508.721161,69.449188 522.987732,75.022850
	C545.994934,84.011253 559.879333,101.081367 565.383972,124.890808
	C570.624390,147.557861 567.943970,169.238342 554.951233,188.924133
	C544.861328,204.211761 530.435913,213.795868 512.506836,217.194962
	C489.639099,221.530365 467.401398,220.230850 447.527710,206.245514
	C443.610687,203.489044 440.150970,200.082718 436.231750,196.720825
M529.518250,123.162750
	C525.539978,118.161812 522.253418,112.335312 517.454285,108.314178
	C502.860046,96.086021 477.257294,97.856369 463.997345,111.571609
	C454.653381,121.236473 451.688446,133.245224 451.976135,146.374268
	C452.437256,167.415024 463.996735,185.077988 486.432098,188.686035
	C502.924225,191.338287 520.778992,183.193588 528.330078,168.318527
	C535.736206,153.729004 535.076904,138.882065 529.518250,123.162750
z`
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              fill: e.fill ?? "#ffffff",
              opacity: "1.000000",
              stroke: "none",
              d: `
M708.999756,191.000000
	C708.990723,197.998840 708.891052,204.499313 709.007935,210.995880
	C709.073669,214.650436 707.471924,216.060974 703.897461,216.009598
	C696.233826,215.899460 688.559998,215.782898 680.904724,216.062225
	C676.170410,216.234970 674.920288,214.189987 674.946594,209.813049
	C675.079712,187.650970 675.184875,165.485260 674.896912,143.326050
	C674.800232,135.885574 674.169434,128.322906 672.641541,121.056053
	C669.049744,103.973022 657.521301,97.665924 640.419739,99.326706
	C623.864319,100.934441 613.282776,112.304886 612.082214,129.014877
	C611.201355,141.274902 611.174744,153.605286 611.036560,165.907333
	C610.869934,180.736313 610.965454,195.568573 611.000916,210.399261
	C611.008484,213.560074 610.558960,216.029755 606.505432,215.983871
	C598.174866,215.889603 589.842346,215.918045 581.511108,215.975769
	C578.340942,215.997742 576.913391,214.538467 577.033813,211.417725
	C577.072388,210.419998 577.005676,209.418640 577.005615,208.418945
	C577.003967,165.759506 576.997559,123.100075 577.011353,80.440643
	C577.013672,73.225296 577.188721,73.061264 584.225952,73.035057
	C591.391235,73.008377 598.559021,73.150185 605.721252,73.001633
	C609.593445,72.921318 611.183472,74.517769 611.012634,78.350403
	C610.851624,81.962250 610.978088,85.586914 610.978088,89.778809
	C616.143372,85.456062 620.173889,80.849152 625.214172,78.080032
	C646.150696,66.577606 667.739807,66.097466 688.370483,78.193916
	C702.060364,86.220749 707.246826,100.429588 707.823608,115.606575
	C708.771667,140.549911 708.662964,165.533432 708.999756,191.000000
z`
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              fill: e.fill ?? "#ffffff",
              opacity: "1.000000",
              stroke: "none",
              d: `
M844.996948,198.041641
	C844.991089,202.532593 844.825317,206.538681 845.023315,210.526733
	C845.229980,214.688522 843.383423,216.070160 839.375122,216.036758
	C824.382996,215.911835 809.389160,215.997650 794.395935,215.999008
	C771.406372,216.001099 748.416748,216.007782 725.427185,215.982773
	C723.339233,215.980499 721.251587,215.762360 717.679626,215.560623
	C743.296997,177.418427 768.197388,140.343765 793.949829,102.000496
	C790.411255,102.000496 788.481201,102.000694 786.551086,102.000465
	C767.892883,101.998283 749.233032,101.861778 730.577454,102.082939
	C725.566040,102.142357 723.649841,100.484566 723.957764,95.453583
	C724.282776,90.142456 724.222595,84.787544 723.978699,79.467896
	C723.763733,74.778526 725.516174,72.862175 730.336609,72.966980
	C740.660278,73.191422 750.992371,73.025276 761.321045,73.024803
	C788.475403,73.023575 815.629761,73.019142 842.784119,73.039070
	C844.745300,73.040504 846.706421,73.228241 850.142578,73.405418
	C838.226379,93.475861 824.923523,111.350983 812.664124,129.889496
	C800.402832,148.430832 787.928345,166.831177 774.905334,186.250549
	C777.956543,186.573380 779.963989,186.964920 781.972534,186.970306
	C800.130859,187.019043 818.289368,186.994171 836.447815,187.003738
	C844.967590,187.008224 844.967712,187.021011 844.995911,195.549561
	C844.998108,196.215988 844.996643,196.882431 844.996948,198.041641
z`
            }
          )
        ] })
      ]
    }
  );
}
function y9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 36 42",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M7.09462 41.7889C3.17163 41.7889 -0.0078125 38.6095 -0.0078125 34.6865V7.10091C-0.0078125 3.17945 3.17163 0 7.09462 0C11.0176 0 14.1971 3.17945 14.1971 7.10091V34.6865C14.1971 38.6095 11.0176 41.7889 7.09462 41.7889Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M36.0065 9.95952C36.0065 15.4608 31.5468 19.919 26.047 19.919C20.5457 19.919 16.0859 15.4608 16.0859 9.95952C16.0859 4.45822 20.5457 0 26.047 0C31.5468 0 36.0065 4.45822 36.0065 9.95952Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M36.0065 31.8289C36.0065 37.3302 31.5468 41.7884 26.047 41.7884C20.5457 41.7884 16.0859 37.3302 16.0859 31.8289C16.0859 26.3276 20.5457 21.8694 26.047 21.8694C31.5468 21.8694 36.0065 26.3276 36.0065 31.8289Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function m9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 263 71",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M47.0107 47.1114C47.0107 61.0114 37.9358 70.7614 24.9037 70.7614C18.9181 70.7614 13.225 67.8682 10.425 63.522V69.6041H0V2.03265H10.425V30.7039C13.225 26.3577 19.2106 23.4613 25.5788 23.4613C38.4212 23.4613 47.0107 32.922 47.0107 47.1114ZM36.4892 47.1114C36.4892 38.7147 31.0822 32.8256 23.3607 32.8256C15.4463 32.8256 10.0393 38.6151 10.0393 47.1114C10.0393 55.6076 15.4463 61.3972 23.3607 61.3972C31.0822 61.3972 36.4892 55.5112 36.4892 47.1114Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M50.3711 47.1115C50.3711 33.8897 59.2531 23.4615 74.1207 23.4615C88.9852 23.4615 97.864 33.8897 97.864 47.1115C97.864 60.3365 88.9852 70.7615 74.1207 70.7615C59.2531 70.7615 50.3711 60.3365 50.3711 47.1115ZM87.3457 47.1115C87.3457 38.9045 82.6138 32.8257 74.1207 32.8257C65.6245 32.8257 60.8926 38.9045 60.8926 47.1115C60.8926 55.3184 65.6245 61.3973 74.1207 61.3973C82.6138 61.3973 87.3457 55.3184 87.3457 47.1115Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M104 69.6042V24.6219H114.518V30.8937C117.321 26.0685 122.536 23.4583 129.193 23.4583C140.004 23.4583 145.604 29.5435 145.604 41.3187V69.6042H135.082V46.1471C135.082 36.5868 132.575 32.4367 125.233 32.4367C118.382 32.4367 114.518 36.979 114.518 44.8902V69.6042H104Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M148.969 69.6053L173.294 33.5018H150.997V24.623H190.765L166.344 60.8229H189.029V69.6053H148.969Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M190.473 47.1115C190.473 33.8897 198.872 23.4615 212.869 23.4615C218.855 23.4615 224.262 26.165 227.058 30.704V24.622H237.487V69.6042H227.058V63.5221C224.262 68.0612 218.083 70.7615 212.58 70.7615C198.101 70.7615 190.473 60.3365 190.473 47.1115ZM227.447 47.1115C227.447 39.39 223.101 32.8257 214.123 32.8257C205.919 32.8257 200.994 38.9045 200.994 47.1115C200.994 55.3184 205.919 61.3973 214.123 61.3973C223.101 61.3973 227.447 54.833 227.447 47.1115Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "250.879",
            cy: "12.502",
            r: "11.6161",
            stroke: "currentColor",
            strokeWidth: "1.0096"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M253.854 20.1193L251.147 15.6786H248.758V20.1193H246.326V5.31678H251.782C254.742 5.31678 256.857 7.47372 256.857 10.4977C256.857 12.8026 255.609 14.6212 253.706 15.3402L256.624 20.1193H253.854ZM248.758 13.5005H251.634C253.241 13.5005 254.425 12.2317 254.425 10.4977C254.425 8.76366 253.241 7.49487 251.634 7.49487H248.758V13.5005Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function g9({
  type: e = "error",
  error: t,
  className: r,
  ...n
}) {
  const o = yt(() => {
    switch (e) {
      default:
      case "error":
        return "bg-red-700 text-bonza-pale";
      case "warning":
        return "bg-orange-700 text-bonza-pale";
      case "success":
        return "bg-green-600 text-bonza-pale";
    }
  }, [e]);
  return /* @__PURE__ */ c(
    "div",
    {
      className: `
                w-full rounded-xl px-4 py-2 text-sm

                ${T5(!t && "hidden")}
                ${o}
                ${r}
            `,
      ...n,
      children: t
    }
  );
}
function z4({
  className: e,
  register: t,
  type: r = "text",
  ...n
}) {
  return /* @__PURE__ */ c(
    "input",
    {
      ...n,
      type: r,
      className: `
                rounded-3xl border-none bg-bonza-dark p-4 text-bonza-pale

                focus:border-bonza-primary focus:ring-bonza-primary

                ${e}
            `,
      ...t
    }
  );
}
function C9({
  register: e,
  className: t,
  ...r
}) {
  return /* @__PURE__ */ c(
    K4,
    {
      ...r,
      className: `
                rounded-3xl border-none bg-bonza-dark p-4 text-bonza-pale

                disabled:text-bonza-pale-t-7

                focus:border-bonza-primary focus:ring-bonza-primary

                ${t}
            `,
      ...e
    }
  );
}
function v9({
  className: e,
  register: t,
  ...r
}) {
  return /* @__PURE__ */ c(
    "textarea",
    {
      ...r,
      className: `
                rounded-3xl border-none bg-bonza-dark p-4 text-bonza-pale

                focus:border-bonza-primary focus:ring-bonza-primary

                ${e}
            `,
      ...t
    }
  );
}
function ai({
  href: e,
  className: t,
  ariaLabel: r,
  inverted: n,
  children: o
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      className: `
                rounded-full transition-all duration-100

                ${n ? `
                            border border-bonza-dark bg-bonza-pale
                            text-bonza-dark

                            hover:bg-bonza-dark hover:text-bonza-pale
                        ` : `
                            bg-bonza-dark-bg text-bonza-pale

                            hover:bg-bonza-pale hover:text-bonza-dark
                        `}
                ${t}
            `,
      children: /* @__PURE__ */ c(
        "a",
        {
          href: e,
          className: "h-full w-full",
          target: "_blank",
          rel: "noreferrer",
          "aria-label": r,
          children: /* @__PURE__ */ c("div", { className: "p-4", children: o })
        }
      )
    }
  );
}
function G4(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 17 18",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "7.18359",
            y: "0.0361328",
            width: "2.61538",
            height: "17",
            rx: "1.30769"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "16.9902",
            y: "7.22852",
            width: "2.61538",
            height: "17",
            rx: "1.30769",
            transform: "rotate(90 16.9902 7.22852)"
          }
        )
      ]
    }
  );
}
function Z4({
  closeCallback: e,
  disabled: t,
  size: r = 40,
  className: n
}) {
  return /* @__PURE__ */ c(
    "button",
    {
      onClick: () => e(),
      className: `
                relative flex items-center justify-center rounded-full
                bg-bonza-pale-t-7 p-2 text-bonza-pale-t-70 transition
                duration-100 ease-in-out

                hover:bg-white hover:text-black

                ${n}
            `,
      disabled: t,
      style: { height: `${r}px`, width: `${r}px` },
      children: /* @__PURE__ */ c(G4, { className: "size-full rotate-45" })
    }
  );
}
function b9({
  title: e,
  description: t,
  className: r
}) {
  const [n, o] = be(!1);
  return n ? null : /* @__PURE__ */ D(
    "div",
    {
      className: `
                flex items-center justify-between gap-4 rounded-[24px]
                bg-bonza-pale-t-7 py-3 pl-6 pr-2

                ${r}
            `,
      children: [
        /* @__PURE__ */ D("div", { className: "flex grow flex-col items-center gap-0.5 text-center", children: [
          /* @__PURE__ */ c("p", { className: "text-[15px]", children: e }),
          t && /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-70", children: t })
        ] }),
        /* @__PURE__ */ c(
          Z4,
          {
            closeCallback: () => o(!0),
            size: 30,
            className: "shrink-0 p-1"
          }
        )
      ]
    }
  );
}
const Hr = 20, Ws = 80, W4 = 150, Q4 = 24, J4 = 0.7, Qs = 0.1;
function Y4(e, t, r, n) {
  const o = (h, f) => 1 - 3 * f + 3 * h, i = (h, f) => 3 * f - 6 * h, s = (h) => 3 * h, a = (h, f, b) => ((o(f, b) * h + i(f, b)) * h + s(f)) * h, u = (h, f, b) => 3 * o(f, b) * h * h + 2 * i(f, b) * h + s(f), d = (h) => {
    let f = h;
    for (let b = 0; b < 8; b++) {
      const C = u(f, e, r);
      if (C === 0) return f;
      f -= (a(f, e, r) - h) / C;
    }
    return f;
  };
  return (h) => a(d(Math.max(0, Math.min(1, h))), t, n);
}
const Js = Y4(0.5, 0, 0.9, 0.4);
function X4(e, t, r, n, o, i, s) {
  const a = o / 2;
  e.save(), e.globalAlpha = s, e.beginPath(), e.roundRect(r - a, n - a, o, o, i), e.clip(), e.drawImage(t, r - a, n - a, o, o), e.restore();
}
function w9({
  imageURLs: e,
  static: t
}) {
  const r = Le(null), n = Le(null), o = yt(() => {
    const i = [...e, ...e];
    return i.map((s, a) => {
      const u = a / i.length * 2 * Math.PI, d = Ws * Math.cos(u), h = Ws * Math.sin(u), f = new Image();
      return f.src = s, {
        image: f,
        startPos: {
          x: d / (5 + 5 * Math.random()) + 50,
          y: h / (5 + 5 * Math.random()) + 50
        },
        endPos: {
          x: d + 50,
          y: h + 50
        },
        startDelay: Math.random() * Hr - 2
      };
    });
  }, [e]);
  return Be(() => {
    const i = r.current, s = n.current;
    if (!i || !s) return;
    const a = i.getContext("2d");
    if (!a) return;
    let u = 0, d = 0;
    const h = () => {
      const g = window.devicePixelRatio || 1;
      u = s.clientWidth, d = s.clientHeight, i.width = u * g, i.height = d * g, a.setTransform(g, 0, 0, g, 0, 0);
    };
    h();
    const f = new ResizeObserver(h);
    f.observe(s);
    const b = (g) => {
      a.clearRect(0, 0, u, d);
      for (const p of o) {
        if (!p.image.complete) continue;
        const m = g(p), v = Js(m), S = (p.startPos.x + (p.endPos.x - p.startPos.x) * v) * (u / 100), x = (p.startPos.y + (p.endPos.y - p.startPos.y) * v) * (d / 100), A = 0.2 + (1 - 0.2) * v, N = m >= Qs ? 1 : m / Qs, $ = Js(N);
        X4(
          a,
          p.image,
          S,
          x,
          W4 * A,
          Q4 * A,
          $
        );
      }
    };
    if (t)
      return b(() => 1), () => f.disconnect();
    let C;
    const l = (g) => {
      const p = g / 1e3;
      b((m) => ((p - m.startDelay) % Hr + Hr) % Hr / Hr), C = requestAnimationFrame(l);
    };
    return C = requestAnimationFrame(l), () => {
      cancelAnimationFrame(C), f.disconnect();
    };
  }, [o, t]), /* @__PURE__ */ c(
    "div",
    {
      ref: n,
      className: "absolute inset-0 overflow-hidden",
      style: { opacity: J4 },
      children: /* @__PURE__ */ c("canvas", { ref: r, className: "h-full w-full" })
    }
  );
}
function e6({
  message: e,
  className: t = "",
  ...r
}) {
  return e ? /* @__PURE__ */ c(
    "p",
    {
      ...r,
      className: `
                text-sm text-red-400

                ${t}
            `,
      children: e
    }
  ) : null;
}
function t6({
  value: e,
  className: t = "",
  children: r,
  ...n
}) {
  return /* @__PURE__ */ c(
    "label",
    {
      ...n,
      className: `
                block font-medium text-md text-bonza-pale

                ${t}
            `,
      children: e || r
    }
  );
}
const r6 = Ii(function({
  type: t = "text",
  isFocused: r = !1,
  ...n
}, o) {
  const i = Le(null);
  return yc(o, () => ({
    focus: () => {
      var s;
      return (s = i.current) == null ? void 0 : s.focus();
    }
  })), Be(() => {
    var s;
    r && ((s = i.current) == null || s.focus());
  }, []), /* @__PURE__ */ c(z4, { ...n, type: t, ref: i });
});
function S9({
  methods: e,
  isPending: t,
  error: r,
  submitCallback: n,
  resendCallback: o
}) {
  const [i, s] = be(""), [a, u] = be(!1), [d, h] = be(e[0] ?? "totp"), f = (l) => {
    l.preventDefault(), n(i);
  }, b = async () => {
    o && (await o(), u(!0), setTimeout(() => u(!1), 3e4));
  }, C = e.find((l) => l !== d);
  return /* @__PURE__ */ c(
    "div",
    {
      className: `
                flex flex-col gap-8 rounded-[45px] bg-bonza-dark px-14 py-10
            `,
      children: /* @__PURE__ */ D(
        "form",
        {
          onSubmit: f,
          className: "flex flex-col items-center gap-8 text-white",
          children: [
            /* @__PURE__ */ D("div", { className: "flex flex-col items-stretch gap-2 text-center", children: [
              /* @__PURE__ */ c("h1", { className: "text-3xl", children: "Verification" }),
              /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: d === "email" ? "Enter the 6-digit code sent to your email." : "Enter the code from your authenticator app." }),
              C && /* @__PURE__ */ c(
                "button",
                {
                  type: "button",
                  className: "text-sm text-bonza-pale-t-40 underline hover:text-bonza-pale",
                  onClick: () => h(C),
                  children: C === "email" ? "Use email code instead" : "Use authenticator app instead"
                }
              ),
              r && /* @__PURE__ */ c("div", { className: "inline-block w-[280px] text-center", children: /* @__PURE__ */ c("span", { className: "text-wrap text-bonza-red", children: r }) })
            ] }),
            /* @__PURE__ */ D("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ c(t6, { htmlFor: "code", value: "Verification Code" }),
              /* @__PURE__ */ c(
                r6,
                {
                  id: "code",
                  type: "text",
                  inputMode: "numeric",
                  autoComplete: "one-time-code",
                  value: i,
                  onChange: (l) => s(
                    l.target.value.replace(/\D/g, "").slice(0, 8)
                  ),
                  className: "mt-1 block w-[220px] text-center tracking-widest",
                  placeholder: "000000",
                  autoFocus: !0
                }
              ),
              /* @__PURE__ */ c(e6, { message: void 0 })
            ] }),
            /* @__PURE__ */ D("div", { className: "flex flex-col items-center gap-3 self-stretch", children: [
              /* @__PURE__ */ c(
                zi,
                {
                  className: "self-stretch",
                  type: "submit",
                  disabled: t || i.length < 6,
                  children: "Verify"
                }
              ),
              d === "email" && o && /* @__PURE__ */ c(
                Gi,
                {
                  type: "button",
                  className: "text-sm",
                  onClick: b,
                  disabled: a || t,
                  children: a ? "Code sent" : "Resend code"
                }
              )
            ] })
          ]
        }
      )
    }
  );
}
function n6(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      fill: "currentColor",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" })
    }
  );
}
function o6({
  planToPurchase: e,
  isFullBorder: t,
  payNowCallback: r,
  callbackText: n = "Add card",
  isPending: o,
  trialCallback: i,
  trialEndPreview: s,
  isTrialPending: a,
  trialDays: u,
  className: d,
  onChooseAnotherPlan: h
}) {
  const f = yt(() => {
    var S, x, A, N, $, q, I;
    const b = (x = (S = e == null ? void 0 : e.prices[0]) == null ? void 0 : S.billing_cycle) == null ? void 0 : x.interval, C = ((A = e == null ? void 0 : e.metadata) == null ? void 0 : A.display_colour) ?? "#ffffff", l = ((N = e == null ? void 0 : e.metadata) == null ? void 0 : N.display_name) ?? "Guest", g = (($ = e == null ? void 0 : e.prices[0].custom_data) == null ? void 0 : $.display_subtitle) || ((q = e == null ? void 0 : e.metadata) == null ? void 0 : q.display_subtitle) || (b === "month" ? `Per month
cancel anytime` : b === "year" ? "Billed yearly" : null), p = (e == null ? void 0 : e.prices[0].paddle_price_id) ?? null, m = (I = e == null ? void 0 : e.prices[0]) == null ? void 0 : I.unit_price.amount;
    return {
      colour: C,
      name: l,
      description: g,
      price: ((F) => F > 0 ? `£${Math.round(F * 100) / 1e4}` : null)(Number(m)),
      priceId: p
    };
  }, [e]);
  return /* @__PURE__ */ c(
    "div",
    {
      className: `
                flex flex-col items-center justify-center gap-3
                rounded-l-[30px] border-bonza-pale-t-7 p-4

                md:border-b md:border-l md:border-t

                ${t ? "rounded-[30px] border border-solid" : "h-[75%] px-6 md:px-8 py-12"}
                ${d}
            `,
      children: /* @__PURE__ */ D("div", { className: "h-full w-full flex flex-col items-center justify-center gap-3", children: [
        /* @__PURE__ */ c("p", { style: { color: f == null ? void 0 : f.colour }, children: f == null ? void 0 : f.name }),
        u ? /* @__PURE__ */ c(
          "div",
          {
            className: `
                        flex flex-col items-center justify-center leading-tight
                    `,
            children: /* @__PURE__ */ c(
              "span",
              {
                className: "text-[24px]",
                children: `${u}-day free trial`
              }
            )
          }
        ) : /* @__PURE__ */ D(
          "div",
          {
            className: `
                        flex flex-col items-center justify-center leading-tight
                    `,
            children: [
              /* @__PURE__ */ c("span", { className: "text-[24px]", children: f == null ? void 0 : f.price }),
              /* @__PURE__ */ c("p", { children: f == null ? void 0 : f.description })
            ]
          }
        ),
        /* @__PURE__ */ D("div", { className: "flex items-center gap-2 text-[12px]", children: [
          /* @__PURE__ */ c(n6, { className: "mb-1 size-4 min-w-4" }),
          /* @__PURE__ */ c("span", { children: "Available for macOS" })
        ] }),
        /* @__PURE__ */ D("div", { className: "flex flex-col gap-2 flex-wrap items-center justify-center md:flex-row", children: [
          i && /* @__PURE__ */ c(
            zi,
            {
              disabled: o || a,
              onClick: () => i(),
              children: "Continue without renewal"
            }
          ),
          r && /* @__PURE__ */ c(
            Gi,
            {
              disabled: o || a,
              onClick: () => r(),
              children: n
            }
          )
        ] }),
        i && s && /* @__PURE__ */ c(
          "p",
          {
            className: `
                                max-w-[240px] text-center text-sm
                                text-bonza-pale-t-40
                            `,
            children: s
          }
        ),
        h && /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            className: `
                            text-sm text-bonza-pale-t-70 underline

                            hover:text-bonza-pale
                        `,
            onClick: h,
            children: "Choose another plan"
          }
        )
      ] })
    }
  );
}
function i6(e) {
  if (!e) return "Session pass";
  if (e % 720 === 0) {
    const t = e / 720;
    return `${t} month${t > 1 ? "s" : ""} access`;
  }
  if (e % 168 === 0) {
    const t = e / 168;
    return `${t} week${t > 1 ? "s" : ""} access`;
  }
  return `${e} hour${e > 1 ? "s" : ""} access`;
}
const ci = (e) => new Date(e).toLocaleDateString("en-GB", {
  day: "2-digit",
  month: "long",
  year: "numeric",
  timeZone: "UTC"
});
function E9({
  purchasedPlan: e,
  purchasedPrice: t,
  isActive: r,
  renewsAt: n,
  trialEndsAt: o,
  trialCardAdded: i = !1,
  isPlanChange: s = !1,
  planChangeDate: a,
  accountName: u,
  accountAvatar: d,
  onContinue: h,
  continueLabel: f = "Continue",
  onAddCard: b,
  onChooseAnotherPlan: C
}) {
  var l;
  return /* @__PURE__ */ D(
    "div",
    {
      className: `
                flex flex-col items-center gap-6

                md:flex-row md:items-center md:justify-center md:gap-10
            `,
      children: [
        /* @__PURE__ */ c(
          o6,
          {
            planToPurchase: e,
            isFullBorder: !0,
            className: "w-full max-w-[320px] md:min-h-[250px] md:w-[350px] md:p-8"
          }
        ),
        /* @__PURE__ */ D(
          "div",
          {
            className: `
                    flex flex-col items-center gap-3 text-center

                    md:max-w-[350px] md:items-start md:text-left
                `,
            children: [
              /* @__PURE__ */ c("h2", { className: "text-[22px]", children: o || i ? "Trial Started!" : s ? "Membership Updated!" : r ? "Subscription Purchased!" : "Pass Purchased!" }),
              /* @__PURE__ */ D("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ c(
                  "div",
                  {
                    className: `
                            flex size-5 shrink-0 items-center justify-center
                            overflow-hidden rounded-full bg-bonza-pale-t-7
                            text-[10px] uppercase text-bonza-pale-t-70
                        `,
                    children: d ? /* @__PURE__ */ c(
                      "img",
                      {
                        src: d,
                        alt: u,
                        className: "h-full w-full object-cover"
                      }
                    ) : u.charAt(0)
                  }
                ),
                /* @__PURE__ */ c("p", { className: "text-xs text-bonza-pale-t-40", children: u })
              ] }),
              i ? /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: o ? `Your trial ends on ${ci(o)}. Your subscription will renew automatically.` : "Your card has been added — your subscription will start automatically when your trial ends." }) : o ? /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: `Your trial ends on ${ci(o)}. Add a card anytime to auto-renew your subscription.` }) : s ? /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: `Your plan will change at the end of your billing cycle${a ? ` on ${a}` : ""}.` }) : r ? n && /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: `Renews on ${ci(n)}` }) : /* @__PURE__ */ D(Jr, { children: [
                /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: "This plan will activate when you next use Bonza" }),
                !!((l = t == null ? void 0 : t.custom_data) != null && l.payg_duration_hours) && /* @__PURE__ */ c("p", { className: "text-sm text-bonza-pale-t-40", children: i6(
                  t.custom_data.payg_duration_hours
                ) })
              ] }),
              /* @__PURE__ */ D("div", { className: "flex flex-wrap items-center justify-center gap-2", children: [
                /* @__PURE__ */ c(zi, { onClick: h, children: f }),
                o && !i && b && /* @__PURE__ */ c(Gi, { onClick: b, children: "Add card" })
              ] }),
              C && /* @__PURE__ */ c(
                "button",
                {
                  type: "button",
                  className: `
                            text-sm text-bonza-pale-t-70 underline

                            hover:text-bonza-pale
                        `,
                  onClick: C,
                  children: "Choose another plan"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function s6(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("g", { opacity: "0.7", clipPath: "url(#clip0_1173_3306)", children: /* @__PURE__ */ c(
          "path",
          {
            d: "M10.7142 10.3774L17.4162 18H15.8286L10.0068 11.3827L5.3604 18H0L7.0278 7.99254L0 0H1.5876L7.7316 6.98958L12.6396 0H18M2.1606 16.8286H4.5996L15.8274 1.11387H13.3878",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_1173_3306", children: /* @__PURE__ */ c(
          "rect",
          {
            width: "18",
            height: "18",
            fill: "currentColor",
            transform: "matrix(1 0 0 -1 0 18)"
          }
        ) }) })
      ]
    }
  );
}
function a6(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 9 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("g", { opacity: "0.7", clipPath: "url(#clip0_1173_3310)", children: /* @__PURE__ */ c(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.88603 9.28378V18.1903C1.88603 18.3198 1.98737 18.4212 2.11686 18.4212H5.42163C5.55112 18.4212 5.65246 18.3198 5.65246 18.1903V9.1374H8.05082C8.16905 9.1374 8.27039 9.04732 8.28165 8.92346L8.51247 6.19857C8.52373 6.06345 8.41676 5.94522 8.28165 5.94522H5.65246V4.00852C5.65246 3.55249 6.01841 3.18655 6.47443 3.18655H8.32105C8.45054 3.18655 8.55188 3.08521 8.55188 2.95572V0.230828C8.55188 0.101339 8.45054 0 8.32105 0H5.19644C3.37234 0 1.88603 1.4863 1.88603 3.31604V5.94522H0.230828C0.101339 5.94522 0 6.04656 0 6.17605V8.90094C0 9.03043 0.101339 9.13177 0.230828 9.13177H1.88603V9.27814V9.28378Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_1173_3310", children: /* @__PURE__ */ c(
          "rect",
          {
            width: "8.55751",
            height: "18.4212",
            fill: "currentColor"
          }
        ) }) })
      ]
    }
  );
}
function c6(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 19 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ D("g", { opacity: "0.7", clipPath: "url(#clip0_1173_3314)", children: [
          /* @__PURE__ */ c(
            "path",
            {
              d: "M18.8464 11.0395V17.6987C18.8464 17.8624 18.7155 17.9999 18.5452 17.9999H15.1076C14.9439 17.9999 14.8064 17.8689 14.8064 17.6987V11.5044C14.8064 9.87399 14.2237 8.76086 12.7635 8.76086C11.6504 8.76086 10.989 9.50731 10.6944 10.2341C10.5896 10.496 10.5634 10.8562 10.5634 11.2163V17.6987C10.5634 17.8624 10.4325 17.9999 10.2622 17.9999H6.8246C6.66091 17.9999 6.5234 17.8689 6.5234 17.6987C6.52995 16.0486 6.56269 8.04715 6.52995 6.16137C6.52995 5.99767 6.66091 5.86017 6.8246 5.86017H10.2557C10.4194 5.86017 10.5569 5.99113 10.5569 6.16137V7.58225C10.5569 7.58225 10.5372 7.60844 10.5307 7.62154H10.5569V7.58225C11.0938 6.75722 12.0498 5.57861 14.1909 5.57861C16.8428 5.57861 18.8333 7.31379 18.8333 11.0395H18.8464ZM0.564872 17.9999H4.00249C4.16618 17.9999 4.30369 17.8689 4.30369 17.6987V6.16137C4.30369 5.99767 4.17273 5.86017 4.00249 5.86017H0.564872C0.401176 5.86017 0.263672 5.99113 0.263672 6.16137V17.6987C0.263672 17.8624 0.394629 17.9999 0.564872 17.9999Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              d: "M2.16079 4.32157C3.35416 4.32157 4.32157 3.35416 4.32157 2.16079C4.32157 0.967417 3.35416 0 2.16079 0C0.967417 0 0 0.967417 0 2.16079C0 3.35416 0.967417 4.32157 2.16079 4.32157Z",
              fill: "currentColor"
            }
          )
        ] }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_1173_3314", children: /* @__PURE__ */ c("rect", { width: "18.8447", height: "18", fill: "currentColor" }) }) })
      ]
    }
  );
}
function x9({
  featuredSrc: e,
  featuredSrcWebp: t,
  headerImgLink: r,
  title: n,
  publishDate: o,
  children: i,
  className: s
}) {
  const a = new URL(window.location.href), u = `https://www.facebook.com/sharer/sharer.php?u=${a}`, d = `https://www.linkedin.com/sharing/share-offsite/?url=${a}`, h = `https://twitter.com/intent/tweet?url=${a}`, f = r != null && r.startsWith("#") ? {
    onClick: (b) => {
      var C;
      b.preventDefault(), (C = document.getElementById(r.slice(1))) == null || C.scrollIntoView({ behavior: "smooth" });
    }
  } : { target: "_blank", rel: "noreferrer" };
  return /* @__PURE__ */ D(Jr, { children: [
    n && /* @__PURE__ */ c($3, { title: n }),
    /* @__PURE__ */ D(
      "div",
      {
        className: `
                    w-full rounded-b-[40px] bg-bonza-pale pb-[40px]
                    text-bonza-dark
                `,
        children: [
          /* @__PURE__ */ D("section", { children: [
            /* @__PURE__ */ c(
              "div",
              {
                className: `
                            px-main py-main mx-auto flex w-full grow flex-col
                            items-center justify-center gap-8 bg-bonza-dark-bg
                            pt-[150px] text-bonza-pale

                            md:gap-8
                        `,
                children: /* @__PURE__ */ D(
                  "div",
                  {
                    className: `
                                flex w-full flex-col px-2 text-left

                                md:px-auto md:text-center
                            `,
                    children: [
                      n && /* @__PURE__ */ c(
                        "h1",
                        {
                          className: `
                                    text-[32px]

                                    md:text-[55px]
                                `,
                          children: n
                        }
                      ),
                      o && /* @__PURE__ */ c("span", { children: o })
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ D(
              "div",
              {
                className: `
                            px-main relative flex w-full grow flex-col
                            items-center justify-center
                        `,
                children: [
                  e && (r ? /* @__PURE__ */ c(
                    "a",
                    {
                      href: r,
                      ...f,
                      className: "flex items-center justify-center",
                      children: /* @__PURE__ */ c(
                        "div",
                        {
                          className: `
                                        z-10 grow overflow-hidden rounded-[40px]
                                        bg-cover bg-center max-w-main
                                    `,
                          children: /* @__PURE__ */ D("picture", { children: [
                            t && /* @__PURE__ */ c(
                              "source",
                              {
                                srcSet: t,
                                type: "image/webp"
                              }
                            ),
                            /* @__PURE__ */ c(
                              "img",
                              {
                                src: e,
                                alt: n || "Featured image",
                                className: "max-h-[60vh] min-h-[50dvh] object-[50%_50%] sm:object-[50%_30%] xl:object-[50%_40%]"
                              }
                            )
                          ] })
                        }
                      )
                    }
                  ) : /* @__PURE__ */ c(
                    "div",
                    {
                      className: `
                                        z-10 grow overflow-hidden rounded-[40px]
                                        bg-cover bg-center max-w-main
                                    `,
                      children: /* @__PURE__ */ D("picture", { children: [
                        t && /* @__PURE__ */ c(
                          "source",
                          {
                            srcSet: t,
                            type: "image/webp"
                          }
                        ),
                        /* @__PURE__ */ c(
                          "img",
                          {
                            src: e,
                            alt: n || "Featured image",
                            className: "max-h-[60vh] min-h-[50dvh] object-[50%_50%] sm:object-[50%_30%] xl:object-[50%_40%]"
                          }
                        )
                      ] })
                    }
                  )),
                  /* @__PURE__ */ c("div", { className: "absolute inset-0 flex flex-col", children: /* @__PURE__ */ c(
                    "div",
                    {
                      className: `
                                    min-h-[50%] rounded-b-[40px]
                                    bg-bonza-dark-bg
                                `
                    }
                  ) })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ c(
            "section",
            {
              className: `
                        px-main py-main flex w-full flex-col items-center
                        text-left
                    `,
              children: /* @__PURE__ */ c(
                "article",
                {
                  className: `
                            w-full max-w-[660px] py-4 ql-editor

                            ${s}
                        `,
                  children: i
                }
              )
            }
          ),
          /* @__PURE__ */ D(
            "menu",
            {
              className: `
                        px-main py-main flex w-full flex-col items-center
                        justify-center gap-2
                    `,
              children: [
                /* @__PURE__ */ c("p", { className: "text-[25px]", children: "Share this article" }),
                /* @__PURE__ */ D("ul", { className: "flex flex-wrap gap-2", children: [
                  /* @__PURE__ */ c("li", { children: /* @__PURE__ */ c(
                    ai,
                    {
                      href: u,
                      ariaLabel: "Share with Facebook",
                      inverted: !0,
                      children: /* @__PURE__ */ c(
                        a6,
                        {
                          className: `
                                        size-4

                                        sm:size-6
                                    `
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ c("li", { children: /* @__PURE__ */ c(
                    ai,
                    {
                      href: d,
                      ariaLabel: "Share with LinkedIn",
                      inverted: !0,
                      children: /* @__PURE__ */ c(
                        c6,
                        {
                          className: `
                                        size-4

                                        sm:size-6
                                    `
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ c("li", { children: /* @__PURE__ */ c(
                    ai,
                    {
                      href: h,
                      ariaLabel: "Share with X",
                      inverted: !0,
                      children: /* @__PURE__ */ c(
                        s6,
                        {
                          className: `
                                        size-4

                                        sm:size-6
                                    `
                        }
                      )
                    }
                  ) })
                ] })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ c("style", { children: `
                    .ql-editor { line-height: 1.42; outline: none; }
                    .ql-editor p { margin-bottom: 1em; }
                    .ql-editor h1, .ql-editor h2, .ql-editor h3,
                    .ql-editor h4, .ql-editor h5, .ql-editor h6 { font-weight: bold; margin-bottom: 0.5em; }
                    .ql-editor h1 { font-size: 2em; }
                    .ql-editor h2 { font-size: 1.5em; }
                    .ql-editor h3 { font-size: 1.17em; }
                    .ql-editor ul, .ql-editor ol { padding-left: 1.5em; margin-bottom: 1em; }
                    .ql-editor ul { list-style-type: disc; }
                    .ql-editor ol { list-style-type: decimal; }
                    .ql-editor blockquote { border-left: 4px solid #ccc; margin-bottom: 1em; padding-left: 1em; }
                    .ql-editor .ql-align-center { text-align: center; }
                    .ql-editor .ql-align-right { text-align: right; }
                    .ql-editor .ql-align-justify { text-align: justify; }
                    .ql-editor .ql-indent-1 { padding-left: 3em; }
                    .ql-editor .ql-indent-2 { padding-left: 6em; }
                    .ql-editor .ql-indent-3 { padding-left: 9em; }
                    .ql-editor img { max-width: 100%; overflow: hidden; border-radius: 20px; }
                    .ql-editor .ql-align-center img { display: block; margin: 0 auto; }
                    .ql-editor .ql-align-right img { display: block; margin-left: auto; }
                    .ql-editor .ql-video { display: block; width: 100%; aspect-ratio: 16 / 9; height: auto; border: 0; border-radius: 20px; }
                ` })
  ] });
}
function R9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 34 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M12.675 12.7071C11.6367 9.6266 12.2608 7.22272 14.5223 5.66843C16.5459 4.27769 19.2399 4.39776 21.1612 5.96916C23.0029 7.47548 23.8044 10.1793 22.5743 12.7478C22.6795 12.8083 22.7872 12.8698 22.8945 12.9321C26.5897 15.0755 28.5451 18.2678 28.6873 22.5471C28.7101 23.2299 28.3706 23.737 27.7978 23.9499C27.2461 24.155 26.585 24.0131 26.2613 23.5232C26.0745 23.2406 25.9604 22.8637 25.9429 22.5227C25.7799 19.3469 24.3384 16.9627 21.5858 15.369C21.5759 15.3632 21.5646 15.3593 21.5548 15.3531C21.0099 15.0085 20.5306 14.9302 19.8649 15.2523C18.233 16.0417 16.5619 15.9131 14.9633 15.0528C14.7659 14.9465 14.6116 14.9289 14.4133 15.0215C11.2643 16.4933 9.57566 18.9594 9.35348 22.4273C9.34156 22.6129 9.35194 22.804 9.30944 22.9826C9.1442 23.6762 8.49323 24.113 7.78194 24.0249C7.09506 23.9399 6.58743 23.3521 6.59781 22.6074C6.64606 19.1497 8.01268 16.3092 10.6654 14.1022C11.2873 13.5849 11.9972 13.1732 12.675 12.7071ZM17.6394 12.9811C19.1668 12.9823 20.402 11.7533 20.4034 10.231C20.4048 8.71361 19.1627 7.46847 17.6455 7.4658C16.1331 7.46328 14.8826 8.71095 14.8802 10.2248C14.8777 11.7435 16.1154 12.9798 17.6394 12.9811Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M12.9495 15.0109C13.1155 14.957 13.2998 14.9362 13.4872 14.9396C12.8854 13.781 11.9379 12.8301 10.6511 12.0838C10.5843 12.0451 10.5171 12.0066 10.4516 11.9689C11.2183 10.3678 10.7187 8.68234 9.57059 7.7434C8.373 6.76378 6.69359 6.68902 5.43218 7.556C4.02236 8.52482 3.6334 10.0233 4.28059 11.9437C3.85811 12.2342 3.41557 12.4908 3.02788 12.8133C1.37428 14.189 0.522301 15.9596 0.492284 18.1151C0.485832 18.5794 0.802273 18.9458 1.23036 18.9988C1.67375 19.0536 2.07968 18.7814 2.18263 18.3491C2.20914 18.2377 2.20269 18.1185 2.21012 18.0029C2.34857 15.841 3.40126 14.3038 5.36429 13.3863C5.48786 13.3287 5.58395 13.3396 5.7071 13.4058C6.70355 13.942 7.74531 14.0223 8.76266 13.5301C9.17757 13.3294 9.47633 13.3782 9.81592 13.5931C9.82209 13.5968 9.8291 13.5992 9.83541 13.6029C10.7826 14.1513 11.4795 14.8508 11.932 15.6997C12.1845 15.3894 12.5306 15.1464 12.9495 15.0109ZM7.37528 12.1144C6.42526 12.1135 5.6538 11.3429 5.6552 10.3963C5.65674 9.45254 6.43634 8.67476 7.37907 8.67631C8.32489 8.67799 9.09902 9.45422 9.09817 10.4C9.09733 11.3491 8.32741 12.1152 7.37528 12.1144Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "27.793",
            y: "0.241211",
            width: "1.78389",
            height: "8.91944",
            rx: "0.891944",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "33.1484",
            y: "3.80884",
            width: "1.78389",
            height: "8.91944",
            rx: "0.891944",
            transform: "rotate(90 33.1484 3.80884)",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function O9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 20 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M9.98892 18.5369C7.37616 18.5373 4.76357 18.5376 2.15081 18.5364C1.97694 18.5362 1.79783 18.5488 1.63025 18.513C0.917994 18.3608 0.734339 17.7614 1.16438 17.261C2.52196 15.6811 3.2136 13.8248 3.37803 11.7461C3.51276 10.0397 3.69362 8.33526 3.9124 6.63763C4.17503 4.5996 5.32362 3.23677 7.27061 2.60036C9.07222 2.0113 10.907 2.0085 12.706 2.59808C14.7447 3.26613 15.8613 4.72314 16.092 6.85431C16.2919 8.701 16.4819 10.5486 16.6784 12.3954C16.87 14.1953 17.5981 15.7667 18.7212 17.1673C18.9321 17.4305 19.1892 17.6797 18.9976 18.0538C18.8014 18.4368 18.4451 18.5369 18.0448 18.5369C15.3595 18.5364 12.6742 18.5366 9.98892 18.5369Z" }),
        /* @__PURE__ */ c("path", { d: "M11.8127 19.2178C11.755 20.1229 10.9582 20.838 10.0168 20.8581C9.07742 20.8782 8.24774 20.1628 8.15723 19.2178H11.8127Z" }),
        /* @__PURE__ */ c("path", { d: "M11.3291 1.57918H8.6401C8.53159 1.02367 8.75508 0.520581 9.26097 0.206218C9.75182 -0.0987094 10.3788 -0.0646344 10.8475 0.292366C11.2798 0.621757 11.4603 1.12554 11.3291 1.57918Z" })
      ]
    }
  );
}
function P9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "91",
      height: "46",
      viewBox: "0 0 91 46",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "2.11719",
            y: "1.81714",
            width: "86.3711",
            height: "38.7115",
            rx: "4.25",
            stroke: "currentColor",
            strokeWidth: "3.5"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "43.7736",
            cy: "21.1728",
            r: "8.55879",
            stroke: "currentColor",
            strokeWidth: "3.5"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "69.6604",
            cy: "21.1728",
            r: "8.55879",
            stroke: "currentColor",
            strokeWidth: "3.5"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M43.7734 9.39478L43.7734 12.0666",
            stroke: "currentColor",
            strokeWidth: "3.5",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M69.6562 9.39478L69.6562 12.0666",
            stroke: "currentColor",
            strokeWidth: "3.5",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M14.7812 15.3672L21.2975 15.3672",
            stroke: "currentColor",
            strokeWidth: "3.5",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M14.7812 26.9785L21.2975 26.9785",
            stroke: "currentColor",
            strokeWidth: "3.5",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M14.0703 43.4121H27.2616",
            stroke: "currentColor",
            strokeWidth: "3.5",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M63.3438 43.4121H76.5351",
            stroke: "currentColor",
            strokeWidth: "3.5",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
function A9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 78 42",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M73.5996 0.975586C75.5567 0.975637 77.1436 2.56248 77.1436 4.51953V33.4043C77.1436 35.3614 75.5567 36.9482 73.5996 36.9482H4.09863C2.14155 36.9482 0.554688 35.3614 0.554688 33.4043V4.51953C0.554688 2.56245 2.14155 0.975586 4.09863 0.975586H73.5996ZM38.0957 6.27734C37.4053 6.27734 36.8457 6.83699 36.8457 7.52734V9.42578C31.9486 9.95702 28.1367 14.1042 28.1367 19.1426C28.1369 24.5411 32.5136 28.917 37.9121 28.917C43.3105 28.9168 47.6864 24.541 47.6865 19.1426C47.6865 14.231 44.0646 10.1653 39.3457 9.47168V7.52734C39.3457 6.83699 38.7861 6.27734 38.0957 6.27734ZM61.3379 6.27734C60.6477 6.27734 60.0882 6.83624 60.0879 7.52637V9.42676C55.1927 9.9598 51.3828 14.1056 51.3828 19.1426C51.383 24.5411 55.7596 28.917 61.1582 28.917C66.5566 28.9168 70.9325 24.541 70.9326 19.1426C70.9326 14.2297 67.3086 10.1637 62.5879 9.47168V7.52734C62.5879 6.83699 62.0282 6.27734 61.3379 6.27734ZM12.8906 22.6602C12.2003 22.6602 11.6406 23.2198 11.6406 23.9102C11.6409 24.6003 12.2004 25.1602 12.8906 25.1602H18.4434C19.1336 25.1602 19.6931 24.6003 19.6934 23.9102C19.6934 23.2198 19.1337 22.6602 18.4434 22.6602H12.8906ZM12.8906 12.7646C12.2003 12.7646 11.6406 13.3243 11.6406 14.0146C11.6409 14.7048 12.2004 15.2646 12.8906 15.2646H18.4434C19.1336 15.2646 19.6931 14.7048 19.6934 14.0146C19.6934 13.3243 19.1337 12.7646 18.4434 12.7646H12.8906Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M23.5244 38.7803C24.2148 38.7803 24.7744 39.3399 24.7744 40.0303C24.7744 40.7206 24.2148 41.2803 23.5244 41.2803H12.2832C11.5928 41.2803 11.0332 40.7206 11.0332 40.0303C11.0332 39.3399 11.5928 38.7803 12.2832 38.7803H23.5244Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M65.5146 38.7803C66.205 38.7803 66.7646 39.3399 66.7646 40.0303C66.7646 40.7206 66.205 41.2803 65.5146 41.2803H54.2734C53.5831 41.2803 53.0234 40.7206 53.0234 40.0303C53.0234 39.3399 53.5831 38.7803 54.2734 38.7803H65.5146Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function L9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "77",
      height: "66",
      viewBox: "0 0 77 66",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ D("g", { opacity: "0.4", clipPath: "url(#clip0_491_5782)", children: [
          /* @__PURE__ */ c(
            "path",
            {
              d: "M5.03007 0.77112L71.5246 0.723877C74.5603 1.18281 76.8821 3.67658 77 6.86888V59.7476C76.7577 62.9095 74.5472 65.2616 71.5246 65.7239H5.47544C2.35129 65.2278 0.248884 62.8218 0 59.5789V6.86888C0.239059 3.74407 2.11551 1.56413 5.03007 0.77112ZM6.34326 5.65742C5.74725 5.75191 5.34772 5.94088 4.99732 6.45719V59.9872C5.44597 60.679 6.17297 60.8274 6.94909 60.8409H70.0575C70.9678 60.8443 72.1107 60.5271 72.1042 59.4135L72.0092 6.45719C71.5606 5.76541 70.8336 5.61693 70.0575 5.60343L6.34653 5.65405L6.34326 5.65742Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              d: "M47.4275 48.5206C47.6043 48.6252 47.8434 48.5206 47.9875 48.3856L54.6091 41.9065C55.7749 41.1068 56.6296 41.424 57.5368 42.4059C59.9503 45.0279 61.9806 49.1212 64.309 51.9288C64.9312 53.1909 64.0176 54.7601 62.6782 54.9288L14.3063 54.949C12.5478 54.4597 12.1024 53.1605 12.9539 51.5239C17.2602 43.2293 23.9277 35.2047 28.4796 26.9405C29.2819 25.6245 30.8374 25.3849 31.8821 26.5761L47.4341 48.5206H47.4275Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              d: "M52.4419 12.2275C61.536 11.259 63.5729 24.4534 55.2189 26.7042C45.1915 29.4038 42.7714 13.2567 52.4419 12.2275Z",
              fill: "currentColor"
            }
          )
        ] }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_491_5782", children: /* @__PURE__ */ c(
          "rect",
          {
            width: "77",
            height: "65",
            fill: "currentColor",
            transform: "translate(0 0.723877)"
          }
        ) }) })
      ]
    }
  );
}
function T9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 113.4 131.2",
      fill: "currentColor",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M22.2,131.2h0c-12.3,0-22.2-9.9-22.2-22.2V22.2C0,9.9,9.9,0,22.2,0h0c12.3,0,22.2,9.9,22.2,22.2v86.8c0,12.3-9.9,22.2-22.2,22.2Z" }),
        /* @__PURE__ */ c("circle", { cx: "82.1", cy: "31.3", r: "31.3" }),
        /* @__PURE__ */ c("circle", { cx: "82.1", cy: "99.9", r: "31.3" })
      ]
    }
  );
}
function M9({ opacity: e = 1 }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: { width: "100%", height: "100%" },
      children: /* @__PURE__ */ D("g", { opacity: e, children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M22.2862 3.67181H7.49838C4.32148 3.67181 1.74609 6.2472 1.74609 9.4241V22.6224C1.74609 25.7993 4.32148 28.3747 7.49838 28.3747H22.2862C25.4631 28.3747 28.0385 25.7993 28.0385 22.6224V9.4241C28.0385 6.2472 25.4631 3.67181 22.2862 3.67181Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "7.07648",
            cy: "18.0885",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "7.07648",
            cy: "23.1368",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "12.2874",
            cy: "18.0885",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "12.2874",
            cy: "23.1368",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "17.4984",
            cy: "18.0884",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "17.4984",
            cy: "23.1369",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "22.7093",
            cy: "18.0885",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            cx: "22.7093",
            cy: "23.1368",
            r: "1.53742",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M9.10938 1.18292V6.1665",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M20.6797 1.18292V6.1665",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.74609 13.0326H28.0385",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        )
      ] })
    }
  );
}
function _9(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      ...e,
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
        }
      )
    }
  );
}
function N9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "67",
      height: "68",
      viewBox: "0 0 67 68",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M9.25772 0.762203L57.714 0.70874C62.6797 0.991779 66.1548 3.57372 66.8939 8.63383V59.6469C66.5322 63.5497 63.3779 66.6945 59.5757 67.3927C42.2663 67.6443 24.8595 67.7512 7.55634 67.3392C3.79821 66.5341 0.870334 63.5308 0.496094 59.6469L0.518108 8.18411C1.24457 3.80959 4.85804 0.85026 9.25772 0.759058V0.762203ZM8.31111 4.36623C6.02164 4.79393 4.22592 6.61482 3.95546 8.95775L3.94917 59.1783C4.25108 61.7728 6.2638 63.7698 8.89291 63.9648H58.6574C61.2866 63.6157 63.2144 61.6879 63.4439 59.021V9.2628C63.2175 6.64941 61.2677 4.58637 58.6574 4.31906L8.31426 4.36623H8.31111Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M20.5522 19.4175C21.0585 19.3609 21.6246 19.6031 22.0051 19.9333L33.6915 31.6259L45.4596 19.8578C47.5006 18.4269 49.3844 20.9051 47.7334 22.6002L36.2923 34.1953L47.7334 45.6773C49.4096 47.4038 47.5006 49.8505 45.4596 48.4196L33.6915 36.6515L21.9233 48.4196C19.8855 49.8474 17.9734 47.4069 19.6496 45.6773L31.0907 34.1953L19.42 22.358C18.5426 21.2133 19.0615 19.5842 20.549 19.4144L20.5522 19.4175Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function F9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 17 16",
      fill: "currentColor",
      stroke: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.91406 1.41406L15.0858 14.5858",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M15.0858 1.41406L1.91406 14.5858",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function $9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "20",
      height: "27",
      viewBox: "0 0 20 27",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.59617 9.76218V22.9892C3.59617 23.5815 4.07632 24.0617 4.66863 24.0617H14.6783C15.2706 24.0617 15.7508 23.5815 15.7508 22.9892V9.76218H3.59617ZM1.80873 7.25977C1.41386 7.25977 1.09375 7.57987 1.09375 7.97474V22.9892C1.09375 24.9636 2.69428 26.5641 4.66863 26.5641H14.6783C16.6526 26.5641 18.2532 24.9636 18.2532 22.9892V7.97474C18.2532 7.57987 17.9331 7.25977 17.5382 7.25977H1.80873Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M11.2725 0.897461C12.5268 0.897461 13.5463 1.8915 13.5918 3.13477H18.123C18.7885 3.13477 19.3281 3.67441 19.3281 4.33984C19.3281 5.00521 18.7884 5.54492 18.123 5.54492H1.22852C0.563129 5.54492 0.0235073 5.00521 0.0234375 4.33984C0.0234375 3.67441 0.563086 3.13477 1.22852 3.13477H5.75781C5.80328 1.89163 6.82296 0.897687 8.07715 0.897461H11.2725Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function I9(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "18",
      height: "20",
      viewBox: "0 0 18 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M13.2182 0.626503C13.9211 0.559217 14.7988 1.41039 15.3033 1.9142C16.1047 2.71407 17.6945 4.45343 16.8618 5.69066L6.29035 17.3397L1.04545 19.4104C0.536374 19.5172 0.0990448 19.1606 0.0585938 18.5954C0.617276 16.5549 1.28815 14.5355 1.97048 12.5388C5.29586 8.88425 8.59835 5.20536 11.9321 1.56011C12.3389 1.11601 12.5748 0.688744 13.2182 0.627345V0.626503ZM1.72396 16.7299C1.96514 16.8258 2.20632 17.0865 2.36812 17.3018C2.43223 17.3868 2.53221 17.6567 2.61464 17.6576L5.49277 16.5019C5.073 15.7281 4.53874 15.0073 3.93121 14.4034C3.7778 14.2512 2.86574 13.4328 2.73218 13.4581L1.72396 16.7299Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function q9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "40",
      height: "88",
      viewBox: "0 0 40 88",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M12.3002 25.0952V36.5261C12.3002 36.9465 13.1684 38.9182 13.4734 39.3429C15.6926 42.4118 23.1722 42.5043 25.815 40.0954C26.5011 39.469 27.7124 37.3922 27.7124 36.5261V25.0952H39.1138V47.751H0.894531V25.0952H12.2959H12.3002Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M8.91873 0.757849V5.26883C8.91873 5.79854 9.68108 6.40393 10.2317 6.48801C13.1201 6.91683 11.7183 2.58662 12.1799 0.95544C12.3917 0.652747 15.043 0.551849 15.2251 1.10258C15.5046 2.60344 14.4246 6.53846 16.8387 6.53846C19.2528 6.53846 18.0797 2.48152 18.5159 0.95544L21.3917 0.850338C22.2133 1.41789 20.371 6.72764 23.306 6.52585C25.6354 6.36609 24.4072 2.47732 24.8519 0.95544L27.7277 0.850338L27.8971 1.10258C28.2274 2.77581 26.9187 6.90842 29.786 6.48381C30.3366 6.40393 31.0947 5.79854 31.0947 5.26883V0.757849H35.2114L35.5291 1.07316V21.9464H27.715V14.0806C27.715 13.0884 26.5164 12.7815 25.7159 12.7101C22.9968 12.462 16.7667 12.4158 14.0943 12.7185C13.514 12.7857 12.2985 13.1977 12.2985 13.8704V21.9464H4.48438V1.07316L4.80202 0.757849H8.91873Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M2.90317 50.6855H37.1074L37.3234 51.1017L27.3578 63.8611L12.5088 63.7981L2.69141 51.1017L2.90317 50.6855Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M24.545 15.863V36.5261C24.545 37.1777 23.2829 38.254 22.6518 38.4221C21.8556 38.6281 18.3572 38.6408 17.5229 38.4726C16.8325 38.3339 15.4688 37.2366 15.4688 36.5261V15.863H24.5492H24.545Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M23.274 75.4392H16.7305V87.6058H23.274V75.4392Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M26.6585 67.0479H13.3555V72.2903H26.6585V67.0479Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function k9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M5.13761 2.18736H2.51873C1.40381 2.18736 0.5 3.09117 0.5 4.20608V8.84187C0.5 9.95678 1.40381 10.8606 2.51873 10.8606H7.05769C8.1726 10.8606 9.07641 9.95679 9.07641 8.84187V6.08403",
            stroke: "currentColor",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M4.80176 6.50349L10.8052 0.5M10.8052 0.5H6.94586M10.8052 0.5V4.38707",
            stroke: "currentColor",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
function D9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 31 21",
      fill: "none",
      stroke: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "1.18787",
            y: "1.63318",
            width: "12.5246",
            height: "7.19231",
            rx: "0.715214",
            strokeWidth: "1.43043"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "17.2894",
            y: "1.63318",
            width: "12.5246",
            height: "7.19231",
            rx: "0.715214",
            strokeWidth: "1.43043"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "1.18787",
            y: "12.4017",
            width: "12.5246",
            height: "7.19231",
            rx: "0.715214",
            strokeWidth: "1.43043"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "17.2894",
            y: "12.4017",
            width: "12.5246",
            height: "7.19231",
            rx: "0.715214",
            strokeWidth: "1.43043"
          }
        )
      ]
    }
  );
}
function H9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 21 14",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M9.12193 5.702C8.38704 3.52156 8.82875 1.82006 10.4295 0.719909C11.8618 -0.264476 13.7687 -0.17949 15.1286 0.932771C16.4322 1.99897 16.9995 3.91273 16.1288 5.73079C16.2033 5.77358 16.2795 5.81717 16.3555 5.86125C18.9709 7.37839 20.355 9.63795 20.4557 12.6669C20.4718 13.1502 20.2315 13.5091 19.8261 13.6598C19.4356 13.8049 18.9677 13.7046 18.7385 13.3578C18.6063 13.1577 18.5256 12.8909 18.5132 12.6496C18.3978 10.4017 17.3775 8.71413 15.4291 7.58608C15.4221 7.58201 15.4142 7.57923 15.4072 7.57486C15.0215 7.33093 14.6822 7.27553 14.2111 7.50348C13.056 8.06224 11.8732 7.9712 10.7416 7.3623C10.6019 7.28705 10.4927 7.27463 10.3523 7.34016C8.12345 8.38193 6.92819 10.1274 6.77093 12.5821C6.76249 12.7134 6.76983 12.8487 6.73975 12.9751C6.6228 13.4661 6.16202 13.7753 5.65856 13.7129C5.17238 13.6527 4.81307 13.2366 4.82042 12.7096C4.85458 10.2621 5.82188 8.25157 7.69952 6.68946C8.13973 6.32331 8.6422 6.03192 9.12193 5.702ZM12.6358 5.8959C13.7169 5.89679 14.5912 5.02688 14.5922 3.94937C14.5932 2.87533 13.714 1.994 12.6401 1.99211C11.5696 1.99033 10.6845 2.87344 10.6829 3.945C10.6811 5.01993 11.5571 5.89501 12.6358 5.8959Z" }),
        /* @__PURE__ */ c("path", { d: "M9.31744 7.33284C9.43499 7.29472 9.56545 7.28002 9.69809 7.2824C9.27207 6.46233 8.60142 5.78929 7.6906 5.26101C7.64334 5.23361 7.59579 5.20641 7.54942 5.1797C8.0921 4.04639 7.73845 2.85342 6.92583 2.18882C6.07815 1.49543 4.88944 1.44251 3.9966 2.05618C2.99871 2.74192 2.7234 3.80255 3.18149 5.16183C2.88245 5.36745 2.56921 5.54913 2.2948 5.77738C1.12436 6.75114 0.521315 8.00438 0.500069 9.53006C0.495502 9.85868 0.719483 10.118 1.02249 10.1555C1.33632 10.1944 1.62365 10.0017 1.69652 9.69566C1.71529 9.61683 1.71072 9.53244 1.71598 9.45063C1.81397 7.92039 2.55909 6.83236 3.94855 6.18295C4.03601 6.14215 4.10402 6.14989 4.19119 6.19675C4.89649 6.57631 5.63386 6.6331 6.35396 6.28471C6.64764 6.14264 6.85911 6.17719 7.09947 6.32929C7.10384 6.33197 7.1088 6.33366 7.11327 6.33624C7.78373 6.72444 8.27696 7.21956 8.59725 7.82042C8.77596 7.6008 9.02098 7.42875 9.31744 7.33284ZM5.37196 5.28266C4.69952 5.28206 4.15346 4.7366 4.15446 4.06655C4.15555 3.39857 4.70736 2.84805 5.37464 2.84914C6.0441 2.85034 6.59204 3.39977 6.59144 4.06923C6.59085 4.74097 6.04589 5.28325 5.37196 5.28266Z" })
      ]
    }
  );
}
function B9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "57",
      height: "89",
      viewBox: "0 0 57 89",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M50.4911 36.8717C52.7935 28.0605 50.2988 17.8297 43.4666 11.7653C42.8698 12.3262 42.0333 12.6667 41.2042 12.6391C39.6735 12.5841 37.9729 10.6886 36.5695 9.90741C31.3005 6.97286 23.427 7.3184 18.5401 10.904C16.5299 12.3787 15.4436 14.482 12.5544 12.519C6.33401 18.8212 4.02165 28.4411 6.36897 36.9969C7.89723 36.3659 10.2945 34.9061 11.3633 36.9243L14.3149 55.145C14.1601 57.7666 9.39552 56.8326 7.79984 56.2392C2.25617 54.1835 -0.0237309 47.4456 1.91156 42.0848C2.04391 41.7167 2.55832 40.9555 2.5758 40.6826C2.60077 40.2745 1.82416 38.2739 1.66934 37.6454C-3.01781 18.5909 11.3258 -1.2674 31.5927 1.02615C48.4709 2.93411 59.5657 20.9871 55.3456 37.1747C55.1558 37.9033 54.2368 40.0641 54.2468 40.5599C54.2518 40.8454 55.0359 42.2175 55.1957 42.7183C56.8289 47.8462 54.2218 54.4514 48.9928 56.2968C47.3971 56.8602 42.5102 57.7891 42.5302 55.0674L45.5692 36.7465C46.4932 34.6733 50.2913 37.052 50.4936 36.8717H50.4911Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M13.9325 35.1491C15.2684 34.8411 16.6319 35.7701 16.9266 37.0946L19.581 53.4349C19.6085 55.7285 16.4396 57.1732 15.8703 54.772L12.9711 36.6815C12.8187 36.078 13.3681 35.2818 13.9325 35.1516V35.1491Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M41.9854 35.1514C42.7445 35.0212 43.8508 35.1514 44.0056 36.0653C43.3314 42.4076 41.9879 48.6899 41.1164 55.0197C40.2274 56.9952 37.8626 55.6907 37.543 54.0406C38.1298 48.2867 39.3234 42.5729 40.185 36.844C40.4247 36.0728 41.1838 35.2916 41.9854 35.1514Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "28.1719",
            y: "83.0483",
            width: "9.05967",
            height: "3.70702",
            rx: "1.5165",
            transform: "rotate(-90 28.1719 83.0483)",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M30.028 88.937C29.4495 88.937 28.9805 88.468 28.9805 87.8895L28.9805 82.5034L31.0755 82.5034L31.0755 87.8895C31.0755 88.468 30.6065 88.937 30.028 88.937Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M10.2383 54.0745L11.4856 58.5431C12.4004 61.8204 15.3864 64.087 18.7889 64.087H42.9966C45.0864 64.087 46.7805 65.7811 46.7805 67.8709V67.8709C46.7805 69.9607 45.0864 71.6548 42.9966 71.6548H36.5494H33.554C31.6247 71.6548 30.0607 73.2188 30.0607 75.1481V75.1481",
            stroke: "currentColor",
            strokeWidth: "2.5"
          }
        )
      ]
    }
  );
}
function U9(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 16 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M15.9716 16.5983H10.5791V16.3942C10.579 15.0645 10.5842 13.7348 10.5772 12.4052C10.5708 11.1735 9.73221 10.151 8.5318 9.89174C6.9372 9.54737 5.42242 10.7475 5.40834 12.3802C5.3969 13.7098 5.40564 15.0395 5.40543 16.3692V16.591H0.0129271V16.3974C0.0129271 13.2003 0.0132114 10.0032 0.0117188 6.80603C0.0117188 6.69607 0.0222381 6.61284 0.126152 6.53522C2.70992 4.605 5.29014 2.66994 7.87107 0.735951C7.90839 0.707947 7.9472 0.682004 7.99624 0.647461C8.44125 0.980312 8.88512 1.31188 9.32842 1.6441C11.4746 3.2522 13.6195 4.86194 15.769 6.46564C15.9149 6.57446 15.977 6.68121 15.9766 6.86978C15.9696 10.0314 15.9716 13.1931 15.9716 16.3548V16.5983Z" })
    }
  );
}
function V9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "12",
      height: "17",
      viewBox: "0 0 12 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M6.17492 11.6214C9.14945 11.6214 11.5608 9.21011 11.5608 6.23559C11.5608 3.26106 9.14945 0.849731 6.17492 0.849731C3.20039 0.849731 0.789062 3.26106 0.789062 6.23559C0.789062 9.21011 3.20039 11.6214 6.17492 11.6214Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M10.0331 11.0609V15.7141C10.0331 16.0558 9.55055 16.3633 9.23217 16.1918L6.1841 14.0667L3.12123 16.1918C2.76216 16.358 2.32031 16.0577 2.32031 15.6678V11.0609L3.13603 11.596C5.12422 12.7167 7.54825 12.6561 9.47679 11.4399L10.0329 11.0609H10.0331Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function j9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "70",
      height: "69",
      viewBox: "0 0 70 69",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("g", { clipPath: "url(#clip0_433_6353)", children: /* @__PURE__ */ c(
          "path",
          {
            d: "M69.5703 34.3924C69.5703 53.1712 54.1248 68.3941 35.0721 68.3941C16.0194 68.3941 0.570312 53.1677 0.570312 34.3924C0.570312 15.617 16.0159 0.390625 35.0686 0.390625C54.1212 0.390625 69.5668 15.6135 69.5668 34.3924H69.5703ZM33.5975 3.57189C27.7346 4.82081 24.4407 10.7844 22.3574 15.8598C25.9469 17.1365 29.7617 18.0177 33.5975 18.1114V3.57189ZM36.5853 3.57189V18.1114C40.4247 18.0246 44.2289 17.14 47.8255 15.8598C45.7245 10.7983 42.4517 4.83468 36.5853 3.57189ZM25.3451 4.95958C22.2905 5.73668 19.5385 7.35333 16.9308 9.03937L14.2844 11.2701C14.7912 11.9049 19.3555 14.8017 19.7251 14.4756C20.8864 10.9578 22.938 7.77658 25.3451 4.95958ZM55.9019 11.0203C54.1248 9.81994 52.4567 8.41144 50.5775 7.35333C48.8355 6.37154 46.7838 5.46955 44.8412 4.96305C47.2237 7.80433 49.3106 10.9578 50.4613 14.4791C50.7992 14.7774 54.9482 12.1582 55.462 11.7072C55.6767 11.5164 55.9618 11.3568 55.9054 11.0238L55.9019 11.0203ZM3.74459 32.8243H15.949C16.4663 32.0923 16.1426 30.8885 16.2129 29.9691C16.5473 25.754 17.3461 21.6014 18.4758 17.5355L11.9337 13.4522C7.0174 18.6872 4.04723 25.6673 3.74107 32.8243H3.74459ZM66.4383 32.8243C66.0406 25.6604 63.1831 18.7011 58.2457 13.4522L51.7036 17.5355C52.8543 21.6569 53.618 25.8685 53.9664 30.1426C54.0368 31.0099 53.7201 32.1478 54.2303 32.8243H66.4347H66.4383ZM33.5975 21.2267C29.364 21.1053 25.3029 20.0506 21.3052 18.8017C20.1509 23.388 19.1831 28.068 19.1972 32.8208H33.5975V21.2232V21.2267ZM36.5853 21.2267V32.8243H50.9857C50.9716 28.0715 50.0355 23.3915 48.8777 18.8052C44.8553 20.0402 40.84 21.0949 36.5853 21.2302V21.2267ZM3.74459 35.9396C4.08946 43.0931 6.98924 50.101 11.9372 55.3117L18.4793 51.2319C17.325 47.1695 16.5508 43.0134 16.2165 38.7948C16.1426 37.8755 16.4698 36.6716 15.9525 35.9396H3.74459ZM33.5975 35.9396H19.1972C19.2148 40.6959 20.1333 45.3724 21.3052 49.9587C25.2959 48.7514 29.3781 47.565 33.5975 47.5337V35.9362V35.9396ZM50.9857 35.9396H36.5853V47.5372C40.8118 47.5441 44.8729 48.7896 48.8777 49.9622C50.0355 45.3724 50.9716 40.6959 50.9857 35.9431V35.9396ZM66.4383 35.9396H54.2339C53.7201 36.6161 54.0403 37.754 53.9699 38.6213C53.6215 42.8954 52.8579 47.107 51.7071 51.2284L58.2562 55.3186C63.1373 49.9865 66.1145 43.1695 66.4418 35.9396H66.4383ZM33.5975 50.6491C29.7582 50.6664 25.9328 51.5927 22.3574 52.9006C24.4478 57.9414 27.7452 63.9847 33.5975 65.1851V50.6456V50.6491ZM36.5853 50.6491V65.1886C42.4482 63.9188 45.714 57.9622 47.8255 52.9041C44.2395 51.6135 40.4282 50.656 36.5853 50.6526V50.6491ZM19.7215 54.2848C19.4083 54.0108 14.2774 57.1539 14.2809 57.4869C17.3954 60.401 21.2418 62.5485 25.3416 63.8009C22.9697 60.9631 20.8688 57.813 19.7215 54.2848ZM44.8377 63.8009C48.9094 62.5797 52.8016 60.3629 55.8984 57.4869C55.8984 57.1539 50.771 54.0108 50.4578 54.2848C49.3387 57.8373 47.1498 60.9214 44.8377 63.8009Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_433_6353", children: /* @__PURE__ */ c(
          "rect",
          {
            width: "69",
            height: "68",
            fill: "white",
            transform: "translate(0.570312 0.390625)"
          }
        ) }) })
      ]
    }
  );
}
function K9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "19",
      height: "18",
      viewBox: "0 0 19 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M5.23454 9.16092C4.48976 6.95112 4.93741 5.22671 6.55969 4.11174C8.01133 3.11411 9.94382 3.20024 11.3221 4.32748C12.6432 5.40802 13.2182 7.34757 12.3357 9.1901C12.4112 9.23347 12.4885 9.27764 12.5655 9.32232C15.2162 10.8599 16.6189 13.1499 16.7209 16.2196C16.7372 16.7094 16.4937 17.0731 16.0828 17.2259C15.6871 17.373 15.2129 17.2712 14.9806 16.9198C14.8466 16.717 14.7648 16.4467 14.7522 16.2021C14.6353 13.9239 13.6012 12.2136 11.6267 11.0704C11.6195 11.0662 11.6115 11.0634 11.6044 11.059C11.2135 10.8118 10.8697 10.7556 10.3922 10.9867C9.22157 11.5529 8.0228 11.4607 6.87604 10.8436C6.73447 10.7673 6.62378 10.7547 6.48151 10.8211C4.22261 11.8769 3.01125 13.6459 2.85187 16.1336C2.84332 16.2668 2.85076 16.4039 2.82028 16.532C2.70175 17.0296 2.23478 17.3429 1.72453 17.2797C1.2318 17.2187 0.867665 16.797 0.875112 16.2628C0.909723 13.7825 1.89006 11.7448 3.79296 10.1617C4.23911 9.7906 4.74835 9.49528 5.23454 9.16092ZM8.79575 9.35743C9.89139 9.35834 10.7774 8.47671 10.7785 7.38469C10.7795 6.29619 9.88848 5.40299 8.80008 5.40108C7.7152 5.39927 6.81818 6.29428 6.81648 7.38026C6.81466 8.46967 7.70252 9.35652 8.79575 9.35743Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M14.7573 4.5433C14.4212 4.5433 14.1216 4.54612 13.8222 4.5427C13.2156 4.53576 12.7819 4.12362 12.7813 3.55764C12.7805 2.98984 13.2139 2.57469 13.8178 2.56825C14.1176 2.56503 14.4175 2.56764 14.7577 2.56764C14.7577 2.23339 14.7498 1.91905 14.7593 1.60532C14.7802 0.913461 15.35 0.460272 15.9944 0.615025C16.4343 0.720675 16.736 1.10846 16.747 1.59143C16.7539 1.89239 16.7517 2.19344 16.7548 2.49449C16.755 2.50928 16.7668 2.52397 16.7857 2.56754C17.072 2.56754 17.3708 2.56553 17.6696 2.56804C18.2947 2.57318 18.7261 2.9834 18.7218 3.56528C18.7175 4.13499 18.2891 4.53656 17.6753 4.5428C17.376 4.54582 17.0767 4.5433 16.7477 4.5433C16.7477 4.89265 16.7543 5.21645 16.746 5.53984C16.7349 5.97833 16.4662 6.34338 16.072 6.4755C15.6688 6.61063 15.2089 6.49391 14.9785 6.13601C14.8544 5.94342 14.7944 5.69217 14.7658 5.46005C14.7303 5.17237 14.7573 4.87716 14.7573 4.5433Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function z9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 44 44",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "0.523438",
            y: "0.13739",
            width: "42.9538",
            height: "42.9299",
            rx: "21.4649",
            fill: "none"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M22.6426 21.6885V21.3663C22.6427 18.3518 22.6416 15.3374 22.6436 12.3229C22.6441 11.623 23.1382 11.0746 23.7904 11.0363C24.4906 10.995 25.0722 11.5177 25.1133 12.2269C25.1186 12.321 25.1158 12.4158 25.1158 12.5102C25.1159 16.9589 25.1162 21.4076 25.1158 25.8563C25.1156 28.4475 23.3055 30.5204 20.7402 30.868C18.2474 31.2058 15.7405 29.3491 15.3199 26.8535C14.7833 23.6696 17.2416 20.8919 20.4715 21.0409C21.1483 21.0721 21.7903 21.2575 22.396 21.5639C22.4637 21.5982 22.5314 21.6324 22.6426 21.6885ZM20.1648 28.4239C21.5159 28.4302 22.633 27.3286 22.6415 25.9813C22.6499 24.6334 21.5462 23.5147 20.1988 23.5056C18.8359 23.4963 17.7106 24.6045 17.7062 25.9601C17.7019 27.3012 18.8158 28.4176 20.1648 28.4239Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function G9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 32 32",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M12.6989 11.9451C12.7587 11.8462 12.8187 11.7536 12.872 11.6574C13.5875 10.3674 14.3348 9.0936 15.0075 7.78163C15.6592 6.51066 17.2001 6.11056 18.3766 7.01916C18.4129 7.04725 18.4558 7.06666 18.5193 7.10406C18.8747 6.56847 19.3631 6.22884 19.9984 6.12314C20.448 6.04851 20.8791 6.11644 21.2889 6.31653C22.3275 6.82367 22.6753 7.56582 22.5295 8.96747C23.2421 9.21754 23.8123 9.62596 24.0794 10.3718C24.3404 11.1006 24.1939 11.7747 23.7784 12.4246C24.4153 12.6057 24.901 12.9441 25.2008 13.5006C25.6026 14.2466 25.5714 14.9926 25.1639 15.7354C23.9123 18.0174 22.6768 20.3084 21.4141 22.5843C21.0374 23.2635 20.6661 23.9686 20.1644 24.5519C18.251 26.7767 15.2664 27.9889 11.7796 26.3182C10.6637 25.7835 9.64757 25.1245 8.8625 24.1523C7.72553 22.7444 7.29648 21.094 7.23297 19.3237C7.18549 17.997 7.40245 16.7006 7.66578 15.4058C7.82477 14.6245 7.93522 13.8311 8.02598 13.0385C8.14201 12.0241 8.62045 11.2753 9.56852 10.8892C10.5251 10.4996 11.4163 10.6742 12.1911 11.3599C12.3775 11.5249 12.5214 11.7379 12.6989 11.9451ZM18.0593 24.306C18.6645 23.8467 19.1936 23.1871 19.6087 22.4235C20.9371 19.9796 22.2759 17.5414 23.6098 15.1005C23.6728 14.9852 23.7417 14.8704 23.7841 14.7473C23.8691 14.5 23.7471 14.2226 23.5153 14.1C23.2911 13.9815 23.0065 14.0254 22.8482 14.2232C22.714 14.3909 22.5852 14.5666 22.4806 14.7536C21.788 15.992 21.1044 17.2356 20.4137 18.4752C20.1346 18.9761 19.6142 19.1179 19.1748 18.823C18.7988 18.5708 18.7208 18.1192 18.982 17.6463C20.1268 15.5734 21.275 13.5021 22.4202 11.4294C22.616 11.075 22.5527 10.8298 22.2291 10.6461C21.8984 10.4584 21.6609 10.5302 21.4634 10.8852C21.0521 11.6243 20.6443 12.3653 20.2346 13.1052C19.5881 14.2726 18.9449 15.4418 18.2928 16.606C17.992 17.1432 17.3475 17.2408 16.939 16.8245C16.6683 16.5483 16.6478 16.1626 16.8874 15.7297C18.1846 13.3867 19.483 11.0442 20.7806 8.70129C21.0152 8.27776 20.9689 8.0419 20.6165 7.84803C20.2713 7.65832 20.0498 7.74703 19.8139 8.18036C19.5264 8.70832 19.2496 9.24203 18.9594 9.7683C17.9971 11.5128 17.0333 13.2564 16.0619 14.9958C15.9826 15.1376 15.8603 15.2746 15.7245 15.3616C15.416 15.5591 15.0094 15.5055 14.7553 15.269C14.4665 15.0002 14.3975 14.6119 14.5992 14.236C14.9591 13.5654 15.3325 12.9019 15.701 12.236C16.2879 11.1753 16.8771 10.1158 17.462 9.05402C17.6675 8.68083 17.5686 8.40292 17.1815 8.23337C16.8878 8.10468 16.6706 8.19979 16.4771 8.5495C15.3671 10.5558 14.2565 12.5619 13.1538 14.5721C13.0862 14.6953 13.0547 14.8551 13.0574 14.9969C13.0708 15.6928 13.1046 16.3883 13.1246 17.0842C13.1363 17.4934 12.9371 17.8042 12.5961 17.9336C12.0396 18.145 11.4928 17.7626 11.468 17.1298C11.418 15.8515 11.3897 14.5721 11.3244 13.2945C11.3123 13.0586 11.2173 12.7909 11.073 12.6064C10.8684 12.3446 10.5455 12.2874 10.2238 12.4056C9.88197 12.5313 9.71904 12.7915 9.66809 13.1523C9.53534 14.0917 9.41088 15.0335 9.23463 15.9652C8.99593 17.2275 8.81036 18.4899 8.9187 19.7784C9.03519 21.1655 9.45854 22.4261 10.4483 23.4511C11.1981 24.2275 12.132 24.7001 13.1204 25.0855C14.8732 25.7691 16.4778 25.4498 18.0593 24.306Z" }),
        /* @__PURE__ */ c("path", { d: "M9.95245 5.71268C11.1283 4.84131 12.4095 4.18401 13.8062 3.75196C14.3315 3.5896 14.7785 3.78668 14.9349 4.24662C15.0936 4.71332 14.8457 5.16812 14.3157 5.33443C12.5011 5.90377 10.9399 6.87429 9.62225 8.24633C9.13653 8.75206 8.4718 8.66783 8.19855 8.09148C8.04684 7.77155 8.1138 7.42074 8.3885 7.13413C8.57066 6.94426 8.75155 6.75196 8.94738 6.57667C9.27635 6.28196 9.61677 5.99999 9.95245 5.71268Z" }),
        /* @__PURE__ */ c("path", { d: "M29.2856 15.7733C29.3036 15.8816 29.3818 16.0922 29.3657 16.2953C29.2108 18.2603 28.6218 20.0904 27.6088 21.7812C27.3591 22.198 26.8492 22.3233 26.4576 22.0867C26.0562 21.844 25.9332 21.367 26.1897 20.9295C26.9164 19.6897 27.406 18.3665 27.6235 16.945C27.669 16.6475 27.6879 16.346 27.7339 16.0486C27.7879 15.6982 28.0326 15.437 28.365 15.3687C28.7095 15.2978 28.9951 15.4028 29.2856 15.7733Z" })
      ]
    }
  );
}
function Z9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 19 14",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M16.4613 5.61442C15.9036 5.61442 15.3449 5.63523 14.7886 5.6073C14.3997 5.58769 14.0923 5.28755 14.0071 4.93073C13.9138 4.539 14.0516 4.14565 14.3813 3.93145C14.4986 3.85517 14.6461 3.78319 14.7805 3.78171C15.907 3.76949 17.0341 3.75673 18.16 3.78279C18.6005 3.79299 18.922 4.16579 18.963 4.58989C19.0051 5.02608 18.765 5.43312 18.3617 5.56513C18.2062 5.61603 18.0331 5.62812 17.8677 5.63121C17.399 5.63953 16.9302 5.63416 16.4613 5.63416V5.61442Z" }),
        /* @__PURE__ */ c("path", { d: "M9.50235 5.61436C8.94463 5.61436 8.38583 5.63598 7.82973 5.60711C7.42778 5.58629 7.11528 5.27151 7.03994 4.89844C6.95816 4.49287 7.12576 4.09402 7.47747 3.89473C7.58129 3.83591 7.70577 3.78125 7.82127 3.78031C8.94772 3.77145 10.0747 3.75788 11.2006 3.78273C11.6292 3.79213 11.9476 4.14949 11.9978 4.55666C12.0527 5.00104 11.8358 5.40513 11.433 5.55138C11.2697 5.61073 11.0845 5.62672 10.9085 5.63061C10.44 5.64109 9.97117 5.63424 9.50235 5.63424V5.61436Z" }),
        /* @__PURE__ */ c("path", { d: "M9.48084 1.91438C8.9896 1.91438 8.49835 1.91989 8.00724 1.9129C7.41621 1.90458 7.01615 1.51217 7.02354 0.960762C7.03052 0.430436 7.43287 0.0451474 8.00751 0.0412529C9.01216 0.0345382 10.0169 0.0342696 11.0217 0.0413872C11.6125 0.045416 12.0132 0.443194 12.0053 0.994201C11.9975 1.52775 11.5992 1.90512 11.0215 1.9129C10.5081 1.91989 9.99438 1.91438 9.48084 1.91438Z" }),
        /* @__PURE__ */ c("path", { d: "M9.52534 7.4747C10.0277 7.47497 10.5301 7.46892 11.0324 7.47644C11.6082 7.48517 12.0029 7.86778 12.0052 8.40522C12.0075 8.94253 11.614 9.34152 11.0442 9.34689C10.0284 9.35629 9.01248 9.35548 7.99654 9.34729C7.42445 9.34273 7.02614 8.95045 7.02345 8.41704C7.02063 7.86899 7.42405 7.48679 8.01816 7.4747C8.04059 7.4743 8.06288 7.47443 8.08518 7.47443C8.56528 7.47443 9.04524 7.47443 9.52534 7.4747Z" }),
        /* @__PURE__ */ c("path", { d: "M2.5446 7.47508C3.03571 7.47508 3.52709 7.472 4.0182 7.47589C4.64294 7.48073 5.05079 7.85769 5.04636 8.41904C5.04206 8.96695 4.63891 9.34566 4.03727 9.34888C3.0435 9.35439 2.04986 9.3552 1.05622 9.34848C0.467207 9.34446 0.0573427 8.94681 0.0605657 8.4044C0.0639231 7.86333 0.474728 7.48207 1.07086 7.47616C1.56184 7.47119 2.05335 7.47508 2.5446 7.47508Z" }),
        /* @__PURE__ */ c("path", { d: "M16.4773 9.35059C15.9749 9.35072 15.4724 9.3565 14.97 9.34911C14.3795 9.34051 13.9745 8.94462 13.9825 8.39737C13.9903 7.86301 14.389 7.48122 14.966 7.47746C15.9708 7.47101 16.9757 7.47115 17.9805 7.47732C18.5568 7.48095 18.9599 7.86315 18.9683 8.39321C18.9771 8.93871 18.5707 9.33971 17.9846 9.34884C17.4822 9.35677 16.9797 9.35045 16.4773 9.35059Z" }),
        /* @__PURE__ */ c("path", { d: "M2.57251 13.0637C2.07025 13.0634 1.56786 13.0718 1.06574 13.0613C0.454162 13.0487 0.0610846 12.6768 0.0605474 12.1301C0.0600103 11.5865 0.452685 11.1997 1.06211 11.191C2.05521 11.1769 3.04885 11.1777 4.04209 11.1906C4.6503 11.1985 5.04701 11.5846 5.04795 12.1266C5.04889 12.6727 4.65407 13.0417 4.04585 13.0633C4.02342 13.0641 4.00113 13.064 3.97884 13.064C3.51002 13.064 3.04133 13.064 2.57251 13.0637Z" }),
        /* @__PURE__ */ c("path", { d: "M9.50109 13.0636C9.00998 13.0635 8.51873 13.0714 8.02789 13.0615C7.41511 13.0491 7.02364 12.6806 7.02149 12.133C7.01935 11.5885 7.41108 11.1999 8.01889 11.1912C9.012 11.1769 10.0055 11.1776 10.9987 11.1906C11.6102 11.1987 12.0027 11.5801 12.0046 12.124C12.0063 12.6868 11.6118 13.0518 10.9743 13.0621C10.4833 13.0701 9.9922 13.0637 9.50109 13.0636Z" }),
        /* @__PURE__ */ c("path", { d: "M16.4724 13.0632C15.9813 13.0632 15.49 13.0702 14.9992 13.0615C14.384 13.0505 13.9884 12.6873 13.9806 12.1429C13.9727 11.5881 14.3771 11.1965 15.0028 11.1894C15.9849 11.1781 16.9673 11.1773 17.9494 11.1895C18.5777 11.1973 18.9756 11.5871 18.9668 12.1464C18.9582 12.6909 18.5643 13.0503 17.9456 13.0615C17.4548 13.0703 16.9635 13.0632 16.4724 13.0632Z" })
      ]
    }
  );
}
function W9({ className: e }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "30px",
      height: "30px",
      className: `
                animate-spin

                ${e}
            `,
      viewBox: "0 0 16 16",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: /* @__PURE__ */ c(
        "path",
        {
          fill: "currentColor",
          d: "M15 8c0 3.9-3.1 7-7 7s-7-3-7-7h-1c0 4 3.6 8 8 8s8-3.6 8-8h-1z"
        }
      )
    }
  );
}
function Q9(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 19 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { opacity: "0.7", children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M9.30669 10.0911C11.6183 10.0911 13.4923 8.15441 13.4923 5.76536C13.4923 3.37631 11.6183 1.43961 9.30669 1.43961C6.99505 1.43961 5.12109 3.37631 5.12109 5.76536C5.12109 8.15441 6.99505 10.0911 9.30669 10.0911Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.57812 15.7066C3.12372 12.3531 6.00373 10.091 9.30613 10.091C12.6085 10.091 15.4885 12.3531 17.0341 15.7066",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        )
      ] })
    }
  );
}
function J9(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 22 22",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M11.0048 0.871094C5.41162 0.871092 0.876085 5.40364 0.871114 10.9981C0.867885 12.6293 1.26044 14.237 2.01509 15.6831C2.08715 15.8183 2.15021 15.9534 2.22227 16.0796C2.38385 16.391 2.41621 16.7536 2.31235 17.0887C2.02335 17.8598 1.78268 18.6482 1.59173 19.4492C1.59173 19.8457 1.70883 20.0799 2.13219 20.0799C2.90156 19.9073 3.65962 19.6876 4.40213 19.4222C4.72475 19.338 5.06592 19.3601 5.37496 19.4853C5.6542 19.6294 5.90642 19.8367 6.18566 19.9628H6.27573C9.41618 21.6162 13.1925 21.5058 16.2311 19.6719C19.2698 17.838 21.1278 14.5478 21.1294 10.9981C21.1245 5.40715 16.5944 0.876061 11.0048 0.871094Z" })
    }
  );
}
function Y9(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 16 25",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { children: [
        /* @__PURE__ */ c("path", { d: "M12.83 9.2585C12.83 10.4288 12.8473 11.5995 12.8263 12.7695C12.7866 14.9704 11.1641 16.9591 9.04504 17.4356C6.39551 18.0314 3.77076 16.3197 3.22765 13.635C3.16673 13.3337 3.11831 13.0237 3.11707 12.7176C3.10795 10.3956 3.09658 8.07354 3.11651 5.7517C3.13577 3.51859 4.7671 1.50372 6.89886 1.02795C9.54434 0.43744 12.1512 2.12452 12.7087 4.80299C12.79 5.19373 12.8219 5.60036 12.8277 6.00034C12.8436 7.0862 12.8333 8.17241 12.8333 9.2585H12.83Z" }),
        /* @__PURE__ */ c("path", { d: "M7.03256 22.6361C7.03256 22.196 7.02851 21.756 7.03493 21.316C7.03695 21.1702 6.99889 21.1054 6.83899 21.0804C3.18118 20.5075 0.498094 17.3926 0.182344 13.7911C0.161174 13.5488 0.142932 13.3056 0.14068 13.0626C0.135275 12.4657 0.530075 12.0374 1.08556 12.0247C1.64657 12.012 2.04317 12.412 2.09418 13.0088C2.13799 13.5199 2.14993 14.045 2.28134 14.5356C2.925 16.9385 4.40747 18.5633 6.87153 19.1032C9.30148 19.6355 11.6925 18.504 12.9954 16.3294C13.5694 15.3716 13.8765 14.333 13.9068 13.2145C13.9092 13.121 13.9087 13.0269 13.9187 12.9341C13.9811 12.3614 14.4067 11.9933 14.9641 12.0271C15.4802 12.0583 15.8638 12.4762 15.8608 13.0263C15.8534 14.4471 15.5293 15.7937 14.8296 17.0313C13.5732 19.2535 11.7048 20.64 9.17018 21.0784C8.99215 21.1093 8.96625 21.1859 8.96692 21.3368C8.97087 22.1888 8.97841 23.0411 8.96411 23.8928C8.9524 24.591 8.27957 25.0444 7.64796 24.7894C7.26735 24.6357 7.04855 24.345 7.03763 23.928C7.02648 23.4977 7.03515 23.0668 7.03515 22.6361H7.03256Z" })
      ] })
    }
  );
}
function X9(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "60",
      height: "75",
      viewBox: "0 0 60 75",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M32.4634 15.4182L44.4705 27.3942L15.6575 53.7144L15.2213 53.7213L6.17782 44.5913L6.13281 44.1897L32.4564 15.4182H32.4634ZM33.1974 25.4449C32.0791 25.5557 29.6035 28.9003 28.6687 29.7312C28.1632 30.8288 29.3612 31.8051 30.3929 31.1127C30.798 30.8392 33.9348 27.6989 34.1841 27.3007C34.7692 26.3763 34.333 25.3307 33.1974 25.4449Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M46.0025 0.395583C48.5126 0.315951 51.4867 1.20229 53.5883 2.56296C61.233 7.51055 61.3369 19.0711 53.6818 24.0048L35.6953 6.31606C37.9042 2.94381 41.9205 0.523687 46.0025 0.395583Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M51.2133 25.407C50.3893 25.6079 49.5306 25.9506 48.6893 26.0822C48.0661 26.1791 46.8301 26.3903 46.3627 26.0233L33.67 13.3099C33.6388 11.7207 33.9747 10.1557 34.4524 8.64966L51.2098 25.407H51.2133Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M5.36415 47.1917L12.6661 54.3862C12.7457 54.6009 12.6315 54.7152 12.5207 54.8779C12.2783 55.2414 8.68793 58.8283 8.41095 58.9045C8.16166 58.9738 7.94354 58.9461 7.74965 58.766L1.13672 52.0665L1.27175 51.2287L5.36415 47.1917Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M13.5023 71.9329C14.1359 72.6115 13.5992 73.7125 12.6887 73.896C12.3286 73.9687 10.1508 73.8371 9.66264 73.7852C0.23142 72.8123 -2.49685 64.5548 2.40573 57.0278L4.03992 58.6655C0.484167 65.1399 2.50959 70.7488 10.1785 71.5417C11.0302 71.6282 12.9068 71.2993 13.4988 71.9329H13.5023Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "19.7031",
            y: "73.5327",
            width: "9.05967",
            height: "3.70702",
            rx: "1.5165",
            transform: "rotate(174.304 19.7031 73.5327)",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M25.3804 71.1012C25.4378 71.6769 25.0177 72.1901 24.442 72.2475L19.0825 72.7821L18.8746 70.6974L24.2341 70.1628C24.8098 70.1054 25.323 70.5255 25.3804 71.1012Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function ef(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 18 11",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "rect",
          {
            x: "0.961308",
            y: "0.77686",
            width: "6.42537",
            height: "3.42361",
            rx: "0.715214",
            stroke: "currentColor",
            strokeWidth: "1.43043"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "10.0238",
            y: "0.77686",
            width: "6.42537",
            height: "3.42361",
            rx: "0.715214",
            stroke: "currentColor",
            strokeWidth: "1.43043"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "0.961308",
            y: "6.83875",
            width: "6.42537",
            height: "3.42361",
            rx: "0.715214",
            stroke: "currentColor",
            strokeWidth: "1.43043"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "10.0238",
            y: "6.83887",
            width: "6.42537",
            height: "3.42361",
            rx: "0.715214",
            stroke: "currentColor",
            strokeWidth: "1.43043"
          }
        )
      ]
    }
  );
}
function tf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 18 11",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c(
        "rect",
        {
          x: "0.957402",
          y: "1.00806",
          width: "15.4875",
          height: "9.02306",
          rx: "0.715214",
          stroke: "currentColor",
          strokeWidth: "1.43043"
        }
      )
    }
  );
}
function rf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 23 23",
      stroke: "currentColor",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.90625 11.4229H21.2331",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M5.78516 21.3257L11.5704 15.5404L17.3557 21.3257",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M5.78516 1.26575L11.5704 7.05103L17.3557 1.26575",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function nf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { children: [
        /* @__PURE__ */ c("path", { d: "M5.76522 1.87974C5.76522 1.23483 5.24242 0.711914 4.59739 0.711914C3.95249 0.711914 3.42969 1.23483 3.42969 1.87974V5.94586H5.76522V1.87974Z" }),
        /* @__PURE__ */ c("path", { d: "M3.42969 9.4668V22.0683C3.42969 22.7134 3.95249 23.2362 4.59752 23.2362C5.24242 23.2362 5.76522 22.7134 5.76522 22.0683V9.4668H3.42969Z" }),
        /* @__PURE__ */ c("path", { d: "M7.34255 6.53906H1.97251C1.32749 6.53906 0.804688 7.06186 0.804688 7.70689C0.804688 8.3518 1.32749 8.87472 1.97251 8.87472H7.34255C7.98746 8.87472 8.51038 8.3518 8.51038 7.70689C8.51038 7.06186 7.98746 6.53906 7.34255 6.53906Z" }),
        /* @__PURE__ */ c("path", { d: "M10.7324 21.8907C10.7324 22.5356 11.2551 23.0585 11.9001 23.0585C12.5452 23.0585 13.068 22.5356 13.068 21.8907V19.6621H10.7324V21.8907Z" }),
        /* @__PURE__ */ c("path", { d: "M13.0661 1.70201C13.0661 1.0571 12.5433 0.53418 11.8983 0.53418C11.2534 0.53418 10.7305 1.0571 10.7305 1.70201V16.1412H13.0661V1.70201Z" }),
        /* @__PURE__ */ c("path", { d: "M14.6257 16.7344H9.25571C8.61069 16.7344 8.08789 17.2572 8.08789 17.9022C8.08789 18.5471 8.61069 19.0699 9.25571 19.0699H14.6257C15.2707 19.0699 15.7936 18.5471 15.7936 17.9022C15.7936 17.2572 15.2707 16.7344 14.6257 16.7344Z" }),
        /* @__PURE__ */ c("path", { d: "M20.4879 1.87974C20.4879 1.23483 19.9651 0.711914 19.3201 0.711914C18.6751 0.711914 18.1523 1.23483 18.1523 1.87974V8.07974H20.4879V1.87974Z" }),
        /* @__PURE__ */ c("path", { d: "M18.1523 22.0682C18.1523 22.7131 18.6751 23.2361 19.3202 23.2361C19.9651 23.2361 20.4879 22.7131 20.4879 22.0682V11.6006H18.1523V22.0682Z" }),
        /* @__PURE__ */ c("path", { d: "M22.0281 8.67285H16.6581C16.013 8.67285 15.4902 9.19566 15.4902 9.84068C15.4902 10.4856 16.013 11.0085 16.6581 11.0085H22.0281C22.673 11.0085 23.1959 10.4856 23.1959 9.84068C23.1959 9.19566 22.673 8.67285 22.0281 8.67285Z" })
      ] })
    }
  );
}
function of(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 24 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.369033 4.87918C-0.123011 5.37123 -0.123011 6.16899 0.369033 6.66103C0.861076 7.15307 1.65884 7.15307 2.15088 6.66103C7.39405 1.41786 15.8949 1.41786 21.1381 6.66103C21.6301 7.15307 22.4279 7.15307 22.9199 6.66103C23.412 6.16898 23.412 5.37123 22.9199 4.87918C16.6927 -1.34807 6.59629 -1.34807 0.369033 4.87918ZM2.60734 10.2823C2.20291 9.87784 2.20291 9.22213 2.60734 8.8177C7.59995 3.8251 15.6946 3.82509 20.6872 8.8177C21.0916 9.22213 21.0916 9.87784 20.6872 10.2823C20.2827 10.6867 19.627 10.6867 19.2226 10.2823C15.0388 6.09852 8.25566 6.09853 4.07191 10.2823C3.66748 10.6867 3.01177 10.6867 2.60734 10.2823ZM4.83502 13.6015C4.51871 13.2851 4.51871 12.7723 4.83502 12.456C8.59247 8.69854 14.6845 8.69854 18.4419 12.456C18.7582 12.7723 18.7582 13.2851 18.4419 13.6015C18.1256 13.9178 17.6128 13.9178 17.2965 13.6015C14.1716 10.4766 9.10531 10.4766 5.98049 13.6015C5.66418 13.9178 5.15133 13.9178 4.83502 13.6015ZM12.091 20.7915C13.5871 20.7915 14.8 19.5786 14.8 18.0824C14.8 16.5863 13.5871 15.3734 12.091 15.3734C10.5948 15.3734 9.38193 16.5863 9.38193 18.0824C9.38193 19.5786 10.5948 20.7915 12.091 20.7915Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function sf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 54 54",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("rect", { x: "0.410156", width: "54", height: "54", rx: "27", fill: "none" }),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M24.7177 28.5844V28.1828C24.7178 24.4261 24.7164 20.6695 24.7189 16.9128C24.7196 16.0405 25.3353 15.3571 26.1481 15.3094C27.0207 15.2579 27.7455 15.9093 27.7967 16.7932C27.8034 16.9105 27.7999 17.0285 27.7999 17.1462C27.8 22.6902 27.8003 28.2343 27.7999 33.7784C27.7996 37.0076 25.5438 39.5909 22.3469 40.0241C19.2403 40.4451 16.1161 38.1311 15.592 35.0211C14.9233 31.0533 17.9868 27.5916 22.012 27.7774C22.8555 27.8163 23.6556 28.0472 24.4103 28.4291C24.4947 28.4718 24.5791 28.5145 24.7177 28.5844ZM21.6298 36.9782C23.3135 36.9861 24.7057 35.6131 24.7162 33.9341C24.7268 32.2544 23.3513 30.8602 21.6722 30.8489C19.9737 30.8373 18.5714 32.2183 18.5658 33.9078C18.5604 35.579 19.9487 36.9704 21.6298 36.9782Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "34.4102",
            y: "11",
            width: "2",
            height: "10",
            rx: "1",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "rect",
          {
            x: "40.4102",
            y: "15",
            width: "2",
            height: "10",
            rx: "1",
            transform: "rotate(90 40.4102 15)",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function af(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { opacity: "0.4", children: [
        /* @__PURE__ */ c(
          "line",
          {
            x1: "1",
            y1: "-1",
            x2: "8.6",
            y2: "-1",
            transform: "matrix(-1 0 0 1 16 2)",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "line",
          {
            x1: "1",
            y1: "-1",
            x2: "11.8",
            y2: "-1",
            transform: "matrix(-1 0 0 1 16 8)",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "line",
          {
            x1: "1",
            y1: "-1",
            x2: "15",
            y2: "-1",
            transform: "matrix(-1 0 0 1 16 14)",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round"
          }
        )
      ] })
    }
  );
}
function cf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 29 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { children: [
        /* @__PURE__ */ c("path", { d: "M12.6409 7.99922C11.6338 5.0112 12.2392 2.67951 14.4328 1.17189C16.3956 -0.177083 19.0087 -0.0606209 20.8723 1.46359C22.6587 2.92468 23.4361 5.54726 22.2429 8.03868C22.345 8.09732 22.4495 8.15704 22.5535 8.21745C26.1378 10.2965 28.0345 13.3929 28.1724 17.5437C28.1945 18.206 27.8652 18.6978 27.3096 18.9044C26.7745 19.1033 26.1333 18.9657 25.8193 18.4905C25.638 18.2163 25.5274 17.8508 25.5104 17.52C25.3523 14.4396 23.9541 12.127 21.2842 10.5811C21.2745 10.5755 21.2636 10.5717 21.2541 10.5657C20.7255 10.2315 20.2606 10.1555 19.6149 10.4679C18.0321 11.2336 16.4111 11.1089 14.8605 10.2745C14.6691 10.1713 14.5194 10.1543 14.327 10.2441C11.2726 11.6717 9.63467 14.0637 9.41917 17.4275C9.4076 17.6075 9.41767 17.7929 9.37644 17.9661C9.21617 18.6389 8.58474 19.0626 7.89481 18.9771C7.22856 18.8947 6.73618 18.3245 6.74625 17.6022C6.79305 14.2483 8.11862 11.4931 10.6917 9.35241C11.2949 8.85065 11.9835 8.45133 12.6409 7.99922ZM17.4563 8.26493C18.9378 8.26616 20.1359 7.07405 20.1372 5.59746C20.1386 4.12563 18.9338 2.91787 17.4621 2.91529C15.9952 2.91284 14.7823 4.12304 14.78 5.59147C14.7775 7.06453 15.9781 8.26371 17.4563 8.26493Z" }),
        /* @__PURE__ */ c("path", { d: "M12.9113 10.2336C13.0724 10.1814 13.2512 10.1613 13.4329 10.1645C12.8491 9.04072 11.9301 8.11841 10.6819 7.39446C10.6172 7.35691 10.552 7.31963 10.4885 7.28303C11.2321 5.72998 10.7475 4.09515 9.63391 3.18441C8.47228 2.2342 6.84331 2.16169 5.61977 3.00264C4.25229 3.94236 3.87501 5.39583 4.50277 7.25854C4.09297 7.54032 3.66372 7.78929 3.28767 8.10208C1.68373 9.4365 0.857335 11.1539 0.828219 13.2447C0.821961 13.695 1.1289 14.0504 1.54414 14.1018C1.9742 14.155 2.36794 13.8909 2.46781 13.4716C2.49352 13.3636 2.48726 13.2479 2.49447 13.1358C2.62876 11.0388 3.64984 9.54779 5.55392 8.65786C5.67378 8.60195 5.76698 8.61256 5.88644 8.67677C6.85296 9.19691 7.86344 9.27473 8.85024 8.79732C9.25269 8.60262 9.54248 8.64997 9.87187 8.8584C9.87785 8.86208 9.88466 8.86439 9.89078 8.86793C10.8096 9.3999 11.4855 10.0784 11.9244 10.9018C12.1693 10.6009 12.5051 10.3651 12.9113 10.2336ZM7.50453 7.42412C6.58303 7.42331 5.83474 6.67582 5.8361 5.7576C5.83759 4.84222 6.59378 4.0878 7.5082 4.0893C8.42561 4.09093 9.1765 4.84386 9.17568 5.76127C9.17486 6.68181 8.42806 7.42494 7.50453 7.42412Z" })
      ] })
    }
  );
}
function lf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M11.8174 0.200955C12.0879 -0.0666955 12.5264 -0.0667046 12.7969 0.200955C13.0088 0.410824 13.0519 0.721303 12.9316 0.975369C18.7706 1.54802 23.333 6.46926 23.333 12.4588C23.3328 18.8328 18.166 23.9996 11.792 23.9998C5.41784 23.9998 0.250215 18.8329 0.25 12.4588C0.25 11.9065 0.697715 11.4588 1.25 11.4588C1.80228 11.4588 2.25 11.9065 2.25 12.4588C2.25021 17.7283 6.52241 21.9998 11.792 21.9998C17.0614 21.9996 21.3328 17.7282 21.333 12.4588C21.333 7.56885 17.6547 3.53978 12.9141 2.98416C13.0588 3.24456 13.0197 3.57781 12.7969 3.79861C12.5433 4.04958 12.1422 4.06598 11.8701 3.84646L11.8174 3.79861L10 1.99978L11.8174 0.200955ZM11.4766 6.0281C12.0288 6.0281 12.4766 6.47582 12.4766 7.0281V12.6834L15.6973 15.9041C16.0876 16.2946 16.0877 16.9277 15.6973 17.3181C15.3068 17.7085 14.6737 17.7085 14.2832 17.3181L10.4766 13.5115V7.0281C10.4766 6.47582 10.9243 6.0281 11.4766 6.0281ZM2.93359 7.72439C2.62569 8.29926 2.372 8.908 2.17969 9.54275L1.70117 9.39724L1.22266 9.25271C1.4343 8.55414 1.71308 7.88405 2.05176 7.25174L2.93359 7.72439ZM5.10352 4.30935L5.42188 4.69607C4.91357 5.11371 4.44693 5.58035 4.0293 6.08865L3.64258 5.77029L3.25586 5.45291C3.71479 4.89435 4.22758 4.38157 4.78613 3.92263L5.10352 4.30935ZM8.73047 2.36795L8.87598 2.84646C8.24122 3.03878 7.6325 3.29246 7.05762 3.60037L6.58496 2.71853C7.21729 2.37985 7.88736 2.10108 8.58594 1.88943L8.73047 2.36795Z",
          fill: "currentColor",
          fillOpacity: "0.4"
        }
      )
    }
  );
}
function uf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 8 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.02344 1.83594V10.6724",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M6.97266 1.83594V10.6724",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
function ff(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 12 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c(
        "path",
        {
          opacity: "0.7",
          d: "M8.94703 0.550744C9.4191 0.505556 10.0086 1.07719 10.3474 1.41553C10.8856 1.9527 11.9532 3.12082 11.394 3.95171L4.29447 11.7749L0.772122 13.1656C0.430241 13.2373 0.136541 12.9978 0.109375 12.6182C0.484573 11.2479 0.935118 9.89169 1.39335 8.55073C3.6266 6.09645 5.84447 3.62579 8.08336 1.17773C8.35655 0.879487 8.51494 0.592543 8.94703 0.551309V0.550744ZM1.22779 11.3654C1.38976 11.4298 1.55173 11.6049 1.6604 11.7495C1.70345 11.8065 1.7706 11.9879 1.82596 11.9884L3.75884 11.2123C3.47693 10.6926 3.11813 10.2086 2.71013 9.80301C2.60711 9.70077 1.99459 9.15117 1.90489 9.16811L1.22779 11.3654Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function df(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 28 32",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M26.3633 13.0155C28.3633 14.1702 28.3633 17.0569 26.3633 18.2116L4.61328 30.769C2.61328 31.9237 0.11328 30.4803 0.11328 28.1709L0.113281 3.05615C0.113281 0.746752 2.61328 -0.696621 4.61328 0.45808L26.3633 13.0155Z" })
    }
  );
}
function pf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 12 11",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M0.0845531 0.777594L11.373 0.351204L6.09803 10.3405L0.0845531 0.777594Z" })
    }
  );
}
function hf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M12.9054 9.22911V10.9924H13.2652C15.1442 10.9924 17.0234 10.9922 18.9026 10.9926C19.6588 10.9927 19.9852 11.3143 19.9858 12.0604C19.9866 12.8688 19.986 13.6772 19.986 14.5218C20.1056 14.5294 20.2099 14.5417 20.3143 14.5419C21.054 14.5436 21.7937 14.5401 22.5333 14.5437C23.1886 14.5471 23.5356 14.8886 23.5364 15.5414C23.5394 17.84 23.5395 20.1386 23.5363 22.4371C23.5355 23.0782 23.1954 23.42 22.5557 23.4211C20.2568 23.4246 17.9577 23.4242 15.6588 23.4213C15.0046 23.4205 14.659 23.075 14.6582 22.4209C14.6552 20.1325 14.6553 17.8439 14.6581 15.5553C14.6589 14.8908 15.0117 14.546 15.6841 14.5436C16.5124 14.5407 17.3407 14.5429 18.1921 14.5429V12.8027H5.80431V14.5264C5.91656 14.5321 6.02221 14.5419 6.12798 14.5422C6.86766 14.5435 7.60735 14.5392 8.34703 14.5441C8.97818 14.5484 9.33903 14.9001 9.34035 15.5279C9.34478 17.8364 9.34514 20.1451 9.33999 22.4536C9.33867 23.07 8.9843 23.4197 8.36706 23.4207C6.05819 23.4248 3.7492 23.4246 1.44021 23.421C0.802942 23.42 0.463681 23.0757 0.462961 22.4346C0.460203 20.1361 0.460323 17.8375 0.462961 15.539C0.463681 14.8877 0.810257 14.547 1.46767 14.5437C2.1974 14.5401 2.92701 14.5429 3.65674 14.5429C3.76419 14.5428 3.87152 14.5428 4.01339 14.5428V14.0376C4.01339 13.3981 4.01327 12.7584 4.01339 12.1189C4.01363 11.2992 4.31679 10.9926 5.12747 10.9924C6.98663 10.9923 8.84579 10.9924 10.7049 10.9924H11.0837V9.2447C10.9871 9.23978 10.8826 9.23007 10.7779 9.22983C10.0483 9.22839 9.31852 9.23151 8.58891 9.22839C7.8996 9.22539 7.56022 8.88205 7.55998 8.19238C7.55938 5.92368 7.55938 3.65511 7.55998 1.38653C7.56022 0.687144 7.88857 0.350761 8.58088 0.350162C10.8598 0.348123 13.1388 0.348123 15.4177 0.350162C16.1085 0.350761 16.4389 0.688823 16.4392 1.38653C16.4399 3.65511 16.4399 5.92368 16.4392 8.19226C16.4389 8.88133 16.0981 9.22539 15.4096 9.22839C14.69 9.23151 13.9703 9.22911 13.2507 9.22911H12.9054ZM2.24777 21.6293H7.54091V16.3417H2.24777V21.6293ZM16.4555 21.6263H21.7448V16.3336H16.4555V21.6263ZM14.638 2.14073H9.36049V7.43267H14.638V2.14073Z" })
    }
  );
}
function yf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 20 18",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ c("path", { d: "M5.73759 7.50647C4.8468 4.86348 5.38221 2.80103 7.32252 1.4675C9.05872 0.274293 11.37 0.377307 13.0185 1.72552C14.5986 3.01789 15.2863 5.33764 14.2309 7.54137C14.3211 7.59324 14.4135 7.64607 14.5056 7.6995C17.6759 9.53848 19.3536 12.2774 19.4757 15.9488C19.4952 16.5347 19.2039 16.9697 18.7125 17.1524C18.2391 17.3283 17.672 17.2067 17.3942 16.7863C17.2339 16.5438 17.1361 16.2204 17.121 15.9279C16.9812 13.2032 15.7444 11.1576 13.3828 9.79024C13.3742 9.7853 13.3646 9.78193 13.3562 9.77664C12.8887 9.48096 12.4774 9.4138 11.9063 9.69011C10.5062 10.3674 9.07243 10.2571 7.70088 9.51898C7.53155 9.42776 7.39917 9.41272 7.22901 9.49215C4.52729 10.7549 3.07847 12.8707 2.88785 15.8461C2.87762 16.0053 2.88652 16.1693 2.85006 16.3225C2.70829 16.9176 2.14978 17.2924 1.53951 17.2168C0.95019 17.1438 0.514666 16.6395 0.523572 16.0006C0.56497 13.034 1.73748 10.5969 4.01342 8.70341C4.54703 8.25959 5.15609 7.90638 5.73759 7.50647ZM9.99692 7.7415C11.3073 7.74259 12.3671 6.68814 12.3683 5.38204C12.3695 4.08017 11.304 3.01187 10.0021 3.00959C8.70454 3.00742 7.63168 4.07788 7.62963 5.37675C7.62747 6.67971 8.68938 7.74042 9.99692 7.7415Z" })
    }
  );
}
function mf(e) {
  return /* @__PURE__ */ D("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ c("circle", { cx: "15.9999", cy: "15.8856", r: "8.95738", fill: "currentColor" }),
    /* @__PURE__ */ c(
      "circle",
      {
        cx: "16",
        cy: "15.8857",
        r: "13.9775",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2.5"
      }
    )
  ] });
}
function gf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 26 27",
      stroke: "currentColor",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.47852 7.56614L12.9985 1.73633L24.5213 7.56614V19.9362L12.9999 25.8192L1.47852 19.9362V7.56614Z",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M1.47852 7.56641L12.9863 13.3802L24.5213 7.56641",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M12.9863 13.3799V25.8191",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] })
    }
  );
}
function Cf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ D("g", { opacity: "0.7", children: [
          /* @__PURE__ */ c(
            "foreignObject",
            {
              x: "-9.3125",
              y: "-9.68652",
              width: "32.7578",
              height: "32.6697"
            }
          ),
          /* @__PURE__ */ c(
            "ellipse",
            {
              "data-figma-bg-blur-radius": "10",
              cx: "7.06563",
              cy: "6.64832",
              rx: "5.87813",
              ry: "5.83484",
              stroke: "white",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ c(
            "foreignObject",
            {
              x: "0.71875",
              y: "0.269287",
              width: "24.1953",
              height: "24.1727"
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              "data-figma-bg-blur-radius": "10",
              d: "M14.415 13.942L11.2188 10.7693",
              stroke: "white",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c(
          "clipPath",
          {
            id: "bgblur_0_760_14885_clip_path",
            transform: "translate(9.3125 9.68652)",
            children: /* @__PURE__ */ c(
              "ellipse",
              {
                cx: "7.06563",
                cy: "6.64832",
                rx: "5.87813",
                ry: "5.83484"
              }
            )
          }
        ) })
      ]
    }
  );
}
function vf({ type: e, ...t }) {
  return e === "add" ? /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 26 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M11.2475 23.1465V22.6934C11.2476 18.455 11.246 14.2165 11.2489 9.97803C11.2497 8.99391 11.9444 8.22288 12.8613 8.16899C13.8458 8.11089 14.6637 8.84589 14.7214 9.84309C14.7289 9.97541 14.725 10.1086 14.725 10.2414C14.7252 16.4965 14.7254 22.7516 14.725 29.0066C14.7247 32.65 12.1795 35.5646 8.57267 36.0534C5.06769 36.5284 1.54279 33.9177 0.951403 30.4088C0.19695 25.9321 3.65339 22.0264 8.19479 22.236C9.14647 22.2799 10.0492 22.5405 10.9007 22.9713C10.9959 23.0196 11.0911 23.0676 11.2475 23.1465ZM7.76357 32.6169C9.66329 32.6257 11.234 31.0767 11.2459 29.1824C11.2578 27.2872 9.70588 25.7142 7.81139 25.7014C5.8951 25.6884 4.31294 27.2466 4.30669 29.1526C4.30059 31.0382 5.8669 32.608 7.76357 32.6169Z",
            fill: "currentColor"
          }
        ),
        e === "add" && /* @__PURE__ */ D(Jr, { children: [
          /* @__PURE__ */ c(
            "rect",
            {
              x: "19.957",
              y: "0.900146",
              width: "1.38848",
              height: "9.02512",
              rx: "0.69424",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ c(
            "rect",
            {
              x: "25.1641",
              y: "4.71875",
              width: "1.38848",
              height: "9.02512",
              rx: "0.69424",
              transform: "rotate(90 25.1641 4.71875)",
              fill: "currentColor"
            }
          )
        ] })
      ]
    }
  ) : /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 14 26",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c(
        "path",
        {
          d: "M10.1267 13.9024V13.4971C10.1269 9.70532 10.1254 5.91354 10.128 2.12175C10.1287 1.24135 10.7498 0.551579 11.5697 0.503368C12.45 0.451388 13.1812 1.10893 13.2328 2.00103C13.2395 2.11941 13.236 2.23858 13.236 2.35735C13.2362 7.95322 13.2364 13.5491 13.236 19.1449C13.2358 22.4043 10.9601 25.0118 7.73516 25.449C4.60131 25.874 1.44965 23.5384 0.920887 20.3993C0.246321 16.3944 3.33677 12.9004 7.39729 13.0879C8.2482 13.1271 9.05531 13.3603 9.81668 13.7457C9.9018 13.7888 9.98692 13.8318 10.1267 13.9024ZM7.01173 22.3747C8.7103 22.3826 10.1147 20.9969 10.1253 19.3022C10.136 17.6067 8.74837 16.1995 7.05449 16.1881C5.34111 16.1764 3.92648 17.5704 3.92089 19.2755C3.91543 20.9624 5.3159 22.3668 7.01173 22.3747Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function bf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M1.86144 14.8251C1.92624 14.6653 1.96139 14.5337 2.02843 14.4212C2.33061 13.9131 2.64239 13.4106 2.94963 12.9055C3.1162 12.6316 3.07694 12.5304 2.76918 12.4533C2.20982 12.3134 1.64995 12.1755 1.08948 12.0397C0.661368 11.9361 0.501061 11.7407 0.500718 11.3049C0.499861 10.2498 0.499604 9.19466 0.50089 8.13955C0.501404 7.7009 0.716232 7.43849 1.14426 7.33562C1.69787 7.20266 2.2508 7.06661 2.80347 6.92963C3.04736 6.8691 3.07779 6.79204 2.94586 6.56761C2.63888 6.0458 2.32872 5.52579 2.02123 5.00424C1.83486 4.68808 1.86452 4.4093 2.12333 4.15273C2.89786 3.38463 3.67487 2.61901 4.45317 1.85469C4.72003 1.59271 4.98475 1.56125 5.30434 1.7537C5.81689 2.06248 6.3255 2.37761 6.83676 2.68854C7.0936 2.84481 7.20144 2.80058 7.27473 2.50671C7.41592 1.94041 7.55394 1.37334 7.6935 0.806695C7.7962 0.389727 7.99234 0.232678 8.41831 0.232249C9.47359 0.231221 10.5289 0.231135 11.5841 0.232249C12.0109 0.232678 12.242 0.415787 12.3455 0.833184C12.4894 1.41346 12.6309 1.99433 12.7744 2.57478C12.832 2.80821 12.9077 2.84087 13.1206 2.71451C13.6536 2.39819 14.1843 2.078 14.7162 1.75996C15.049 1.56091 15.3253 1.5946 15.5998 1.87535C16.3424 2.63487 17.0838 3.39568 17.8234 4.15821C18.1149 4.45868 18.1425 4.70394 17.9318 5.0621C17.6427 5.55322 17.3511 6.0428 17.061 6.53332C16.8795 6.84039 16.9189 6.93374 17.269 7.0199C17.8151 7.15423 18.3615 7.28744 18.9078 7.42049C19.3491 7.52799 19.4994 7.71787 19.4997 8.17402C19.5002 9.21489 19.5 10.2558 19.4997 11.2966C19.4996 11.7765 19.3463 11.9693 18.8876 12.08C18.3064 12.2202 17.726 12.3634 17.1455 12.5064C16.9359 12.5581 16.8972 12.634 16.998 12.8244C17.2878 13.3719 17.5833 13.9164 17.8753 14.4627C18.0281 14.7487 18.0027 15.0187 17.7768 15.2467C16.994 16.0368 16.2075 16.8234 15.4169 17.6056C15.1865 17.8335 14.9177 17.8592 14.6337 17.6942C14.1102 17.39 13.5911 17.0785 13.0695 16.7711C12.8148 16.6209 12.7313 16.6573 12.6584 16.9517C12.5145 17.532 12.3744 18.1133 12.2291 18.6933C12.1348 19.0693 11.9309 19.2274 11.54 19.228C10.4705 19.2297 9.40089 19.2297 8.33138 19.228C7.94091 19.2274 7.73739 19.0684 7.64318 18.6922C7.49265 18.0915 7.34674 17.4897 7.19672 16.8889C7.13766 16.6524 7.06265 16.6198 6.85108 16.7439C6.32267 17.0539 5.79717 17.3687 5.26919 17.6793C4.95946 17.8614 4.68429 17.8343 4.43337 17.585C3.65447 16.8113 2.87574 16.037 2.10755 15.2527C1.99585 15.1387 1.94168 14.9684 1.86144 14.8251ZM15.0397 3.08373C14.601 3.33902 14.1817 3.59362 13.7526 3.83048C12.8377 4.33541 11.8579 3.92247 11.575 2.91622C11.4594 2.50526 11.3511 2.09197 11.2496 1.67724C11.2196 1.55439 11.1765 1.49893 11.0384 1.50038C10.354 1.50741 9.66947 1.50621 8.98504 1.50124C8.86022 1.5003 8.81505 1.54522 8.78881 1.66532C8.70232 2.06154 8.60108 2.45459 8.50635 2.8491C8.25243 3.90627 7.22261 4.35341 6.27801 3.8136C5.91942 3.60863 5.56186 3.40134 5.21038 3.18437C5.08197 3.10508 5.00121 3.10105 4.88797 3.21969C4.51875 3.60631 4.13659 3.98067 3.75571 4.35589C3.62035 4.48928 3.47419 4.6117 3.33797 4.73463C3.60209 5.16454 3.84075 5.54422 4.07066 5.92904C4.61999 6.84862 4.20928 7.87372 3.17852 8.15781C2.76687 8.27131 2.35479 8.38404 1.93945 8.48263C1.80726 8.51392 1.7692 8.56981 1.77014 8.699C1.77537 9.36911 1.77751 10.0393 1.76885 10.7093C1.76688 10.8612 1.81446 10.9175 1.96165 10.9483C2.35864 11.0317 2.75238 11.1309 3.14594 11.2294C4.16213 11.4837 4.61005 12.5138 4.0975 13.4246C3.85721 13.8516 3.60457 14.2717 3.37372 14.6673C3.94533 15.2376 4.49878 15.7898 5.06465 16.3544C5.43258 16.1286 5.81783 15.8861 6.20891 15.6536C7.11863 15.1128 8.13687 15.5208 8.42448 16.5417C8.54218 16.9595 8.65191 17.3797 8.75444 17.8016C8.78401 17.9234 8.83819 17.9601 8.95906 17.9592C9.6435 17.9544 10.328 17.9545 11.0124 17.9591C11.1347 17.96 11.1843 17.9206 11.2109 17.798C11.2955 17.4085 11.3958 17.0226 11.4896 16.6352C11.7547 15.5399 12.7852 15.1009 13.7609 15.6685C14.118 15.8762 14.4763 16.0819 14.829 16.2968C14.9309 16.3589 14.9934 16.3616 15.0835 16.2713C15.5621 15.792 16.0451 15.3171 16.5347 14.8493C16.6364 14.7521 16.6251 14.6855 16.5606 14.5792C16.339 14.2139 16.1224 13.8453 15.9126 13.473C15.682 13.064 15.5975 12.6338 15.7771 12.1814C15.9699 11.6962 16.3287 11.3977 16.8312 11.2666C17.3183 11.1396 17.8051 11.0116 18.2871 10.8853V8.59167C17.8412 8.47354 17.4025 8.35438 16.9622 8.24131C15.8597 7.95799 15.4325 6.94857 16.0033 5.96873C16.2112 5.61177 16.4252 5.25824 16.6255 4.89708C16.6567 4.84076 16.661 4.72074 16.6238 4.68251C16.1031 4.14604 15.573 3.61874 15.0397 3.08373Z" }),
        /* @__PURE__ */ c("path", { d: "M9.99535 6.02442C12.0673 6.01971 13.7287 7.67884 13.7332 9.7569C13.7377 11.8118 12.0715 13.4899 10.0194 13.4971C7.95304 13.5044 6.27402 11.8381 6.2676 9.77362C6.26107 7.71005 7.93246 6.02906 9.99535 6.02442ZM7.53015 9.73796C7.53804 11.0907 8.6547 12.2032 10.0029 12.2013C11.359 12.1994 12.4852 11.0637 12.4716 9.71173C12.4579 8.3589 11.3314 7.24738 9.9873 7.2605C8.63087 7.2737 7.52235 8.39139 7.53015 9.73796Z" })
      ]
    }
  );
}
function wf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 15 12",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("path", { d: "M6.8093 5.9958C6.8093 7.63156 6.80836 9.26731 6.8103 10.9031C6.81062 11.1363 6.74032 11.3276 6.52611 11.4477C6.33373 11.5555 6.12828 11.521 5.94404 11.3435C5.73139 11.1387 5.52382 10.9289 5.3143 10.721C4.69689 10.1082 4.07773 9.497 3.46407 8.88053C3.36957 8.7856 3.27601 8.7419 3.13842 8.74332C2.47647 8.75023 1.81447 8.7469 1.1524 8.74628C0.712861 8.74585 0.523609 8.55875 0.523547 8.12624C0.523422 6.70652 0.523359 5.28681 0.523609 3.8671C0.523672 3.46076 0.724869 3.26336 1.13846 3.26323C1.81616 3.26299 2.4938 3.26083 3.17144 3.26558C3.27901 3.26632 3.35437 3.23675 3.43024 3.16101C4.24359 2.34869 5.06126 1.54063 5.87574 0.72942C6.05055 0.555289 6.24217 0.458873 6.49228 0.555907C6.70892 0.639916 6.79748 0.80985 6.8073 1.02688C6.81337 1.16033 6.80924 1.29428 6.80924 1.42804C6.80936 2.95065 6.8093 4.4732 6.8093 5.9958Z" }),
        /* @__PURE__ */ c("path", { d: "M14.0357 6.15806C14.0274 7.75147 13.4624 9.09815 12.4936 10.2966C12.4124 10.3971 12.3274 10.4947 12.2428 10.5924C11.9863 10.889 11.6659 10.9363 11.4108 10.7158C11.1693 10.5072 11.1784 10.1868 11.4364 9.89665C11.9387 9.33179 12.3533 8.71292 12.6296 8.00924C13.1257 6.74545 13.063 5.48468 12.6093 4.22515C12.3255 3.43746 11.9129 2.7218 11.3844 2.0704C11.234 1.8851 11.1854 1.68597 11.2907 1.46777C11.4662 1.10389 11.9407 1.06574 12.2087 1.39425C12.6288 1.90917 12.977 2.46909 13.2654 3.06531C13.7451 4.05695 14.026 5.09636 14.0357 6.15806Z" }),
        /* @__PURE__ */ c("path", { d: "M11.9401 5.98584C11.9648 7.28117 11.5252 8.37033 10.7414 9.33789C10.6699 9.42617 10.5963 9.51308 10.5195 9.59691C10.2975 9.83899 9.97352 9.86566 9.74049 9.66344C9.51626 9.46888 9.50038 9.14605 9.71284 8.90476C10.0774 8.49076 10.391 8.04528 10.5978 7.53344C11.0848 6.32836 10.9312 5.1642 10.3353 4.04207C10.1626 3.71677 9.93875 3.41555 9.7179 3.11796C9.50958 2.83729 9.51596 2.51687 9.76501 2.32317C10.0102 2.13237 10.3384 2.18089 10.5472 2.44841C11.3718 3.50474 11.8774 4.68285 11.9401 5.98584Z" }),
        /* @__PURE__ */ c("path", { d: "M9.77185 5.99155C9.78604 6.88146 9.4497 7.62378 8.85192 8.25839C8.66737 8.45432 8.35396 8.45722 8.13932 8.28926C7.93493 8.12933 7.88515 7.83619 8.02562 7.60786C8.05252 7.56422 8.08578 7.5241 8.11893 7.48459C8.81665 6.65455 8.88281 5.7223 8.30505 4.80585C8.231 4.68832 8.14256 4.57968 8.06052 4.46715C7.88221 4.22247 7.91324 3.93192 8.13725 3.74995C8.36671 3.5636 8.67517 3.58773 8.87668 3.81686C9.42793 4.44357 9.73051 5.17096 9.77185 5.99155Z" })
      ]
    }
  );
}
function Sf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 18 13",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M13.0907 10.5501C12.5981 10.5501 12.2015 10.1502 12.2015 9.66085C12.2015 7.85042 10.7301 6.37904 8.91964 6.37904C7.10921 6.37904 5.63783 7.85042 5.63783 9.66085C5.63783 10.1534 5.23799 10.5501 4.7486 10.5501C4.25921 10.5501 3.85938 10.1502 3.85938 9.66085C3.85938 6.87163 6.13042 4.60059 8.91964 4.60059C11.7089 4.60059 13.9799 6.87163 13.9799 9.66085C13.9799 10.1534 13.5801 10.5501 13.0907 10.5501Z",
            fill: "white",
            fillOpacity: "0.4"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M16.7088 10.5501C16.2163 10.5501 15.8196 10.1502 15.8196 9.66085C15.8196 5.85766 12.7233 2.76136 8.92013 2.76136C5.11693 2.76136 2.02064 5.85766 2.02064 9.66085C2.02064 10.1534 1.62081 10.5501 1.13141 10.5501C0.642019 10.5501 0.242188 10.1502 0.242188 9.66085C0.242188 4.87567 4.13495 0.98291 8.92013 0.98291C13.7053 0.98291 17.5981 4.87567 17.5981 9.66085C17.5981 10.1534 17.1982 10.5501 16.7088 10.5501Z",
            fill: "white",
            fillOpacity: "0.4"
          }
        ),
        /* @__PURE__ */ c("path", { d: "M12.1855 9.33139C12.6941 8.92196 13.2218 8.54452 13.7592 8.17988C13.1259 6.11035 11.1971 4.60059 8.91964 4.60059C6.13042 4.60059 3.85938 6.87163 3.85938 9.66085C3.85938 10.1534 4.25921 10.5501 4.7486 10.5501C5.23799 10.5501 5.63783 10.1502 5.63783 9.66085C5.63783 7.85042 7.10921 6.37904 8.91964 6.37904C10.6181 6.37904 12.0159 7.67449 12.1823 9.33139H12.1855Z" }),
        /* @__PURE__ */ c("path", { d: "M15.3494 7.1755C15.7237 6.95159 16.1011 6.73089 16.4785 6.51018C16.5777 6.37264 16.7056 6.24789 16.8496 6.13914C15.4966 3.10682 12.4546 0.98291 8.92013 0.98291C4.13495 0.98291 0.242188 4.87567 0.242188 9.66085C0.242188 10.1534 0.642019 10.5501 1.13141 10.5501C1.62081 10.5501 2.02064 10.1502 2.02064 9.66085C2.02064 5.85766 5.11693 2.76136 8.92013 2.76136C11.8469 2.76136 14.3482 4.59739 15.3494 7.1755Z" }),
        /* @__PURE__ */ c("path", { d: "M9.33585 11.4681C8.64814 11.4681 7.92205 10.9467 7.49023 10.1438C7.23754 9.67364 7.11599 9.15866 7.14478 8.69806C7.17996 8.13189 7.44545 7.67768 7.86767 7.45058C7.94444 7.409 8.01161 7.38981 8.0436 7.38021L16.2609 4.46624L16.3665 4.44385H16.4529C16.7887 4.44385 17.1022 4.66775 17.2493 5.01961C17.3869 5.35226 17.3325 5.70412 17.099 5.93442L17.067 5.96641L10.0939 11.2122C10.0747 11.2282 10.0236 11.273 9.9468 11.3146C9.75808 11.4169 9.55336 11.4681 9.33265 11.4681H9.33585Z" }),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M16.4526 5.08024C16.6029 5.08024 16.7533 5.37452 16.6445 5.48327L9.70662 10.7035C9.68423 10.7195 9.66504 10.7419 9.63945 10.7547C9.54349 10.8058 9.44114 10.8282 9.33238 10.8282C8.89736 10.8282 8.37598 10.4444 8.04972 9.83984C7.64349 9.08176 7.69467 8.2629 8.16807 8.01021C8.19366 7.99741 8.22245 7.99421 8.24804 7.98142L16.4302 5.08024C16.4302 5.08024 16.4462 5.08024 16.4526 5.08024ZM16.4526 3.80078C16.3598 3.80078 16.2671 3.81038 16.1775 3.82957L16.0879 3.84876L16.0016 3.88075L7.84181 6.77553C7.76504 6.79792 7.66908 6.8299 7.56033 6.89068C6.4504 7.48563 6.16891 9.05297 6.9206 10.454C7.47077 11.4775 8.39518 12.1173 9.32918 12.1173C9.65544 12.1173 9.96252 12.0405 10.244 11.8902C10.3528 11.8294 10.4359 11.7686 10.4935 11.7174L17.4122 6.51324L17.4857 6.45886L17.5497 6.39489C17.9591 5.98226 18.0711 5.34893 17.8344 4.78277C17.5881 4.19102 17.0443 3.81038 16.4494 3.81038L16.4526 3.80078Z",
            fill: "#24272B"
          }
        ),
        /* @__PURE__ */ c("path", { d: "M8.79993 10.9983C9.66025 10.9983 10.3577 10.3009 10.3577 9.44056C10.3577 8.58024 9.66025 7.88281 8.79993 7.88281C7.93961 7.88281 7.24219 8.58024 7.24219 9.44056C7.24219 10.3009 7.93961 10.9983 8.79993 10.9983Z" })
      ]
    }
  );
}
function Ef(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 24 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.7732 5.2659L22.8963 10.5459C23.2474 10.7741 23.1792 11.3071 22.7819 11.4395L20.224 12.2921L22.1511 15.1828C22.3655 15.5044 22.2786 15.9391 21.9569 16.1535L21.1394 16.6985C20.8098 16.9183 20.3637 16.8209 20.1555 16.4839L18.4424 13.7099L16.9301 15.7262C16.6719 16.0705 16.1283 15.9495 16.0406 15.5282L14.0112 5.7871C13.9205 5.35186 14.4004 5.02361 14.7732 5.2659Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 0.183594C0.447715 0.183594 0 0.631309 0 1.18359V11.1836C0 11.7359 0.447715 12.1836 1 12.1836H13.2996L12.052 6.19501C11.5986 4.01883 13.9981 2.37757 15.8619 3.58902L21 6.92879V1.18359C21 0.631309 20.5523 0.183594 20 0.183594H1ZM21 9.31416L14.7719 5.2659C14.3992 5.02361 13.9192 5.35187 14.0099 5.7871L15.3425 12.1836H20C20.5523 12.1836 21 11.7359 21 11.1836V9.31416Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function xf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 4 20",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c("circle", { cx: "2", cy: "2", r: "2" }),
        /* @__PURE__ */ c("circle", { cx: "2", cy: "10", r: "2" }),
        /* @__PURE__ */ c("circle", { cx: "2", cy: "18", r: "2" })
      ]
    }
  );
}
function Rf(e) {
  return /* @__PURE__ */ c(
    "svg",
    {
      viewBox: "0 0 26 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ D("g", { children: [
        /* @__PURE__ */ c("path", { d: "M9.4971 14.8441C7.16566 14.8441 4.83422 14.8448 2.50278 14.8439C1.28876 14.8433 0.539927 14.0978 0.5397 12.8889C0.538907 9.35868 0.538794 5.82839 0.5397 2.29822C0.54004 1.1039 1.28966 0.352582 2.48274 0.352355C7.17404 0.351336 11.8652 0.351223 16.5564 0.352469C17.7427 0.352695 18.4886 1.09552 18.4889 2.27432C18.49 5.81401 18.49 9.35369 18.4889 12.8934C18.4886 14.0886 17.7381 14.843 16.5481 14.8437C14.1978 14.8451 11.8475 14.8441 9.4971 14.8441Z" }),
        /* @__PURE__ */ c("path", { d: "M25.4576 7.61854C25.4576 8.92058 25.459 10.2226 25.457 11.5247C25.4557 12.3236 24.8637 12.7075 24.14 12.3771C22.8975 11.8098 21.6594 11.2329 20.4142 10.6714C20.0138 10.4908 19.8198 10.2012 19.8203 9.76727C19.8218 8.32376 19.8212 6.88013 19.8207 5.43662C19.8205 5.0037 20.0176 4.70897 20.4142 4.52887C21.6578 3.964 22.897 3.38949 24.1392 2.82144C24.8421 2.49998 25.4553 2.88782 25.4568 3.65579C25.4595 4.97674 25.4576 6.29759 25.4576 7.61854Z" })
      ] })
    }
  );
}
function Of(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "24",
      height: "22",
      viewBox: "0 0 24 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M11.0198 15.0104V7.62904H12.3304V15.0104H11.0198ZM10.583 17.1796C10.583 16.577 11.0499 16.0799 11.6676 16.0799C12.2852 16.0799 12.7823 16.577 12.7823 17.1796C12.7823 17.7822 12.2852 18.2793 11.6676 18.2793C11.0499 18.2793 10.583 17.7822 10.583 17.1796Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M9.99686 3.14671L1.65099 18.1673C0.910298 19.5004 1.87423 21.1387 3.39924 21.1387H20.0896C21.6145 21.1387 22.5785 19.5005 21.8379 18.1674L13.4934 3.14684C12.7315 1.77524 10.7589 1.77517 9.99686 3.14671Z",
            stroke: "currentColor",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function Pf(e) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 53 59",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M25.0558 0.0530935C42.1432 -1.13327 53.2637 17.808 44.0187 32.2363C36.0547 44.6648 17.9889 44.9809 9.46279 32.9633C0.0340203 19.6727 8.89798 1.1719 25.0558 0.0530935ZM25.326 8.00904C14.9865 8.92516 9.93301 21.232 16.5918 29.2069C22.4425 36.2143 33.7144 35.0279 37.9193 26.9395C42.627 17.8837 35.4926 7.10913 25.3287 8.00904H25.326Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M53 21.3212C52.9595 29.6825 48.7383 37.6303 41.9849 42.4704C34.6667 47.7131 25.5406 48.8481 17.0956 45.6971C7.10738 41.9758 0.113502 32.1687 0 21.4563H3.64017C3.83474 28.8663 7.72354 35.9359 13.9013 39.9895C29.0862 49.9534 48.8842 39.1653 49.3571 21.3212H52.9973H53Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M47.1622 56.6958C47.9107 57.4471 47.1946 58.5253 46.1947 58.4173H6.80413C5.50426 58.4686 5.00161 57.066 6.19608 56.4499L46.1947 56.3823C46.4649 56.3823 46.9811 56.5147 47.1622 56.6958Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M28.4573 46.4725V56.9904H24.5469V46.4725C24.6469 46.4374 24.709 46.6077 24.7496 46.6077H28.2546C28.2951 46.6077 28.3573 46.4374 28.4573 46.4725Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M25.1931 10.0332C37.0865 8.81709 42.1265 24.702 31.8302 30.4284C23.3095 35.1685 13.5294 27.3638 15.9238 18.027C16.9858 13.8868 20.9287 10.4683 25.1904 10.0305L25.1931 10.0332ZM25.4579 15.0165C22.6042 15.4029 20.3449 18.3918 20.5179 21.2347C20.8449 26.5612 27.6712 28.8799 31.0871 24.6938C34.5029 20.5078 30.9465 14.2706 25.4552 15.0165H25.4579Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  j8 as AGE_RANGE_OPTS,
  R9 as AddGroup,
  g9 as Alert,
  O9 as AlertIcon,
  n6 as AppleLogo,
  h9 as ApplicationLogo,
  m9 as ApplicationLogoNoIcon,
  y9 as ApplicationLogoNoText,
  x9 as ArticleLayout,
  P9 as AudioInterface,
  A9 as AudioInterfaceFilled,
  L9 as BlankImage,
  T9 as Bonza,
  r9 as BufferSizes,
  M9 as Calendar,
  _9 as Chevron,
  N9 as CloseApplications,
  w9 as CloudBackground,
  s9 as CodecOptions,
  F9 as Cross,
  p9 as CustomCheckbox,
  f9 as DangerButton,
  $9 as Delete,
  b9 as DismissibleNotice,
  G8 as ENSEMBLE_OPTS,
  W8 as EXCITED_OPTS,
  I9 as Edit,
  q9 as Ethernet,
  k9 as ExternalLink,
  D9 as Grid,
  H9 as Groups,
  Z8 as HOW_FIND_OPTS,
  B9 as Headphones,
  U9 as Home,
  V9 as HostBadge,
  Q8 as IMPORTANCE_OPTS,
  t9 as InputChannelMap,
  j9 as Internet,
  K9 as InviteUser,
  J8 as JOIN_OPTS,
  x5 as JitterValueStrings,
  z9 as JoinSession,
  G9 as Leave,
  Z9 as Live,
  W9 as LoadingSpinner,
  Q9 as Login,
  a9 as ManualJitterValueStrings,
  J9 as Message,
  Y9 as Microphone,
  X9 as MicrophoneDetailed,
  ef as MiniGrid,
  tf as MiniRectangle,
  rf as MirrorIcon,
  nf as Mixer,
  of as Network,
  sf as NewSession,
  af as OrderBy,
  K8 as PERSON_OPTS,
  q8 as PaddleCheckoutContextProvider,
  cf as Participants,
  lf as PastSession,
  uf as Pause,
  ff as Pencil,
  E9 as PlanPurchaseConfirmationCard,
  o6 as PlanToPurchaseCard,
  df as Play,
  G4 as Plus,
  pf as Pointer,
  hf as Positions,
  zi as PrimaryButton,
  yf as Profile,
  z8 as REHEARSAL_FREQUENCY_OPTS,
  mf as Record,
  gf as RoomSound,
  o9 as SampleRateValueStrings,
  n9 as SampleRateValues,
  Cf as Search,
  Gi as SecondaryButton,
  C9 as SelectInput,
  vf as Session,
  bf as Settings,
  wf as Speaker,
  Sf as Speedometer,
  v9 as TextAreaInput,
  z4 as TextInput,
  S9 as TwoFactorChallenge,
  Ef as UserInterface,
  u9 as ValidEmail,
  xf as VerticalEllipsis,
  Rf as Video,
  i9 as VideoResolutionStrings,
  Of as WarningTriangle,
  Pf as Webcam,
  Z as accountKeys,
  P8 as alphanumericRegex,
  hr as blogKeys,
  N6 as cancelSubscription,
  Du as cancelTrial,
  Hu as confirmCardTrial,
  on as connectionKeys,
  U8 as countPendingGrantsByPlanId,
  Bu as createCheckoutTransaction,
  _a as dashboardKeys,
  H3 as deleteConnect,
  c0 as deleteGroup,
  r7 as deleteGroupAvatar,
  d8 as deleteMirror,
  Rt as deleteRequest,
  Qu as deleteSession,
  x0 as deleteUserAvatar,
  M0 as disableTwoFactor,
  e5 as emailRegex,
  T0 as enableEmailTwoFactor,
  L0 as enableTotp,
  I8 as formatPaddlePrice,
  A0 as generateTotpSecret,
  Au as getAccount,
  _u as getAccountActivePlans,
  Tu as getAccountPlan,
  Mu as getAccountSubscriptions,
  Nu as getAccountTransactions,
  Pu as getAccountUsage,
  Lu as getAccountWithUsers,
  Ru as getAccounts,
  q3 as getAllConnections,
  qu as getAvailablePlans,
  V3 as getBonzaSessionPeers,
  Gu as getConnections,
  ks as getCurrencySymbol,
  Ku as getDashboard,
  e9 as getExternalIPAndPortMessage,
  o0 as getGroup,
  l0 as getGroupMembers,
  u0 as getGroupPendingInvites,
  f0 as getGroupSessions,
  i0 as getGroupTypes,
  n0 as getGroups,
  K3 as getMirrors,
  Ou as getOwnAccounts,
  W3 as getPaddlePrices,
  Z3 as getPaddleProducts,
  v0 as getPeopleSearch,
  _0 as getRecoveryCodes,
  G as getRequest,
  Na as getSession,
  Fa as getSessionMembers,
  Ju as getSessionPendingInvites,
  zu as getSessions,
  k6 as getSubscriptionUpdatePaymentUrl,
  _6 as getTransactionInvoiceUrl,
  P0 as getTwoFactorStatus,
  O0 as getUserCalendarToken,
  n7 as getUserGroups,
  b0 as getUserInvites,
  S0 as getUserList,
  w0 as getUserSessions,
  R0 as getUserStats,
  j as groupKeys,
  D8 as isGrantOnlyPlan,
  _n as isTrialEligiblePlan,
  p8 as joinMirror,
  G3 as leaveMirror,
  Xa as mirrorKeys,
  qn as paddleKeys,
  qa as paginateGroups,
  Ia as paginateSessions,
  xu as patchRequest,
  C0 as patchUserProfile,
  F6 as pauseSubscription,
  l9 as playerColours,
  z3 as postAndJoinMirror,
  k3 as postConnect,
  s0 as postGroup,
  h0 as postGroupAcceptInvite,
  t7 as postGroupAvatar,
  y0 as postGroupRevokeInvite,
  p0 as postInviteMultipleToGroup,
  Xu as postInviteMultipleToSession,
  d0 as postInviteToGroup,
  Yu as postInviteToSession,
  B3 as postJoinBonzaSession,
  Iu as postKickFromAccount,
  U3 as postLeaveBonzaSession,
  f8 as postMirror,
  E8 as postRegister,
  le as postRequest,
  Zu as postSession,
  e0 as postSessionAcceptInvite,
  t0 as postSessionRevokeInvite,
  E0 as postUserAvatar,
  j3 as postWhisperToSession,
  Fu as putAccount,
  D3 as putConnect,
  a0 as putGroup,
  e7 as putGroupAvatar,
  gt as putRequest,
  Wu as putSession,
  $u as putSetRoleInAccount,
  g0 as queryGroups,
  $a as querySessions,
  N0 as regenerateRecoveryCodes,
  m0 as removeUserFromGroup,
  r0 as removeUserFromSession,
  o7 as resendVerificationEmail,
  B8 as resolveActivePlanHandle,
  k8 as resolveCurrentPlan,
  H8 as resolvePlanCtaLabel,
  $6 as resumeSubscription,
  K as sessionKeys,
  X8 as standaloneMessage,
  c9 as startStreamMessage,
  ku as startTrial,
  Y8 as stdAzimuthAndDistanceMessageParams,
  R8 as submitEmailMarketing,
  O8 as submitForm,
  q6 as swapSubscription,
  jr as tagKeys,
  Ki as twoFactorKeys,
  I6 as uncancelSubscription,
  x8 as updateUserContact,
  _7 as useAcceptGroupInvite,
  Q7 as useAcceptSessionInvite,
  Q6 as useCancelTrial,
  Vu as useConfirmCardTrial,
  ju as useCreateCheckoutTransaction,
  M8 as useDateFormatter,
  L8 as useDebounce,
  T8 as useDebounceQueue,
  s8 as useDeleteConnection,
  I7 as useDeleteGroup,
  X7 as useDeleteSession,
  d7 as useDeleteUserAvatar,
  b7 as useDisableTwoFactor,
  A8 as useEmailRegex,
  v7 as useEnableEmailTwoFactor,
  C7 as useEnableTotp,
  _8 as useFormatVerboseDate,
  B6 as useGetAccount,
  Uu as useGetAccountActivePlans,
  U6 as useGetAccountPlan,
  V6 as useGetAccountSubscriptions,
  K6 as useGetAccountTransactions,
  z6 as useGetAccountUsage,
  j6 as useGetAccountWithUsers,
  D6 as useGetAccounts,
  Z6 as useGetAvailablePlans,
  b8 as useGetBlogPost,
  r8 as useGetConnectedUsers,
  l8 as useGetConnectionPeers,
  n8 as useGetConnections,
  V7 as useGetCurrentSession,
  X6 as useGetDashboard,
  x7 as useGetGroup,
  A7 as useGetGroupMembers,
  L7 as useGetGroupPendingInvites,
  F7 as useGetGroupSessions,
  R7 as useGetGroupTypes,
  S7 as useGetGroups,
  v8 as useGetInfiniteBlogPosts,
  E7 as useGetInfiniteGroups,
  H7 as useGetInfiniteSessions,
  h8 as useGetMirrors,
  B7 as useGetNextSession,
  H6 as useGetOwnAccounts,
  C8 as useGetPaddlePrices,
  g8 as useGetPaddleProducts,
  q7 as useGetPaginatedGroups,
  e8 as useGetPaginatedSessions,
  g7 as useGetRecoveryCodes,
  U7 as useGetSession,
  z7 as useGetSessionMembers,
  G7 as useGetSessionPendingInvites,
  D7 as useGetSessions,
  S8 as useGetTag,
  w8 as useGetTags,
  m7 as useGetTotpSetup,
  y7 as useGetTwoFactorStatus,
  h7 as useGetUserCalendarToken,
  a7 as useGetUserInvites,
  c7 as useGetUserList,
  l7 as useGetUserSearch,
  s7 as useGetUserSessions,
  p7 as useGetUserStats,
  F8 as useInviteDateFormatter,
  m8 as useLeaveMirror,
  Eu as useLogger,
  w5 as usePaddleCheckoutContext,
  u7 as usePatchUserProfile,
  V8 as usePlanPurchaseCheckout,
  y8 as usePostAndJoinMirror,
  o8 as usePostConnection,
  O7 as usePostGroup,
  T7 as usePostInviteToGroup,
  Z7 as usePostInviteToSession,
  a8 as usePostJoinBonzaSession,
  Y6 as usePostKickFromAccount,
  c8 as usePostLeaveBonzaSession,
  M7 as usePostMultipleInviteToGroup,
  W7 as usePostMultipleInviteToSession,
  $7 as usePostRemoveUserFromGroup,
  Y7 as usePostRemoveUserFromSession,
  j7 as usePostSession,
  f7 as usePostUserAvatar,
  u8 as usePostWhisper,
  k7 as usePrefetchPaginatedGroups,
  t8 as usePrefetchPaginatedSessions,
  G6 as usePutAccount,
  i8 as usePutConnection,
  P7 as usePutGroup,
  K7 as usePutSession,
  J6 as usePutSetRoleInAccount,
  w7 as useRegenerateRecoveryCodes,
  N7 as useRevokeGroupInvite,
  J7 as useRevokeSessionInvite,
  W6 as useStartTrial,
  N8 as useTimeAgoFormatter,
  $8 as useWindowSize,
  Re as userKeys
};
